// src/enums.ts
var UserRole = {
  ADMIN: "ADMIN",
  CALL_CENTER: "CALL_CENTER",
  SURVEYOR: "SURVEYOR",
  CONSTRUCTOR: "CONSTRUCTOR",
  DOCUMENTS: "DOCUMENTS",
  INSTALLER: "INSTALLER",
  MANAGER: "MANAGER",
  STOREKEEPER: "STOREKEEPER",
  SERVICE: "SERVICE",
  CASHIER: "CASHIER",
  SURVEYOR_HEAD: "SURVEYOR_HEAD",
  /** Склад забора: выдаёт только строки, отмеченные основным складом (правило 292) */
  PICKUP_KEEPER: "PICKUP_KEEPER"
};
var USER_ROLE_LABELS = {
  ADMIN: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
  CALL_CENTER: "\u041A\u043E\u043B\u043B-\u0446\u0435\u043D\u0442\u0440",
  SURVEYOR: "\u0417\u0430\u043C\u0435\u0440\u0449\u0438\u043A",
  CONSTRUCTOR: "\u041A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440",
  DOCUMENTS: "\u041E\u0442\u0434\u0435\u043B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
  INSTALLER: "\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0438\u043A",
  MANAGER: "\u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C",
  STOREKEEPER: "\u041A\u043B\u0430\u0434\u043E\u0432\u0449\u0438\u043A",
  SERVICE: "\u041E\u0442\u0434\u0435\u043B \u0441\u0435\u0440\u0432\u0438\u0441\u0430",
  CASHIER: "\u041A\u0430\u0441\u0441\u0430",
  SURVEYOR_HEAD: "\u0413\u043B\u0430\u0432\u043D\u044B\u0439 \u043F\u043E \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A\u0430\u043C",
  PICKUP_KEEPER: "\u041A\u043B\u0430\u0434\u043E\u0432\u0449\u0438\u043A \u2014 \u0432\u044B\u0434\u0430\u0451\u0442 \u043F\u043E \u043E\u0442\u043C\u0435\u0442\u043A\u0435"
};
var PriceUnit = {
  SQM: "SQM",
  LINEAR_M: "LINEAR_M",
  PIECE: "PIECE",
  SET: "SET",
  HOUR: "HOUR",
  JOB: "JOB",
  /**
   * Точка крепления — так карниз считают на их бланке: «10 Т.кр.».
   *
   * Не «шт»: штука это сам карниз, а точек крепления у него столько,
   * сколько кронштейнов, и платят именно за них. Считать в штуках значит
   * получить в акте «1 шт» там, где работы на десять точек.
   */
  MOUNT_POINT: "MOUNT_POINT",
  /** Километр: «Выезд за город» у кондиционерщиков считается по расстоянию */
  KM: "KM"
};
var PRICE_UNIT_LABELS = {
  SQM: "\u043C\xB2",
  LINEAR_M: "\u043F\u043E\u0433.\u043C",
  PIECE: "\u0448\u0442",
  SET: "\u043A\u043E\u043C\u043F\u043B",
  HOUR: "\u0447\u0430\u0441",
  JOB: "\u0440\u0430\u0431\u043E\u0442\u0430",
  MOUNT_POINT: "\u0422.\u043A\u0440.",
  KM: "\u043A\u043C"
};
var DealStatus = {
  NEW: "NEW",
  MEASUREMENT_SCHEDULED: "MEASUREMENT_SCHEDULED",
  MEASURED: "MEASURED",
  WON: "WON",
  IN_DESIGN: "IN_DESIGN",
  READY_TO_INSTALL: "READY_TO_INSTALL",
  INSTALLATION_SCHEDULED: "INSTALLATION_SCHEDULED",
  INSTALLED: "INSTALLED",
  CLOSED: "CLOSED",
  LOST: "LOST",
  CANCELLED: "CANCELLED"
};
var DEAL_STATUS_LABELS = {
  NEW: "\u041D\u043E\u0432\u0430\u044F \u0437\u0430\u044F\u0432\u043A\u0430",
  MEASUREMENT_SCHEDULED: "\u0417\u0430\u043C\u0435\u0440 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D",
  MEASURED: "\u0417\u0430\u043C\u0435\u0440 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D",
  WON: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440",
  IN_DESIGN: "\u0412 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0441\u043A\u043E\u043C",
  READY_TO_INSTALL: "\u0416\u0434\u0451\u0442 \u043C\u043E\u043D\u0442\u0430\u0436\u0430",
  INSTALLATION_SCHEDULED: "\u041C\u043E\u043D\u0442\u0430\u0436 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D",
  INSTALLED: "\u0421\u043C\u043E\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
  CLOSED: "\u0417\u0430\u043A\u0440\u044B\u0442\u0430",
  LOST: "\u041E\u0442\u043A\u0430\u0437",
  CANCELLED: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"
};
var ACTIVE_DEAL_STATUSES = [
  "NEW",
  "MEASUREMENT_SCHEDULED",
  "MEASURED",
  "WON",
  "IN_DESIGN",
  "READY_TO_INSTALL",
  "INSTALLATION_SCHEDULED",
  "INSTALLED"
];
var WON_DEAL_STATUSES = [
  "WON",
  "IN_DESIGN",
  "READY_TO_INSTALL",
  "INSTALLATION_SCHEDULED",
  "INSTALLED",
  "CLOSED"
];
var DEAL_STATUS_TRANSITIONS = {
  NEW: ["MEASUREMENT_SCHEDULED", "LOST", "CANCELLED"],
  MEASUREMENT_SCHEDULED: ["MEASURED", "NEW", "LOST", "CANCELLED"],
  MEASURED: ["WON", "LOST", "MEASUREMENT_SCHEDULED"],
  WON: ["IN_DESIGN", "READY_TO_INSTALL", "LOST"],
  IN_DESIGN: ["WON", "READY_TO_INSTALL"],
  // Запись на монтаж и его завершение статус двигают сами — руками
  // отсюда можно только откатиться назад или отменить
  READY_TO_INSTALL: ["INSTALLATION_SCHEDULED", "IN_DESIGN", "CANCELLED"],
  INSTALLATION_SCHEDULED: ["INSTALLED", "READY_TO_INSTALL", "CANCELLED"],
  INSTALLED: ["CLOSED", "INSTALLATION_SCHEDULED"],
  // Закрытая сделка возвращается только в «смонтировано»: это отмена
  // ошибочного закрытия, а не повторный запуск работы
  CLOSED: ["INSTALLED"],
  LOST: ["NEW"],
  CANCELLED: ["NEW"]
};
var InstallationStatus = {
  SCHEDULED: "SCHEDULED",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  CANCELLED: "CANCELLED"
};
var INSTALLATION_STATUS_LABELS = {
  SCHEDULED: "\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D",
  IN_PROGRESS: "\u0411\u0440\u0438\u0433\u0430\u0434\u0430 \u043D\u0430 \u043E\u0431\u044A\u0435\u043A\u0442\u0435",
  DONE: "\u0421\u043C\u043E\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
  CANCELLED: "\u041E\u0442\u043C\u0435\u043D\u0451\u043D"
};
var ConsumablesCardStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED"
};
var CONSUMABLES_CARD_STATUS_LABELS = {
  DRAFT: "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A",
  SUBMITTED: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434",
  ISSUED: "\u0412\u044B\u0434\u0430\u043D\u043E, \u0441\u043F\u0438\u0441\u0430\u043D\u043E",
  CANCELLED: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"
};
var MeasurementStatus = {
  SCHEDULED: "SCHEDULED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  RESCHEDULED: "RESCHEDULED"
};
var MEASUREMENT_STATUS_LABELS = {
  SCHEDULED: "\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D",
  IN_PROGRESS: "\u041D\u0430 \u043E\u0431\u044A\u0435\u043A\u0442\u0435",
  COMPLETED: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D",
  CANCELLED: "\u041E\u0442\u043C\u0435\u043D\u0451\u043D",
  RESCHEDULED: "\u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0451\u043D"
};
var PaymentMethod = {
  CASH: "CASH",
  CASHLESS: "CASHLESS",
  MIXED: "MIXED"
};
var PAYMENT_METHOD_LABELS = {
  CASH: "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
  CASHLESS: "\u0411\u0435\u0437\u043D\u0430\u043B",
  MIXED: "\u0421\u043C\u0435\u0448\u0430\u043D\u043D\u0430\u044F"
};
var PayrollTarget = {
  SURVEYOR: "SURVEYOR",
  INSTALLER_BRIGADE: "INSTALLER_BRIGADE"
};
var PAYROLL_TARGET_LABELS = {
  SURVEYOR: "\u0417\u0430\u043C\u0435\u0440\u0449\u0438\u043A",
  INSTALLER_BRIGADE: "\u0411\u0440\u0438\u0433\u0430\u0434\u0430 \u043C\u043E\u043D\u0442\u0430\u0436\u043D\u0438\u043A\u043E\u0432"
};
var PayrollBasis = {
  PERCENT_OF_DEAL: "PERCENT_OF_DEAL",
  PERCENT_OF_MARGIN: "PERCENT_OF_MARGIN",
  RATE_PER_UNIT: "RATE_PER_UNIT",
  FIXED_PER_DEAL: "FIXED_PER_DEAL",
  FIXED_PER_VISIT: "FIXED_PER_VISIT"
};
var PAYROLL_BASIS_LABELS = {
  PERCENT_OF_DEAL: "% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B \u0441\u0434\u0435\u043B\u043A\u0438",
  PERCENT_OF_MARGIN: "% \u043E\u0442 \u043C\u0430\u0440\u0436\u0438",
  RATE_PER_UNIT: "\u0441\u0442\u0430\u0432\u043A\u0430 \u0437\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443",
  FIXED_PER_DEAL: "\u0444\u0438\u043A\u0441 \u0437\u0430 \u0441\u0434\u0435\u043B\u043A\u0443",
  FIXED_PER_VISIT: "\u0444\u0438\u043A\u0441 \u0437\u0430 \u0432\u044B\u0435\u0437\u0434"
};
var PayrollStatus = {
  ACCRUED: "ACCRUED",
  APPROVED: "APPROVED",
  PAID: "PAID",
  CANCELLED: "CANCELLED"
};
var PAYROLL_STATUS_LABELS = {
  ACCRUED: "\u041D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E",
  APPROVED: "\u0423\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E",
  PAID: "\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
  CANCELLED: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u043E"
};
var ServiceCategoryCode = {
  CEILING: "CEILING",
  AC: "AC",
  QUIET_WALL: "QUIET_WALL",
  RENOVATION: "RENOVATION"
};

// src/money.ts
import Decimal from "decimal.js";
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP });
function toDecimal(value) {
  if (value === null || value === void 0 || value === "") return new Decimal(0);
  if (value instanceof Decimal) return value;
  try {
    const d = new Decimal(value);
    return d.isFinite() ? d : new Decimal(0);
  } catch {
    return new Decimal(0);
  }
}
function roundMoney(value) {
  return toDecimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}
function moneyToString(value) {
  return roundMoney(value).toFixed(2);
}
function moneyToNumber(value) {
  return roundMoney(value).toNumber();
}
function roundQuantity(value) {
  return toDecimal(value).toDecimalPlaces(3, Decimal.ROUND_HALF_UP);
}
function formatMoney(value, withSymbol = true) {
  const n = moneyToNumber(value);
  const formatted = new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(n);
  return withSymbol ? `${formatted} \u20BD` : formatted;
}
function formatMoneyShort(value, withSymbol = true) {
  const n = moneyToNumber(value);
  const formatted = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 }).format(n);
  return withSymbol ? `${formatted} \u20BD` : formatted;
}
function formatQuantity(value) {
  const d = roundQuantity(value);
  return new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 3 }).format(d.toNumber());
}
function sumMoney(values) {
  return values.reduce((acc, v) => acc.plus(toDecimal(v)), new Decimal(0));
}
function clampMoney(value, min, max) {
  let result = toDecimal(value);
  if (min !== null && min !== void 0 && min !== "") {
    const minD = toDecimal(min);
    if (result.lessThan(minD)) result = minD;
  }
  if (max !== null && max !== void 0 && max !== "") {
    const maxD = toDecimal(max);
    if (result.greaterThan(maxD)) result = maxD;
  }
  return result;
}
function percentOf(base, percent) {
  return toDecimal(base).times(toDecimal(percent)).dividedBy(100);
}

// src/id.ts
function randomBytes(count) {
  const bytes = new Uint8Array(count);
  const cryptoObj = globalThis.crypto;
  if (cryptoObj?.getRandomValues) {
    cryptoObj.getRandomValues(bytes);
    return bytes;
  }
  for (let i = 0; i < count; i++) {
    bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
}
var HEX = Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, "0"));
function newId(now = Date.now()) {
  const bytes = randomBytes(16);
  const ts = BigInt(now);
  bytes[0] = Number(ts >> 40n & 0xffn);
  bytes[1] = Number(ts >> 32n & 0xffn);
  bytes[2] = Number(ts >> 24n & 0xffn);
  bytes[3] = Number(ts >> 16n & 0xffn);
  bytes[4] = Number(ts >> 8n & 0xffn);
  bytes[5] = Number(ts & 0xffn);
  bytes[6] = (bytes[6] ?? 0) & 15 | 112;
  bytes[8] = (bytes[8] ?? 0) & 63 | 128;
  const h = (i) => HEX[bytes[i] ?? 0];
  return `${h(0)}${h(1)}${h(2)}${h(3)}-${h(4)}${h(5)}-${h(6)}${h(7)}-${h(8)}${h(9)}-${h(10)}${h(11)}${h(12)}${h(13)}${h(14)}${h(15)}`;
}
var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function isUuid(value) {
  return typeof value === "string" && UUID_RE.test(value);
}
function timestampFromId(id) {
  if (!isUuid(id)) return null;
  const hex = id.replace(/-/g, "").slice(0, 12);
  const ms = Number.parseInt(hex, 16);
  return Number.isFinite(ms) ? new Date(ms) : null;
}

// src/phone.ts
function normalizePhone(raw) {
  if (!raw) return null;
  let digits = raw.replace(/\D/g, "");
  if (digits.length === 0) return null;
  if (digits.length === 11 && digits.startsWith("8")) {
    digits = "7" + digits.slice(1);
  }
  if (digits.length === 10) {
    digits = "7" + digits;
  }
  if (digits.length !== 11 || !digits.startsWith("7")) return null;
  return "+" + digits;
}
function isValidPhone(raw) {
  return normalizePhone(raw) !== null;
}
function formatPhone(raw) {
  const normalized = normalizePhone(raw);
  if (!normalized) return raw ?? "";
  const d = normalized.slice(2);
  return `+7 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`;
}
function formatPhoneInput(raw) {
  let digits = raw.replace(/\D/g, "");
  if (digits.length === 0) return "";
  if (digits.startsWith("8")) digits = "7" + digits.slice(1);
  if (!digits.startsWith("7")) digits = "7" + digits;
  digits = digits.slice(0, 11);
  const rest = digits.slice(1);
  let out = "+7";
  if (rest.length > 0) out += ` (${rest.slice(0, 3)}`;
  if (rest.length >= 3) out += ")";
  if (rest.length > 3) out += ` ${rest.slice(3, 6)}`;
  if (rest.length > 6) out += `-${rest.slice(6, 8)}`;
  if (rest.length > 8) out += `-${rest.slice(8, 10)}`;
  return out;
}

// src/docx-write.ts
var CRC_TABLE = (() => {
  const table = new Uint32Array(256);
  for (let i = 0; i < 256; i++) {
    let c = i;
    for (let k = 0; k < 8; k++) c = c & 1 ? 3988292384 ^ c >>> 1 : c >>> 1;
    table[i] = c >>> 0;
  }
  return table;
})();
function crc32(bytes) {
  let c = 4294967295;
  for (let i = 0; i < bytes.length; i++) c = CRC_TABLE[(c ^ bytes[i]) & 255] ^ c >>> 8;
  return (c ^ 4294967295) >>> 0;
}
function xmlEscape(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function utf8(text3) {
  return new TextEncoder().encode(text3);
}
function zipStore(entries) {
  const chunks = [];
  const central = [];
  let offset = 0;
  const u16 = (v) => [v & 255, v >>> 8 & 255];
  const u32 = (v) => [v & 255, v >>> 8 & 255, v >>> 16 & 255, v >>> 24 & 255];
  for (const entry of entries) {
    const name = utf8(entry.name);
    const crc = crc32(entry.bytes);
    const size = entry.bytes.length;
    const local = new Uint8Array([
      80,
      75,
      3,
      4,
      ...u16(20),
      ...u16(2048),
      // имена и текст в UTF-8
      ...u16(0),
      // без сжатия
      ...u16(0),
      // время
      ...u16(33),
      // дата: 1980-01-01
      ...u32(crc),
      ...u32(size),
      ...u32(size),
      ...u16(name.length),
      ...u16(0),
      ...name
    ]);
    chunks.push(local, entry.bytes);
    central.push(
      new Uint8Array([
        80,
        75,
        1,
        2,
        ...u16(20),
        ...u16(20),
        ...u16(2048),
        ...u16(0),
        ...u16(0),
        ...u16(33),
        ...u32(crc),
        ...u32(size),
        ...u32(size),
        ...u16(name.length),
        ...u16(0),
        ...u16(0),
        ...u16(0),
        ...u16(0),
        ...u32(0),
        ...u32(offset),
        ...name
      ])
    );
    offset += local.length + size;
  }
  const dirSize = central.reduce((sum, c) => sum + c.length, 0);
  const end = new Uint8Array([
    80,
    75,
    5,
    6,
    ...u16(0),
    ...u16(0),
    ...u16(entries.length),
    ...u16(entries.length),
    ...u32(dirSize),
    ...u32(offset),
    ...u16(0)
  ]);
  const total = offset + dirSize + end.length;
  const out = new Uint8Array(total);
  let at = 0;
  for (const part of [...chunks, ...central, end]) {
    out.set(part, at);
    at += part.length;
  }
  return out;
}
function runProps(run, size, font) {
  const name = font ? xmlEscape(font) : "";
  const fonts = font ? `<w:rFonts w:ascii="${name}" w:hAnsi="${name}" w:cs="${name}"/>` : "";
  return `<w:rPr>${fonts}${run.bold ? "<w:b/>" : ""}<w:sz w:val="${size}"/><w:szCs w:val="${size}"/>${run.underline ? '<w:u w:val="single"/>' : ""}</w:rPr>`;
}
function runXml(run, size, font) {
  if (!run.text) return "";
  const props = runProps(run, size, font);
  return run.text.split(/\r?\n/).map((part) => `<w:r>${props}<w:t xml:space="preserve">${xmlEscape(part)}</w:t></w:r>`).join(`<w:r>${props}<w:br/></w:r>`);
}
function paragraphXml(p, opts) {
  const size = p.size ?? opts.size ?? 22;
  const after = p.spaceAfter ?? opts.spaceAfter;
  const before = p.spaceBefore ? ` w:before="${p.spaceBefore}"` : "";
  const spacing = before || after !== void 0 ? `<w:spacing${before}${after !== void 0 ? ` w:after="${after}"` : ""}/>` : "";
  const runs = p.runs ?? [{ text: p.text }];
  return (
    // Свойства знака абзаца — тот же шрифт и размер: иначе пустой абзац
    // встаёт высотой шрифта Word по умолчанию и раздвигает лист
    `<w:p><w:pPr>${spacing}${runProps({ bold: p.bold }, size, opts.font)}</w:pPr>` + runs.map((r) => runXml({ ...r, bold: r.bold ?? p.bold }, size, opts.font)).join("") + "</w:p>"
  );
}
function tableXml(t, opts) {
  const size = t.size ?? opts.size ?? 20;
  const grid = t.widths.map((w) => `<w:gridCol w:w="${w}"/>`).join("");
  const total = t.widths.reduce((sum, w) => sum + w, 0);
  const rows = t.rows.map(
    (row) => "<w:tr>" + row.map((cell, i) => {
      const align = t.align?.[i];
      return `<w:tc><w:tcPr><w:tcW w:w="${t.widths[i] ?? 2e3}" w:type="dxa"/></w:tcPr><w:p><w:pPr><w:spacing w:after="0"/>${align ? `<w:jc w:val="${align}"/>` : ""}${runProps({}, size, opts.font)}</w:pPr>${runXml({ text: cell }, size, opts.font)}</w:p></w:tc>`;
    }).join("") + "</w:tr>"
  ).join("");
  const m = t.cellMargins;
  const margins = m ? "<w:tblCellMar>" + ["top", "left", "bottom", "right"].filter((side) => m[side] !== void 0).map((side) => `<w:${side} w:w="${m[side]}" w:type="dxa"/>`).join("") + "</w:tblCellMar>" : "";
  return (
    // Ширина целиком и неизменная раскладка: ширины колонок заданы, и Word
    // не должен растягивать их по тексту — иначе таблица работ у каждого
    // адреса выходила бы своей ширины
    `<w:tbl><w:tblPr><w:tblW w:w="${total}" w:type="dxa"/><w:tblBorders>` + ["top", "left", "bottom", "right", "insideH", "insideV"].map((side) => `<w:${side} w:val="single" w:sz="4" w:space="0" w:color="000000"/>`).join("") + `</w:tblBorders><w:tblLayout w:type="fixed"/>${margins}</w:tblPr><w:tblGrid>${grid}</w:tblGrid>${rows}</w:tbl>`
  );
}
function emptyParagraph(opts) {
  return `<w:p><w:pPr><w:spacing w:after="0"/>${runProps({}, opts.size ?? 22, opts.font)}</w:pPr></w:p>`;
}
var CONTENT_TYPES = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/word/document.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/></Types>';
var RELS = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml"/></Relationships>';
function buildDocx(blocks, options = {}) {
  const body = blocks.map((block, i) => {
    if (block.kind === "p") return paragraphXml(block, options);
    const next = blocks[i + 1];
    return tableXml(block, options) + (!next || next.kind === "table" ? emptyParagraph(options) : "");
  }).join("");
  const m = options.margins ?? { top: 720, right: 720, bottom: 720, left: 720 };
  const document = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><w:document xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"><w:body>${body}<w:sectPr><w:pgSz w:w="11906" w:h="16838"/><w:pgMar w:top="${m.top}" w:right="${m.right}" w:bottom="${m.bottom}" w:left="${m.left}"/></w:sectPr></w:body></w:document>`;
  return zipStore([
    { name: "[Content_Types].xml", bytes: utf8(CONTENT_TYPES) },
    { name: "_rels/.rels", bytes: utf8(RELS) },
    { name: "word/document.xml", bytes: utf8(document) }
  ]);
}

// src/schemas.ts
import { z } from "zod";

// src/schedule.ts
var SCHEDULE_START_HOUR = 9;
var SCHEDULE_END_HOUR = 21;
var SLOT_MINUTES = 60;
var POOL_PAST_WINDOW_DAYS = 30;
function scheduleHours() {
  const hours = [];
  for (let h = SCHEDULE_START_HOUR; h <= SCHEDULE_END_HOUR; h++) hours.push(h);
  return hours;
}
function formatHour(hour) {
  return `${String(hour).padStart(2, "0")}:00`;
}
function slotStart(date, hour) {
  const d = date instanceof Date ? new Date(date) : new Date(date);
  d.setHours(hour, 0, 0, 0);
  return d;
}
function hourOf(date) {
  const d = date instanceof Date ? date : new Date(date);
  return d.getHours();
}
function dateKey(date) {
  const d = date instanceof Date ? date : new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
}
function isWithinWorkingHours(date) {
  const hour = hourOf(date);
  return hour >= SCHEDULE_START_HOUR && hour <= SCHEDULE_END_HOUR;
}
function calcSlotOccupancy(params) {
  const taken = params.assigned + params.unassigned;
  return {
    hour: params.hour,
    capacity: params.capacity,
    assigned: params.assigned,
    unassigned: params.unassigned,
    free: Math.max(0, params.capacity - taken),
    overbooked: taken > params.capacity
  };
}
function formatFreeSlots(free) {
  if (free <= 0) return "\u043D\u0435\u0442 \u043E\u043A\u043E\u0448\u0435\u043A";
  const lastTwo = free % 100;
  const last = free % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return `${free} \u043E\u043A\u043E\u0448\u0435\u043A`;
  if (last === 1) return `${free} \u043E\u043A\u043E\u0448\u043A\u043E`;
  if (last >= 2 && last <= 4) return `${free} \u043E\u043A\u043E\u0448\u043A\u0430`;
  return `${free} \u043E\u043A\u043E\u0448\u0435\u043A`;
}
function absentHoursFrom(value) {
  if (!Array.isArray(value)) return null;
  const hours = value.filter(
    (h) => typeof h === "number" && Number.isInteger(h) && h >= SCHEDULE_START_HOUR && h <= SCHEDULE_END_HOUR
  );
  if (hours.length === 0) return null;
  return [...new Set(hours)].sort((a, b) => a - b);
}
function worksAtHour(absence, hour) {
  if (absence === void 0) return true;
  if (absence === null) return false;
  return !absence.includes(hour);
}
function absentHoursCount(absence) {
  if (absence === null) return scheduleHours().length;
  return absence.filter((h) => h >= SCHEDULE_START_HOUR && h <= SCHEDULE_END_HOUR).length;
}
function describeAbsentHours(hours) {
  const sorted = [...new Set(hours)].sort((a, b) => a - b);
  if (sorted.length === 0) return "";
  const runs = [];
  for (const hour of sorted) {
    const last = runs[runs.length - 1];
    if (last && hour === last[1] + 1) last[1] = hour;
    else runs.push([hour, hour]);
  }
  return runs.map(([a, b]) => `${formatHour(a)}\u2013${formatHour(b + 1)}`).join(", ");
}

// src/schemas.ts
var uuidSchema = z.string().uuid("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440");
var phoneSchema = z.string().trim().transform((v) => normalizePhone(v)).refine((v) => v !== null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 +7 (999) 123-45-67");
var optionalPhoneSchema = z.string().trim().optional().nullable().transform((v) => v ? normalizePhone(v) : null);
var MONEY_TEXT = /^-?(?:\d{1,3}(?:[   ]\d{3})+|\d+)(?:[.,]\d+)?$/;
var moneySchema = z.union([z.number(), z.string()]).transform((v, ctx) => {
  const text3 = typeof v === "string" ? v.trim() : null;
  const n = text3 === null ? v : MONEY_TEXT.test(text3) ? Number(text3.replace(/[   ]/g, "").replace(",", ".")) : Number.NaN;
  if (!Number.isFinite(n)) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430" });
    return z.NEVER;
  }
  return n;
});
var nonNegativeMoneySchema = moneySchema.refine((n) => n >= 0, "\u0421\u0443\u043C\u043C\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439");
var loginSchema = z.object({
  /** Телефон в любом виде или логин */
  phone: z.string().trim().min(3, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0438\u043B\u0438 \u043B\u043E\u0433\u0438\u043D").max(50),
  password: z.string().min(4, "\u041F\u0430\u0440\u043E\u043B\u044C \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439"),
  device: z.string().max(200).optional()
});
var refreshSchema = z.object({
  refreshToken: z.string().min(10)
});
var changePasswordSchema = z.object({
  currentPassword: z.string().min(1, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C"),
  newPassword: z.string().min(8, "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u2014 \u043D\u0435 \u043A\u043E\u0440\u043E\u0447\u0435 \u0432\u043E\u0441\u044C\u043C\u0438 \u0437\u043D\u0430\u043A\u043E\u0432").max(100, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0434\u043B\u0438\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C")
});
var createClientSchema = z.object({
  id: uuidSchema.optional(),
  fullName: z.string().trim().min(2, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0438\u043C\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430").max(200),
  phone: phoneSchema,
  phoneExtra: optionalPhoneSchema,
  email: z.string().trim().email("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 email").max(150).optional().nullable().or(z.literal("")),
  city: z.string().trim().max(100).optional().nullable(),
  address: z.string().trim().max(300).optional().nullable(),
  sourceId: uuidSchema.optional().nullable(),
  notes: z.string().max(5e3).optional().nullable(),
  /**
   * Заказчик — организация.
   *
   * Признаком, а не отдельной сущностью: путь заказа один и тот же, а
   * отличаются они только реквизитами в бумагах.
   */
  isCompany: z.boolean().optional(),
  // Реквизиты организации. У человека пусты
  inn: z.string().trim().max(12).optional().nullable(),
  kpp: z.string().trim().max(9).optional().nullable(),
  ogrn: z.string().trim().max(15).optional().nullable(),
  legalAddress: z.string().trim().max(300).optional().nullable(),
  bankName: z.string().trim().max(200).optional().nullable(),
  bankAccount: z.string().trim().max(34).optional().nullable(),
  corrAccount: z.string().trim().max(34).optional().nullable(),
  bik: z.string().trim().max(9).optional().nullable(),
  signerName: z.string().trim().max(200).optional().nullable(),
  signerTitle: z.string().trim().max(120).optional().nullable(),
  signerBasis: z.string().trim().max(120).optional().nullable(),
  signerGenitive: z.string().trim().max(300).optional().nullable()
});
var updateClientSchema = createClientSchema.partial().extend({
  version: z.number().int().optional()
});
var createDealSchema = z.object({
  id: uuidSchema.optional(),
  clientId: uuidSchema,
  categoryId: uuidSchema,
  responsibleId: uuidSchema.optional().nullable(),
  address: z.string().trim().max(300).optional().nullable(),
  comment: z.string().max(5e3).optional().nullable()
});
var quickLeadSchema = z.object({
  client: createClientSchema,
  /**
   * Направление работ. Сообщение СВОЁ, по-русски: без него отказ
   * приходил как «categoryId: Required» — техническим именем поля и
   * по-английски. Экран это поле требует и сам, но ответ сервера читает
   * человек, а не разработчик (та же причина, что у правила 47).
   */
  categoryId: z.string({ required_error: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0440\u0430\u0431\u043E\u0442" }).uuid("\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0440\u0430\u0431\u043E\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043E \u043D\u0435\u0432\u0435\u0440\u043D\u043E"),
  comment: z.string().max(5e3).optional().nullable(),
  address: z.string().trim().max(300).optional().nullable(),
  /** Сразу назначить замер, если клиент готов назвать время */
  measurement: z.object({
    scheduledAt: z.coerce.date(),
    durationMin: z.number().int().min(15).max(600).default(60),
    surveyorId: uuidSchema.optional().nullable(),
    address: z.string().trim().min(3, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043E\u0431\u044A\u0435\u043A\u0442\u0430").max(300),
    contactPhone: optionalPhoneSchema,
    objectType: z.string().trim().max(50).optional().nullable(),
    floor: z.string().trim().max(20).optional().nullable(),
    hasElevator: z.boolean().optional().nullable(),
    callCenterNotes: z.string().max(5e3).optional().nullable(),
    /**
     * Точка адреса на карте — от подсказки при вводе.
     *
     * Необязательна: адрес можно набрать руками, и тогда времени в пути
     * программа не знает. Это молчание, а не ноль (см. calc/travel-fit).
     */
    addressLat: z.number().min(-90).max(90).optional().nullable(),
    addressLon: z.number().min(-180).max(180).optional().nullable()
  }).optional()
});
var updateDealSchema = z.object({
  categoryId: uuidSchema,
  responsibleId: uuidSchema.nullable(),
  brigadeId: uuidSchema.nullable(),
  address: z.string().trim().max(300).nullable(),
  comment: z.string().max(5e3).nullable(),
  /**
   * Номер заказа у партнёра: «6772609». Бригада называет на объекте
   * ЕГО, а не наш, и без него разговор с диспетчером партнёра не
   * начать. Вводится руками, как и сама заявка.
   */
  partnerOrderNo: z.string().trim().max(60).nullable(),
  /**
   * ИП, через которого идёт заказ: на него бригада берёт доплату, и в
   * наряде он стоит рядом с деньгами. Выбирается из списка ИП в
   * реквизитах; пусто — не назначен.
   */
  entrepreneur: z.string().trim().max(200).nullable()
}).partial().strict();
var changeDealStatusSchema = z.object({
  status: z.nativeEnum(DealStatus),
  lostReason: z.string().trim().max(300).optional().nullable()
});
var setFollowUpSchema = z.object({
  followUpAt: z.coerce.date().nullable(),
  followUpNote: z.string().trim().max(300).optional().nullable()
});
var paymentPlanItemSchema = z.object({
  label: z.string().trim().min(1, "\u0423 \u0432\u0437\u043D\u043E\u0441\u0430 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435").max(200),
  amount: nonNegativeMoneySchema,
  dueAt: z.coerce.date().optional().nullable()
});
var setPaymentPlanSchema = z.object({
  items: z.array(paymentPlanItemSchema).max(24, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u043D\u043E\u0433\u043E \u0432\u0437\u043D\u043E\u0441\u043E\u0432")
});
var scheduleMeasurementSchema = z.object({
  id: uuidSchema.optional(),
  dealId: uuidSchema,
  surveyorId: uuidSchema.optional().nullable(),
  scheduledAt: z.coerce.date(),
  durationMin: z.number().int().min(15).max(600).default(60),
  address: z.string().trim().min(3, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043E\u0431\u044A\u0435\u043A\u0442\u0430").max(300),
  contactPhone: optionalPhoneSchema,
  objectType: z.string().trim().max(50).optional().nullable(),
  floor: z.string().trim().max(20).optional().nullable(),
  hasElevator: z.boolean().optional().nullable(),
  callCenterNotes: z.string().max(5e3).optional().nullable(),
  /**
   * Точка адреса на карте — от подсказки при вводе.
   *
   * Необязательна: адрес можно набрать руками, и тогда времени в пути
   * программа не знает. Это молчание, а не ноль (см. calc/travel-fit).
   */
  addressLat: z.number().min(-90).max(90).optional().nullable(),
  addressLon: z.number().min(-180).max(180).optional().nullable()
});
var rescheduleMeasurementSchema = z.object({
  scheduledAt: z.coerce.date(),
  durationMin: z.number().int().min(15).max(600).optional(),
  surveyorId: uuidSchema.optional().nullable(),
  reason: z.string().trim().max(300).optional().nullable()
});
var wallSegmentSchema = z.object({
  lengthMm: z.number().int().min(1).max(5e4),
  turnDeg: z.number().min(-180).max(180),
  /** Профиль по стене. Не указан — считается обычным багетом. */
  profile: z.enum(["BAGUETTE", "FLOAT", "SHADOW", "NONE"]).optional(),
  /**
   * Стрелка прогиба дуги, мм: ноль или пусто — стена прямая.
   * Предел — половина хорды, то есть полуокружность: сильнее выгнутая
   * стена в один сегмент обхода не описывается, её делят на две.
   */
  bulgeMm: z.number().int().min(-25e3).max(25e3).optional(),
  /** Закладная под карниз по этой стене */
  curtainNiche: z.boolean().optional(),
  /** Дверь или окно в этой стене: ориентир для чертежа, денег не считает */
  opening: z.enum(["DOOR", "WINDOW"]).optional(),
  /** Длина снята рулеткой или введена числом, а не взята с клеток холста */
  measured: z.boolean().optional()
});
var roomFixtureSchema = z.object({
  id: z.string().min(1).max(40),
  kind: z.enum(["LAMP", "CHANDELIER", "TRACK", "PIPE", "COLUMN"]),
  x: z.number(),
  y: z.number(),
  diameterMm: z.number().min(10).max(2e3)
});
var diagonalCheckSchema = z.object({
  fromIndex: z.number().int().min(0).max(99),
  toIndex: z.number().int().min(0).max(99),
  measuredMm: z.number().int().min(1).max(6e4)
});
var signatureSchema = z.object({
  strokes: z.array(z.array(z.object({ x: z.number(), y: z.number() })).min(1)).min(1, "\u041F\u043E\u0434\u043F\u0438\u0441\u044C \u043F\u0443\u0441\u0442\u0430\u044F").max(200),
  widthPx: z.number().int().min(1).max(4e3),
  heightPx: z.number().int().min(1).max(4e3),
  /** Кто расписался — вписывается вручную, может не совпадать с клиентом в базе */
  signerName: z.string().trim().max(200).optional().nullable(),
  signedAt: z.coerce.date()
});
var measurementRoomSchema = z.object({
  id: uuidSchema.optional(),
  name: z.string().trim().min(1, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E").max(150),
  /** Светильники и обводы, расставленные замерщиком */
  fixtures: z.array(roomFixtureSchema).max(200).optional().nullable(),
  /**
   * Обход стен. Необязателен: замеры, снятые до появления проектировки,
   * хранят только площадь с периметром. Если контур пришёл — сервер
   * пересчитывает по нему площадь и периметр сам.
   */
  contourWalls: z.array(wallSegmentSchema).min(3).optional().nullable(),
  /** Контрольные диагонали — проверка углов помещения */
  diagonals: z.array(diagonalCheckSchema).max(20).optional().nullable(),
  /**
   * Световые линии: разрезы через потолок (правило 160).
   *
   * Каждая делит полотно надвое, и раскрой считает части отдельно.
   * Хранится координатами концов в системе контура — как и допы.
   */
  lightLines: z.array(
    z.object({
      id: z.string().max(40),
      from: z.object({ x: z.number(), y: z.number() }),
      to: z.object({ x: z.number(), y: z.number() })
    })
  ).max(20).optional().nullable(),
  areaSqm: moneySchema.refine((n) => n >= 0, "\u041F\u043B\u043E\u0449\u0430\u0434\u044C \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439"),
  perimeterM: moneySchema.refine((n) => n >= 0, "\u041F\u0435\u0440\u0438\u043C\u0435\u0442\u0440 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C"),
  heightM: moneySchema.optional().nullable(),
  cornersCount: z.number().int().min(0).max(100).default(4),
  ceilingType: z.string().trim().max(50).optional().nullable(),
  /**
   * Площадь второго уровня, м². Замерщик видит короб на объекте,
   * конструктор потом — только контур помещения.
   */
  secondLevelSqm: moneySchema.optional().nullable(),
  /**
   * Сколько секунд комнату чертили на холсте — от открытия до «Взять в
   * замер», суммой по открытиям (правило 194). Пусто — не на холсте
   */
  sketchSeconds: z.number().int().min(0).max(86400).optional().nullable(),
  materialId: uuidSchema.optional().nullable(),
  notes: z.string().max(2e3).optional().nullable(),
  sortOrder: z.number().int().default(0)
});
var measurementItemSchema = z.object({
  id: uuidSchema.optional(),
  roomId: uuidSchema.optional().nullable(),
  priceItemId: uuidSchema.optional().nullable(),
  name: z.string().trim().min(1, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E").max(200),
  unit: z.nativeEnum(PriceUnit),
  quantity: moneySchema.refine((n) => n >= 0, "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C"),
  unitPrice: nonNegativeMoneySchema,
  costPrice: moneySchema.optional().nullable(),
  notes: z.string().max(2e3).optional().nullable(),
  sortOrder: z.number().int().default(0)
});
var completeMeasurementSchema = z.object({
  rooms: z.array(measurementRoomSchema).default([]),
  items: z.array(measurementItemSchema).min(1, "\u0421\u043C\u0435\u0442\u0430 \u043F\u0443\u0441\u0442\u0430 \u2014 \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0443 \u043F\u043E\u0437\u0438\u0446\u0438\u044E"),
  discountValue: nonNegativeMoneySchema.default(0),
  prepayment: nonNegativeMoneySchema.default(0),
  paymentMethod: z.nativeEnum(PaymentMethod).default(PaymentMethod.CASH),
  surveyorNotes: z.string().max(5e3).optional().nullable(),
  brigadeId: uuidSchema.optional().nullable(),
  /** Клиент согласился на договор прямо на замере */
  dealWon: z.boolean().default(false),
  startedAt: z.coerce.date().optional().nullable(),
  completedAt: z.coerce.date().optional().nullable(),
  /** Время на устройстве — помогает разбирать конфликты синхронизации */
  /** Подпись заказчика, если он расписался прямо на планшете */
  clientSignature: signatureSchema.optional().nullable(),
  clientCreatedAt: z.coerce.date().optional().nullable()
});
var cancelMeasurementSchema = z.object({
  status: z.enum([MeasurementStatus.CANCELLED, MeasurementStatus.RESCHEDULED]),
  cancelReason: z.string().trim().min(3, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443").max(300)
});
var updateEstimateSchema = z.object({
  items: z.array(measurementItemSchema).min(1, "\u0412 \u0441\u043C\u0435\u0442\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u043E\u0441\u0442\u0430\u0442\u044C\u0441\u044F \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0438\u044F"),
  discountValue: nonNegativeMoneySchema.default(0),
  prepayment: nonNegativeMoneySchema.default(0),
  paymentMethod: z.nativeEnum(PaymentMethod).optional(),
  reason: z.string().trim().min(3, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435, \u043F\u043E\u0447\u0435\u043C\u0443 \u043F\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u043C\u0435\u0442\u0430").max(300)
});
var scheduleInstallationSchema = z.object({
  id: uuidSchema.optional(),
  dealId: uuidSchema,
  brigadeId: uuidSchema.optional().nullable(),
  scheduledAt: z.coerce.date(),
  durationMin: z.number().int().min(30).max(1440).default(240),
  address: z.string().trim().min(3, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043E\u0431\u044A\u0435\u043A\u0442\u0430").max(300),
  contactPhone: optionalPhoneSchema,
  notes: z.string().max(5e3).optional().nullable(),
  /** Точка адреса на карте — от подсказки при вводе */
  addressLat: z.number().min(-90).max(90).optional().nullable(),
  addressLon: z.number().min(-180).max(180).optional().nullable()
});
var rescheduleInstallationSchema = z.object({
  scheduledAt: z.coerce.date(),
  durationMin: z.number().int().min(30).max(1440).optional(),
  brigadeId: uuidSchema.optional().nullable(),
  reason: z.string().trim().max(300).optional().nullable()
});
var reassignInstallationSchema = z.object({
  /** Пусто — снять бригаду с адреса: так адрес возвращается в очередь */
  brigadeId: uuidSchema.nullable(),
  reason: z.string().trim().max(300).optional().nullable()
});
var completeInstallationSchema = z.object({
  /** Сколько денег получили на объекте. 0 или пусто — ничего не брали */
  paymentAmount: z.coerce.number().optional(),
  paymentMethod: z.nativeEnum(PaymentMethod).optional(),
  receivedById: z.string().uuid().optional(),
  notes: z.string().max(5e3).optional().nullable(),
  clientSignature: signatureSchema.optional().nullable(),
  completedAt: z.coerce.date().optional().nullable()
});
var cancelInstallationSchema = z.object({
  reason: z.string().trim().min(3, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443").max(300)
});
var closeDealSchema = z.object({
  force: z.boolean().optional(),
  reason: z.string().trim().max(300).optional()
}).refine((v) => !v.force || !!v.reason?.trim(), {
  message: "\u0417\u0430\u043A\u0440\u044B\u0442\u0438\u0435 \u0441 \u0434\u043E\u043B\u0433\u043E\u043C \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u0438\u0447\u0438\u043D\u044B",
  path: ["reason"]
});
var serviceCategorySchema = z.object({
  id: uuidSchema.optional(),
  code: z.string().trim().min(2).max(50).regex(/^[A-Z0-9_]+$/, "\u041A\u043E\u0434: \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u0435 \u043B\u0430\u0442\u0438\u043D\u0441\u043A\u0438\u0435 \u0431\u0443\u043A\u0432\u044B \u0438 _"),
  name: z.string().trim().min(2).max(150),
  color: z.string().trim().regex(/^#[0-9a-fA-F]{6}$/, "\u0426\u0432\u0435\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 #RRGGBB").optional().nullable(),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true)
});
var priceItemSchema = z.object({
  id: uuidSchema.optional(),
  categoryId: uuidSchema,
  code: z.string().trim().min(1).max(50),
  name: z.string().trim().min(2, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u0438").max(200),
  unit: z.nativeEnum(PriceUnit),
  price: nonNegativeMoneySchema,
  costPrice: moneySchema.optional().nullable(),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
  notes: z.string().max(2e3).optional().nullable(),
  /** Как записана на листе замерщика: «св, точка, Ф100» */
  sketchAliases: z.string().trim().max(300).optional().nullable(),
  // Бланк «Спецификация» (правило 190): артикул, раздел, строка и
  // вариант, цена по безналу и верх диапазона. У позиции, заведённой
  // руками, всё это пусто
  article: z.string().trim().max(20).optional().nullable(),
  section: z.string().trim().max(120).optional().nullable(),
  lineName: z.string().trim().max(300).optional().nullable(),
  variantLabel: z.string().trim().max(120).optional().nullable(),
  priceCashless: nonNegativeMoneySchema.optional().nullable(),
  priceTo: nonNegativeMoneySchema.optional().nullable(),
  priceToCashless: nonNegativeMoneySchema.optional().nullable()
});
var ceilingMaterialSchema = z.object({
  id: uuidSchema.optional(),
  categoryId: uuidSchema,
  name: z.string().trim().min(2).max(200),
  texture: z.string().trim().max(50).optional().nullable(),
  manufacturer: z.string().trim().max(100).optional().nullable(),
  widthM: moneySchema.optional().nullable(),
  /**
   * УСАДКА ЗАВОДИТСЯ РУКАМИ, А НЕ БЕРЁТСЯ ПО УМОЛЧАНИЮ.
   *
   * Поле было в базе и в расчёте — а в схеме и в сохранении его не
   * было: новая фактура получала пустую усадку, и раскрой брал
   * запасные 7% ПВХ. Для ТКАНИ это порча: её кроят с ПРИПУСКОМ
   * (−3%), она не греется. Разница в десять процентов — полотно не
   * натянется, и его выбросят.
   *
   * Плюс — кроим меньше комнаты, минус — с припуском. Пределы шире
   * привычных: у новых материалов бывает и то и другое.
   */
  shrinkagePercent: z.coerce.number().min(-20).max(20).optional().nullable(),
  /**
   * Какой гарпун приваривают к этому полотну.
   *
   * Текстом, а не справочником: программа его не проверяет, а передаёт
   * в цех (правило 61). До этого поля цех звонил и спрашивал, что брать
   * со стеллажа.
   */
  harpoonType: z.string().trim().max(200).optional().nullable(),
  pricePerSqm: nonNegativeMoneySchema,
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().default(0)
});
var leadSourceSchema = z.object({
  id: uuidSchema.optional(),
  code: z.string().trim().min(2).max(50),
  name: z.string().trim().min(2).max(150),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().default(0)
});
var payrollRuleSchema = z.object({
  id: uuidSchema.optional(),
  name: z.string().trim().min(2, "\u041D\u0430\u0437\u043E\u0432\u0438\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u043E \u043F\u043E\u043D\u044F\u0442\u043D\u043E: \u0435\u0433\u043E \u0431\u0443\u0434\u0443\u0442 \u0447\u0438\u0442\u0430\u0442\u044C").max(200),
  target: z.nativeEnum(PayrollTarget),
  basis: z.nativeEnum(PayrollBasis),
  value: moneySchema,
  categoryId: uuidSchema.optional().nullable(),
  priceItemId: uuidSchema.optional().nullable(),
  minAmount: moneySchema.optional().nullable(),
  maxAmount: moneySchema.optional().nullable(),
  priority: z.number().int().default(0),
  validFrom: z.coerce.date(),
  validTo: z.coerce.date().optional().nullable(),
  isActive: z.boolean().default(true),
  notes: z.string().max(2e3).optional().nullable()
}).superRefine((v, ctx) => {
  if (v.basis === PayrollBasis.RATE_PER_UNIT && !v.priceItemId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["priceItemId"],
      message: "\u0414\u043B\u044F \u0441\u0442\u0430\u0432\u043A\u0438 \u0437\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u044E \u043F\u0440\u0430\u0439\u0441\u0430"
    });
  }
  if ((v.basis === PayrollBasis.PERCENT_OF_DEAL || v.basis === PayrollBasis.PERCENT_OF_MARGIN) && (v.value < 0 || v.value > 100)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["value"],
      message: "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043E\u0442 0 \u0434\u043E 100"
    });
  }
  if (v.validTo && v.validTo <= v.validFrom) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["validTo"],
      message: "\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043F\u043E\u0437\u0436\u0435 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430"
    });
  }
});
var createUserSchema = z.object({
  id: uuidSchema.optional(),
  fullName: z.string().trim().min(2).max(200),
  phone: phoneSchema,
  /**
   * Логин — второй способ войти, рядом с телефоном.
   *
   * Приводится к нижнему регистру: человек набирает его на планшете, и
   * «Petrov» с «petrov» для него один и тот же вход. Пусто — входит по
   * телефону, как раньше.
   *
   * Цифрами не бывает: строка из одних цифр на входе разбирается как
   * телефон, и такой логин просто не нашли бы.
   */
  login: z.string().trim().toLowerCase().min(3, "\u041B\u043E\u0433\u0438\u043D \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439").max(50).regex(/^(?![\d+]+$)[a-z0-9._-]+$/i, "\u0422\u043E\u043B\u044C\u043A\u043E \u043B\u0430\u0442\u0438\u043D\u0438\u0446\u0430, \u0446\u0438\u0444\u0440\u044B, \u0442\u043E\u0447\u043A\u0430, \u0434\u0435\u0444\u0438\u0441 \u2014 \u0438 \u043D\u0435 \u043E\u0434\u043D\u0438 \u0446\u0438\u0444\u0440\u044B").optional().nullable().or(z.literal("")),
  email: z.string().trim().email().max(150).optional().nullable().or(z.literal("")),
  password: z.string().min(4).max(100).optional().nullable(),
  roles: z.array(z.nativeEnum(UserRole)).min(1, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0443 \u0440\u043E\u043B\u044C"),
  isActive: z.boolean().default(true),
  /**
   * Склад выдачи кладовщика (правило 200): акты списания уходят с него, и
   * при выдаче склад не выбирают. Сверяется со складами компании на
   * сервере. Пусто — склад называет выдающий.
   */
  issueWarehouse: z.string().trim().max(120).optional().nullable().or(z.literal(""))
});
var issueAccessSchema = z.object({
  userIds: z.array(uuidSchema).min(1, "\u041E\u0442\u043C\u0435\u0442\u044C\u0442\u0435, \u043A\u043E\u043C\u0443 \u0432\u044B\u0434\u0430\u0442\u044C \u0432\u0445\u043E\u0434").max(50)
});
var setUserPasswordSchema = z.object({
  password: z.string().trim().min(4, "\u041F\u0430\u0440\u043E\u043B\u044C \u2014 \u043D\u0435 \u043A\u043E\u0440\u043E\u0447\u0435 4 \u0437\u043D\u0430\u043A\u043E\u0432").max(100).optional().nullable().or(z.literal(""))
}).strict();
var brigadeSchema = z.object({
  id: uuidSchema.optional(),
  name: z.string().trim().min(2).max(150),
  phone: optionalPhoneSchema,
  isActive: z.boolean().default(true),
  /**
   * Контрагент бригады в 1С («БРИГАДА ЧЕПИГА»): продажа и возврат ищут
   * покупателя по точному имени (правило 207). Пусто — название бригады.
   */
  onecCounterparty: z.string().trim().max(200).optional().nullable(),
  members: z.array(
    z.object({
      userId: uuidSchema,
      share: moneySchema.default(1),
      isLead: z.boolean().default(false)
    })
  ).default([]),
  /**
   * Что бригада берёт по сложности. Отсутствие строки означает, что
   * этой сложности она НЕ делает — так и на рабочем листе.
   */
  skills: z.array(
    z.object({
      level: z.number().int().min(1).max(4),
      maxSqm: z.number().positive().max(1e3).nullable().optional(),
      note: z.string().trim().max(200).nullable().optional()
    })
  ).optional(),
  /** Направления работ: потолки, тихие стены, ремонт */
  categoryIds: z.array(uuidSchema).optional(),
  /** Выходные дни недели по ISO: 1 — понедельник, 7 — воскресенье */
  daysOff: z.array(z.number().int().min(1).max(7)).optional(),
  scheduleNote: z.string().trim().max(300).nullable().optional(),
  cityOnly: z.boolean().optional(),
  supervisorId: uuidSchema.nullable().optional(),
  notes: z.string().trim().max(2e3).nullable().optional(),
  /**
   * Что бригада берёт ЗА СВОЙ СЧЁТ сверх второй страницы карточки: плёнка
   * у одной бригады вычитается из зарплаты, у другой списывается на
   * компанию (правило 213). Строки справочника расходки, списком целиком.
   */
  chargedItemIds: z.array(uuidSchema).max(300).optional(),
  /**
   * Куда бригаду не отправлять — проверяемым правилом.
   *
   * `pattern` — кусок адреса, по которому объект узнаётся: «Агрыз»,
   * «Парыгин». Человек называет его сам, поэтому угадывать по свободной
   * фразе не приходится (в отличие от `notes`, где оговорки остаются
   * текстом — правило 61).
   */
  addressRules: z.array(
    z.object({
      pattern: z.string().trim().min(2).max(120),
      reason: z.string().trim().max(300).nullable().optional()
    })
  ).max(50).optional()
});
var setInstallationDaysSchema = z.object({
  days: z.array(
    z.object({
      date: z.coerce.date(),
      /** Пусто — выходит бригада самого монтажа */
      brigadeId: uuidSchema.nullable().optional()
    })
  ).max(60).optional(),
  dates: z.array(z.coerce.date()).max(60).optional()
}).refine((v) => (v.days?.length ?? 0) > 0 || (v.dates?.length ?? 0) > 0, {
  message: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0434\u0435\u043D\u044C",
  path: ["days"]
});
var setInstallationWorksSchema = z.strictObject({
  works: z.array(
    z.strictObject({
      name: z.string().trim().min(1).max(200),
      unit: z.string().trim().min(1).max(20),
      /**
       * Количество — не отрицательное и не с потолка: «1300» кв.м. в
       * квартире это промах пальцем, а по этому листу бригада берёт
       * материал (та же причина, что у пределов в правиле 169).
       */
      quantity: z.coerce.number().min(0).max(1e5)
    })
  ).max(200)
});
var setInstallationNoteSchema = z.strictObject({
  notes: z.string().trim().max(2e3).nullable()
});
var setInstallationActMarksSchema = z.strictObject({
  received: z.boolean().optional(),
  checked: z.boolean().optional()
}).refine((v) => v.received !== void 0 || v.checked !== void 0, {
  message: "\u041E\u0442\u043C\u0435\u0442\u044C\u0442\u0435, \u0441\u0434\u0430\u043D \u0430\u043A\u0442 \u0438\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D"
});
var setInstallationCrewSchema = z.strictObject({
  userIds: z.array(uuidSchema).max(10)
});
var saveSheetEntrySchema = z.strictObject({
  id: uuidSchema.optional(),
  workDate: z.coerce.date(),
  timeText: z.string().trim().max(40).nullable().optional(),
  brigadeId: uuidSchema.nullable().optional(),
  orderNo: z.string().trim().max(40).nullable().optional(),
  address: z.string().trim().min(1).max(300),
  client: z.string().trim().max(200).nullable().optional(),
  phone: z.string().trim().max(120).nullable().optional(),
  moneyLine: z.string().trim().max(1e3).nullable().optional(),
  notes: z.string().trim().max(2e3).nullable().optional(),
  works: z.array(
    z.strictObject({
      name: z.string().trim().min(1).max(200),
      unit: z.string().trim().min(1).max(20),
      quantity: z.coerce.number().min(0).max(1e5)
    })
  ).max(200).optional(),
  crew: z.array(uuidSchema).max(10).optional()
});
var brigadeConflictSchema = z.object({
  brigadeAId: uuidSchema,
  brigadeBId: uuidSchema,
  reason: z.string().trim().min(3).max(300)
});
var installerConflictSchema = z.object({
  userAId: uuidSchema,
  userBId: uuidSchema,
  reason: z.string().trim().min(3).max(300)
});
var complexityLevelSchema = z.object({
  level: z.number().int().min(1).max(4),
  title: z.string().trim().min(1).max(100),
  description: z.string().trim().max(4e3)
});
var syncOperationSchema = z.object({
  /** Идентификатор операции с планшета — защита от повторной отправки */
  clientMutationId: uuidSchema,
  entityType: z.enum(["measurement", "client", "deal"]),
  entityId: uuidSchema,
  operation: z.enum(["create", "update", "complete"]),
  /** Полезная нагрузка операции — валидируется по entityType на сервере */
  payload: z.unknown(),
  /** Время выполнения на устройстве */
  clientTimestamp: z.coerce.date()
});
var syncPushSchema = z.object({
  operations: z.array(syncOperationSchema).max(200)
});
var syncPullSchema = z.object({
  /** Отдать всё, что изменилось на сервере после этой отметки */
  since: z.coerce.date().optional().nullable()
});
var ceilingCutInputSchema = z.object({
  /** Помещение замера, если раскрой делается по нему */
  roomId: uuidSchema.optional().nullable(),
  roomName: z.string().trim().min(1, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E").max(150),
  contourWalls: z.array(wallSegmentSchema).min(3, "\u041A\u043E\u043D\u0442\u0443\u0440 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0445\u043E\u0442\u044F \u0431\u044B \u0442\u0440\u0438 \u0441\u0442\u0435\u043D\u044B"),
  materialId: uuidSchema.optional().nullable(),
  /** Ширина рулона в мм — нужна, когда материал не выбран из справочника */
  rollWidthMm: z.number().int().min(500).max(1e4).optional().nullable(),
  /** Усадка в % — переопределяет значение из справочника */
  shrinkagePercent: z.number().min(-20).max(20).optional().nullable(),
  /** Светильники и обводы: шов обходит их, монтажник сверлит по ним */
  fixtures: z.array(roomFixtureSchema).max(200).optional().nullable(),
  /**
   * Световые линии (правило 160): каждая режет полотно надвое.
   *
   * Едут в раскрой вместе с контуром — иначе цех получит задание
   * сварить целое полотно там, где нужно два куска.
   */
  lightLines: z.array(
    z.object({
      id: z.string().max(40),
      from: z.object({ x: z.number(), y: z.number() }),
      to: z.object({ x: z.number(), y: z.number() })
    })
  ).max(20).optional().nullable(),
  /**
   * Ручная раскладка. Конструктор двигает шов не только ради расхода:
   * вдоль света, не по центру комнаты, вне зоны видимости.
   */
  rotationDeg: z.number().min(0).max(360).optional().nullable(),
  seamOffsetsMm: z.array(z.number().min(0)).max(20).optional().nullable(),
  /**
   * Второй уровень потолка — отдельное полотно поверх короба.
   *
   * Материал он расходует наравне с остальными и в закупку входит, а вот
   * в сверку сметы — нет: чем именно тарифицируется второй уровень
   * (позицией LEVEL-2, отдельным монтажом или и тем и другим), решает
   * компания, и подставлять за неё эту цифру нельзя.
   */
  secondLevel: z.boolean().optional(),
  /** Короб этого уровня вырезан из основного полотна помещения */
  cutFromBase: z.boolean().optional(),
  sortOrder: z.number().int().default(0)
});
var saveCeilingProjectSchema = z.object({
  cuts: z.array(ceilingCutInputSchema).default([]),
  notes: z.string().max(2e3).optional().nullable()
});
var recordPaymentSchema = z.object({
  dealId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0441\u0434\u0435\u043B\u043A\u0430").max(40),
  /**
   * Ноль не принимается: платёж на ноль рублей — это не событие, а
   * пустая строка в истории и лишняя квитанция с номером (правило 58).
   * Минус принимается: возврат записывается платежом со знаком и
   * остаётся в истории (правило 38).
   */
  amount: z.coerce.number().refine((v) => v !== 0, "\u0421\u0443\u043C\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043D\u0443\u043B\u0435\u0432\u043E\u0439").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C"),
  method: z.nativeEnum(PaymentMethod).default(PaymentMethod.CASH),
  /** Дата приёма денег: по ней платёж попадает в нужный месяц кассы */
  receivedAt: z.coerce.date().optional(),
  installationId: z.string().max(40).optional().nullable(),
  note: z.string().trim().max(1e3).optional().nullable()
}).strict();
var createAmendmentSchema = z.object({
  reason: z.string().trim().min(3, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u0447\u0442\u043E \u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F").max(1e3),
  amountDelta: z.coerce.number().refine((v) => v !== 0, "\u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0431\u0435\u0437 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0443\u043C\u043C\u044B \u043D\u0435 \u043D\u0443\u0436\u043D\u043E").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C")
}).strict();
var setContractNoSchema = z.object({
  contractNo: z.coerce.number().int("\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u2014 \u0446\u0435\u043B\u043E\u0435 \u0447\u0438\u0441\u043B\u043E").positive("\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F").max(9999999).nullable(),
  contractDate: z.coerce.date().optional().nullable()
}).strict();
var payrollAmountSchema = z.coerce.number().positive("\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F").max(1e7, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C");
var addDeductionSchema = z.object({
  userId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A").max(40),
  /** Месяц ведомости: по нему удержание попадает в свою выплату */
  month: z.coerce.date(),
  amount: payrollAmountSchema,
  /**
   * Причина обязательна: удержание объясняют человеку, у которого
   * забрали деньги, и «почему у меня меньше» спрашивают всегда
   * (правило 59)
   */
  reason: z.string().trim().min(3, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u0437\u0430 \u0447\u0442\u043E \u0443\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435").max(500),
  /**
   * Не снять, а ВЕРНУТЬ в зарплату: бригада сдала купленное у склада,
   * а 1С суммы возврата не назвала. Сумма та же, положительная, — знак
   * ставит сервер: минус, набранный в поле руками, читался бы как
   * опечатка
   */
  refund: z.boolean().optional()
}).strict();
var workPayLineSchema = z.object({
  installationId: z.string().min(1).max(40),
  brigadeId: z.string().min(1).max(40),
  lineKey: z.string().trim().min(1).max(300),
  lineName: z.string().trim().min(1).max(200),
  amount: z.coerce.number().min(0, "\u0421\u0443\u043C\u043C\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e7, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C").nullable(),
  rate: z.coerce.number().min(0, "\u0421\u0442\u0430\u0432\u043A\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e6, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0442\u0430\u0432\u043A\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C").nullable().optional(),
  reason: z.string().trim().max(300).optional().nullable()
}).strict().refine((v) => v.amount === null || v.rate === null || v.rate === void 0, {
  message: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u043B\u0438\u0431\u043E \u0441\u0443\u043C\u043C\u0443 \u0441\u0442\u0440\u043E\u043A\u0438, \u043B\u0438\u0431\u043E \u0441\u0442\u0430\u0432\u043A\u0443",
  path: ["rate"]
});
var workPayPersonSchema = z.object({
  installationId: z.string().min(1).max(40),
  brigadeId: z.string().min(1).max(40),
  day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0435\u043D\u044C \u2014 \u0432 \u0432\u0438\u0434\u0435 2026-09-29"),
  userId: z.string().min(1).max(40),
  amount: z.coerce.number().min(0, "\u0421\u0443\u043C\u043C\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e7, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C").nullable(),
  reason: z.string().trim().max(300).optional().nullable()
}).strict();
var debtInstalmentSchema = z.object({
  month: z.coerce.date(),
  amount: z.coerce.number().min(0, "\u0421\u0443\u043C\u043C\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e7, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C")
}).strict();
var payOutSchema = z.object({
  /**
   * Выдаётся частями — аванс в середине месяца обычное дело
   * (правило 40). Ноль и минус не выдают: возврат выданного это не
   * выплата, а удержание.
   */
  amount: payrollAmountSchema
}).strict();
var setSalarySchema = z.object({
  userId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A").max(40),
  amount: payrollAmountSchema,
  /** Дата начала действия: отбор идёт на месяц начисления (правило 33) */
  validFrom: z.coerce.date(),
  notes: z.string().trim().max(1e3).optional().nullable()
}).strict();
var accrueMonthSchema = z.object({
  month: z.coerce.date().optional()
}).strict();
var calendarDaySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0430\u0442\u0430 \u0432 \u0432\u0438\u0434\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414").refine((v) => !Number.isNaN((/* @__PURE__ */ new Date(`${v}T00:00:00.000Z`)).getTime()), "\u0422\u0430\u043A\u043E\u0439 \u0434\u0430\u0442\u044B \u043D\u0435\u0442");
var shiftRuleSchema = z.object({
  title: z.string().trim().min(2, "\u041D\u0430\u0437\u043E\u0432\u0438\u0442\u0435 \u0443\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435: \xAB\u041A\u043E\u043F\u0438\u043B\u043A\u0430\xBB, \xAB\u0410\u0440\u0435\u043D\u0434\u0430 \u0430\u0432\u0442\u043E\xBB").max(120),
  amount: z.coerce.number().positive("\u0421\u0443\u043C\u043C\u0430 \u0437\u0430 \u0441\u043C\u0435\u043D\u0443 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F").max(1e5, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0437\u0430 \u043E\u0434\u043D\u0443 \u0441\u043C\u0435\u043D\u0443 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C"),
  userId: z.string().min(1).max(40).nullable().optional(),
  validFrom: calendarDaySchema
}).strict();
var closeShiftRuleSchema = z.object({ validTo: calendarDaySchema }).strict();
var chargeShiftDeductionsSchema = z.object({ month: z.coerce.date() }).strict();
var workTypeMaterialSchema = z.object({
  /** Код 1С: по нему норма сходится со строкой карточки и остатками */
  externalCode: z.string().trim().min(1, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u044E 1\u0421").max(100),
  name: z.string().trim().min(1, "\u0423 \u043F\u043E\u0437\u0438\u0446\u0438\u0438 \u043D\u0435\u0442 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F").max(300),
  unit: z.string().trim().min(1, "\u0423 \u043F\u043E\u0437\u0438\u0446\u0438\u0438 \u043D\u0435\u0442 \u0435\u0434\u0438\u043D\u0438\u0446\u044B").max(20),
  /**
   * Сколько позиции на единицу работы. Больше нуля: ноль даёт норму,
   * которая молчит, а выглядит заведённой
   */
  perUnit: z.coerce.number().positive("\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0443\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443 \u0440\u0430\u0431\u043E\u0442\u044B \u2014 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F").max(1e5, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u043D\u043E\u0440\u043C\u0430 \u043D\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443 \u0440\u0430\u0431\u043E\u0442\u044B \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B")
}).strict();
var workTypeSchema = z.object({
  id: z.string().min(1).max(40).optional(),
  name: z.string().trim().min(2, "\u041D\u0430\u0437\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0431\u043E\u0442\u0443 \u0442\u0430\u043A, \u043A\u0430\u043A \u0435\u0451 \u043F\u0438\u0448\u0443\u0442 \u0432 \u043D\u0430\u0440\u044F\u0434\u0435").max(200),
  unit: z.string().trim().min(1, "\u0415\u0434\u0438\u043D\u0438\u0446\u0430 \u0440\u0430\u0431\u043E\u0442\u044B: \u041F.\u043C., \u0448\u0442, \u041A\u0432.\u043C.").max(20),
  /** Другие написания той же работы — по строке */
  aliases: z.string().trim().max(2e3).optional().nullable(),
  article: z.string().trim().max(20).optional().nullable(),
  notes: z.string().trim().max(1e3).optional().nullable(),
  isActive: z.boolean().optional(),
  materials: z.array(workTypeMaterialSchema).max(30, "\u0411\u043E\u043B\u044C\u0448\u0435 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0438\u0439 \u043D\u0430 \u043E\u0434\u043D\u0443 \u0440\u0430\u0431\u043E\u0442\u0443 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A")
}).strict();
var workRateSchema = z.object({
  amount: z.coerce.number().min(0, "\u0421\u0442\u0430\u0432\u043A\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e6, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0437\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0442\u0430\u0432\u043A\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C"),
  validFrom: calendarDaySchema,
  /** Пусто — всем бригадам; заполнено — этой бригаде вместо общей */
  brigadeId: z.string().min(1).max(40).nullable().optional()
}).strict();
var closeWorkRateSchema = z.object({ validTo: calendarDaySchema }).strict();
var onecWorkRatesSchema = z.object({
  priceType: z.string().trim().min(1).max(150).nullable().optional(),
  rows: z.array(
    z.object({
      code: z.string().trim().min(1, "\u041D\u0435\u0442 \u043A\u043E\u0434\u0430 \u0443\u0441\u043B\u0443\u0433\u0438").max(100),
      name: z.string().trim().max(300).default(""),
      unit: z.string().trim().max(40).default(""),
      price: z.coerce.number().min(0, "\u0421\u0442\u0430\u0432\u043A\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e7, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u0440\u044F\u0434\u044B").refine((v) => Number.isFinite(v), "\u0421\u0442\u0430\u0432\u043A\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C"),
      since: z.coerce.date().refine((d) => !Number.isNaN(d.getTime()), "\u0414\u0430\u0442\u0430 \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0435 \u043F\u043E\u0445\u043E\u0436\u0430 \u043D\u0430 \u0434\u0430\u0442\u0443")
    }).strict()
  ).max(2e4, "\u0411\u043E\u043B\u044C\u0448\u0435 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u0438 \u0442\u044B\u0441\u044F\u0447 \u0441\u0442\u0440\u043E\u043A \u0441\u0442\u0430\u0432\u043E\u043A \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u043A 1\u0421")
}).strict();
var createDebtSchema = z.object({
  userId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A").max(40),
  // Значения повторяют `DebtKind` из calc/debts.ts: он объявлен типом,
  // а Zod нужен список — расхождение поймает проверка типов ниже
  kind: z.enum(["DEFECT", "TOOL", "LOAN", "OTHER", "CASH"]).default("OTHER"),
  amount: payrollAmountSchema,
  reason: z.string().trim().min(3, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u0437\u0430 \u0447\u0442\u043E \u0434\u043E\u043B\u0433").max(500),
  occurredAt: z.coerce.date().optional(),
  /**
   * Предел взноса: сумма и доля. Доля не больше ста процентов — иначе
   * в месяц без работы взнос съел бы всю получку, и человек ушёл бы из
   * компании вместе с долгом (правило 59)
   */
  monthlyAmount: z.coerce.number().positive().max(1e7).optional().nullable(),
  monthlyPercent: z.coerce.number().positive().max(100, "\u0414\u043E\u043B\u044F \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 100%").optional().nullable()
}).strict();
var updateDebtSchema = z.object({
  amount: payrollAmountSchema.optional(),
  reason: z.string().trim().min(3).max(500).optional(),
  occurredAt: z.coerce.date().optional(),
  monthlyAmount: z.coerce.number().positive().max(1e7).optional().nullable(),
  monthlyPercent: z.coerce.number().positive().max(100, "\u0414\u043E\u043B\u044F \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 100%").optional().nullable()
}).strict();
var writeOffDebtSchema = z.object({
  reason: z.string().trim().min(3, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u043F\u043E\u0447\u0435\u043C\u0443 \u0434\u043E\u043B\u0433 \u043F\u0440\u043E\u0449\u0430\u0435\u0442\u0441\u044F").max(500)
}).strict();
var percentSchema = (fallback) => z.coerce.number().min(0, "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C").max(100, "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 100").default(fallback);
var orgText = (max) => z.string().trim().max(max).optional().nullable().transform((v) => v ? v : null);
var saveOrgSettingsSchema = z.object({
  name: z.string().trim().min(1, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u2014 \u043E\u043D\u043E \u043F\u0435\u0447\u0430\u0442\u0430\u0435\u0442\u0441\u044F \u0432 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435").max(300),
  shortName: orgText(150),
  /** Организация или ИП: от этого зависит род в договоре (правило 134) */
  isCompany: z.coerce.boolean().default(true),
  inn: orgText(20),
  kpp: orgText(20),
  ogrn: orgText(20),
  legalAddress: orgText(500),
  actualAddress: orgText(500),
  phone: orgText(50),
  email: orgText(150),
  site: orgText(150),
  signerName: orgText(200),
  signerTitle: orgText(150),
  signerBasis: orgText(200),
  signerGenitive: orgText(300),
  bankName: orgText(200),
  bankAccount: orgText(34),
  corrAccount: orgText(34),
  bik: orgText(12),
  receiptPrefix: orgText(20),
  contractPrefix: orgText(20),
  /**
   * Склады, с которых бригады берут материал — по строке на склад.
   *
   * Узнаётся куском строки: в 1С склад называется «Удмуртская, 206», а
   * говорят «удм» (правило 109 про то же с адресами бригад).
   */
  pickupWarehouses: orgText(1e3),
  /** ИП компании — по строке на предпринимателя (правило 55) */
  entrepreneurs: orgText(2e3),
  ndflPercent: percentSchema(13),
  contributionsPercent: percentSchema(30),
  /** Гарантия печатается в договоре и талоне (правила 76, 81) */
  warrantyMonths: z.coerce.number().int().min(0).max(600).default(24),
  /** Срок работ по договору, рабочих дней */
  workDaysDefault: z.coerce.number().int().min(1).max(365).default(14)
}).passthrough();
var saveRatingsSchema = z.object({
  rows: z.array(
    z.object({
      // Значения — как в базе: `CLEANUP`, а не «CLEANING». Ошибка
      // ровно того же рода, что чинило правило 147 у способа оплаты,
      // только с обратным знаком: схема отвергала бы ВЕРНЫЕ данные
      role: z.enum(["CLEANUP", "SURVEYOR", "MANAGER", "INSTALLERS"]),
      score: z.coerce.number().int("\u0411\u0430\u043B\u043B \u2014 \u0446\u0435\u043B\u043E\u0435 \u0447\u0438\u0441\u043B\u043E").min(1, "\u0411\u0430\u043B\u043B \u043E\u0442 1 \u0434\u043E 5").max(5, "\u0411\u0430\u043B\u043B \u043E\u0442 1 \u0434\u043E 5"),
      comment: z.string().trim().max(1e3).optional().nullable()
    })
  ).max(20)
}).strict();
var mmSchema = (label) => z.coerce.number().positive(`${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F`).max(1e5, `${label} \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0435\u0434\u0438\u043D\u0438\u0446\u044B, \u0442\u0443\u0442 \u043C\u0438\u043B\u043B\u0438\u043C\u0435\u0442\u0440\u044B`);
var addRemnantSchema = z.object({
  materialId: z.string().max(40).optional().nullable(),
  materialName: z.string().trim().min(1, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0444\u0430\u043A\u0442\u0443\u0440\u0443 \u043F\u043E\u043B\u043E\u0442\u043D\u0430").max(200),
  rollWidthMm: mmSchema("\u0428\u0438\u0440\u0438\u043D\u0430 \u0440\u0443\u043B\u043E\u043D\u0430"),
  widthMm: mmSchema("\u0428\u0438\u0440\u0438\u043D\u0430 \u043A\u0443\u0441\u043A\u0430"),
  lengthMm: mmSchema("\u0414\u043B\u0438\u043D\u0430 \u043A\u0443\u0441\u043A\u0430"),
  location: z.string().trim().max(200).optional().nullable(),
  defect: z.string().trim().max(500).optional().nullable(),
  productionOrderId: z.string().max(40).optional().nullable()
}).strict();
var useRemnantSchema = z.object({
  status: z.enum(["USED", "WRITTEN_OFF"]),
  dealId: z.string().max(40).optional().nullable(),
  note: z.string().trim().max(500).optional().nullable()
}).strict();
var setShippingSchema = z.object({
  shipAt: z.coerce.date().optional().nullable(),
  deliveryTo: z.string().trim().max(300).optional().nullable()
}).strict();
var assignMeasurementSchema = z.object({
  /** Пусто — вернуть наряд в общий пул: это то же действие с пустым значением */
  surveyorId: z.string().max(40).nullable()
}).strict();
var setAbsenceSchema = z.object({
  surveyorId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A").max(40),
  date: z.coerce.date(),
  /**
   * Часы, в которые человек не работает. Не прислали — весь день.
   *
   * ПУСТОЙ СПИСОК ОТВЕРГАЕТСЯ. «Не работает ни в какие часы» — это
   * обычный рабочий день, и снимается он удалением записи, а не
   * записью ни о чём. Молча превратить пустой список в выходной
   * значило бы отнять у человека день окошек за промах пальцем.
   */
  hours: z.array(
    z.number().int("\u0427\u0430\u0441 \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0446\u0435\u043B\u044B\u043C \u0447\u0438\u0441\u043B\u043E\u043C").min(SCHEDULE_START_HOUR, `\u0420\u0430\u0431\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C \u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u0432 ${SCHEDULE_START_HOUR}:00`).max(SCHEDULE_END_HOUR, `\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0447\u0430\u0441 \u0437\u0430\u043F\u0438\u0441\u0438 \u2014 ${SCHEDULE_END_HOUR}:00`)
  ).min(1, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0447\u0430\u0441\u044B \u0438\u043B\u0438 \u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0432\u044B\u0445\u043E\u0434\u043D\u043E\u0439 \u043D\u0430 \u0432\u0435\u0441\u044C \u0434\u0435\u043D\u044C").max(scheduleHours().length).optional().nullable(),
  reason: z.string().trim().max(300).optional().nullable()
}).strict();
var sheetNumberKindSchema = z.enum(["wall", "diagonal", "other"]);
var labelSheetSchema = z.object({
  numbers: z.array(
    z.object({
      /**
       * Как написано на листе: «368» — это 368, «2.6» — это 2.6.
       * Ни округления, ни пересчёта: учим читать лист, а не считать
       */
      value: z.number().finite("\u0427\u0438\u0441\u043B\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u043E \u043D\u0435\u0432\u0435\u0440\u043D\u043E"),
      kind: sheetNumberKindSchema
    })
  ).max(400, "\u0421\u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0438\u0441\u0435\u043B \u043D\u0430 \u043B\u0438\u0441\u0442\u0435 \u043D\u0435 \u0431\u044B\u0432\u0430\u0435\u0442 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0442\u043A\u0443"),
  /** Чем написан лист и как снят: «маркер, боком» */
  note: z.string().trim().max(300).optional().nullable(),
  /**
   * Размечено С ПОДСКАЗКАМИ читателя (правило 189). Для проверки модели
   * нужны листы без них (правило 186): подсказки учат тем же ошибкам, что
   * делает читатель. Старый экран поля не шлёт — тогда неизвестно
   */
  hintsUsed: z.boolean().optional()
}).strict();
var createWarrantyClaimSchema = z.object({
  dealId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0437\u0430\u043A\u0430\u0437").max(40),
  description: z.string().trim().min(5, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u043D\u0430 \u0447\u0442\u043E \u0436\u0430\u043B\u0443\u0435\u0442\u0441\u044F \u0437\u0430\u043A\u0430\u0437\u0447\u0438\u043A").max(2e3)
}).strict();
var attachInstallationSchema = z.object({ installationId: z.string().min(1, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u044B\u0435\u0437\u0434").max(40) }).strict();
var blameBrigadeSchema = z.object({
  /** Пусто — снять обвинение: по нему удерживают деньги (правило 59) */
  brigadeId: z.string().max(40).nullable()
}).strict();
var closeWarrantyClaimSchema = z.object({
  fixed: z.coerce.boolean(),
  /**
   * Чем кончилось — обязательно: обращение живёт дольше выезда
   * («приехали, не помогло, приехали снова»), и без этой строки
   * следующий разбирающий начинает с нуля
   */
  resolution: z.string().trim().min(3, "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435, \u0447\u0435\u043C \u043A\u043E\u043D\u0447\u0438\u043B\u043E\u0441\u044C").max(2e3),
  blamedBrigadeId: z.string().max(40).optional().nullable()
}).strict();
var sendToProductionSchema = z.object({
  note: z.string().trim().max(2e3).optional().nullable(),
  /** Срок отгрузки: пусто — не назван, и программа молчит (правило 116) */
  shipAt: z.coerce.date().optional().nullable(),
  deliveryTo: z.string().trim().max(300).optional().nullable()
}).strict();
var cancelProductionSchema = z.object({ reason: z.string().trim().min(3, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u043F\u043E\u0447\u0435\u043C\u0443 \u0437\u0430\u043A\u0430\u0437 \u043E\u0442\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F").max(500) }).strict();
var advanceProductionSchema = z.object({
  // Значения СВЕРЕНЫ со схемой базы, а не написаны по памяти:
  // «варят» — это IN_WORK, «забрали» — RECEIVED. Придуманные слова
  // отвергали бы верные запросы, а это хуже пропущенной проверки
  status: z.enum(["QUEUED", "IN_WORK", "READY", "RECEIVED", "CANCELLED"])
}).strict();
var changePayrollStatusSchema = z.object({
  status: z.enum(["ACCRUED", "APPROVED", "PAID", "CANCELLED"]),
  comment: z.string().trim().max(1e3).optional()
}).strict();
var onecLocalDateTimeSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/, "\u0412\u0440\u0435\u043C\u044F \u043C\u043E\u043D\u0442\u0430\u0436\u0430 \u0432 \u0432\u0438\u0434\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414T\u0427\u0427:\u041C\u041C:\u0421\u0421");
var onecInstallationLineSchema = z.object({
  name: z.string().trim().min(1).max(200),
  qty: z.coerce.number().min(0).max(1e5),
  unit: z.string().trim().max(20).nullish(),
  code: z.string().trim().max(100).nullish(),
  kind: z.string().trim().max(40).nullish()
});
var onecInvoiceSchema = z.object({
  number: z.string().trim().min(1).max(40),
  date: z.string().trim().max(40).nullish(),
  lines: z.array(onecInstallationLineSchema).max(300)
});
var onecInstallationSchema = z.object({
  uid: z.string().trim().min(1).max(64),
  at: onecLocalDateTimeSchema,
  brigade: z.object({
    name: z.string().trim().min(1).max(150),
    counterparty: z.string().trim().max(200).nullish()
  }).nullish(),
  customer: z.object({
    name: z.string().trim().min(1).max(200),
    code: z.string().trim().max(40).nullish()
  }),
  address: z.string().trim().min(1).max(300),
  phone: z.string().trim().max(300).nullish(),
  comment: z.string().trim().max(2e3).nullish(),
  invoices: z.array(onecInvoiceSchema).max(10).default([])
});
var onecBaseSchema = z.object({
  key: z.string().trim().min(1).max(64),
  label: z.string().trim().max(120).nullish()
});
var onecInstallationsImportSchema = z.object({
  from: calendarDaySchema,
  to: calendarDaySchema,
  base: onecBaseSchema,
  rows: z.array(onecInstallationSchema).max(2e3),
  /**
   * Часть записей окна не прочиталась: отсутствие записи значит «не
   * прочиталась», а не «сняли», — и CRM по такому ответу ничего не снимает
   */
  partial: z.boolean().optional()
}).strict().refine((v) => v.from < v.to, "\u041E\u043A\u043D\u043E \u043E\u0431\u043C\u0435\u043D\u0430 \u043F\u0443\u0441\u0442\u043E\u0435: \xAB\u0441\xBB \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0440\u0430\u043D\u044C\u0448\u0435 \xAB\u043F\u043E\xBB");

// src/day-sheet-import.ts
import { z as z2 } from "zod";
var daySheetParseSchema = z2.object({
  fileName: z2.string().trim().max(255).default("\u043B\u0438\u0441\u0442.docx"),
  /** Файл .docx в base64 — лист на день весит десятки килобайт */
  data: z2.string().min(1, "\u0424\u0430\u0439\u043B \u043F\u0443\u0441\u0442\u043E\u0439").max(4e6, "\u0424\u0430\u0439\u043B \u0431\u043E\u043B\u044C\u0448\u0435 \u0442\u0440\u0451\u0445 \u043C\u0435\u0433\u0430\u0431\u0430\u0439\u0442 \u2014 \u044D\u0442\u043E \u043D\u0435 \u043B\u0438\u0441\u0442 \u043D\u0430 \u0434\u0435\u043D\u044C")
}).strict();
var sheetWorkSchema = z2.object({
  name: z2.string().trim().min(1).max(200),
  qty: z2.coerce.number().min(0).max(1e5),
  unit: z2.string().trim().max(20).default("")
});
var daySheetApplySchema = z2.object({
  day: z2.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0435\u043D\u044C \u0432 \u0432\u0438\u0434\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414"),
  visits: z2.array(
    z2.object({
      uid: z2.string().trim().regex(/^manual-\d{8}-[A-Za-z0-9-]{1,48}$/, "\u041A\u043B\u044E\u0447 \u0432\u044B\u0435\u0437\u0434\u0430 \u043B\u0438\u0441\u0442\u0430: manual-<\u0434\u0435\u043D\u044C>-<\u043D\u043E\u043C\u0435\u0440>"),
      base: z2.string().trim().min(1).max(64),
      time: z2.string().regex(/^\d{2}:\d{2}$/, "\u0412\u0440\u0435\u043C\u044F \u0432 \u0432\u0438\u0434\u0435 \u0427\u0427:\u041C\u041C"),
      address: z2.string().trim().min(1, "\u0410\u0434\u0440\u0435\u0441 \u043F\u0443\u0441\u0442\u043E\u0439").max(300),
      customer: z2.string().trim().min(1, "\u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043D\u0435 \u043D\u0430\u0437\u0432\u0430\u043D").max(200),
      phones: z2.array(z2.string().trim().max(20)).max(5).default([]),
      comment: z2.string().trim().max(2e3).default(""),
      works: z2.array(sheetWorkSchema).max(300).default([]),
      brigadeId: z2.string().trim().min(1).nullable(),
      crewUserIds: z2.array(z2.string().trim().min(1)).max(10).default([]),
      /** Перенести этот выезд другого дня сюда, а не заводить новый (правило 79) */
      moveFromId: z2.string().trim().min(1).max(64).optional()
    }).strict()
  ).min(1, "\u041E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441").max(200)
}).strict();

// src/history.ts
import { z as z3 } from "zod";
var HISTORY_KINDS = ["lines", "pay"];
var historyBaseKeySchema = z3.string().trim().regex(/^[A-Za-z0-9_.-]{2,20}$/, "\u041A\u043B\u044E\u0447 \u0431\u0430\u0437\u044B 1\u0421");
var historyMonthSchema = z3.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, "\u041C\u0435\u0441\u044F\u0446 \u0413\u0413\u0413\u0413-\u041C\u041C");
var historySpanSchema = z3.object({
  base: historyBaseKeySchema,
  label: z3.string().trim().min(1).max(80),
  /** День первого и последнего заказа покупателя; пусто — заказов нет */
  linesFrom: z3.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  linesTo: z3.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  payFrom: z3.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  payTo: z3.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable()
}).strict();
var historyPartSchema = z3.object({
  sliceId: z3.string().min(1).max(64),
  base: historyBaseKeySchema,
  kind: z3.enum(HISTORY_KINDS),
  month: historyMonthSchema,
  part: z3.number().int().min(0).max(199),
  parts: z3.number().int().min(1).max(200),
  asOf: z3.string().min(10).refine((s) => !Number.isNaN(new Date(s).getTime()), "\u0414\u0430\u0442\u0430 \u0432\u044B\u0431\u043E\u0440\u043A\u0438 \u043D\u0435 \u0440\u0430\u0437\u043E\u0431\u0440\u0430\u043B\u0430\u0441\u044C"),
  rows: z3.array(z3.record(z3.unknown())).max(2e4)
}).strict();
function monthsBetween(fromDay, toDay) {
  const out = [];
  let y = Number(fromDay.slice(0, 4));
  let m = Number(fromDay.slice(5, 7));
  const ty = Number(toDay.slice(0, 4));
  const tm = Number(toDay.slice(5, 7));
  if (!y || !m || !ty || !tm) return out;
  while (y < ty || y === ty && m <= tm) {
    out.push(`${y}-${String(m).padStart(2, "0")}`);
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
    if (out.length > 600) break;
  }
  return out;
}
function monthWindow(month) {
  const y = Number(month.slice(0, 4));
  const m = Number(month.slice(5, 7));
  const ny = m === 12 ? y + 1 : y;
  const nm = m === 12 ? 1 : m + 1;
  return { from: `${month}-01`, to: `${ny}-${String(nm).padStart(2, "0")}-01` };
}
var FRESH_MONTHS = 3;
var FRESH_EVERY_MS = 6 * 36e5;
var OLD_EVERY_MS = 30 * 24 * 36e5;
function historyPlan(spans, loaded, now, limit = 8) {
  const today = now.toISOString().slice(0, 10);
  const freshFrom = monthsBetween(
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - (FRESH_MONTHS - 1), 1)).toISOString().slice(0, 10),
    today
  )[0];
  const at = new Map(loaded.map((l) => [`${l.base}|${l.kind}|${l.month}`, l.loadedAt.getTime()]));
  const missing = [];
  const stale = [];
  for (const s of spans) {
    for (const kind of HISTORY_KINDS) {
      const from = kind === "lines" ? s.linesFrom : s.payFrom;
      const last = kind === "lines" ? s.linesTo : s.payTo;
      if (!from || !last) continue;
      const to = last >= freshFrom ? today : last;
      for (const month of monthsBetween(from, to)) {
        const w = { base: s.base, kind, month, ...monthWindow(month), rank: -Number(month.replace("-", "")) };
        const t = at.get(`${s.base}|${kind}|${month}`);
        if (t === void 0) missing.push(w);
        else if (now.getTime() - t > (month >= freshFrom ? FRESH_EVERY_MS : OLD_EVERY_MS)) stale.push(w);
      }
    }
  }
  const byRank = (a, b) => a.rank - b.rank || a.base.localeCompare(b.base);
  return [...missing.sort(byRank), ...stale.sort(byRank)].slice(0, limit).map(({ rank: _rank, ...w }) => w);
}
function historySearchText(parts) {
  return parts.map((p) => (p ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/[^a-zа-я0-9]+/g, " ").trim()).filter(Boolean).join(" ").slice(0, 700);
}

// src/day-sheet-text.ts
var SHEET_COMMENT_MARKER = "\u041F\u043E \u043B\u0438\u0441\u0442\u0443 \u043E\u0442\u0434\u0435\u043B\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430";
function isSheetComment(notes) {
  return !!notes && notes.includes(SHEET_COMMENT_MARKER);
}
function looksLikeSheetTime(text3) {
  const t = text3.replace(/^[•*·▪\s/]+/, "").trim();
  if (!t || t.length > 80) return false;
  if (/^(?:строго\s+)?(?:(?:к|до|с|в|около|не\s+позже)\s*)?\d{1,2}[.:]\d{2}(?!\d)/i.test(t)) return true;
  return /^(?:с\s*утра|сутра|утром|ближе\s+к|после(?![а-яё])|вечер(?:ом)?(?![а-яё])|днём|днем|до\s+обеда|в\s+течени|созв|соз-ся|чем\s+раньше)/i.test(
    t
  );
}
var ABBREVIATIONS = /* @__PURE__ */ new Set(["\u0443\u043B", "\u043A\u0432", "\u0442\u0435\u043B", "\u043F\u0440", "\u043F\u0435\u0440", "\u043A\u043E\u0440\u043F", "\u0441\u0442\u0440", "\u043C\u043A\u0440", "\u043E\u0431\u043B", "\u043F\u043E\u0441", "\u0438\u043C", "\u044D\u0442", "\u0434\u0435\u0440", "\u043F\u0440-\u0442", "\u0440-\u043D"]);
function keepsSentence(before) {
  const word = (/(\S+)$/.exec(before)?.[1] ?? "").replace(/^[(«"„]+/, "");
  const last = word.split(".").pop() ?? "";
  return /^[A-Za-zА-Яа-яЁё]$/.test(last) || ABBREVIATIONS.has(last.toLowerCase());
}
function splitSheetNotes(text3) {
  const out = [];
  for (const line2 of text3.split(/\r?\n/)) {
    let start = 0;
    const re = /[.!?](?=\s+(?:[А-ЯЁA-Z0-9«"„•*]|[Дд]оплат))/g;
    let m;
    while ((m = re.exec(line2)) !== null) {
      if (m[0] === "." && keepsSentence(line2.slice(start, m.index))) continue;
      out.push(line2.slice(start, m.index + 1));
      start = m.index + 1;
    }
    out.push(line2.slice(start));
  }
  return out.map((s) => s.replace(/^[\s.,;]+/, "").trim()).filter((s) => /[A-Za-zА-Яа-яЁё0-9]/.test(s));
}
function sheetCommentParts(comment) {
  let text3 = (comment ?? "").trim();
  const marker = text3.indexOf(SHEET_COMMENT_MARKER);
  if (marker >= 0) {
    text3 = text3.slice(0, marker);
    const crew = text3.lastIndexOf("\u0415\u0434\u0443\u0442:");
    if (crew >= 0 && (crew === 0 || /\s/.test(text3[crew - 1]))) text3 = text3.slice(0, crew);
  }
  text3 = text3.trim();
  let timeText = null;
  const stop = text3.search(/\.(?:\s|$)/);
  const head = (stop >= 0 ? text3.slice(0, stop) : text3).trim();
  if (looksLikeSheetTime(head)) {
    timeText = head;
    text3 = stop >= 0 ? text3.slice(stop + 1) : "";
  }
  return { timeText, notes: splitSheetNotes(text3) };
}
var INTERNAL_NOTE_RE = /(?<![A-Za-zА-Яа-яЁё0-9])(?:(?:инфо\s+)?для\s+(?:ОД|СО|КЦ|отдела\s+документов|документов|отдела\s+сервиса|сервис[а-яё]*(?:\s+отдел[а-яё]*)?|офиса|бухгалтер[а-яё]*|себя|нас)|инфо\s+для\s+[^:!?\n]{1,40}?)\s*:/i;
function cutInternalNote(text3) {
  let rest = text3 ?? "";
  const internal = [];
  for (let guard = 0; guard < 20; guard++) {
    const m = INTERNAL_NOTE_RE.exec(rest);
    if (!m) break;
    const start = m.index;
    const stops = [rest.indexOf(SHEET_COMMENT_MARKER, start)];
    const crew = /(?:^|\s)Едут:/.exec(rest.slice(start + m[0].length));
    if (crew) stops.push(start + m[0].length + crew.index);
    const end = Math.min(...stops.filter((i) => i > start), rest.length);
    const part = rest.slice(start, end).trim();
    if (part) internal.push(part);
    const before = rest.slice(0, start).trimEnd();
    const after = rest.slice(end).trimStart();
    const gap = /\n/.test(rest.slice(before.length, start) + rest.slice(end, rest.length - after.length)) ? "\n" : " ";
    rest = before && after ? `${before}${gap}${after}` : before || after;
  }
  return { text: rest, internal: internal.length ? internal.join("\n") : null };
}
function sheetStageNote(comment) {
  const { notes } = sheetCommentParts(cutInternalNote(comment).text);
  const hit = notes.find((n) => /^\d\s*этап(?![а-яё])/i.test(n));
  if (!hit) return null;
  let t = hit.replace(/[.!\s]+$/, "").replace(/\s*[–—]\s*/g, " - ").replace(/\s+/g, " ").trim();
  t = /[а-яё]/.test(t) ? t.replace(/ЭТАП/g, "\u044D\u0442\u0430\u043F") : t.toLowerCase();
  return t.slice(0, 200) || null;
}
function isSheetMoney(text3) {
  return /^\s*доплат/i.test(text3);
}
function sheetMoneySplit(text3) {
  const comma = text3.search(/,(?!\d)|(?<!\d),/);
  const open = text3.indexOf("(");
  let end;
  if (open >= 0 && (comma < 0 || open < comma)) {
    const close = text3.indexOf(")", open);
    end = close >= 0 ? close + 1 : text3.length;
  } else if (comma >= 0) {
    end = comma;
  } else {
    end = text3.replace(/[.\s]+$/, "").length;
  }
  return { bold: text3.slice(0, end), rest: text3.slice(end) };
}
function sheetPhone(raw) {
  const trimmed = (raw ?? "").trim();
  if (!trimmed) return null;
  const normalized = normalizePhone(trimmed);
  if (!normalized) return trimmed;
  if (normalized.startsWith("+7000")) return null;
  const d = normalized.slice(2);
  return `8-${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`;
}
var PHONE_IN_TEXT = /(?<!\d)(?:\+7|8|7)(?:[\s().-]*\d){10}(?!\d)/g;
function sheetPhones(raws) {
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const add = (phone) => {
    if (!phone) return;
    const key = normalizePhone(phone) ?? phone;
    if (seen.has(key)) return;
    seen.add(key);
    out.push(phone);
  };
  for (const raw of raws) {
    for (const piece of (raw ?? "").split(/[/\\;]+/)) {
      const found = piece.match(PHONE_IN_TEXT);
      if (found?.length) for (const f of found) add(sheetPhone(f));
      else add(sheetPhone(piece.replace(/^[\s,]+|[\s,]+$/g, "")));
    }
  }
  return out;
}

// src/act-works.ts
var LETTER = /[A-Za-zА-Яа-яЁё]/;
function pastedQuantity(raw) {
  const s = raw.replace(/\s/g, "").replace(",", ".");
  if (!/^\d+(\.\d+)?$/.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}
function splitPastedRows(text3) {
  const rows = [];
  let row = [];
  let cell = "";
  let i = 0;
  const endCell = () => {
    row.push(cell);
    cell = "";
  };
  const endRow = () => {
    endCell();
    rows.push(row);
    row = [];
  };
  while (i < text3.length) {
    const ch = text3[i];
    if (cell === "" && ch === '"') {
      const close = quotedEnd(text3, i);
      if (close !== -1) {
        cell = text3.slice(i + 1, close).replace(/""/g, '"');
        i = close + 1;
        continue;
      }
    }
    if (ch === "	") {
      endCell();
    } else if (ch === "\r" || ch === "\n") {
      endRow();
      if (ch === "\r" && text3[i + 1] === "\n") i++;
    } else {
      cell += ch;
    }
    i++;
  }
  if (cell !== "" || row.length > 0) endRow();
  return rows;
}
function quotedEnd(text3, start) {
  let i = start + 1;
  while (i < text3.length) {
    if (text3[i] === '"') {
      if (text3[i + 1] === '"') {
        i += 2;
        continue;
      }
      const next = text3[i + 1];
      return next === void 0 || next === "	" || next === "\r" || next === "\n" ? i : -1;
    }
    i++;
  }
  return -1;
}
var QTY_WITH_UNIT = /^(\d[\d\s]*(?:[.,]\d+)?)\s*([A-Za-zА-Яа-яЁё].*)$/;
function workOfCells(raw) {
  let cells = raw.map((c) => c.replace(/[\r\n\t]+/g, " ").trim()).filter((c) => c !== "");
  if (cells.length >= 3 && /^\d{1,4}\.?$/.test(cells[0]) && LETTER.test(cells[1])) cells = cells.slice(1);
  if (cells.length < 2 || !LETTER.test(cells[0])) return null;
  for (let at = 1; at < cells.length; at++) {
    const qty = pastedQuantity(cells[at]);
    if (qty !== null) {
      const next = cells[at + 1];
      const unit2 = next && LETTER.test(next) && pastedQuantity(next) === null ? next : "";
      return { name: cells.slice(0, at).join(" "), quantity: qty, unit: unit2 };
    }
    const joined = QTY_WITH_UNIT.exec(cells[at]);
    const qtyJoined = joined ? pastedQuantity(joined[1]) : null;
    if (joined && qtyJoined !== null) {
      return { name: cells.slice(0, at).join(" "), quantity: qtyJoined, unit: joined[2].trim() };
    }
  }
  return null;
}
var SPACED_LINE = /^(?:\d{1,4}[.)]?\s+(?=[A-ZА-ЯЁ"«]))?(.*?\S)\s+(\d{1,3}(?:[^\S \t]\d{3})+(?:[.,]\d+)?|\d+(?:[.,]\d+)?)\s+([A-Za-zА-Яа-яЁё]\S*)\s*$/;
function workOfLine(line2) {
  const m = SPACED_LINE.exec(line2.trim());
  if (!m || !LETTER.test(m[1])) return null;
  const qty = pastedQuantity(m[2]);
  if (qty === null) return null;
  return { name: m[1].trim(), quantity: qty, unit: m[3] };
}
var HEADER = /^(№|наименование|работа|кол-?во|количество|ед\.?|изм\.?|\s)+$/i;
function parsePastedWorks(text3) {
  const works = [];
  const skipped = [];
  for (const row of splitPastedRows(text3)) {
    const filled = row.map((c) => c.trim()).filter((c) => c !== "");
    if (filled.length === 0) continue;
    const work = filled.length === 1 ? workOfLine(filled[0]) : workOfCells(row);
    if (work) {
      works.push(work);
      continue;
    }
    const shown = filled.join(" ");
    if (LETTER.test(shown) && !HEADER.test(shown)) skipped.push(shown);
  }
  return { works, skipped };
}

// src/calc/deal-total.ts
function calcLineTotal(item) {
  return roundMoney(roundQuantity(item.quantity).times(toDecimal(item.unitPrice)));
}
function calcLineCost(item) {
  if (item.costPrice === null || item.costPrice === void 0) return new Decimal(0);
  return roundMoney(roundQuantity(item.quantity).times(toDecimal(item.costPrice)));
}
function calcDealTotals(input) {
  const lines = input.items.map((item) => ({
    lineTotal: calcLineTotal(item),
    lineCost: calcLineCost(item)
  }));
  const itemsTotal = roundMoney(
    lines.reduce((acc, l) => acc.plus(l.lineTotal), new Decimal(0))
  );
  const costTotal = roundMoney(
    lines.reduce((acc, l) => acc.plus(l.lineCost), new Decimal(0))
  );
  const discountValue = clampMoney(input.discountValue ?? 0, 0, itemsTotal);
  const totalAmount = roundMoney(itemsTotal.minus(discountValue));
  const prepayment = clampMoney(input.prepayment ?? 0, 0, totalAmount);
  const rooms = input.rooms ?? [];
  const totalAreaSqm = roundQuantity(
    rooms.reduce((acc, r) => acc.plus(toDecimal(r.areaSqm)), new Decimal(0))
  );
  const totalPerimeterM = roundQuantity(
    rooms.reduce((acc, r) => acc.plus(toDecimal(r.perimeterM)), new Decimal(0))
  );
  return {
    itemsTotal,
    discountValue,
    totalAmount,
    costTotal,
    margin: roundMoney(totalAmount.minus(costTotal)),
    prepayment,
    balanceDue: roundMoney(totalAmount.minus(prepayment)),
    lines,
    totalAreaSqm,
    totalPerimeterM,
    roomsCount: rooms.length
  };
}
function discountPercentToValue(itemsTotal, percent) {
  const pct3 = clampMoney(percent, 0, 100);
  return roundMoney(toDecimal(itemsTotal).times(pct3).dividedBy(100));
}
function discountValueToPercent(itemsTotal, value) {
  const base = toDecimal(itemsTotal);
  if (base.isZero()) return new Decimal(0);
  return toDecimal(value).times(100).dividedBy(base).toDecimalPlaces(2);
}

// src/calc/payroll.ts
function asDate(value) {
  return value instanceof Date ? value : new Date(value);
}
function localDayStart(value) {
  const d = asDate(value);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}
function isRuleEffective(rule, date) {
  if (rule.isActive === false) return false;
  const d = localDayStart(date);
  if (Number.isNaN(d)) return false;
  if (localDayStart(rule.validFrom) > d) return false;
  if (rule.validTo) {
    const to = localDayStart(rule.validTo);
    if (!Number.isNaN(to) && d >= to) return false;
  }
  return true;
}
function selectApplicableRules(rules, ctx) {
  return rules.filter((r) => r.target === ctx.target).filter((r) => isRuleEffective(r, ctx.effectiveDate)).filter((r) => !r.categoryId || r.categoryId === ctx.categoryId).filter((r) => ctx.dealWon || r.basis === PayrollBasis.FIXED_PER_VISIT).sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
}
function quantityForPriceItem(items, priceItemId) {
  return items.filter((i) => i.priceItemId === priceItemId).reduce((acc, i) => acc.plus(roundQuantity(i.quantity)), new Decimal(0));
}
function calcPayroll(rules, ctx) {
  const applicable = selectApplicableRules(rules, ctx);
  const lines = [];
  let total = new Decimal(0);
  for (const rule of applicable) {
    const value = toDecimal(rule.value);
    let raw = new Decimal(0);
    let base = new Decimal(0);
    let explanation = "";
    switch (rule.basis) {
      case PayrollBasis.PERCENT_OF_DEAL: {
        base = ctx.totals.totalAmount;
        raw = percentOf(base, value);
        explanation = `${value.toString()}% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B \u0441\u0434\u0435\u043B\u043A\u0438 ${base.toFixed(2)} \u20BD`;
        break;
      }
      case PayrollBasis.PERCENT_OF_MARGIN: {
        base = ctx.totals.margin;
        raw = percentOf(base, value);
        explanation = `${value.toString()}% \u043E\u0442 \u043C\u0430\u0440\u0436\u0438 ${base.toFixed(2)} \u20BD`;
        break;
      }
      case PayrollBasis.RATE_PER_UNIT: {
        if (!rule.priceItemId) {
          lines.push({
            ruleId: rule.id,
            ruleName: rule.name,
            basis: rule.basis,
            value: value.toString(),
            base: "0",
            amount: "0.00",
            explanation: "\u041F\u0440\u0430\u0432\u0438\u043B\u043E \u043D\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u043E: \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0438\u044F \u043F\u0440\u0430\u0439\u0441\u0430"
          });
          continue;
        }
        base = quantityForPriceItem(ctx.items, rule.priceItemId);
        raw = base.times(value);
        explanation = `${base.toString()} \xD7 ${value.toString()} \u20BD \u0437\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443`;
        break;
      }
      case PayrollBasis.FIXED_PER_DEAL: {
        base = value;
        raw = value;
        explanation = `\u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0441\u0434\u0435\u043B\u043A\u0443 ${value.toFixed(2)} \u20BD`;
        break;
      }
      case PayrollBasis.FIXED_PER_VISIT: {
        base = value;
        raw = value;
        explanation = `\u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0432\u044B\u0435\u0437\u0434 ${value.toFixed(2)} \u20BD`;
        break;
      }
      default: {
        continue;
      }
    }
    const clamped = roundMoney(clampMoney(raw, rule.minAmount ?? 0, rule.maxAmount));
    const bounded = clamped.isNegative() ? new Decimal(0) : clamped;
    if (!bounded.equals(roundMoney(raw))) {
      explanation += ` (\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E \u043F\u0440\u0430\u0432\u0438\u043B\u043E\u043C: ${bounded.toFixed(2)} \u20BD)`;
    }
    total = total.plus(bounded);
    lines.push({
      ruleId: rule.id,
      ruleName: rule.name,
      basis: rule.basis,
      value: value.toString(),
      base: base.toString(),
      amount: bounded.toFixed(2),
      explanation
    });
  }
  return {
    target: ctx.target,
    amount: roundMoney(total),
    lines,
    hasNoRules: applicable.length === 0
  };
}
function splitAmountByShares(amount, parts) {
  const total = roundMoney(amount);
  if (parts.length === 0) return [];
  const shares = parts.map((p) => {
    const s = toDecimal(p.share);
    return s.isPositive() ? s : new Decimal(0);
  });
  const sharesSum = shares.reduce((acc, s) => acc.plus(s), new Decimal(0));
  const effective = sharesSum.isZero() ? parts.map(() => new Decimal(1)) : shares;
  const effectiveSum = sharesSum.isZero() ? new Decimal(parts.length) : sharesSum;
  const sign = total.isNegative() ? new Decimal(-1) : new Decimal(1);
  const abs = total.abs();
  const kop = new Decimal("0.01");
  const exact = parts.map((_, i) => abs.times(effective[i] ?? new Decimal(0)).dividedBy(effectiveSum));
  const out = parts.map((p, i) => ({
    key: p.key,
    share: effective[i] ?? new Decimal(0),
    amount: (exact[i] ?? new Decimal(0)).dividedBy(kop).floor().times(kop)
  }));
  const spare = abs.minus(out.reduce((acc, p) => acc.plus(p.amount), new Decimal(0))).dividedBy(kop).toDecimalPlaces(0, Decimal.ROUND_HALF_UP).toNumber();
  const queue = out.map((p, i) => ({ i, tail: (exact[i] ?? new Decimal(0)).minus(p.amount), share: p.share })).sort((a, b) => b.tail.comparedTo(a.tail) || b.share.comparedTo(a.share) || a.i - b.i);
  for (let k = 0; k < spare && k < queue.length; k++) {
    const target = out[queue[k].i];
    target.amount = target.amount.plus(kop);
  }
  for (const p of out) p.amount = roundMoney(p.amount.times(sign));
  return out;
}
function splitBrigadeAmount(amount, members) {
  return splitAmountByShares(
    amount,
    members.map((m) => ({ key: m, share: m.share }))
  ).map((part) => ({
    userId: part.key.userId,
    fullName: part.key.fullName,
    share: part.share.toString(),
    amount: part.amount
  }));
}

// src/calc/taxes.ts
var DEFAULT_NDFL_PERCENT = 13;
var DEFAULT_CONTRIBUTIONS_PERCENT = 30;
function percentOf2(base, percent) {
  if (!percent || percent <= 0) return new Decimal(0);
  return base.times(percent).dividedBy(100).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}
function calcTaxes(taxableBase, rates = {}) {
  const base = toDecimal(taxableBase);
  const safeBase = base.isNegative() ? new Decimal(0) : base;
  const ndfl = percentOf2(safeBase, rates.ndflPercent ?? DEFAULT_NDFL_PERCENT);
  const contributions = percentOf2(
    safeBase,
    rates.contributionsPercent ?? DEFAULT_CONTRIBUTIONS_PERCENT
  );
  return {
    taxableBase: safeBase,
    ndfl,
    contributions,
    netFromTaxable: safeBase.minus(ndfl),
    employerCost: safeBase.plus(contributions)
  };
}
function grossUpFromNet(net, ndflPercent = DEFAULT_NDFL_PERCENT) {
  const target = toDecimal(net);
  if (ndflPercent <= 0 || ndflPercent >= 100) return target;
  return target.dividedBy(new Decimal(1).minus(new Decimal(ndflPercent).dividedBy(100))).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}

// src/calc/salary.ts
function asDate2(value) {
  return value instanceof Date ? value : new Date(value);
}
function monthStart(value) {
  const d = asDate2(value);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1));
}
function localMonthStart(moment) {
  return new Date(Date.UTC(moment.getFullYear(), moment.getMonth(), 1));
}
function monthEnd(value) {
  const d = asDate2(value);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1));
}
function daysInMonth(value) {
  const d = asDate2(value);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
}
function formatMonth(value) {
  return asDate2(value).toLocaleDateString("ru-RU", {
    month: "long",
    year: "numeric",
    timeZone: "UTC"
  });
}
function salaryForMonth(rules, month) {
  const target = monthStart(month).getTime();
  const applicable = rules.filter((rule) => {
    const from = monthStart(rule.validFrom).getTime();
    if (from > target) return false;
    if (rule.validTo) {
      const to = monthStart(rule.validTo).getTime();
      if (target > to) return false;
    }
    return true;
  });
  if (applicable.length === 0) return null;
  return applicable.reduce(
    (latest, rule) => monthStart(rule.validFrom).getTime() >= monthStart(latest.validFrom).getTime() ? rule : latest
  );
}
function calcMonthlyPayroll(input) {
  const days = daysInMonth(input.month);
  const rule = salaryForMonth(input.salaryRules, input.month);
  const salaryFull = rule ? roundMoney(toDecimal(rule.amount)) : new Decimal(0);
  const absence = Math.min(Math.max(input.absenceDays ?? 0, 0), days);
  const worked = days - absence;
  const salary = absence === 0 ? salaryFull : roundMoney(salaryFull.times(worked).dividedBy(days));
  const piecework = roundMoney(
    input.pieceworkAmounts.reduce(
      (acc, amount) => acc.plus(toDecimal(amount)),
      new Decimal(0)
    )
  );
  const gross = roundMoney(salary.plus(piecework));
  let positive = new Decimal(0);
  let refunds = new Decimal(0);
  for (const amount of input.deductions ?? []) {
    const d = toDecimal(amount);
    if (d.isNegative()) refunds = refunds.plus(d);
    else positive = positive.plus(d);
  }
  positive = roundMoney(positive);
  refunds = roundMoney(refunds);
  const ndfl = input.ndflPercent === void 0 ? new Decimal(0) : calcTaxes(salary, { ndflPercent: input.ndflPercent }).ndfl;
  const payable = roundMoney(gross.minus(ndfl));
  const limit = payable.lessThan(0) ? new Decimal(0) : payable;
  const deducted = roundMoney((positive.greaterThan(limit) ? limit : positive).plus(refunds));
  return {
    salary,
    salaryFull,
    piecework,
    gross,
    deducted,
    total: roundMoney(gross.minus(deducted)),
    daysInMonth: days,
    absenceDays: absence
  };
}

// src/calc/shift-deductions.ts
function ruleDayKey(value) {
  const d = value instanceof Date ? value : new Date(value);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
function shiftsWord(n) {
  const tail = n % 100;
  if (tail >= 11 && tail <= 14) return "\u0441\u043C\u0435\u043D";
  const last = n % 10;
  if (last === 1) return "\u0441\u043C\u0435\u043D\u0430";
  if (last >= 2 && last <= 4) return "\u0441\u043C\u0435\u043D\u044B";
  return "\u0441\u043C\u0435\u043D";
}
function rubles(value) {
  const fixed = value.toFixed(2);
  const plain = fixed.endsWith(".00") ? fixed.slice(0, -3) : fixed.replace(".", ",");
  return plain.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
function planShiftDeductions(rules, people) {
  const plan = [];
  for (const rule of rules) {
    const perShift = toDecimal(rule.amount);
    if (perShift.lte(0)) continue;
    const from = ruleDayKey(rule.validFrom);
    const to = rule.validTo ? ruleDayKey(rule.validTo) : null;
    for (const person of people) {
      if (rule.userId && rule.userId !== person.userId) continue;
      const shifts = new Set(person.days.filter((d) => d >= from && (to === null || d < to))).size;
      if (shifts === 0) continue;
      const amount = roundMoney(perShift.times(shifts));
      plan.push({
        ruleId: rule.id,
        userId: person.userId,
        shifts,
        amount,
        reason: `${rule.title}: ${rubles(roundMoney(perShift))} \u20BD \xD7 ${shifts} ${shiftsWord(shifts)}`
      });
    }
  }
  return plan;
}

// src/calc/payments.ts
function calcSettlement(totalAmount, payments) {
  const total = roundMoney(toDecimal(totalAmount));
  const paid = roundMoney(
    payments.reduce((acc, p) => acc.plus(toDecimal(p.amount)), new Decimal(0))
  );
  const difference = total.minus(paid);
  const balanceDue = difference.greaterThan(0) ? roundMoney(difference) : new Decimal(0);
  const overpaid = difference.lessThan(0) ? roundMoney(difference.negated()) : new Decimal(0);
  return {
    totalAmount: total,
    paidAmount: paid,
    balanceDue,
    overpaid,
    // Ноль тоже считается закрытым: сделка на 0 ₽ бывает при полной скидке
    settled: balanceDue.isZero(),
    paymentsCount: payments.length
  };
}

// src/calc/payment-plan.ts
function toDate(value) {
  if (value === null || value === void 0) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}
function buildPaymentPlan(items, totalPaid, totalAmount, now = /* @__PURE__ */ new Date()) {
  const paid = roundMoney(totalPaid);
  let pool = paid;
  let planned = new Decimal(0);
  const statuses = items.map((item) => {
    const amount = roundMoney(item.amount);
    planned = planned.plus(amount);
    const available = pool.greaterThan(0) ? pool : new Decimal(0);
    const taken = Decimal.min(amount, available);
    pool = pool.minus(taken);
    const remaining = roundMoney(amount.minus(taken));
    const dueAt = toDate(item.dueAt);
    const state = remaining.isZero() ? "paid" : taken.greaterThan(0) ? "partial" : "pending";
    return {
      label: item.label,
      amount,
      dueAt,
      covered: roundMoney(taken),
      remaining,
      state,
      // Событийный взнос (без даты) просрочить нельзя: у него нет срока.
      overdue: dueAt !== null && dueAt.getTime() < now.getTime() && state !== "paid"
    };
  });
  planned = roundMoney(planned);
  const total = roundMoney(totalAmount);
  return {
    items: statuses,
    planned,
    paid,
    unallocated: pool.greaterThan(0) ? roundMoney(pool) : new Decimal(0),
    matchesTotal: planned.equals(total),
    nextDue: statuses.find((s) => s.state !== "paid") ?? null
  };
}
var PAYMENT_PLAN_TEMPLATES = [
  {
    key: "30-40-30",
    title: "30 / 40 / 30",
    parts: [
      { label: "\u041F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u0437\u0430\u043C\u0435\u0440\u0435", percent: 30 },
      { label: "\u041F\u0435\u0440\u0435\u0434 \u043C\u043E\u043D\u0442\u0430\u0436\u043E\u043C", percent: 40 },
      { label: "\u041F\u0440\u0438 \u0441\u0434\u0430\u0447\u0435 \u0440\u0430\u0431\u043E\u0442", percent: 30 }
    ]
  },
  {
    key: "50-50",
    title: "50 / 50",
    parts: [
      { label: "\u041F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u0437\u0430\u043C\u0435\u0440\u0435", percent: 50 },
      { label: "\u041F\u0440\u0438 \u0441\u0434\u0430\u0447\u0435 \u0440\u0430\u0431\u043E\u0442", percent: 50 }
    ]
  },
  {
    key: "full-on-done",
    title: "100% \u043F\u043E \u0444\u0430\u043A\u0442\u0443",
    parts: [{ label: "\u041F\u0440\u0438 \u0441\u0434\u0430\u0447\u0435 \u0440\u0430\u0431\u043E\u0442", percent: 100 }]
  }
];
function planFromTemplate(template, totalAmount) {
  const total = roundMoney(totalAmount);
  const parts = template.parts;
  let allocated = new Decimal(0);
  return parts.map((part, i) => {
    const isLast = i === parts.length - 1;
    const amount = isLast ? roundMoney(total.minus(allocated)) : roundMoney(total.times(part.percent).dividedBy(100));
    allocated = allocated.plus(amount);
    return { label: part.label, amount: amount.toFixed(2) };
  });
}
function sumPlanItems(items) {
  return roundMoney(
    items.reduce((acc, it) => acc.plus(toDecimal(it.amount)), new Decimal(0))
  );
}

// src/calc/sketch-grouping.ts
function meanPoint(numbers) {
  const n = numbers.length || 1;
  return {
    x: Math.round(numbers.reduce((acc, p) => acc + p.x, 0) / n),
    y: Math.round(numbers.reduce((acc, p) => acc + p.y, 0) / n)
  };
}
var MIN_SIDE_CM = 50;
var MAX_SIDE_CM = 1500;
var MIN_LOOSE_SIDE_CM = 100;
var MAX_LOOSE_SIDE_CM = 999;
function isLooseSideCandidate(value) {
  return value >= MIN_LOOSE_SIDE_CM && value <= MAX_LOOSE_SIDE_CM;
}
var AREA_TOLERANCE = 0.03;
var MAX_ASPECT = 5;
function areaReadings(value) {
  return Number.isInteger(value) ? [value / 100] : [value];
}
var MIN_AREA_SQM = 1;
var MAX_AREA_SQM = 60;
function isSideCandidate(value) {
  return value >= MIN_SIDE_CM && value <= MAX_SIDE_CM;
}
function isAreaCandidate(value) {
  return areaReadings(value).some((a) => a >= MIN_AREA_SQM && a <= MAX_AREA_SQM);
}
function isGeometryCandidate(value) {
  return isSideCandidate(value) || isAreaCandidate(value);
}
function splitColumns(numbers) {
  if (numbers.length < 4) return [numbers];
  const sorted = [...numbers].sort((a, b) => a.x - b.x);
  const gaps = sorted.slice(1).map((n, i) => ({ gap: n.x - sorted[i].x, at: i + 1 }));
  if (gaps.length === 0) return [numbers];
  const median2 = [...gaps].sort((a, b) => a.gap - b.gap)[Math.floor(gaps.length / 2)].gap;
  const widest = gaps.reduce((best, g) => g.gap > best.gap ? g : best, gaps[0]);
  const isRealSplit = widest.gap > Math.max(median2 * 5, 120);
  if (!isRealSplit) return [numbers];
  return [sorted.slice(0, widest.at), sorted.slice(widest.at)];
}
function matchTriple(numbers) {
  const sides = numbers.filter((n) => isSideCandidate(n.value));
  let best = null;
  let bestSpread = Infinity;
  const spreadOf = (pts) => {
    let sum = 0;
    for (let m = 0; m < pts.length; m++)
      for (let k = m + 1; k < pts.length; k++)
        sum += Math.hypot(pts[m].x - pts[k].x, pts[m].y - pts[k].y);
    return sum;
  };
  for (let i = 0; i < sides.length; i++) {
    for (let j = i + 1; j < sides.length; j++) {
      const a = sides[i].value;
      const b = sides[j].value;
      const product = a * b / 1e4;
      for (const third of numbers) {
        const other = third.value;
        if (other === a || other === b) continue;
        if (third === sides[i] || third === sides[j]) continue;
        for (const area of areaReadings(other)) {
          if (area <= 0) continue;
          if (Math.abs(product - area) / area <= AREA_TOLERANCE) {
            const long = Math.max(a, b);
            const short = Math.min(a, b);
            const stretched = long / short > MAX_ASPECT;
            const spread = spreadOf([sides[i], sides[j], third]);
            const penalty = stretched ? spread * 3 + 1e6 : spread;
            if (penalty < bestSpread) {
              bestSpread = penalty;
              best = {
                sideACm: long,
                sideBCm: short,
                areaSqm: Number(area.toFixed(2)),
                source: [a, b, other],
                used: [sides[i], sides[j], third],
                at: meanPoint([sides[i], sides[j], third]),
                problem: stretched ? `\u043A\u043E\u043C\u043D\u0430\u0442\u0430 ${(long / 100).toFixed(2)} x ${(short / 100).toFixed(2)} \u043C \u2014 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0442\u044F\u043D\u0443\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0440\u044B` : null
              };
            }
          }
        }
      }
    }
  }
  return best;
}
function readCluster(cluster) {
  const values = cluster.map((n) => n.value);
  const matched = matchTriple(cluster);
  if (matched) return matched;
  const sides = values.filter((v) => isLooseSideCandidate(v));
  if (sides.length < 2) return null;
  const a = Math.max(sides[0], sides[1]);
  const b = Math.min(sides[0], sides[1]);
  return {
    sideACm: a,
    sideBCm: b,
    areaSqm: null,
    source: values,
    at: meanPoint(cluster),
    problem: values.length > 2 ? "\u043D\u0438 \u043E\u0434\u043D\u0430 \u043F\u0430\u0440\u0430 \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432 \u043D\u0435 \u0434\u0430\u0451\u0442 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u0443\u044E \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u2014 \u0446\u0438\u0444\u0440\u0430 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0430 \u043D\u0435\u0432\u0435\u0440\u043D\u043E" : "\u043F\u043B\u043E\u0449\u0430\u0434\u044C \u043D\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0430 \u2014 \u0441\u0432\u0435\u0440\u0438\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u043D\u0435 \u0441 \u0447\u0435\u043C"
  };
}
function readSketchNumbers(numbers) {
  const rooms = collectRooms(numbers);
  const anyVerified = rooms.some((room) => room.areaSqm !== null);
  return anyVerified ? rooms : [];
}
function collectVerifiedTriples(candidates2, compactPx) {
  const dist2 = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const triples = [];
  for (let i = 0; i < candidates2.length; i++) {
    for (let j = i + 1; j < candidates2.length; j++) {
      const A = candidates2[i];
      const B2 = candidates2[j];
      if (!isSideCandidate(A.value) || !isSideCandidate(B2.value)) continue;
      const product = A.value * B2.value / 1e4;
      for (const third of candidates2) {
        if (third === A || third === B2) continue;
        for (const area of areaReadings(third.value)) {
          if (area < MIN_AREA_SQM || area > MAX_AREA_SQM) continue;
          if (Math.abs(product - area) / area > AREA_TOLERANCE) continue;
          const pts = [A, B2, third];
          const spread = dist2(A, B2) + dist2(A, third) + dist2(B2, third);
          if (Math.max(dist2(A, B2), dist2(A, third), dist2(B2, third)) > compactPx) continue;
          const long = Math.max(A.value, B2.value);
          const short = Math.min(A.value, B2.value);
          const stretched = long / short > MAX_ASPECT;
          triples.push({
            pts,
            // Вытянутая пара уступает любой нормальной: произведение у
            // неё сошлось скорее случайно
            spread: stretched ? spread * 3 + 1e6 : spread,
            room: {
              sideACm: long,
              sideBCm: short,
              areaSqm: Number(area.toFixed(2)),
              source: [A.value, B2.value, third.value],
              at: meanPoint(pts),
              problem: stretched ? `\u043A\u043E\u043C\u043D\u0430\u0442\u0430 ${(long / 100).toFixed(2)} x ${(short / 100).toFixed(2)} \u043C \u2014 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0442\u044F\u043D\u0443\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0440\u044B` : null
            }
          });
        }
      }
    }
  }
  triples.sort((a, b) => a.spread - b.spread);
  const used = /* @__PURE__ */ new Set();
  const items = [];
  for (const t of triples) {
    if (t.pts.some((pt) => used.has(pt))) continue;
    t.pts.forEach((pt) => used.add(pt));
    items.push({ room: t.room, pts: t.pts });
  }
  return { items, used };
}
function collectRooms(numbers) {
  const rooms = [];
  const candidatesAll = numbers.filter((n) => isGeometryCandidate(n.value));
  const spanX = Math.max(...candidatesAll.map((n) => n.x), 0) - Math.min(...candidatesAll.map((n) => n.x), 0);
  const spanY = Math.max(...candidatesAll.map((n) => n.y), 0) - Math.min(...candidatesAll.map((n) => n.y), 0);
  const roomsOnSheet = candidatesAll.length <= 6 ? Math.max(1, Math.ceil(candidatesAll.length / 3)) : 4;
  const compactPx = Math.hypot(spanX, spanY) / roomsOnSheet;
  const dist2 = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const isCompact = (pts) => pts.every((a) => pts.every((b) => dist2(a, b) <= compactPx));
  const verified = collectVerifiedTriples(candidatesAll, compactPx);
  const placed = /* @__PURE__ */ new Set();
  for (const column of splitColumns(numbers)) {
    const columnSet = new Set(column);
    const mine = verified.items.filter((v) => !placed.has(v) && v.pts.every((pt) => columnSet.has(pt))).sort((a, b) => (a.room.at?.y ?? 0) - (b.room.at?.y ?? 0));
    mine.forEach((v) => placed.add(v));
    rooms.push(...mine.map((v) => v.room));
    const queue = [...column].filter((n) => isGeometryCandidate(n.value) && !verified.used.has(n)).sort((p, q) => p.y === q.y ? p.x - q.x : p.y - q.y);
    while (queue.length >= 2) {
      const head = queue.slice(0, 3);
      const sides = head.slice(1).filter((n) => isLooseSideCandidate(n.value));
      if (sides.length === 2 && isCompact(head)) {
        rooms.push({
          sideACm: Math.max(sides[0].value, sides[1].value),
          sideBCm: Math.min(sides[0].value, sides[1].value),
          areaSqm: null,
          source: head.map((n) => n.value),
          at: meanPoint(head),
          problem: "\u043D\u0438 \u043E\u0434\u043D\u0430 \u043F\u0430\u0440\u0430 \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432 \u043D\u0435 \u0434\u0430\u0451\u0442 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u0443\u044E \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u2014 \u0446\u0438\u0444\u0440\u0430 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0430 \u043D\u0435\u0432\u0435\u0440\u043D\u043E"
        });
        queue.splice(0, 3);
      } else if (isLooseSideCandidate(queue[0].value) && isLooseSideCandidate(queue[1].value) && isCompact([queue[0], queue[1]])) {
        rooms.push({
          sideACm: Math.max(queue[0].value, queue[1].value),
          sideBCm: Math.min(queue[0].value, queue[1].value),
          areaSqm: null,
          source: [queue[0].value, queue[1].value],
          at: meanPoint([queue[0], queue[1]]),
          problem: "\u043F\u043B\u043E\u0449\u0430\u0434\u044C \u043D\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0430 \u2014 \u0441\u0432\u0435\u0440\u0438\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u043D\u0435 \u0441 \u0447\u0435\u043C"
        });
        queue.splice(0, 2);
      } else {
        queue.splice(0, 1);
      }
    }
  }
  for (const v of verified.items) if (!placed.has(v)) rooms.push(v.room);
  return rooms;
}
function guessToWalls(guess) {
  const a = Math.round(guess.sideACm * 10);
  const b = Math.round(guess.sideBCm * 10);
  return [
    { lengthMm: a, turnDeg: 90 },
    { lengthMm: b, turnDeg: 90 },
    { lengthMm: a, turnDeg: 90 },
    { lengthMm: b, turnDeg: 90 }
  ];
}

// src/calc/sketch-outline.ts
var MIN_SIDE_CM2 = 50;
var MAX_SIDE_CM2 = 2e3;
var MIN_CHAIN_SIDE_CM = 10;
var MAX_WALLS = 12;
var CLOSURE_TOLERANCE_CM = 3;
function isSide(value) {
  return Number.isInteger(value) && value >= MIN_SIDE_CM2 && value <= MAX_SIDE_CM2;
}
function isChainSide(value) {
  return Number.isInteger(value) && value >= MIN_CHAIN_SIDE_CM && value <= MAX_SIDE_CM2;
}
function readOutlineSketch(numbers) {
  const sides = numbers.filter((n2) => isSide(n2.value));
  if (sides.length < 4 || sides.length > MAX_WALLS) return null;
  const cx2 = sides.reduce((s, n2) => s + n2.x, 0) / sides.length;
  const cy2 = sides.reduce((s, n2) => s + n2.y, 0) / sides.length;
  const ordered = [...sides].sort(
    (a, b) => Math.atan2(a.y - cy2, a.x - cx2) - Math.atan2(b.y - cy2, b.x - cx2)
  );
  const lengths = ordered.map((n2) => n2.value);
  const n = lengths.length;
  if (n % 2 !== 0) return null;
  let best = null;
  let bestScore = -Infinity;
  for (let startHorizontal = 0; startHorizontal < 2; startHorizontal++) {
    for (let mask = 0; mask < 1 << n; mask++) {
      let x = 0;
      let y = 0;
      const walls = [];
      for (let i = 0; i < n; i++) {
        const horizontal = i % 2 === 0 === (startHorizontal === 1);
        const sign = mask >> i & 1 ? 1 : -1;
        const len = lengths[i];
        const dx = horizontal ? sign * len : 0;
        const dy = horizontal ? 0 : sign * len;
        x += dx;
        y += dy;
        walls.push({ lengthCm: len, dx, dy });
      }
      if (Math.abs(x) > CLOSURE_TOLERANCE_CM || Math.abs(y) > CLOSURE_TOLERANCE_CM) continue;
      const points = [];
      let px = 0;
      let py = 0;
      for (const w of walls) {
        points.push({ x: px, y: py });
        px += w.dx;
        py += w.dy;
      }
      if (selfIntersects(points)) continue;
      const area = Math.abs(polygonArea(points)) / 1e4;
      if (area < 1 || area > 200) continue;
      const mids = walls.map((w, i) => {
        let mx = 0;
        let my = 0;
        for (let k = 0; k < i; k++) {
          mx += walls[k].dx;
          my += walls[k].dy;
        }
        return { x: mx + w.dx / 2, y: my + w.dy / 2 };
      });
      const fit = -shapeDistance(mids, ordered);
      const score = fit;
      if (score > bestScore) {
        bestScore = score;
        best = {
          walls,
          areaSqm: Number(area.toFixed(2)),
          perimeterM: Number((lengths.reduce((a, b) => a + b, 0) / 100).toFixed(2)),
          used: lengths
        };
      }
    }
  }
  return best;
}
function shapeDistance(a, b) {
  const norm2 = (pts) => {
    const cx2 = pts.reduce((s, p) => s + p.x, 0) / pts.length;
    const cy2 = pts.reduce((s, p) => s + p.y, 0) / pts.length;
    const shifted = pts.map((p) => ({ x: p.x - cx2, y: p.y - cy2 }));
    const radius = shifted.reduce((s, p) => s + Math.hypot(p.x, p.y), 0) / shifted.length || 1;
    return shifted.map((p) => ({ x: p.x / radius, y: p.y / radius }));
  };
  const na = norm2(a);
  const nb = norm2(b);
  let sum = 0;
  for (let i = 0; i < na.length; i++) {
    sum += Math.hypot(na[i].x - nb[i].x, na[i].y - nb[i].y) ** 2;
  }
  return sum;
}
function polygonArea(points) {
  let sum = 0;
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    sum += a.x * b.y - b.x * a.y;
  }
  return sum / 2;
}
function selfIntersects(points) {
  const n = points.length;
  const cross = (a1, a2, b1, b2) => {
    const d = (p, q, r) => (q.x - p.x) * (r.y - p.y) - (q.y - p.y) * (r.x - p.x);
    const d1 = d(b1, b2, a1);
    const d2 = d(b1, b2, a2);
    const d3 = d(a1, a2, b1);
    const d4 = d(a1, a2, b2);
    return (d1 > 0 && d2 < 0 || d1 < 0 && d2 > 0) && (d3 > 0 && d4 < 0 || d3 < 0 && d4 > 0);
  };
  for (let i = 0; i < n; i++) {
    for (let j = i + 2; j < n; j++) {
      if (i === 0 && j === n - 1) continue;
      if (cross(points[i], points[(i + 1) % n], points[j], points[(j + 1) % n])) return true;
    }
  }
  return false;
}
function outlineToWalls(guess) {
  const n = guess.walls.length;
  return guess.walls.map((w, i) => {
    const next = guess.walls[(i + 1) % n];
    const heading2 = Math.atan2(-w.dy, w.dx);
    const nextHeading = Math.atan2(-next.dy, next.dx);
    let turn2 = (nextHeading - heading2) * 180 / Math.PI;
    if (turn2 > 180) turn2 -= 360;
    if (turn2 <= -180) turn2 += 360;
    return { lengthMm: w.lengthCm * 10, turnDeg: Math.round(turn2) };
  });
}
function suggestOutlineFix(numbers) {
  const sides = numbers.filter((n) => isSide(n.value));
  if (sides.length < 4 || sides.length > MAX_WALLS || sides.length % 2 !== 0) return null;
  if (readOutlineSketch(numbers)) return null;
  const cx2 = sides.reduce((s, n) => s + n.x, 0) / sides.length;
  const cy2 = sides.reduce((s, n) => s + n.y, 0) / sides.length;
  const ordered = [...sides].sort(
    (a, b) => Math.atan2(a.y - cy2, a.x - cx2) - Math.atan2(b.y - cy2, b.x - cx2)
  );
  let best = null;
  let bestCost = Infinity;
  for (let i = 0; i < ordered.length; i++) {
    for (const candidate of candidatesFor(ordered, i)) {
      const patched = ordered.map((n, k) => k === i ? { ...n, value: candidate } : n);
      if (!readOutlineSketch(patched)) continue;
      const read = String(ordered[i].value);
      const fixed = String(candidate);
      const edits = editDistance(read, fixed);
      if (edits === 0 || edits > 2) continue;
      const cost = edits * 100 + Math.abs(read.length - fixed.length) * 10 + Math.min(9, Math.abs(candidate - ordered[i].value) / 100);
      if (cost < bestCost) {
        bestCost = cost;
        best = { index: i, readCm: ordered[i].value, shouldBeCm: candidate };
      }
    }
  }
  return best;
}
function editDistance(a, b) {
  const prev = Array.from({ length: b.length + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i++) {
    let diagonal = prev[0];
    prev[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const current = prev[j];
      prev[j] = Math.min(
        prev[j] + 1,
        prev[j - 1] + 1,
        diagonal + (a[i - 1] === b[j - 1] ? 0 : 1)
      );
      diagonal = current;
    }
  }
  return prev[b.length];
}
function candidatesFor(ordered, index) {
  const out = /* @__PURE__ */ new Set();
  const n = ordered.length;
  for (let startHorizontal = 0; startHorizontal < 2; startHorizontal++) {
    for (let mask = 0; mask < 1 << n; mask++) {
      let x = 0;
      let y = 0;
      let sign = 1;
      let horizontalAtIndex = false;
      for (let i = 0; i < n; i++) {
        const horizontal = i % 2 === 0 === (startHorizontal === 1);
        const s = mask >> i & 1 ? 1 : -1;
        if (i === index) {
          sign = s;
          horizontalAtIndex = horizontal;
          continue;
        }
        const len = ordered[i].value;
        if (horizontal) x += s * len;
        else y += s * len;
      }
      const need = horizontalAtIndex ? -x : -y;
      const other = horizontalAtIndex ? y : x;
      if (Math.abs(other) > CLOSURE_TOLERANCE_CM) continue;
      const value = Math.round(need / sign);
      if (isSide(value)) out.add(value);
    }
  }
  return [...out];
}
function chainToContour(lengthsCm) {
  const n = lengthsCm.length;
  if (n < 4 || n > MAX_WALLS || n % 2 !== 0) return null;
  if (lengthsCm.some((l) => !isChainSide(l))) return null;
  let best = null;
  for (let startHorizontal = 0; startHorizontal < 2; startHorizontal++) {
    for (let mask = 0; mask < 1 << n; mask++) {
      let x = 0;
      let y = 0;
      const walls = [];
      for (let i = 0; i < n; i++) {
        const horizontal = i % 2 === 0 === (startHorizontal === 1);
        const sign = mask >> i & 1 ? 1 : -1;
        const len = lengthsCm[i];
        const dx = horizontal ? sign * len : 0;
        const dy = horizontal ? 0 : sign * len;
        x += dx;
        y += dy;
        walls.push({ lengthCm: len, dx, dy });
      }
      if (Math.abs(x) > CLOSURE_TOLERANCE_CM || Math.abs(y) > CLOSURE_TOLERANCE_CM) continue;
      const points = [];
      let px = 0;
      let py = 0;
      for (const w of walls) {
        points.push({ x: px, y: py });
        px += w.dx;
        py += w.dy;
      }
      if (selfIntersects(points)) continue;
      const area = Math.abs(polygonArea(points)) / 1e4;
      if (area < 1 || area > 200) continue;
      if (!best || area > best.area) best = { walls, area };
    }
  }
  if (!best) return null;
  const guess = {
    walls: best.walls,
    areaSqm: Number(best.area.toFixed(2)),
    perimeterM: Number((lengthsCm.reduce((a, b) => a + b, 0) / 100).toFixed(2)),
    used: lengthsCm
  };
  return {
    walls: outlineToWalls(guess),
    areaSqm: guess.areaSqm,
    perimeterM: guess.perimeterM
  };
}
function parseLengthChain(text3) {
  return text3.split(/[\s,;x×*]+/).map((part) => Number(part.replace(",", "."))).filter((value) => Number.isFinite(value) && value > 0).map((value) => Math.round(value));
}

// src/calc/sheet-place.ts
var HINT_PERI_CM = 2;
var HINT_AREA_FRAC = 0.03;
var HINT_AREA_SQM = 0.06;
var HINT_WEIGHT = 0.9;
var BAND_PX = 130;
var BAND_FRAC = 0.25;
var ALONG = [-0.2, 1.2];
var CLOSE_CM = 5;
var CLOSE_FRAC = 0.01;
var SLANT_FRAC = 0.15;
var MAX_CANDS = 4;
var SCALE_SPAN = 3.5;
var INSIDE_PENALTY = 3;
var MAX_COMBOS = 3e5;
var REF_SIDE = 1600;
var AXIS = {
  R: [1, 0],
  L: [-1, 0],
  D: [0, 1],
  U: [0, -1]
};
function wallCmOf(value) {
  if (!Number.isFinite(value) || !Number.isInteger(value)) return null;
  return value >= 10 && value <= 1500 ? value : null;
}
function inside(poly, p) {
  let hit = false;
  const n = poly.length;
  for (let i = 0; i < n; i++) {
    const a = poly[i];
    const b = poly[(i + 1) % n];
    if (a.y > p.y !== b.y > p.y && p.x < a.x + (b.x - a.x) * (p.y - a.y) / (b.y - a.y)) {
      hit = !hit;
    }
  }
  return hit;
}
function segDist(p, a, b) {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const l2 = dx * dx + dy * dy;
  if (l2 === 0) return { d: Math.hypot(p.x - a.x, p.y - a.y), t: 0 };
  const t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / l2;
  const tc = Math.min(1, Math.max(0, t));
  return { d: Math.hypot(p.x - (a.x + dx * tc), p.y - (a.y + dy * tc)), t };
}
function wallsOf(poly) {
  const n = poly.length;
  const raw = poly.map((a, i) => {
    const b = poly[(i + 1) % n];
    return { a, b, px: Math.hypot(b.x - a.x, b.y - a.y), ang: Math.atan2(b.y - a.y, b.x - a.x) };
  });
  const folded = raw.map((w) => ({ a: ((w.ang * 180 / Math.PI + 45) % 90 + 90) % 90 - 45, l: w.px })).sort((p, q) => p.a - q.a);
  const half = folded.reduce((s, f) => s + f.l, 0) / 2;
  let acc = 0;
  let skewDeg = folded[folded.length - 1]?.a ?? 0;
  for (const f of folded) {
    acc += f.l;
    if (acc >= half) {
      skewDeg = f.a;
      break;
    }
  }
  return raw.map((w) => {
    const rel = w.ang * 180 / Math.PI - skewDeg;
    const norm2 = ((rel + 180) % 360 + 360) % 360 - 180;
    let letter = "S";
    for (const [name, ang] of [
      ["R", 0],
      ["D", 90],
      ["L", 180],
      ["L", -180],
      ["U", -90]
    ]) {
      if (Math.abs(norm2 - ang) <= 22) letter = name;
    }
    const dir = letter === "S" ? [Math.cos(norm2 * Math.PI / 180), Math.sin(norm2 * Math.PI / 180)] : AXIS[letter];
    return { a: w.a, b: w.b, px: w.px, letter, dir, near: [], opts: [], scale: null };
  });
}
function candidates(poly, numbers, frameSide) {
  const walls = wallsOf(poly);
  const k = frameSide / REF_SIDE;
  numbers.forEach((num4, id) => {
    const cm = wallCmOf(num4.value);
    if (cm === null) return;
    const within = inside(poly, num4);
    for (const w of walls) {
      const { d, t } = segDist(num4, w.a, w.b);
      const band = Math.max(BAND_PX * k, BAND_FRAC * w.px);
      if (d <= band && t >= ALONG[0] && t <= ALONG[1]) {
        w.near.push({ cm, d: d * (within ? INSIDE_PENALTY : 1), t, id });
      }
    }
  });
  const scales = walls.filter((w) => w.near.length > 0).map((w) => w.near.reduce((m, c) => c.d < m.d ? c : m).cm / Math.max(1, w.px)).sort((p, q) => p - q);
  const scale = scales.length ? scales[Math.floor(scales.length / 2)] : null;
  for (const w of walls) {
    w.scale = scale;
    const near3 = [...w.near].sort((p, q) => p.d - q.d).filter((c) => {
      if (scale === null) return true;
      const r = c.cm / Math.max(1, w.px) / scale;
      return r >= 1 / SCALE_SPAN && r <= SCALE_SPAN;
    }).slice(0, MAX_CANDS);
    const opts = near3.map((c) => ({ cm: c.cm, d: c.d, parts: [c.cm], ids: [c.id] }));
    const byT = [...near3].sort((p, q) => p.t - q.t);
    for (let i = 0; i < byT.length; i++) {
      for (let j = i + 1; j < byT.length; j++) {
        if (byT[j].t - byT[i].t < 0.2) continue;
        opts.push({
          cm: byT[i].cm + byT[j].cm,
          d: Math.max(byT[i].d, byT[j].d),
          parts: [byT[i].cm, byT[j].cm],
          ids: [byT[i].id, byT[j].id]
        });
        for (let m = j + 1; m < byT.length; m++) {
          if (byT[m].t - byT[j].t < 0.2) continue;
          opts.push({
            cm: byT[i].cm + byT[j].cm + byT[m].cm,
            d: Math.max(byT[i].d, byT[j].d, byT[m].d),
            parts: [byT[i].cm, byT[j].cm, byT[m].cm],
            ids: [byT[i].id, byT[j].id, byT[m].id]
          });
        }
      }
    }
    const seen = /* @__PURE__ */ new Map();
    for (const o of opts) {
      const prev = seen.get(o.cm);
      if (!prev || o.d < prev.d) seen.set(o.cm, o);
    }
    w.opts = [...seen.values()].sort((p, q) => p.d - q.d);
  }
  return walls;
}
function plausible(w, cm) {
  if (cm <= 0) return false;
  if (w.scale === null || w.scale <= 0) return true;
  const r = cm / Math.max(1, w.px) / w.scale;
  return r >= 1 / SCALE_SPAN && r <= SCALE_SPAN;
}
function residual(cms, walls, perimeters = []) {
  const slanted = walls.some((w) => w.letter === "S");
  const derived = /* @__PURE__ */ new Map();
  if (!slanted) {
    let res = 0;
    const axes = [
      ["R", "L"],
      ["D", "U"]
    ].map(([plus, minus]) => {
      const idx = walls.map((w, i2) => i2).filter((i2) => walls[i2].letter === plus || walls[i2].letter === minus);
      const miss = idx.filter((i2) => cms[i2] === null);
      const total = idx.reduce(
        (s, i2) => cms[i2] === null ? s : s + (walls[i2].letter === plus ? cms[i2] : -cms[i2]),
        0
      );
      return { plus, idx, miss, total };
    });
    if (axes.some((a) => a.miss.length > 2)) return null;
    const twice = axes.filter((a) => a.miss.length === 2);
    if (twice.length > 1 || twice.length === 1 && perimeters.length === 0) return null;
    for (const a of axes) {
      if (a.miss.length === 1) {
        const i2 = a.miss[0];
        const cm = walls[i2].letter === a.plus ? -a.total : a.total;
        if (!plausible(walls[i2], cm)) return null;
        derived.set(i2, Math.round(cm));
      } else if (a.miss.length === 0) {
        res += Math.abs(a.total);
      }
    }
    if (twice.length === 1) {
      const a = twice[0];
      const [i2, j] = a.miss;
      const iPlus = walls[i2].letter === a.plus;
      if (iPlus === (walls[j].letter === a.plus)) return null;
      const [p, m] = iPlus ? [i2, j] : [j, i2];
      let known = 0;
      cms.forEach((c, k) => {
        known += c ?? derived.get(k) ?? 0;
      });
      for (const peri of perimeters) {
        const rest = peri - known;
        const pm = (rest - a.total) / 2;
        const pp = pm - a.total;
        if (pp > 0 && pm > 0 && plausible(walls[p], pp) && plausible(walls[m], pm)) {
          derived.set(p, Math.round(pp));
          derived.set(m, Math.round(pm));
          return { res, derived, byPerimeter: true };
        }
      }
      return null;
    }
    return { res, derived };
  }
  const unknown = cms.map((c, i2) => c === null ? i2 : -1).filter((i2) => i2 >= 0);
  if (unknown.length > 1) return null;
  let rx = 0;
  let ry = 0;
  cms.forEach((c, i2) => {
    if (c === null) return;
    rx += c * walls[i2].dir[0];
    ry += c * walls[i2].dir[1];
  });
  if (unknown.length === 0) return { res: Math.hypot(rx, ry), derived };
  const i = unknown[0];
  const [ux, uy] = walls[i].dir;
  const along = -(rx * ux + ry * uy);
  if (!plausible(walls[i], along)) return null;
  derived.set(i, Math.round(along));
  return { res: Math.hypot(rx + along * ux, ry + along * uy), derived };
}
var VARIANTS = /* @__PURE__ */ new Map();
function digitVariants(value) {
  return [...variantsOf(value)];
}
function variantsOf(value) {
  const known = VARIANTS.get(value);
  if (known) return known;
  const digits = String(value).split("");
  const out = /* @__PURE__ */ new Set();
  digits.forEach((ch, i) => {
    for (let d = 0; d <= 9; d++) {
      if (String(d) === ch || i === 0 && d === 0) continue;
      out.add(Number([...digits.slice(0, i), String(d), ...digits.slice(i + 1)].join("")));
    }
    if (digits.length > 2) out.add(Number([...digits.slice(0, i), ...digits.slice(i + 1)].join("")));
  });
  const list = [...out].filter((v) => v >= 10 && v <= 1500);
  if (VARIANTS.size < 2e4) VARIANTS.set(value, list);
  return list;
}
function findFixes(walls, derived, fixTol, memo) {
  const fixes = /* @__PURE__ */ new Map();
  for (const [i, cm] of derived) {
    const memoKey = `${i}|${cm}|${fixTol}`;
    const known = memo?.get(memoKey);
    if (known !== void 0) {
      if (known) fixes.set(i, known);
      continue;
    }
    const near3 = [...walls[i].near].sort((p, q) => p.t - q.t);
    let best = null;
    const consider = (combo) => {
      combo.forEach((part, at) => {
        const rest = combo.reduce((s, c) => s + c.cm, 0) - part.cm;
        for (const v of variantsOf(part.cm)) {
          const err = Math.abs(rest + v - cm);
          if (err > fixTol) continue;
          const rank = [Math.round(err), -combo.length, err];
          if (!best || rank[0] < best.rank[0] || rank[0] === best.rank[0] && (rank[1] < best.rank[1] || rank[1] === best.rank[1] && rank[2] < best.rank[2])) {
            best = {
              rank,
              fix: { read: part.cm, likely: v, parts: combo.map((c) => c.cm), at, ids: combo.map((c) => c.id) }
            };
          }
        }
      });
    };
    for (const c of near3) consider([c]);
    for (let p = 0; p < near3.length; p++) {
      for (let q = p + 1; q < near3.length; q++) {
        if (near3[q].t - near3[p].t >= 0.2) consider([near3[p], near3[q]]);
      }
    }
    const fix = best ? best.fix : null;
    memo?.set(memoKey, fix);
    if (fix) fixes.set(i, fix);
  }
  return fixes;
}
function placeSheetNumbers(polygon, numbers, frame, hints) {
  if (polygon.length < 3) return null;
  const frameSide = frame ? Math.max(frame.width, frame.height, 1) : Math.max(...polygon.map((p) => Math.max(p.x, p.y)), ...numbers.map((n) => Math.max(n.x, n.y)), 1);
  const walls = candidates(polygon, numbers, frameSide);
  if (!walls.some((w) => w.opts.length > 0)) return null;
  const periGuess = walls.reduce((s, w) => s + (w.opts[0]?.cm ?? 0), 0) || 1;
  const sizesOf = (cms, derived) => {
    let peri = 0;
    let slant = 0;
    for (let i = 0; i < walls.length; i++) {
      const cm = cms[i] ?? derived.get(i) ?? 0;
      peri += cm;
      if (walls[i].letter === "S") slant += cm;
    }
    return { peri: peri || periGuess, slant };
  };
  const tolOf = (cms, derived) => {
    const { peri, slant } = sizesOf(cms, derived);
    return CLOSE_CM + CLOSE_FRAC * peri + SLANT_FRAC * slant;
  };
  const nearIds = /* @__PURE__ */ new Set();
  for (const w of walls) for (const c of w.near) nearIds.add(c.id);
  const choices = walls.map((w) => [null, ...w.opts]);
  const periHints = (hints?.perimeterCm ?? []).filter((v) => v > 0);
  const areaHints = (hints?.areaSqm ?? []).filter((v) => v > 0);
  const hinted = periHints.length > 0 || areaHints.length > 0;
  const checkOf = (cms, derived) => {
    let x = 0;
    let y = 0;
    let twice = 0;
    let peri = 0;
    for (let i = 0; i < walls.length; i++) {
      const cm = cms[i] ?? derived.get(i);
      if (cm == null) return { perimeter: false, area: false };
      const [dx, dy] = walls[i].dir;
      const nx = x + dx * cm;
      const ny = y + dy * cm;
      twice += x * ny - nx * y;
      x = nx;
      y = ny;
      peri += cm;
    }
    const sqm = Math.abs(twice) / 2 / 1e4;
    return {
      perimeter: periHints.some((v) => Math.abs(v - peri) <= HINT_PERI_CM),
      area: areaHints.some((v) => Math.abs(v - sqm) <= Math.max(HINT_AREA_SQM, v * HINT_AREA_FRAC))
    };
  };
  const found = { best: null };
  let combos = 0;
  const pick2 = new Array(walls.length).fill(null);
  const used = /* @__PURE__ */ new Set();
  const better = (a, b2) => {
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b2[i]) return a[i] > b2[i];
    }
    return false;
  };
  const fixMemo = /* @__PURE__ */ new Map();
  const evaluate = () => {
    combos++;
    const cms = pick2.map((o) => o ? o.cm : null);
    const filled = cms.filter((c) => c !== null).length;
    if (filled === 0) return;
    const r = residual(cms, walls, periHints);
    if (!r || r.res > tolOf(cms, r.derived)) return;
    const fixTol = CLOSE_CM + SLANT_FRAC * sizesOf(cms, r.derived).slant;
    const fixes = findFixes(walls, r.derived, fixTol, fixMemo);
    const taken = new Set(used);
    for (const f of fixes.values()) for (const id of f.ids) taken.add(id);
    for (const i of r.derived.keys()) {
      if (walls[i].opts.some((o) => o.parts.length === 1 && o.ids.some((id) => !taken.has(id)))) return;
    }
    let unexplained = 0;
    for (const id of nearIds) if (!taken.has(id)) unexplained++;
    const dist2 = pick2.reduce((s, o) => s + (o ? o.d : 0), 0);
    const checked = hinted ? checkOf(cms, r.derived) : { perimeter: false, area: false };
    if (r.byPerimeter) checked.perimeter = false;
    const score = filled + HINT_WEIGHT * ((checked.perimeter ? 1 : 0) + (checked.area ? 1 : 0));
    const key = [score, fixes.size, -unexplained, -dist2];
    if (!found.best || better(key, found.best.key)) {
      found.best = { key, checked, byPerimeter: !!r.byPerimeter, cms, combo: [...pick2], derived: r.derived, fixes, res: r.res };
    }
  };
  const walk = (i) => {
    if (combos > MAX_COMBOS) return;
    if (i === walls.length) {
      evaluate();
      return;
    }
    for (const o of choices[i]) {
      if (o && o.ids.some((id) => used.has(id))) continue;
      pick2[i] = o;
      if (o) for (const id of o.ids) used.add(id);
      walk(i + 1);
      if (o) for (const id of o.ids) used.delete(id);
      pick2[i] = null;
    }
  };
  walk(0);
  if (!found.best) return null;
  const b = found.best;
  const placed = walls.map((w, i) => {
    const o = b.combo[i];
    if (o) {
      const ids = o.ids.map((id) => numbers[id]?.recognitionId).filter((x) => !!x);
      return { cm: o.cm, source: "sheet", parts: o.parts, recognitionIds: ids, fix: null };
    }
    const fix = b.fixes.get(i);
    if (fix) {
      const { ids: _ids, ...rest } = fix;
      return { cm: null, source: null, parts: [], recognitionIds: [], fix: rest };
    }
    const d = b.derived.get(i);
    if (d !== void 0) return { cm: d, source: "derived", parts: [], recognitionIds: [], fix: null };
    return { cm: null, source: null, parts: [], recognitionIds: [], fix: null };
  });
  return {
    walls: placed,
    letters: walls.map((w) => w.letter),
    residualCm: Math.round(b.res),
    // допуск показывается ТОТ, которым судили взятый набор
    toleranceCm: Math.round(tolOf(b.cms, b.derived)),
    fromSheet: placed.filter((w) => w.source === "sheet").length,
    derived: placed.filter((w) => w.source === "derived").length,
    ...hinted ? { checked: b.checked } : {},
    ...b.byPerimeter ? { byPerimeter: true } : {}
  };
}

// src/calc/sheet-rooms.ts
var LABEL_RADIUS = 0.35;
var LABEL_NEAREST = 3;
var MIN_PERIMETER_M = 2;
var BAND_FRAC2 = 0.09;
var BAND_MIN_WALL = 0.03;
var BOX_RADIUS = 0.2;
var LOOK_ALIKE = {
  g: "9",
  q: "9",
  l: "1",
  I: "1",
  i: "1",
  "|": "1",
  O: "0",
  o: "0",
  \u041E: "0",
  \u043E: "0",
  B: "8",
  \u0412: "8",
  Z: "2",
  z: "2",
  b: "6",
  \u0431: "6",
  G: "6",
  T: "7",
  \u0422: "7"
};
var center = (w) => ({ x: (w.x0 + w.x1) / 2, y: (w.y0 + w.y1) / 2 });
function sheetWallNumbers(words) {
  const out = [];
  for (const wd of words) {
    const t = wd.text.trim().replace(/[.,]+$/, "");
    if (!/^[0-9A-Za-zА-Яа-я|]{2,4}$/u.test(t) || !/\d/.test(t)) continue;
    const digits = [...t].map((c) => /\d/.test(c) ? c : LOOK_ALIKE[c] ?? null);
    if (digits.some((c) => c === null)) continue;
    out.push({ value: Number(digits.join("")), ...center(wd) });
  }
  return out;
}
function sheetLabels(words) {
  const out = [];
  for (const wd of words) {
    const t = wd.text.replace(/\s+/g, "");
    let letter = null;
    let raw = "";
    let rest = "";
    const head = /^([SsСсЅ5$CcPpРрRr])([.\-:,·~=]?)(\d{1,3}(?:[.,]\d{1,2})?)/u.exec(t);
    if (head && !(head[1] === "5" && !head[2])) {
      letter = head[1];
      raw = head[3];
      rest = t.slice(head[0].length);
      if (/[PpРрRr]/u.test(letter) && /^\d{3}$/.test(raw) && /^\d(?!\d)/.test(rest)) {
        raw += rest[0];
        rest = rest.slice(1);
      }
    } else {
      const glued = /[^A-Za-zА-Яа-я]([SsСсPpРр])[.\-:,·~=](\d{1,2}[.,]\d{1,2})/u.exec(t);
      if (glued) {
        letter = glued[1];
        raw = glued[2];
        rest = t.slice(glued.index + glued[0].length);
      }
    }
    if (!letter) continue;
    const kind = /[PpРрRr]/u.test(letter) ? "P" : "S";
    const num4 = raw.replace(",", ".");
    const v = Number(num4);
    const dec = num4.includes(".") ? num4.split(".")[1].length : 0;
    let values;
    if (num4.includes(".")) {
      values = /^\d/.test(rest) && dec === 2 ? [{ v, dec }, { v: Math.trunc(v * 10) / 10, dec: 1 }] : [{ v, dec }];
    } else if (num4.length === 4) {
      values = [{ v: v / 100, dec: 2 }].filter((x) => x.v <= 80);
    } else {
      values = [
        { v, dec: 0 },
        { v: v / 10, dec: 1 },
        { v: v / 100, dec: 2 }
      ].filter((x) => x.v >= 0.3 && x.v <= 80);
    }
    out.push({ kind, text: wd.text, values, tail: /^\d/.test(rest), ...center(wd) });
  }
  return out;
}
var perimeterTol = (dec) => dec >= 2 ? 5e-3 : 0.065;
var exactPerimeter = (l, perimeterM) => l.values.some((q) => q.dec >= 2 && Math.abs(perimeterM - q.v) < 5e-3);
var exactArea = (l, areaSqm) => l.values.some((q) => q.dec >= 2 && Math.abs(areaSqm - q.v) <= 0.0101);
var areaTol = (v, dec) => Math.max(dec >= 2 ? 0.06 : 0.08, v * 0.03);
function boxOf(poly) {
  const xs = poly.map((p) => p.x);
  const ys = poly.map((p) => p.y);
  return [Math.min(...xs), Math.min(...ys), Math.max(...xs), Math.max(...ys)];
}
function distToBox(p, b) {
  const dx = Math.max(b[0] - p.x, 0, p.x - b[2]);
  const dy = Math.max(b[1] - p.y, 0, p.y - b[3]);
  return Math.hypot(dx, dy);
}
function sheetAnswerWords(text3, at) {
  if (!text3.trim() || text3.trim().startsWith("ERROR")) return [];
  return text3.trim().split(/\s+/).map((t) => ({ text: t, x0: at.x0, y0: at.y0, x1: at.x1, y1: at.y1 }));
}
var AXIS2 = { R: [1, 0], L: [-1, 0], D: [0, 1], U: [0, -1] };
function readSheetRooms(input) {
  return traceSheetRooms(input).read;
}
function traceSheetRooms(input) {
  const { width: w, height: h } = input;
  const crops = input.crops ?? [];
  const sources = [
    ...input.words.map((word, k) => ({ word, origin: `ocr:${k}` })),
    ...crops.flatMap((c, i) => c.kind === "box" ? sheetAnswerWords(c.text, c).map((word) => ({ word, origin: `box:${i}` })) : [])
  ];
  const labels = [];
  const labelOrigin = [];
  const numbers = [];
  for (const s of sources) {
    for (const l of sheetLabels([s.word])) {
      labels.push(l);
      labelOrigin.push(s.origin);
    }
  }
  for (const s of sources) {
    for (const n of sheetWallNumbers([s.word])) numbers.push({ ...n, recognitionId: s.origin });
  }
  const claimed = /* @__PURE__ */ new Set();
  const rooms = [];
  const traces = [];
  const roomBoxes = [];
  input.outlines.forEach((o, i) => {
    const poly = o.polygon.map(([fx, fy]) => ({ x: fx * w, y: fy * h }));
    const box = boxOf(poly);
    roomBoxes.push(box);
    const near3 = labels.map((l, k) => ({ l, k, d: distToBox(l, box) })).filter((x) => x.d <= w * LABEL_RADIUS && !claimed.has(x.k)).sort((a, b) => a.d - b.d);
    const nearP = near3.filter((x) => x.l.kind === "P").slice(0, LABEL_NEAREST);
    const nearS = near3.filter((x) => x.l.kind === "S").slice(0, LABEL_NEAREST);
    const band = crops.flatMap((c, ci) => {
      if (c.kind !== "band" || c.room !== i || c.wall == null) return [];
      const a = poly[c.wall];
      const b = poly[(c.wall + 1) % poly.length];
      return bandNumbers(c.text).map((value) => ({ value, x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, recognitionId: `band:${ci}` }));
    });
    const nums = [...numbers, ...band];
    const placement = placeSheetNumbers(poly, nums, { width: w, height: h }, {
      perimeterCm: nearP.flatMap((x) => x.l.values.map((q) => Math.round(q.v * 100))),
      areaSqm: nearS.flatMap((x) => x.l.values.map((q) => q.v))
    });
    const room = {
      polygon: o.polygon.map(([x, y]) => [x, y]),
      walls: [],
      perimeterM: null,
      areaSqm: null,
      signed: { perimeter: null, area: null },
      nearby: { perimeter: nearP.map((x) => x.l.text), area: nearS.map((x) => x.l.text) },
      verdict: "shape"
    };
    const trace = { walls: [], perimeter: null, area: null };
    if (placement) {
      room.walls = placement.walls.map((wl, k) => ({
        cm: wl.cm,
        source: wl.source,
        parts: wl.parts,
        byModel: wl.recognitionIds.some((id) => !id.startsWith("ocr:")),
        letter: placement.letters[k] ?? "S"
      }));
      trace.walls = placement.walls.map((wl) => wl.recognitionIds);
      const sizes = walkSizes(poly, room.walls);
      if (sizes) {
        room.perimeterM = sizes.perimeterM;
        room.areaSqm = sizes.areaSqm;
        const hitP = !placement.byPerimeter && nearP.find(
          (c) => c.l.values.some((q) => q.dec >= 1 && Math.abs(sizes.perimeterM - q.v) <= perimeterTol(q.dec))
        );
        const hitS = nearS.find((c) => c.l.values.some((q) => q.dec >= 1 && Math.abs(sizes.areaSqm - q.v) <= areaTol(q.v, q.dec)));
        if (hitP) {
          room.signed.perimeter = hitP.l.text;
          claimed.add(hitP.k);
          trace.perimeter = { origin: labelOrigin[hitP.k], label: hitP.l };
        }
        if (hitS) {
          room.signed.area = hitS.l.text;
          claimed.add(hitS.k);
          trace.area = { origin: labelOrigin[hitS.k], label: hitS.l };
        }
      }
      const exactP = !!trace.perimeter && exactPerimeter(trace.perimeter.label, room.perimeterM);
      const checked = (room.signed.perimeter && room.signed.area || exactP) && (room.perimeterM ?? 0) >= MIN_PERIMETER_M;
      room.verdict = checked ? "checked" : "lengths";
    }
    rooms.push(room);
    traces.push(trace);
  });
  return { read: { rooms, signedRooms: signedCount(labels, roomBoxes, w) }, traces };
}
function bandNumbers(text3) {
  if (text3.trim().startsWith("ERROR")) return [];
  return (text3.match(/\d+/g) ?? []).map(Number).filter((v) => v >= 10 && v <= 1500).slice(0, 4);
}
function walkSizes(poly, walls) {
  let x = 0;
  let y = 0;
  let twice = 0;
  let per = 0;
  for (let k = 0; k < walls.length; k++) {
    const wl = walls[k];
    if (wl.cm == null) return null;
    let dir = AXIS2[wl.letter];
    if (!dir) {
      const a = poly[k];
      const b = poly[(k + 1) % poly.length];
      const len = Math.hypot(b.x - a.x, b.y - a.y) || 1;
      dir = [(b.x - a.x) / len, (b.y - a.y) / len];
    }
    const nx = x + dir[0] * wl.cm;
    const ny = y + dir[1] * wl.cm;
    twice += x * ny - nx * y;
    x = nx;
    y = ny;
    per += wl.cm;
  }
  return { perimeterM: Math.round(per) / 100, areaSqm: Math.round(Math.abs(twice) / 2 / 100) / 100 };
}
function signedCount(labels, boxes, w) {
  const signed = /* @__PURE__ */ new Set();
  for (const l of labels) {
    const min = l.kind === "P" ? MIN_PERIMETER_M : 0.5;
    if (!l.values.some((q) => q.dec >= 1 && q.v >= min)) continue;
    let best = -1;
    let bestD = w * LABEL_RADIUS;
    boxes.forEach((b, i) => {
      const d = distToBox(l, b);
      if (d <= bestD) {
        if (d < bestD || best < 0) best = i;
        bestD = d;
      }
    });
    if (best >= 0) signed.add(best);
  }
  return signed.size;
}
function sheetCropsToAsk(input) {
  const { width: w, height: h, read } = input;
  const out = [];
  const boxes = [];
  read.rooms.forEach((r, i) => {
    if (r.verdict === "checked" || !r.nearby.perimeter.length && !r.nearby.area.length) return;
    const poly = r.polygon.map(([fx, fy]) => ({ x: fx * w, y: fy * h }));
    boxes.push(boxOf(poly));
    const band = w * BAND_FRAC2;
    for (let k = 0; k < poly.length; k++) {
      if (r.walls[k]?.source === "sheet") continue;
      const a = poly[k];
      const b = poly[(k + 1) % poly.length];
      if (Math.hypot(b.x - a.x, b.y - a.y) < w * BAND_MIN_WALL) continue;
      const ax = a.x + (b.x - a.x) * 0.15;
      const ay = a.y + (b.y - a.y) * 0.15;
      const bx = a.x + (b.x - a.x) * 0.85;
      const by = a.y + (b.y - a.y) * 0.85;
      out.push({
        kind: "band",
        room: i,
        wall: k,
        x0: Math.max(0, Math.min(ax, bx) - band),
        y0: Math.max(0, Math.min(ay, by) - band),
        x1: Math.min(w, Math.max(ax, bx) + band),
        y1: Math.min(h, Math.max(ay, by) + band)
      });
    }
  });
  input.words.forEach((wd, k) => {
    const t = wd.text.trim();
    if (t.length > 9 || !/\d/.test(t)) return;
    const c = center(wd);
    if (!boxes.some((b) => distToBox(c, b) <= w * BOX_RADIUS)) return;
    out.push({ kind: "box", word: k, x0: wd.x0, y0: wd.y0, x1: wd.x1, y1: wd.y1 });
  });
  return out;
}
function sheetLearnBoxes(input, opts = {}) {
  const { read, traces } = traceSheetRooms(opts.ocrOnly ? { ...input, crops: [] } : input);
  const crops = input.crops ?? [];
  const asked = /* @__PURE__ */ new Map();
  for (const c of crops) if (c.kind === "box" && c.word != null && !asked.has(c.word)) asked.set(c.word, c.text);
  const wordOf = (origin) => {
    const [kind, idx] = origin.split(":");
    const n = Number(idx);
    if (kind === "ocr") return n;
    if (kind === "box" && !opts.ocrOnly && sheetAnswerWords(crops[n]?.text ?? "", crops[n]).length === 1) return crops[n]?.word ?? null;
    return null;
  };
  const found = /* @__PURE__ */ new Map();
  const add = (word, kind, truth) => {
    if (word == null || !input.words[word]) return;
    const prev = found.get(word);
    if (prev === void 0) found.set(word, { kind, truth });
    else if (prev && prev.truth !== truth) found.set(word, null);
  };
  read.rooms.forEach((room, i) => {
    if (room.verdict !== "checked") return;
    const trace = traces[i];
    const exactWalls = (!!trace.perimeter && room.perimeterM != null && exactPerimeter(trace.perimeter.label, room.perimeterM) || !!trace.area && room.areaSqm != null && exactArea(trace.area.label, room.areaSqm)) && closesWithin(room.walls, CLOSE_FOR_PAIRS_CM);
    if (exactWalls) room.walls.forEach((wl, k) => {
      const origins = trace.walls[k] ?? [];
      if (wl.source !== "sheet" || origins.length !== wl.parts.length) return;
      wl.parts.forEach((v, j) => add(wordOf(origins[j]), "wall", String(v)));
    });
    for (const [hit, value] of [
      [trace.perimeter, room.perimeterM],
      [trace.area, room.areaSqm]
    ]) {
      if (!hit || value == null || hit.label.tail) continue;
      const q = hit.label.values.find((x) => x.dec >= 1 && Math.abs(Number(value.toFixed(x.dec)) - x.v) < 1e-9);
      if (q) add(wordOf(hit.origin), "label", `${hit.label.kind}-${q.v.toFixed(q.dec).replace(".", ",")}`);
    }
  });
  const out = [];
  for (const [word, f] of [...found.entries()].sort((a, b) => a[0] - b[0])) {
    if (!f || crowded(input.words, word)) continue;
    const wd = input.words[word];
    out.push({
      word,
      x0: wd.x0,
      y0: wd.y0,
      x1: wd.x1,
      y1: wd.y1,
      kind: f.kind,
      truth: f.truth,
      ocr: wd.text,
      answer: asked.get(word) ?? null,
      hard: sheetBoxVerdict(f, wd.text) !== "correct"
    });
  }
  return out;
}
var CLOSE_FOR_PAIRS_CM = 5;
function closesWithin(walls, cm) {
  let x = 0;
  let y = 0;
  for (const wl of walls) {
    const d = AXIS2[wl.letter];
    if (!d) return true;
    x += d[0] * (wl.cm ?? 0);
    y += d[1] * (wl.cm ?? 0);
  }
  return Math.abs(x) <= cm && Math.abs(y) <= cm;
}
var BOX_CROP_PAD = 5;
function crowded(words, k) {
  const me = words[k];
  const x0 = me.x0 - BOX_CROP_PAD;
  const y0 = me.y0 - BOX_CROP_PAD;
  const x1 = me.x1 + BOX_CROP_PAD;
  const y1 = me.y1 + BOX_CROP_PAD;
  return words.some((o, j) => {
    if (j === k) return false;
    const ix = Math.max(0, Math.min(x1, o.x1) - Math.max(x0, o.x0));
    const iy = Math.max(0, Math.min(y1, o.y1) - Math.max(y0, o.y0));
    const area = (o.x1 - o.x0) * (o.y1 - o.y0);
    return area > 0 && ix * iy / area >= 0.5;
  });
}
function sheetBoxVerdict(box, answer) {
  const text3 = (answer ?? "").trim();
  if (!text3 || text3.startsWith("ERROR")) return "silent";
  const words = sheetAnswerWords(text3, { x0: 0, y0: 0, x1: 1, y1: 1 });
  const nums = sheetWallNumbers(words).map((n) => n.value);
  const labs = sheetLabels(words);
  if (box.kind === "wall") {
    if (nums.length === 1 && nums[0] === Number(box.truth) && labs.length === 0) return "correct";
    return nums.length || labs.length ? "wrong" : "silent";
  }
  const want = sheetLabels([{ text: box.truth, x0: 0, y0: 0, x1: 1, y1: 1 }])[0];
  if (want && labs.some((l) => l.kind === want.kind && l.values.some((q) => want.values.some((x) => Math.abs(q.v - x.v) < 5e-3)))) return "correct";
  return nums.length || labs.length ? "wrong" : "silent";
}

// src/calc/sheet-learn.ts
function sheetLearnRowId(fileId, page, bytes, word) {
  return `${fileId}:${page}:${bytes}:w${word}`;
}
function sheetBoxScore(items) {
  const s = {
    walls: { n: 0, correct: 0, wrong: 0, silent: 0 },
    labels: { n: 0, correct: 0, wrong: 0, silent: 0 },
    hard: { n: 0, correct: 0 }
  };
  for (const { row, answer } of items) {
    const v = sheetBoxVerdict(row, answer);
    const bucket = row.kind === "wall" ? s.walls : s.labels;
    bucket.n++;
    bucket[v]++;
    if (row.hard) {
      s.hard.n++;
      if (v === "correct") s.hard.correct++;
    }
  }
  return s;
}
var SHEET_PROMOTE_RULE = { minWalls: 60, minLabels: 20, minGainWalls: 3, minGainShare: 0.05 };
function sheetCandidatePasses(candidate, references) {
  const n = candidate.walls.n;
  if (n < SHEET_PROMOTE_RULE.minWalls) return { passed: false, why: `\u0441\u0442\u0435\u043D \u0432 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 ${n} \u2014 \u043C\u0435\u043D\u044C\u0448\u0435 ${SHEET_PROMOTE_RULE.minWalls}, \u0441\u0443\u0434\u0438\u0442\u044C \u0440\u0430\u043D\u043E` };
  if (candidate.labels.n < SHEET_PROMOTE_RULE.minLabels) {
    return { passed: false, why: `\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439 \u0432 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 ${candidate.labels.n} \u2014 \u043C\u0435\u043D\u044C\u0448\u0435 ${SHEET_PROMOTE_RULE.minLabels}: \u043D\u0435 \u0432\u0438\u0434\u043D\u043E, \u043D\u0435 \u0447\u0438\u0442\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0438 \u0447\u0438\u0441\u043B\u0430\u043C\u0438` };
  }
  if (!references.length) return { passed: false, why: "\u0441\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u043D\u0435 \u0441 \u0447\u0435\u043C: \u043C\u043E\u0434\u0435\u043B\u044C \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u043E \u0440\u0430\u043C\u043A\u0430\u0445 \u043D\u0435 \u0441\u043F\u0440\u043E\u0441\u0438\u043B\u0438" };
  const gain = Math.max(SHEET_PROMOTE_RULE.minGainWalls, Math.ceil(SHEET_PROMOTE_RULE.minGainShare * n));
  for (const r of references) {
    if (candidate.walls.correct < r.walls.correct + gain) {
      return { passed: false, why: `\u0432\u0435\u0440\u043D\u044B\u0445 \u0441\u0442\u0435\u043D ${candidate.walls.correct} \u043F\u0440\u043E\u0442\u0438\u0432 ${r.walls.correct} \u2014 \u043D\u0443\u0436\u043D\u043E \u0431\u043E\u043B\u044C\u0448\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043D\u0430 ${gain}` };
    }
    if (candidate.walls.wrong > r.walls.wrong) return { passed: false, why: `\u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0445 \u0441\u0442\u0435\u043D ${candidate.walls.wrong} \u043F\u0440\u043E\u0442\u0438\u0432 ${r.walls.wrong} \u2014 \u0441\u0442\u0430\u043B\u043E \u0431\u043E\u043B\u044C\u0448\u0435` };
    if (candidate.labels.wrong > r.labels.wrong) {
      return { passed: false, why: `\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \u043D\u0435 \u0442\u0430\u043A ${candidate.labels.wrong} \u043F\u0440\u043E\u0442\u0438\u0432 ${r.labels.wrong} \u2014 \u0441\u0442\u0430\u043B\u043E \u0431\u043E\u043B\u044C\u0448\u0435` };
    }
  }
  return { passed: true, why: `\u0432\u0435\u0440\u043D\u044B\u0445 \u0441\u0442\u0435\u043D ${candidate.walls.correct} \u0438\u0437 ${n}, \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0445 ${candidate.walls.wrong}; \u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439 \u0432\u0435\u0440\u043D\u043E ${candidate.labels.correct} \u0438\u0437 ${candidate.labels.n}` };
}

// src/calc/sketch-aliases.ts
function normalizeAlias(text3) {
  return text3.toLowerCase().replace(/ё/g, "\u0435").replace(/[^a-zа-я0-9]/g, "");
}
function matchPriceItem(recognizedName, priceItems) {
  const needle = normalizeAlias(recognizedName);
  if (!needle) return null;
  for (const item of priceItems) {
    const aliases = (item.sketchAliases ?? "").split(",").map((a) => normalizeAlias(a)).filter(Boolean);
    if (aliases.includes(needle)) return item;
  }
  if (needle.length < 3) return null;
  for (const item of priceItems) {
    if (normalizeAlias(item.name).startsWith(needle)) return item;
  }
  for (const item of priceItems) {
    if (normalizeAlias(item.name).includes(needle)) return item;
  }
  if (needle.length >= MIN_STEM) {
    const stem = needle.slice(0, MIN_STEM);
    for (const item of priceItems) {
      const words = item.name.split(/[^a-zA-Zа-яА-ЯёЁ0-9]+/).filter(Boolean);
      if (words.some((w) => normalizeAlias(w).startsWith(stem))) return item;
    }
  }
  return null;
}
var MIN_STEM = 5;

// src/calc/geometry.ts
var WALL_PROFILE_LABELS = {
  BAGUETTE: "\u0411\u0430\u0433\u0435\u0442",
  FLOAT: "\u041F\u0430\u0440\u044F\u0449\u0438\u0439",
  SHADOW: "\u0422\u0435\u043D\u0435\u0432\u043E\u0439",
  NONE: "\u0411\u0435\u0437 \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
};
var DEFAULT_WALL_PROFILE = "BAGUETTE";
var CLOSURE_TOLERANCE_MM = 20;
var DEG_TO_RAD = Math.PI / 180;
var ARC_STEP_DEG = 6;
var MIN_BULGE_MM = 1;
function arcPoints(from, to, bulgeMm) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const chord = Math.hypot(dx, dy);
  if (chord === 0 || Math.abs(bulgeMm) < MIN_BULGE_MM) return [];
  const half = chord / 2;
  const sagitta = Math.abs(bulgeMm);
  const radius = (half * half + sagitta * sagitta) / (2 * sagitta);
  const sweepDeg = 2 * Math.atan2(half, radius - sagitta) / DEG_TO_RAD;
  const nx = -dy / chord;
  const ny = dx / chord;
  const side = Math.sign(bulgeMm);
  const mx = (from.x + to.x) / 2;
  const my = (from.y + to.y) / 2;
  const cx2 = mx - side * (radius - sagitta) * nx;
  const cy2 = my - side * (radius - sagitta) * ny;
  const startRad = Math.atan2(from.y - cy2, from.x - cx2);
  const sweepRad = -side * sweepDeg * DEG_TO_RAD;
  const steps = Math.min(120, Math.max(2, Math.ceil(sweepDeg / ARC_STEP_DEG)));
  const out = [];
  for (let k = 1; k < steps; k++) {
    const angle = startRad + sweepRad * k / steps;
    out.push({
      x: Math.round(cx2 + radius * Math.cos(angle)),
      y: Math.round(cy2 + radius * Math.sin(angle))
    });
  }
  return out;
}
function wallLengthMm(wall) {
  const bulge = wall.bulgeMm ?? 0;
  if (Math.abs(bulge) < MIN_BULGE_MM || wall.lengthMm <= 0) return wall.lengthMm;
  const half = wall.lengthMm / 2;
  const sagitta = Math.abs(bulge);
  const radius = (half * half + sagitta * sagitta) / (2 * sagitta);
  const sweepRad = 2 * Math.atan2(half, radius - sagitta);
  return radius * sweepRad;
}
function contourFromWalls(walls) {
  const vertices = [];
  let x = 0;
  let y = 0;
  let headingDeg = 0;
  let perimeterMm = 0;
  vertices.push({ x: 0, y: 0 });
  for (let i = 0; i < walls.length; i++) {
    const wall = walls[i];
    const rad = headingDeg * DEG_TO_RAD;
    x += wall.lengthMm * Math.cos(rad);
    y += wall.lengthMm * Math.sin(rad);
    perimeterMm += wallLengthMm(wall);
    if (i < walls.length - 1) {
      vertices.push({ x: Math.round(x), y: Math.round(y) });
    }
    headingDeg += wall.turnDeg;
  }
  const points = [];
  for (let i = 0; i < vertices.length; i++) {
    const from = vertices[i];
    const to = vertices[(i + 1) % vertices.length];
    points.push(from);
    const bulge = walls[i]?.bulgeMm ?? 0;
    if (bulge) points.push(...arcPoints(from, to, bulge));
  }
  return {
    points,
    vertices,
    perimeterMm,
    closureErrorMm: Math.round(Math.hypot(x, y))
  };
}
function isContourClosed(contour) {
  return contour.closureErrorMm <= CLOSURE_TOLERANCE_MM;
}
function polygonAreaMm2(points) {
  if (points.length < 3) return 0;
  let sum = 0;
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    sum += a.x * b.y - b.x * a.y;
  }
  return Math.abs(sum) / 2;
}
function polygonPerimeterMm(points) {
  if (points.length < 2) return 0;
  let sum = 0;
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    sum += Math.hypot(b.x - a.x, b.y - a.y);
  }
  return sum;
}
function boundingBox(points) {
  if (points.length === 0) {
    return { minX: 0, minY: 0, maxX: 0, maxY: 0, widthMm: 0, heightMm: 0 };
  }
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const p of points) {
    if (p.x < minX) minX = p.x;
    if (p.y < minY) minY = p.y;
    if (p.x > maxX) maxX = p.x;
    if (p.y > maxY) maxY = p.y;
  }
  return { minX, minY, maxX, maxY, widthMm: maxX - minX, heightMm: maxY - minY };
}
function rotatePolygon(points, deg) {
  const rad = deg * DEG_TO_RAD;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return points.map((p) => ({
    x: p.x * cos - p.y * sin,
    y: p.x * sin + p.y * cos
  }));
}
function centroid(points) {
  if (points.length === 0) return { x: 0, y: 0 };
  let sx = 0;
  let sy = 0;
  for (const p of points) {
    sx += p.x;
    sy += p.y;
  }
  return { x: sx / points.length, y: sy / points.length };
}
function scalePolygon(points, factor) {
  const c = centroid(points);
  return points.map((p) => ({
    x: c.x + (p.x - c.x) * factor,
    y: c.y + (p.y - c.y) * factor
  }));
}
var DEFAULT_FIXTURE_DIAMETER_MM = {
  LAMP: 85,
  CHANDELIER: 120,
  TRACK: 60,
  PIPE: 60,
  COLUMN: 200
};
var FIXTURE_LABELS = {
  LAMP: "\u0421\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A \u0442\u043E\u0447\u0435\u0447\u043D\u044B\u0439",
  CHANDELIER: "\u041B\u044E\u0441\u0442\u0440\u0430",
  TRACK: "\u0422\u0440\u0435\u043A\u043E\u0432\u044B\u0439 \u0441\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A",
  PIPE: "\u041E\u0431\u0432\u043E\u0434 \u0442\u0440\u0443\u0431\u044B",
  COLUMN: "\u041A\u043E\u043B\u043E\u043D\u043D\u0430 / \u0432\u044B\u0441\u0442\u0443\u043F"
};
function scaleFixtures(fixtures, points, factor) {
  const c = centroid(points);
  return fixtures.map((f) => ({
    ...f,
    x: c.x + (f.x - c.x) * factor,
    y: c.y + (f.y - c.y) * factor,
    diameterMm: f.diameterMm * factor
  }));
}
function rotateFixtures(fixtures, deg) {
  const rad = deg * DEG_TO_RAD;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return fixtures.map((f) => ({
    ...f,
    x: f.x * cos - f.y * sin,
    y: f.x * sin + f.y * cos
  }));
}
function extentInBand(points, yFrom, yTo) {
  if (points.length < 3) return 0;
  const eps = Math.min(1, (yTo - yFrom) / 4);
  const from = yFrom + eps;
  const to = yTo - eps;
  const xs = [];
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    if (a.y >= from && a.y <= to) xs.push(a.x);
    for (const y of [from, to]) {
      const dy = b.y - a.y;
      if (dy === 0) continue;
      const t = (y - a.y) / dy;
      if (t < 0 || t > 1) continue;
      xs.push(a.x + (b.x - a.x) * t);
    }
  }
  if (xs.length === 0) return 0;
  return Math.max(...xs) - Math.min(...xs);
}
function mm2ToSqm(areaMm2) {
  return Math.round(areaMm2 / 1e6 * 100) / 100;
}
function mmToM(lengthMm2) {
  return Math.round(lengthMm2 / 1e3 * 100) / 100;
}
function roomMetrics(contour) {
  return {
    areaSqm: mm2ToSqm(polygonAreaMm2(contour.points)),
    // По стенам, а не по ломаной разбиения: у дуги они расходятся
    perimeterM: mmToM(contour.perimeterMm),
    cornersCount: contour.vertices.length,
    closureErrorMm: contour.closureErrorMm,
    closed: isContourClosed(contour)
  };
}
function metricsFromWalls(walls) {
  return roomMetrics(contourFromWalls(walls));
}
function profileLengths(walls) {
  const totals = {
    BAGUETTE: 0,
    FLOAT: 0,
    SHADOW: 0,
    NONE: 0
  };
  for (const wall of walls) {
    const profile = wall.profile ?? DEFAULT_WALL_PROFILE;
    totals[profile] += wallLengthMm(wall);
  }
  return {
    BAGUETTE: mmToM(totals.BAGUETTE),
    FLOAT: mmToM(totals.FLOAT),
    SHADOW: mmToM(totals.SHADOW),
    NONE: mmToM(totals.NONE)
  };
}
var FIXTURE_ROW_TOLERANCE_MM = 300;
function fixtureMarks(fixtures) {
  const byDepth = [...fixtures].sort((a, b) => a.y - b.y || a.x - b.x);
  const rows = [];
  for (const fixture of byDepth) {
    const row = rows[rows.length - 1];
    if (row && fixture.y - row[0].y <= FIXTURE_ROW_TOLERANCE_MM) row.push(fixture);
    else rows.push([fixture]);
  }
  const sorted = rows.flatMap((row) => [...row].sort((a, b) => a.x - b.x || a.y - b.y));
  return sorted.map((fixture, i) => ({
    index: i + 1,
    fixture,
    xMm: Math.round(fixture.x),
    yMm: Math.round(fixture.y)
  }));
}
function seamMarks(seams) {
  return seams.map(([from, to], i) => ({
    index: i + 1,
    from: { x: Math.round(from.x), y: Math.round(from.y) },
    to: { x: Math.round(to.x), y: Math.round(to.y) },
    lengthMm: Math.round(Math.hypot(to.x - from.x, to.y - from.y))
  }));
}
function overlappingFixtures(fixtures) {
  const found = [];
  for (let i = 0; i < fixtures.length; i++) {
    for (let j = i + 1; j < fixtures.length; j++) {
      const a = fixtures[i];
      const b = fixtures[j];
      const distance = Math.hypot(b.x - a.x, b.y - a.y);
      const needed = (a.diameterMm + b.diameterMm) / 2;
      if (distance < needed) {
        found.push({ a, b, overlapMm: Math.round(needed - distance) });
      }
    }
  }
  return found;
}
var DIAGONAL_TOLERANCE_MM = 30;
function checkDiagonals(contour, checks) {
  const results = [];
  for (const check of checks) {
    const a = contour.vertices[check.fromIndex];
    const b = contour.vertices[check.toIndex];
    if (!a || !b || check.fromIndex === check.toIndex || check.measuredMm <= 0) continue;
    const computedMm = Math.round(Math.hypot(b.x - a.x, b.y - a.y));
    const deviationMm = Math.round(check.measuredMm - computedMm);
    results.push({
      ...check,
      computedMm,
      deviationMm,
      ok: Math.abs(deviationMm) <= DIAGONAL_TOLERANCE_MM
    });
  }
  return results;
}
function longestDiagonal(vertices) {
  const n = vertices.length;
  if (n < 4) return null;
  let best = null;
  for (let i = 0; i < n; i++) {
    for (let j = i + 2; j < n; j++) {
      if (i === 0 && j === n - 1) continue;
      const a = vertices[i];
      const b = vertices[j];
      if (!segmentInsidePolygon(vertices, a, b)) continue;
      const lengthMm2 = Math.round(Math.hypot(b.x - a.x, b.y - a.y));
      if (!best || lengthMm2 > best.lengthMm) {
        best = { fromIndex: i, toIndex: j, lengthMm: lengthMm2 };
      }
    }
  }
  return best;
}
function isPointInsidePolygon(points, probe) {
  let inside2 = false;
  for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
    const a = points[i];
    const b = points[j];
    const crosses = a.y > probe.y !== b.y > probe.y;
    if (!crosses) continue;
    const x = (b.x - a.x) * (probe.y - a.y) / (b.y - a.y) + a.x;
    if (probe.x < x) inside2 = !inside2;
  }
  return inside2;
}
function segmentInsidePolygon(points, a, b) {
  const steps = 10;
  for (let k = 1; k < steps; k++) {
    const t = k / steps;
    const probe = { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t };
    if (!isPointInsidePolygon(points, probe)) return false;
  }
  return true;
}
function curtainNicheLengthM(walls) {
  let totalMm = 0;
  for (const wall of walls) {
    if (wall.curtainNiche) totalMm += wallLengthMm(wall);
  }
  return mmToM(totalMm);
}

// src/calc/plan-layout.ts
var WALL_GAP_MM = 120;
var TARGET_ASPECT = 1.5;
var SHEET_ROW_BAND = 0.08;
function roomShape(input) {
  if (input.walls.length < 3) return null;
  const contour = contourFromWalls(input.walls);
  const box = boundingBox(contour.points);
  if (box.widthMm <= 0 || box.heightMm <= 0) return null;
  const points = contour.points.map((p) => ({ x: p.x - box.minX, y: box.maxY - p.y }));
  return {
    points,
    widthMm: box.widthMm,
    heightMm: box.heightMm,
    areaSqm: mm2ToSqm(polygonAreaMm2(points)),
    closureErrorMm: contour.closureErrorMm
  };
}
function inSheetOrder(rooms) {
  const placed = rooms.filter((r) => r.sheet);
  if (placed.length !== rooms.length) return rooms;
  return [...rooms].sort((a, b) => {
    const ay = a.sheet.y;
    const by = b.sheet.y;
    if (Math.abs(ay - by) > SHEET_ROW_BAND) return ay - by;
    return a.sheet.x - b.sheet.x;
  });
}
function layoutRooms(rooms) {
  const shaped = inSheetOrder(rooms).map((input) => ({ input, shape: roomShape(input), index: rooms.indexOf(input) })).filter(
    (r) => r.shape !== null
  );
  if (shaped.length === 0) {
    return { rooms: [], widthMm: 0, heightMm: 0, totalAreaSqm: 0 };
  }
  const totalAreaMm2 = shaped.reduce((acc, r) => acc + r.shape.widthMm * r.shape.heightMm, 0);
  const widest = shaped.reduce((acc, r) => Math.max(acc, r.shape.widthMm), 0);
  const targetRowMm = Math.max(widest, Math.sqrt(totalAreaMm2 * TARGET_ASPECT));
  const placed = [];
  let cursorX = 0;
  let rowY = 0;
  let rowHeight = 0;
  for (const { input, shape, index } of shaped) {
    const wouldOverflow = cursorX > 0 && cursorX + shape.widthMm > targetRowMm;
    if (wouldOverflow) {
      rowY += rowHeight + WALL_GAP_MM;
      cursorX = 0;
      rowHeight = 0;
    }
    placed.push({
      name: input.name,
      index,
      points: shape.points.map((p) => ({ x: p.x + cursorX, y: p.y + rowY })),
      xMm: cursorX,
      yMm: rowY,
      widthMm: shape.widthMm,
      heightMm: shape.heightMm,
      areaSqm: Number(shape.areaSqm.toFixed(2)),
      sheetAreaSqm: input.areaSqm,
      problem: input.problem === true,
      closureErrorMm: shape.closureErrorMm
    });
    cursorX += shape.widthMm + WALL_GAP_MM;
    rowHeight = Math.max(rowHeight, shape.heightMm);
  }
  const widthMm = Math.max(...placed.map((r) => r.xMm + r.widthMm));
  const heightMm = Math.max(...placed.map((r) => r.yMm + r.heightMm));
  const totalAreaSqm = placed.reduce((acc, r) => acc + r.areaSqm, 0);
  return {
    rooms: placed,
    widthMm,
    heightMm,
    totalAreaSqm: Number(totalAreaSqm.toFixed(2))
  };
}

// src/calc/debts.ts
var DEBT_KIND_LABELS = {
  DEFECT: "\u041D\u0435\u0434\u043E\u0447\u0451\u0442",
  TOOL: "\u0412\u044B\u043A\u0443\u043F \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0430",
  LOAN: "\u0417\u0430\u0451\u043C",
  OTHER: "\u041F\u0440\u043E\u0447\u0435\u0435",
  CASH: "\u0414\u043E\u043B\u0433 \u0432 \u043A\u0430\u0441\u0441\u0435"
};
function debtRemaining(debt) {
  if (debt.writtenOff) return new Decimal(0);
  const left = toDecimal(debt.amount).minus(toDecimal(debt.repaid ?? 0));
  return left.isNegative() ? new Decimal(0) : left;
}
function debtInstalment(debt, accrued) {
  const remainingBefore = debtRemaining(debt);
  const available = toDecimal(accrued);
  if (remainingBefore.lessThanOrEqualTo(0) || available.lessThanOrEqualTo(0)) {
    return {
      amount: new Decimal(0),
      remainingBefore,
      remainingAfter: remainingBefore,
      limitedBy: remainingBefore.greaterThan(0) ? "accrual" : null
    };
  }
  let planned = debt.monthlyAmount == null ? remainingBefore : toDecimal(debt.monthlyAmount);
  if (planned.lessThanOrEqualTo(0)) planned = remainingBefore;
  let limitedBy = null;
  if (debt.monthlyPercent != null && debt.monthlyPercent > 0) {
    const cap = available.times(debt.monthlyPercent).dividedBy(100);
    if (cap.lessThan(planned)) {
      planned = cap;
      limitedBy = "percent";
    }
  }
  if (planned.greaterThan(remainingBefore)) {
    planned = remainingBefore;
    limitedBy = "remainder";
  }
  if (planned.greaterThan(available)) {
    planned = available;
    limitedBy = "accrual";
  }
  const amount = planned.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
  return {
    amount,
    remainingBefore,
    remainingAfter: remainingBefore.minus(amount),
    limitedBy
  };
}
function debtInstalments(debts, accrued) {
  let left = toDecimal(accrued);
  const out = [];
  for (const debt of debts) {
    const instalment = debtInstalment(debt, left);
    out.push(instalment);
    left = left.minus(instalment.amount);
    if (left.lessThan(0)) left = new Decimal(0);
  }
  return out;
}

// src/calc/brigade-fit.ts
function isoWeekday(value) {
  const d = value instanceof Date ? value : new Date(value);
  const js = d.getDay();
  return js === 0 ? 7 : js;
}
var WEEKDAY_NAMES = ["", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0443", "\u0447\u0435\u0442\u0432\u0435\u0440\u0433", "\u043F\u044F\u0442\u043D\u0438\u0446\u0443", "\u0441\u0443\u0431\u0431\u043E\u0442\u0443", "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435"];
function parseDaysOff(value) {
  if (!value) return [];
  return value.split(",").map((p) => Number(p.trim())).filter((n) => Number.isInteger(n) && n >= 1 && n <= 7);
}
function formatDaysOff(days) {
  const clean4 = [...new Set(days)].filter((n) => n >= 1 && n <= 7).sort((a, b) => a - b);
  return clean4.length > 0 ? clean4.join(",") : null;
}
function checkBrigadeFit(brigade, address) {
  const issues = [];
  const skills = brigade.skills ?? [];
  if (address.level != null && skills.length > 0) {
    const skill = skills.find((s) => s.level === address.level);
    if (!skill) {
      issues.push({
        level: "blocker",
        text: `${brigade.name} \u043D\u0435 \u0431\u0435\u0440\u0451\u0442 ${address.level} \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044E`
      });
    } else if (skill.maxSqm != null && address.areaSqm != null && address.areaSqm > skill.maxSqm) {
      issues.push({
        level: "blocker",
        text: `${address.level} \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0434\u043E ${skill.maxSqm} \u043C\xB2, \u0430 \u043D\u0430 \u043E\u0431\u044A\u0435\u043A\u0442\u0435 ${address.areaSqm} \u043C\xB2`
      });
    }
  }
  const categoryIds = brigade.categoryIds ?? [];
  if (address.categoryId && categoryIds.length > 0 && !categoryIds.includes(address.categoryId)) {
    issues.push({
      level: "blocker",
      text: `${brigade.name} \u043D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E`
    });
  }
  const daysOff = brigade.daysOff ?? [];
  if (address.date && daysOff.length > 0) {
    const day = isoWeekday(address.date);
    if (daysOff.includes(day)) {
      issues.push({
        level: "warning",
        text: `\u0423 \u0431\u0440\u0438\u0433\u0430\u0434\u044B \u0432\u044B\u0445\u043E\u0434\u043D\u043E\u0439 \u0432 ${WEEKDAY_NAMES[day]}` + (brigade.scheduleNote ? `. ${brigade.scheduleNote}` : "")
      });
    }
  }
  if (brigade.cityOnly && address.outOfTown) {
    issues.push({ level: "warning", text: `${brigade.name} \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u0433\u043E\u0440\u043E\u0434\u0443` });
  }
  const haystack = (address.address ?? "").toLowerCase();
  if (haystack) {
    for (const rule of brigade.addressRules ?? []) {
      const needle = rule.pattern.trim().toLowerCase();
      if (needle && haystack.includes(needle)) {
        issues.push({
          level: "warning",
          text: `${brigade.name}: \u0430\u0434\u0440\u0435\u0441 \u043F\u043E\u0434\u043F\u0430\u0434\u0430\u0435\u0442 \u043F\u043E\u0434 \u0437\u0430\u043F\u0440\u0435\u0442 \xAB${rule.pattern.trim()}\xBB` + (rule.reason?.trim() ? `. ${rule.reason.trim()}` : "")
        });
      }
    }
  }
  if (brigade.notes?.trim()) {
    issues.push({ level: "note", text: brigade.notes.trim() });
  }
  return {
    clean: !issues.some((i) => i.level === "blocker" || i.level === "warning"),
    issues
  };
}
function findConflict(conflicts, first, second) {
  const hit = conflicts.find(
    (c) => c.brigadeAId === first && c.brigadeBId === second || c.brigadeAId === second && c.brigadeBId === first
  );
  return hit ? { reason: hit.reason } : null;
}
function findInstallerConflicts(conflicts, userIds) {
  const present = new Set(userIds);
  return conflicts.filter((c) => present.has(c.userAId) && present.has(c.userBId));
}
function suggestBrigades(brigades, toInput, address, busyIds = []) {
  const busy = busyIds instanceof Set ? busyIds : new Set(busyIds);
  return brigades.map((brigade) => {
    const fit = checkBrigadeFit(toInput(brigade), address);
    const isBusy = busy.has(brigade.id);
    const blocked = fit.issues.some((i) => i.level === "blocker");
    const warned = fit.issues.some((i) => i.level === "warning");
    const rank = (blocked ? 100 : 0) + (isBusy ? 10 : 0) + (warned ? 1 : 0);
    return { brigade, fit, busy: isBusy, rank };
  }).sort((a, b) => a.rank - b.rank);
}

// src/calc/grid-sketch.ts
var CELL_SIZES_MM = [50, 100, 250, 500];
var DEFAULT_CELL_MM = 100;
var AREA_GAP_MM = 50;
var metres = (mm) => (mm / 1e3).toFixed(2).replace(".", ",");
function closureAxisText(a) {
  return a.axis === "v" ? `\u043F\u043E \u0432\u044B\u0441\u043E\u0442\u0435 \u0441\u043F\u0440\u0430\u0432\u0430 ${metres(a.firstMm)} \u043C, \u0441\u043B\u0435\u0432\u0430 ${metres(a.secondMm)} \u043C` : `\u043F\u043E \u0448\u0438\u0440\u0438\u043D\u0435 \u0441\u0432\u0435\u0440\u0445\u0443 ${metres(a.firstMm)} \u043C, \u0441\u043D\u0438\u0437\u0443 ${metres(a.secondMm)} \u043C`;
}
var MIN_WALL_MM = 100;
var CLOSURE_WARN_MM = 50;
var MAX_CLOSE_TURN_DEG = 1.5;
var SNAP_HEADING_DEG = 1.5;
function closeByTurns(walls) {
  const n = walls.length;
  if (n < 3) return null;
  const rad = Math.PI / 180;
  const turns = walls.map((w) => w.turnDeg);
  const delta = new Array(n).fill(0);
  for (let iter = 0; iter < 8; iter++) {
    const headings = [];
    let acc = 0;
    for (let i = 0; i < n; i++) {
      headings.push(acc + delta[i]);
      acc += turns[i];
    }
    let gx = 0;
    let gy = 0;
    for (let i = 0; i < n; i++) {
      gx += walls[i].lengthMm * Math.cos(headings[i] * rad);
      gy += walls[i].lengthMm * Math.sin(headings[i] * rad);
    }
    if (Math.hypot(gx, gy) < 0.05) break;
    let a = 0;
    let b = 0;
    let c = 0;
    const jx = [0];
    const jy = [0];
    for (let k = 1; k < n; k++) {
      const len = walls[k].lengthMm;
      const x = -len * Math.sin(headings[k] * rad) * rad;
      const y = len * Math.cos(headings[k] * rad) * rad;
      jx.push(x);
      jy.push(y);
      a += x * x;
      b += x * y;
      c += y * y;
    }
    const det = a * c - b * b;
    if (Math.abs(det) < 1e-9) return null;
    const lx = (-c * gx + b * gy) / det;
    const ly = (b * gx - a * gy) / det;
    for (let k = 1; k < n; k++) delta[k] = delta[k] + jx[k] * lx + jy[k] * ly;
  }
  const out = walls.map((w, i) => ({
    ...w,
    turnDeg: Math.round((turns[i] + delta[(i + 1) % n] - delta[i]) * 100) / 100
  }));
  const maxDeg = Math.max(...delta.map((d) => Math.abs(d)));
  if (maxDeg > MAX_CLOSE_TURN_DEG) return null;
  if (contourFromWalls(out).closureErrorMm > CLOSURE_TOLERANCE_MM) return null;
  return { walls: out, maxDeg };
}
var MAX_WALL_MM = 3e4;
function normalizeDeg(deg) {
  let d = deg % 360;
  if (d > 180) d -= 360;
  if (d <= -180) d += 360;
  return d;
}
function signedCellArea(points) {
  let sum = 0;
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    sum += a.col * b.row - b.col * a.row;
  }
  return sum / 2;
}
function segmentsCross(a1, a2, b1, b2) {
  const d = (p, q, r) => (q.col - p.col) * (r.row - p.row) - (q.row - p.row) * (r.col - p.col);
  const d1 = d(b1, b2, a1);
  const d2 = d(b1, b2, a2);
  const d3 = d(a1, a2, b1);
  const d4 = d(a1, a2, b2);
  return (d1 > 0 && d2 < 0 || d1 < 0 && d2 > 0) && (d3 > 0 && d4 < 0 || d3 < 0 && d4 > 0);
}
function hasSelfIntersection(points) {
  const n = points.length;
  for (let i = 0; i < n; i++) {
    for (let j = i + 2; j < n; j++) {
      if (i === 0 && j === n - 1) continue;
      if (segmentsCross(points[i], points[(i + 1) % n], points[j], points[(j + 1) % n])) {
        return true;
      }
    }
  }
  return false;
}
function reverseDirection(points) {
  if (signedCellArea(points) <= 0) return points;
  const n = points.length;
  return points.map((_, j) => {
    const src = points[(n - j) % n];
    const edge = points[(n - j - 1) % n];
    return {
      col: src.col,
      row: src.row,
      ...edge.bulge ? { bulge: -edge.bulge } : {},
      ...edge.profile ? { profile: edge.profile } : {},
      ...edge.curtainNiche ? { curtainNiche: true } : {},
      ...edge.opening ? { opening: edge.opening } : {}
    };
  });
}
function rightwardStart(points) {
  const n = points.length;
  const off = (i) => {
    const a = points[i];
    const b = points[(i + 1) % n];
    return Math.abs(Math.atan2(b.row - a.row, b.col - a.col));
  };
  let best = 0;
  let bestOff = off(0);
  for (let i = 1; i < n && bestOff > 0; i++) {
    const o = off(i);
    if (o < bestOff - 1e-9) {
      best = i;
      bestOff = o;
    }
  }
  return best;
}
function normalizeDirection(points) {
  const dir = reverseDirection(points);
  const s = rightwardStart(dir);
  return s === 0 ? dir : [...dir.slice(s), ...dir.slice(0, s)];
}
function vertexIndexForPathPoint(points, pathIndex) {
  const n = points.length;
  const j = signedCellArea(points) <= 0 ? pathIndex : pathIndex === 0 ? 0 : n - pathIndex;
  const s = rightwardStart(reverseDirection(points));
  return ((j - s) % n + n) % n;
}
function cleanPath(points) {
  const out = [];
  for (const p of points) {
    const last2 = out[out.length - 1];
    if (last2 && last2.col === p.col && last2.row === p.row) continue;
    out.push(p);
  }
  const first = out[0];
  const last = out[out.length - 1];
  if (out.length > 1 && first && last && first.col === last.col && first.row === last.row) {
    out.pop();
  }
  return out;
}
function gridEdgeKey(a, b) {
  const p = `${a.col},${a.row}`;
  const q = `${b.col},${b.row}`;
  return p < q ? `${p}|${q}` : `${q}|${p}`;
}
function gridToWalls(rawPoints, cellMm = DEFAULT_CELL_MM, lengthOverridesMm, measuredEdges, unknownEdges) {
  const problems = [];
  const points = cleanPath(rawPoints);
  const taped = measuredEdges ? new Set(measuredEdges) : null;
  const unknown = new Set(unknownEdges ?? []);
  if (points.length < 3) {
    return {
      walls: [],
      points: [],
      vertices: [],
      problems: [{ blocking: true, text: "\u041D\u0430\u0440\u0438\u0441\u0443\u0439\u0442\u0435 \u043A\u043E\u043D\u0442\u0443\u0440: \u043D\u0443\u0436\u043D\u043E \u0445\u043E\u0442\u044F \u0431\u044B \u0442\u0440\u0438 \u0443\u0433\u043B\u0430" }],
      areaSqm: 0,
      perimeterM: 0,
      closureErrorMm: 0
    };
  }
  if (hasSelfIntersection(points)) {
    problems.push({
      blocking: true,
      text: "\u041B\u0438\u043D\u0438\u0438 \u043F\u0435\u0440\u0435\u0441\u0435\u043A\u0430\u044E\u0442\u0441\u044F \u2014 \u043A\u043E\u043D\u0442\u0443\u0440 \u0441\u0430\u043C \u0441\u0435\u0431\u044F \u043F\u0435\u0440\u0435\u0447\u0451\u0440\u043A\u0438\u0432\u0430\u0435\u0442. \u0422\u0430\u043A\u043E\u0439 \u043F\u043B\u043E\u0449\u0430\u0434\u0438 \u043D\u0435 \u0431\u044B\u0432\u0430\u0435\u0442"
    });
  }
  const path = normalizeDirection(points);
  let walls = [];
  const sides = [];
  const insidePath = (x, y) => {
    let hit = false;
    for (let i = 0, j = path.length - 1; i < path.length; j = i++) {
      const a = path[i];
      const b = path[j];
      if (a.row > y !== b.row > y && x < (b.col - a.col) * (y - a.row) / (b.row - a.row) + a.col) hit = !hit;
    }
    return hit;
  };
  const n = path.length;
  for (let i = 0; i < n; i++) {
    const from = path[i];
    const to = path[(i + 1) % n];
    const next = path[(i + 2) % n];
    const dx = (to.col - from.col) * cellMm;
    const dy = -(to.row - from.row) * cellMm;
    const cellLengthMm = Math.round(Math.hypot(dx, dy));
    const override = lengthOverridesMm?.[gridEdgeKey(from, to)];
    const lengthMm2 = override !== void 0 && override > 0 ? Math.round(override) : cellLengthMm;
    const dCol = to.col - from.col;
    const dRow = to.row - from.row;
    const midCol = (from.col + to.col) / 2;
    const midRow = (from.row + to.row) / 2;
    sides.push(
      from.bulge || dCol !== 0 && dRow !== 0 ? null : {
        axis: dCol !== 0 ? "h" : "v",
        // Комната слева от вертикальной — стена справа; под горизонтальной — стена сверху
        first: dCol !== 0 ? insidePath(midCol, midRow + 0.25) : insidePath(midCol - 0.25, midRow),
        lengthMm: lengthMm2,
        taped: override !== void 0 && override > 0
      }
    );
    const heading2 = Math.atan2(dy, dx) * (180 / Math.PI);
    const nextHeading = Math.atan2(-(next.row - to.row) * cellMm, (next.col - to.col) * cellMm) * (180 / Math.PI);
    const bulgeCells = from.bulge ?? 0;
    walls.push({
      lengthMm: lengthMm2,
      turnDeg: Math.round(normalizeDeg(nextHeading - heading2) * 100) / 100,
      // Откуда длина — едет со стеной: конструктор видит, где рулетки
      // не было, и не принимает клеточную длину за замер
      ...taped && !(unknown.has(gridEdgeKey(from, to)) && !taped.has(gridEdgeKey(from, to))) ? { measured: taped.has(gridEdgeKey(from, to)) } : {},
      ...bulgeCells ? { bulgeMm: Math.round(bulgeCells * cellMm) } : {},
      // Профиль, карниз и проём — свойства стены, а не рисунка: они
      // едут в смету и на чертёж наравне с длиной
      ...from.profile ? { profile: from.profile } : {},
      ...from.curtainNiche ? { curtainNiche: true } : {},
      ...from.opening ? { opening: from.opening } : {}
    });
    if (lengthMm2 < MIN_WALL_MM) {
      problems.push({
        blocking: true,
        text: `\u0421\u0442\u0435\u043D\u0430 ${lengthMm2} \u043C\u043C \u043A\u043E\u0440\u043E\u0447\u0435 ${MIN_WALL_MM} \u043C\u043C \u2014 \u0443\u0431\u0435\u0440\u0438\u0442\u0435 \u043B\u0438\u0448\u043D\u0438\u0439 \u0443\u0433\u043E\u043B`
      });
    } else if (lengthMm2 > MAX_WALL_MM) {
      problems.push({
        blocking: true,
        text: `\u0421\u0442\u0435\u043D\u0430 ${(lengthMm2 / 1e3).toFixed(1)} \u043C \u2014 \u043F\u043E\u0445\u043E\u0436\u0435, \u043F\u0440\u043E\u043C\u0430\u0445 \u043F\u043E \u043A\u043B\u0435\u0442\u043A\u0435`
      });
    }
  }
  let contour = contourFromWalls(walls);
  const allTaped = path.every(
    (p, i) => lengthOverridesMm?.[gridEdgeKey(p, path[(i + 1) % n])] !== void 0
  );
  if (allTaped && contour.closureErrorMm > CLOSURE_TOLERANCE_MM && contour.closureErrorMm <= CLOSURE_WARN_MM) {
    const gapMm = contour.closureErrorMm;
    const closed = closeByTurns(walls);
    if (closed) {
      walls = closed.walls;
      contour = contourFromWalls(walls);
      problems.push({
        blocking: false,
        text: `\u0421\u0442\u0435\u043D\u044B \u043F\u043E \u0440\u0443\u043B\u0435\u0442\u043A\u0435 \u043D\u0435 \u0441\u0445\u043E\u0434\u0438\u043B\u0438\u0441\u044C \u043D\u0430 ${gapMm} \u043C\u043C \u2014 \u0443\u0433\u043B\u044B \u043F\u043E\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u0434\u043E\u043B\u0438 \u0433\u0440\u0430\u0434\u0443\u0441\u0430 (\u0434\u043E ${closed.maxDeg.toFixed(1)}\xB0), \u0434\u043B\u0438\u043D\u044B \u043E\u0441\u0442\u0430\u043B\u0438\u0441\u044C \u043A\u0430\u043A \u0441\u043D\u044F\u0442\u044B. \u0414\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u044C \u043F\u043E\u043A\u0430\u0436\u0435\u0442, \u0432\u0435\u0440\u043D\u043E \u043B\u0438`
      });
    }
  }
  const areaSqm = polygonAreaMm2(contour.points) / 1e6;
  const perimeterM = contour.perimeterMm / 1e3;
  let closureAxes;
  if (lengthOverridesMm && Object.keys(lengthOverridesMm).length > 0) {
    if (contour.closureErrorMm > CLOSURE_TOLERANCE_MM) {
      const axes = ["h", "v"].flatMap((axis) => {
        if (sides.some((s) => s === null)) return [];
        const own = sides.filter((s) => s !== null && s.axis === axis);
        const firstMm = own.filter((s) => s.first).reduce((t, s) => t + s.lengthMm, 0);
        const secondMm = own.filter((s) => !s.first).reduce((t, s) => t + s.lengthMm, 0);
        if (Math.abs(firstMm - secondMm) <= CLOSURE_TOLERANCE_MM) return [];
        return [{ axis, firstMm, secondMm, gridWalls: own.filter((s) => !s.taped).length }];
      });
      if (axes.length > 0) closureAxes = axes;
      const left = (a) => {
        const v = a.axis === "v";
        const n2 = a.gridWalls;
        const mod10 = n2 % 10;
        const few = mod10 >= 2 && mod10 <= 4 && (n2 % 100 < 12 || n2 % 100 > 14);
        if (n2 === 1) return `${v ? "\u043E\u0434\u043D\u0430 \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F" : "\u043E\u0434\u043D\u0430 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0430\u044F"} \u0441\u0442\u0435\u043D\u0430 \u0435\u0449\u0451 \u043F\u043E \u043A\u043B\u0435\u0442\u043A\u0430\u043C, \u0432\u043F\u0438\u0448\u0438\u0442\u0435 \u0435\u0451 \u0440\u0443\u043B\u0435\u0442\u043A\u043E\u0439`;
        return few ? `\u0435\u0449\u0451 ${n2} ${v ? "\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0435" : "\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u044B\u0435"} \u0441\u0442\u0435\u043D\u044B \u043F\u043E \u043A\u043B\u0435\u0442\u043A\u0430\u043C, \u0432\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u0445 \u0440\u0443\u043B\u0435\u0442\u043A\u043E\u0439` : `\u0435\u0449\u0451 ${n2} ${v ? "\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445" : "\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u044B\u0445"} \u0441\u0442\u0435\u043D \u043F\u043E \u043A\u043B\u0435\u0442\u043A\u0430\u043C, \u0432\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u0445 \u0440\u0443\u043B\u0435\u0442\u043A\u043E\u0439`;
      };
      const hint = axes.map(
        (a) => a.gridWalls > 0 ? `${closureAxisText(a)} \u2014 ${left(a)}` : `${closureAxisText(a)} \u2014 \u0432\u0441\u0435 ${a.axis === "v" ? "\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0435" : "\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u044B\u0435"} \u0441\u043D\u044F\u0442\u044B, \u043E\u0434\u043D\u0430 \u0438\u0437 \u043D\u0438\u0445 \u0441\u043D\u044F\u0442\u0430 \u0438\u043B\u0438 \u0432\u043F\u0438\u0441\u0430\u043D\u0430 \u043D\u0435 \u0442\u0430\u043A`
      ).join("; ");
      problems.push({
        blocking: false,
        text: hint ? `\u0421\u0442\u0435\u043D\u044B \u0441 \u0443\u0442\u043E\u0447\u043D\u0451\u043D\u043D\u044B\u043C\u0438 \u0434\u043B\u0438\u043D\u0430\u043C\u0438 \u043D\u0435 \u0441\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u043D\u0430 ${contour.closureErrorMm} \u043C\u043C: ${hint}` : `\u0421\u0442\u0435\u043D\u044B \u0441 \u0443\u0442\u043E\u0447\u043D\u0451\u043D\u043D\u044B\u043C\u0438 \u0434\u043B\u0438\u043D\u0430\u043C\u0438 \u043D\u0435 \u0441\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u043D\u0430 ${contour.closureErrorMm} \u043C\u043C \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u043E\u0442\u0438\u0432\u043E\u043F\u043E\u043B\u043E\u0436\u043D\u044B\u0435 \u0441\u0442\u0435\u043D\u044B: \u0438\u0445 \u0442\u043E\u0436\u0435 \u0443\u0442\u043E\u0447\u043D\u044F\u044E\u0442 \u0440\u0443\u043B\u0435\u0442\u043A\u043E\u0439`
      });
    }
  }
  return {
    walls,
    points: contour.points,
    vertices: contour.vertices,
    problems,
    areaSqm: Number(areaSqm.toFixed(2)),
    perimeterM: Number(perimeterM.toFixed(2)),
    closureErrorMm: contour.closureErrorMm,
    ...closureAxes ? { closureAxes } : {}
  };
}
function roomPointToGrid(point, path, cellMm = DEFAULT_CELL_MM) {
  const clean4 = cleanPath(path);
  if (clean4.length < 2) return { col: 0, row: 0 };
  const ordered = normalizeDirection(clean4);
  const origin = ordered[0];
  const second = ordered[1];
  const headingRad = Math.atan2(-(second.row - origin.row), second.col - origin.col);
  const cos = Math.cos(headingRad);
  const sin = Math.sin(headingRad);
  const dx = point.x * cos - point.y * sin;
  const dy = point.x * sin + point.y * cos;
  return {
    col: origin.col + dx / cellMm,
    row: origin.row - dy / cellMm
  };
}
function gridPointToRoom(point, path, cellMm = DEFAULT_CELL_MM) {
  const clean4 = cleanPath(path);
  if (clean4.length < 2) return { x: 0, y: 0 };
  const ordered = normalizeDirection(clean4);
  const origin = ordered[0];
  const second = ordered[1];
  const headingRad = Math.atan2(-(second.row - origin.row), second.col - origin.col);
  const cos = Math.cos(-headingRad);
  const sin = Math.sin(-headingRad);
  const dx = (point.col - origin.col) * cellMm;
  const dy = -(point.row - origin.row) * cellMm;
  return {
    x: Math.round(dx * cos - dy * sin) + 0,
    y: Math.round(dx * sin + dy * cos) + 0
  };
}
function headingUnit(headingDeg) {
  const norm2 = (headingDeg % 360 + 360) % 360;
  if (norm2 === 0) return { dx: 1, dy: 0 };
  if (norm2 === 90) return { dx: 0, dy: -1 };
  if (norm2 === 180) return { dx: -1, dy: 0 };
  if (norm2 === 270) return { dx: 0, dy: 1 };
  const rad = headingDeg * Math.PI / 180;
  return { dx: Math.cos(rad), dy: -Math.sin(rad) };
}
function wallsToGrid(walls, limits = { cols: 60, rows: 40 }) {
  if (walls.length < 3 || walls.some((w) => !(w.lengthMm > 0))) return null;
  const raw = [];
  let x = 0;
  let y = 0;
  let heading2 = 0;
  for (const wall of walls) {
    raw.push({ x, y });
    const nearest = Math.round(heading2 / 90) * 90;
    const { dx, dy } = headingUnit(Math.abs(heading2 - nearest) <= SNAP_HEADING_DEG ? nearest : heading2);
    x += dx * wall.lengthMm;
    y += dy * wall.lengthMm;
    heading2 += wall.turnDeg;
  }
  const runs = raw.map((p, i) => {
    const q = raw[i + 1] ?? { x, y };
    return { dx: Math.abs(q.x - p.x), dy: Math.abs(q.y - p.y) };
  });
  const totalX = runs.reduce((sum, r) => sum + r.dx, 0);
  const totalY = runs.reduce((sum, r) => sum + r.dy, 0);
  let passedX = 0;
  let passedY = 0;
  raw.forEach((p, i) => {
    if (totalX > 0) p.x -= x * passedX / totalX;
    if (totalY > 0) p.y -= y * passedY / totalY;
    passedX += runs[i].dx;
    passedY += runs[i].dy;
  });
  const minX = Math.min(...raw.map((p) => p.x));
  const maxX = Math.max(...raw.map((p) => p.x));
  const minY = Math.min(...raw.map((p) => p.y));
  const maxY = Math.max(...raw.map((p) => p.y));
  const margin = 2;
  const slack = 1e-6;
  const cellMm = CELL_SIZES_MM.find(
    (mm) => (maxX - minX) / mm <= limits.cols - 2 * margin + slack && (maxY - minY) / mm <= limits.rows - 2 * margin + slack
  ) ?? CELL_SIZES_MM[CELL_SIZES_MM.length - 1];
  const nodes = raw.map((p) => ({
    col: Math.round((p.x - minX) / cellMm) + margin,
    row: Math.round((p.y - minY) / cellMm) + margin
  }));
  const n = walls.length;
  const kept = [];
  const droppedMm = [];
  for (let i = 0; i < n; i++) {
    const a = nodes[i];
    const b = nodes[(i + 1) % n];
    if (a.col === b.col && a.row === b.row) droppedMm.push(Math.round(walls[i].lengthMm));
    else kept.push(i);
  }
  if (kept.length < 3) return null;
  const points = kept.map((i) => {
    const wall = walls[i];
    return {
      ...nodes[i],
      ...wall.bulgeMm ? { bulge: wall.bulgeMm / cellMm } : {},
      ...wall.profile ? { profile: wall.profile } : {},
      ...wall.curtainNiche ? { curtainNiche: true } : {},
      ...wall.opening ? { opening: wall.opening } : {}
    };
  });
  const lengthOverridesMm = {};
  const measuredEdges = [];
  const unknownEdges = [];
  kept.forEach((i, k) => {
    const wall = walls[i];
    const key = gridEdgeKey(points[k], points[(k + 1) % points.length]);
    lengthOverridesMm[key] = Math.round(wall.lengthMm);
    if (wall.measured) measuredEdges.push(key);
    else if (wall.measured === void 0) unknownEdges.push(key);
  });
  const approximated = walls.some((w) => {
    const rem = (w.turnDeg % 90 + 90) % 90;
    return rem > SNAP_HEADING_DEG * 2 && rem < 90 - SNAP_HEADING_DEG * 2;
  });
  return {
    cellMm,
    points,
    lengthOverridesMm,
    measuredEdges,
    unknownEdges,
    approximated,
    frame: { minX, minY, col0: margin, row0: margin },
    droppedMm,
    keptWalls: kept
  };
}
function roomPointOnGrid(point, laid) {
  return {
    col: (point.x - laid.frame.minX) / laid.cellMm + laid.frame.col0,
    row: (-point.y - laid.frame.minY) / laid.cellMm + laid.frame.row0
  };
}
function centerOnGrid(laid, view, margin = 2) {
  const cols = laid.points.map((p) => p.col);
  const rows = laid.points.map((p) => p.row);
  const minCol = Math.min(...cols);
  const minRow = Math.min(...rows);
  const width = Math.max(...cols) - minCol;
  const height = Math.max(...rows) - minRow;
  const dCol = Math.max(margin, Math.floor((view.cols - width) / 2)) - minCol;
  const dRow = Math.max(margin, Math.floor((view.rows - height) / 2)) - minRow;
  if (dCol === 0 && dRow === 0) return laid;
  const points = laid.points.map((p) => ({ ...p, col: p.col + dCol, row: p.row + dRow }));
  const n = points.length;
  const renamed = /* @__PURE__ */ new Map();
  for (let k = 0; k < n; k++) {
    const was = gridEdgeKey(laid.points[k], laid.points[(k + 1) % n]);
    const now = gridEdgeKey(points[k], points[(k + 1) % n]);
    renamed.set(was, now);
  }
  const rename = (key) => renamed.get(key) ?? key;
  return {
    ...laid,
    points,
    lengthOverridesMm: Object.fromEntries(
      Object.entries(laid.lengthOverridesMm).map(([key, mm]) => [rename(key), mm])
    ),
    measuredEdges: laid.measuredEdges.map(rename),
    unknownEdges: laid.unknownEdges.map(rename),
    frame: { ...laid.frame, col0: laid.frame.col0 + dCol, row0: laid.frame.row0 + dRow }
  };
}

// src/calendar-day.ts
function calendarDay(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}
function calendarDayKey(date) {
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${date.getUTCFullYear()}-${month}-${day}`;
}

// src/calc/consumables.ts
var ConsumableCharge = {
  /** Списывается на объект: расход компании */
  COMPANY: "COMPANY",
  /** Продаётся бригаде и вычитается из её зарплаты */
  BRIGADE: "BRIGADE"
};
var CONSUMABLE_CHARGE_LABELS = {
  COMPANY: "\u0441\u043F\u0438\u0441\u044B\u0432\u0430\u0435\u0442\u0441\u044F",
  BRIGADE: "\u0437\u0430 \u0441\u0447\u0451\u0442 \u0431\u0440\u0438\u0433\u0430\u0434\u044B"
};
function packUnits(packSize) {
  if (!packSize || packSize <= 0) return 0;
  return Math.round(packSize * 1e3);
}
function ceilToPack(quantity, packSize) {
  const p = packUnits(packSize);
  if (p === 0 || !Number.isFinite(quantity)) return round3(quantity);
  const q = Math.round(quantity * 1e3);
  if (q <= 0) return 0;
  return round3(Math.ceil(q / p) * p / 1e3);
}
function floorToPack(quantity, packSize) {
  const p = packUnits(packSize);
  if (p === 0 || !Number.isFinite(quantity)) return round3(quantity);
  const q = Math.round(quantity * 1e3);
  if (q <= 0) return 0;
  return round3(Math.floor(q / p) * p / 1e3);
}
function round3(v) {
  return Math.round(v * 1e3) / 1e3;
}
function allocateConsumables(line2, jobs) {
  const requested = round3(Math.max(0, line2.requested));
  if (jobs.length === 0) {
    return { lineId: line2.lineId, parts: [], unallocated: requested, over: 0, explanation: "\u0430\u0434\u0440\u0435\u0441\u043E\u0432 \u043D\u0435\u0442" };
  }
  if (requested === 0) {
    return {
      lineId: line2.lineId,
      parts: jobs.map((j) => ({ jobId: j.jobId, quantity: 0, need: j.need ?? null })),
      unallocated: 0,
      over: 0,
      explanation: "\u043D\u0435 \u0431\u0440\u0430\u043B\u0438 \u2014 \u0440\u0430\u0437\u043D\u043E\u0441\u0438\u0442\u044C \u043D\u0435\u0447\u0435\u0433\u043E"
    };
  }
  if (jobs.length === 1) {
    const need = jobs[0].need ?? null;
    return {
      lineId: line2.lineId,
      parts: [{ jobId: jobs[0].jobId, quantity: requested, need }],
      unallocated: 0,
      over: 0,
      explanation: "\u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u2014 \u0432\u0441\u0451 \u0442\u0443\u0434\u0430"
    };
  }
  const known = jobs.filter((j) => typeof j.need === "number" && Number.isFinite(j.need) && j.need > 0);
  const pack = line2.packSize ?? null;
  if (known.length === 0) {
    let parts2;
    if (pack && pack > 0) {
      const packs = Math.ceil(round3(requested) / pack - 1e-9);
      const base = Math.floor(packs / jobs.length);
      const extra = packs - base * jobs.length;
      parts2 = jobs.map((j, i) => ({
        jobId: j.jobId,
        quantity: round3((base + (i < extra ? 1 : 0)) * pack),
        need: j.need ?? null
      }));
    } else {
      const share = round3(requested / jobs.length);
      parts2 = jobs.map((j) => ({ jobId: j.jobId, quantity: share, need: j.need ?? null }));
      const last = parts2[parts2.length - 1];
      if (last) {
        const others = round3(parts2.slice(0, -1).reduce((s, part) => s + part.quantity, 0));
        last.quantity = round3(requested - others);
      }
    }
    const sum2 = round3(parts2.reduce((s, p) => s + p.quantity, 0));
    return {
      lineId: line2.lineId,
      parts: parts2,
      unallocated: round3(Math.max(0, requested - sum2)),
      over: round3(Math.max(0, sum2 - requested)),
      explanation: `\u043D\u043E\u0440\u043C\u044B \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0430\u043C \u043D\u0435\u0442 \u2014 \u043F\u043E\u0440\u043E\u0432\u043D\u0443${pack ? `, \u043F\u0430\u043B\u043A\u0430\u043C\u0438 \u043F\u043E ${pack}` : ""}`
    };
  }
  const quantities = /* @__PURE__ */ new Map();
  for (const job of jobs) {
    const need = typeof job.need === "number" && Number.isFinite(job.need) && job.need > 0 ? job.need : 0;
    quantities.set(job.jobId, ceilToPack(need, pack));
  }
  const total = () => round3([...quantities.values()].reduce((s, v) => s + v, 0));
  const step = pack && pack > 0 ? pack : null;
  if (step) {
    for (let guard = 0; guard < 1e3 && total() > requested; guard++) {
      const candidates2 = jobs.map((j) => ({
        jobId: j.jobId,
        quantity: quantities.get(j.jobId),
        slack: round3(quantities.get(j.jobId) - (j.need ?? 0))
      })).filter((c) => c.quantity - step >= 0).sort((a, b) => b.slack - a.slack);
      const best = candidates2[0];
      if (!best) break;
      if (best.slack <= 0) break;
      if (round3(total() - step) < requested) break;
      quantities.set(best.jobId, round3(best.quantity - step));
    }
  } else if (total() > requested) {
    const sum2 = total();
    for (const job of jobs) {
      quantities.set(job.jobId, round3(quantities.get(job.jobId) * requested / sum2));
    }
    const last = [...jobs].reverse().find((j) => quantities.get(j.jobId) > 0);
    if (last) {
      const others = round3(
        jobs.filter((j) => j !== last).reduce((acc, j) => acc + quantities.get(j.jobId), 0)
      );
      quantities.set(last.jobId, round3(requested - others));
    }
  }
  const unknownJobs = jobs.filter((j) => !known.includes(j));
  const rest = round3(requested - total());
  if (unknownJobs.length > 0 && rest > 0) {
    if (pack && pack > 0) {
      const packs = Math.ceil(rest / pack - 1e-9);
      const base = Math.floor(packs / unknownJobs.length);
      const extra = packs - base * unknownJobs.length;
      unknownJobs.forEach((j, i) => {
        quantities.set(j.jobId, round3((base + (i < extra ? 1 : 0)) * pack));
      });
    } else {
      const share = round3(rest / unknownJobs.length);
      unknownJobs.forEach((j) => quantities.set(j.jobId, share));
      const lastUnknown = unknownJobs[unknownJobs.length - 1];
      quantities.set(lastUnknown.jobId, round3(rest - share * (unknownJobs.length - 1)));
    }
  }
  const sum = total();
  const parts = jobs.map((j) => ({
    jobId: j.jobId,
    quantity: quantities.get(j.jobId),
    need: typeof j.need === "number" && Number.isFinite(j.need) ? round3(j.need) : null
  }));
  const unknown = jobs.length - known.length;
  return {
    lineId: line2.lineId,
    parts,
    unallocated: round3(Math.max(0, requested - sum)),
    over: round3(Math.max(0, sum - requested)),
    explanation: `\u043F\u043E \u043D\u043E\u0440\u043C\u0430\u043C \u0430\u0434\u0440\u0435\u0441\u043E\u0432${pack ? `, \u043F\u0430\u043B\u043A\u0430\u043C\u0438 \u043F\u043E ${pack}` : ""}` + (unknown > 0 ? `; \u0443 ${unknown} \u0430\u0434\u0440\u0435\u0441(\u043E\u0432) \u043D\u043E\u0440\u043C\u044B \u043D\u0435\u0442` : "")
  };
}
function extrasEntries(text3) {
  return (text3 ?? "").split(/[\r\n]+/).map((s) => s.trim()).filter(Boolean);
}
function parseAltCodes(text3, mainCode) {
  const main = (mainCode ?? "").trim().toLowerCase();
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const raw of (text3 ?? "").split(/[,;\s]+/)) {
    const code = raw.trim();
    const key = code.toLowerCase();
    if (!code || key === main || seen.has(key)) continue;
    seen.add(key);
    out.push(code);
  }
  return out;
}
function consumableItemCodes(item) {
  const main = (item.externalCode ?? "").trim();
  return [...main ? [main] : [], ...parseAltCodes(item.altCodes, main)];
}
function chargeForCode(code, catalog, charged) {
  const key = (code ?? "").trim().toLowerCase();
  if (!key) return ConsumableCharge.COMPANY;
  const item = catalog.find(
    (i) => i.isActive !== false && consumableItemCodes(i).some((c) => c.toLowerCase() === key)
  );
  if (!item) return ConsumableCharge.COMPANY;
  return new Set(charged).has(item.id) ? ConsumableCharge.BRIGADE : item.chargeTo;
}
function matchConsumableAliases(text3, items) {
  const dictionary = [];
  for (const item of items) {
    for (const raw of (item.aliases ?? "").split(/[,;]/)) {
      const alias = normalizeAlias2(raw);
      if (alias.length >= 2) dictionary.push({ alias, item });
    }
  }
  dictionary.sort((a, b) => b.alias.length - a.alias.length);
  return extrasEntries(text3).map((source) => {
    const probe = normalizeAlias2(source);
    const hit = dictionary.find((d) => probe.includes(d.alias));
    return { item: hit ? hit.item : null, quantity: quantityFrom(source, hit?.alias), source };
  });
}
function normalizeAlias2(value) {
  return value.toLowerCase().replace(/ё/g, "\u0435").replace(/[\s\-_.]/g, "");
}
function quantityFrom(source, alias) {
  let rest = source;
  if (alias) {
    const pattern = alias.split("").map((c) => escapeRegExp(c)).join("[\\s\\-_.]*");
    rest = source.replace(new RegExp(pattern, "i"), " ");
  }
  const numbers = [...rest.matchAll(/(\d+(?:[.,]\d+)?)/g)].map((m) => Number(m[1].replace(",", ".")));
  const value = numbers.find((n) => Number.isFinite(n) && n > 0);
  return value === void 0 ? null : round3(value);
}
function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var ALLOCATION_EPS = 1e-6;
function allocatedOver(sum, requested, packSize) {
  const pack = packSize && packSize > 0 ? packSize : 0;
  return sum - requested >= pack - ALLOCATION_EPS && sum - requested > ALLOCATION_EPS;
}
function allocatedShort(sum, requested) {
  return requested - sum > ALLOCATION_EPS;
}
function addressKey(dealId, installationId) {
  return `${dealId}|${installationId ?? ""}`;
}
function allocateByBrigade(line2, jobs) {
  const requested = round3(Math.max(0, line2.requested));
  const takes = jobs.map((j) => round3(Number.isFinite(j.take) ? Math.max(0, j.take) : 0));
  const total = round3(takes.reduce((s, v) => s + v, 0));
  const parts = jobs.map((j, i) => ({
    jobId: j.jobId,
    quantity: takes[i],
    need: typeof j.need === "number" && Number.isFinite(j.need) ? round3(j.need) : null
  }));
  const trimmed = total > requested;
  if (trimmed) {
    parts.forEach((p, i) => {
      p.quantity = round3(takes[i] * requested / total);
    });
    const last = [...parts].reverse().find((p) => p.quantity > 0);
    if (last) {
      const others = round3(parts.filter((p) => p !== last).reduce((s, p) => s + p.quantity, 0));
      last.quantity = round3(requested - others);
    }
  }
  const sum = round3(parts.reduce((s, p) => s + p.quantity, 0));
  return {
    lineId: line2.lineId,
    parts,
    unallocated: round3(Math.max(0, requested - sum)),
    over: round3(Math.max(0, sum - requested)),
    explanation: trimmed ? "\u043A\u0430\u043A \u0440\u0430\u0437\u043D\u0435\u0441\u043B\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0430, \u0441\u0434\u0430\u043D\u043D\u043E\u0435 \u0441\u043D\u044F\u0442\u043E \u0434\u043E\u043B\u044F\u043C\u0438" : "\u043A\u0430\u043A \u0440\u0430\u0437\u043D\u0435\u0441\u043B\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0430"
  };
}
function readAddressTakes(value) {
  if (!Array.isArray(value)) return [];
  const takes = [];
  for (const raw of value) {
    if (!raw || typeof raw !== "object") continue;
    const entry = raw;
    const quantity = round3(Number(entry.quantity));
    if (typeof entry.dealId !== "string" || !entry.dealId || !Number.isFinite(quantity) || quantity <= 0) continue;
    takes.push({
      dealId: entry.dealId,
      installationId: typeof entry.installationId === "string" && entry.installationId ? entry.installationId : null,
      quantity
    });
  }
  return takes;
}
function addressSplitSig(value) {
  return readAddressTakes(value).map((t) => `${addressKey(t.dealId, t.installationId)}=${t.quantity}`).sort().join(";");
}

// src/calc/pickup-stock.ts
var STOCK_SEARCH_LIMIT = 500;
function pickupWarehouses(text3) {
  return (text3 ?? "").split(/[\n;]+/).map((s) => s.trim()).filter(Boolean).slice(0, 20);
}
var norm = (s) => s.toLowerCase().replace(/ё/g, "\u0435").trim();
function isWarehouseList(warehouse) {
  if (/\s\+\d+$/.test(warehouse)) return true;
  return (warehouse.match(/,/g) ?? []).length >= 3;
}
function isOurWarehouse(warehouse, pickup) {
  if (isWarehouseList(warehouse)) return false;
  const value = norm(warehouse);
  return pickup.some((p) => {
    const needle = norm(p);
    return needle.length > 0 && value.includes(needle);
  });
}
function pickupStock(places, pickup) {
  if (!places || places.length === 0) return null;
  const withStock = places.filter((p) => p.quantity > 0);
  const total = withStock.reduce((sum, p) => sum + p.quantity, 0);
  if (withStock.length === 0) {
    return { ours: [], elsewhere: 0, total: 0, unnamed: false, empty: true };
  }
  const named = withStock.filter((p) => !isWarehouseList(p.warehouse));
  const unnamed = named.length === 0;
  const ours = pickup.length ? pickup.map((name) => named.filter((p) => isOurWarehouse(p.warehouse, [name]))).flat().filter((place, i, all) => all.indexOf(place) === i) : [...named].sort((a, b) => b.quantity - a.quantity).slice(0, 2);
  const oursTotal = ours.reduce((sum, p) => sum + p.quantity, 0);
  return {
    ours,
    elsewhere: Math.max(0, total - oursTotal),
    total,
    unnamed,
    empty: false
  };
}
function stockShort(stock, requested) {
  if (!stock || requested <= 0) return false;
  if (stock.empty) return true;
  if (stock.unnamed) return requested > stock.total;
  const best = Math.max(0, ...stock.ours.map((p) => p.quantity));
  return requested > best;
}
function onIssueShelf(places, warehouse) {
  if (!places || places.length === 0 || !warehouse) return null;
  const named = places.filter((p) => !isWarehouseList(p.warehouse));
  if (named.length === 0) return null;
  return named.filter((p) => isOurWarehouse(p.warehouse, [warehouse])).reduce((sum, p) => sum + Math.max(0, p.quantity), 0);
}
function shelfRank(places, pickup) {
  const stock = pickupStock(places, pickup);
  if (!stock || stock.empty) return 2;
  if (stock.unnamed) return 0;
  return stock.ours.length > 0 ? 0 : 1;
}
function orderByShelf(variants, placesOf, pickup) {
  return variants.map((v, i) => ({ v, i, rank: shelfRank(placesOf(v), pickup) })).sort((a, b) => a.rank - b.rank || a.i - b.i).map((x) => x.v);
}

// src/calc/stock-search.ts
var STOCK_SEARCH_WORDS = 20;
var EDGE_MARKS = /^[("«'\[{,.;:!?]+|[)"»'\]},.;:!?]+$/g;
function stockSearchWords(search) {
  return (search ?? "").trim().split(/\s+/).map((w) => w.replace(EDGE_MARKS, "").trim()).filter((w) => w.length > 0).slice(0, STOCK_SEARCH_WORDS);
}
function stockSearchKey(value) {
  return (value ?? "").toLowerCase().replace(/ё/g, "\u0435");
}
function stockWordsMatch(words, position) {
  if (words.length === 0) return true;
  const fields = [position.name, position.fullName, position.externalCode, position.article].map(stockSearchKey);
  return words.every((word) => {
    const key = stockSearchKey(word);
    return fields.some((field) => field.includes(key));
  });
}
var TWIN_SEARCH_LIMIT = 20;
function searchStockIndex(index, search) {
  const words = stockSearchWords(search);
  const asOf = index.asOf ?? index.builtAt;
  const place = (i) => i >= 0 ? index.warehouses[i] ?? null : null;
  const out = [];
  let found = 0;
  for (const p of index.positions) {
    if (found > STOCK_SEARCH_LIMIT) break;
    if (!stockWordsMatch(words, { externalCode: p.c, name: p.n, fullName: p.f, article: p.a })) continue;
    found += 1;
    const base = {
      externalCode: p.c,
      name: p.n,
      fullName: p.f ?? null,
      article: p.a ?? null,
      unit: p.u,
      asOf,
      ...p.x ? { ambiguous: true } : {}
    };
    if (p.w.length === 0) out.push({ ...base, quantity: 0, warehouse: null });
    for (const [w, quantity] of p.w) out.push({ ...base, quantity, warehouse: place(w) });
  }
  let twins = 0;
  for (const t of index.twins) {
    if (twins >= TWIN_SEARCH_LIMIT) break;
    if (!stockWordsMatch(words, { externalCode: t.c, name: t.n, fullName: t.f, article: t.a })) continue;
    twins += 1;
    const base = {
      externalCode: t.c,
      name: t.n,
      fullName: t.f ?? null,
      article: t.a ?? null,
      unit: t.u,
      asOf,
      ambiguous: true,
      twin: true,
      stockKnown: t.k === 1
    };
    if (t.w.length === 0) out.push({ ...base, quantity: 0, warehouse: null });
    for (const [w, quantity] of t.w) out.push({ ...base, quantity, warehouse: place(w) });
  }
  return out;
}

// src/calc/nomenclature-match.ts
var PAPER_NOISE = /* @__PURE__ */ new Set([
  "\u043F\u043E\u0434\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044C",
  "\u043D\u0443\u0436\u043D\u043E\u0435",
  "\u0438\u043B\u0438",
  "\u043B\u0438\u0431\u043E",
  "\u0434\u043B\u044F",
  "\u0441\u043A\u043B\u0430\u0434\u0430",
  "\u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B",
  "\u0441\u043C",
  "\u043F\u0440\u0438",
  "\u0448\u0442"
]);
function meaningful(word) {
  if (PAPER_NOISE.has(word)) return false;
  return word.length > 1 || /\d/.test(word);
}
function nomenclatureWords(name) {
  return name.toLowerCase().replace(/ё/g, "\u0435").replace(/(\d),(\d)/g, "$1.$2").replace(/(\d)\s*(мм|см|шт|кг|гр|м|г|л)(?![a-zа-я])/g, "$1 $2").replace(/[^a-zа-я0-9.]+/g, " ").split(" ").map((w) => w.replace(/^\.+|\.+$/g, "")).filter((w) => w.length > 0 && meaningful(w));
}
function positionTitle(position) {
  if (isObsoletePosition(position.name)) return position.name.slice(0, TITLE_MAX);
  return (position.fullName?.trim() || position.name).slice(0, TITLE_MAX);
}
var TITLE_MAX = 300;
function isObsoleteCandidate(position) {
  return isObsoletePosition(position.name) || isObsoletePosition(position.fullName);
}
function isObsoletePosition(name) {
  return /^\s*удалить(?![а-яё])/iu.test(name ?? "");
}
function indexNomenclature(candidates2) {
  const docs = candidates2.filter((c) => !isObsoleteCandidate(c)).map((candidate) => ({
    candidate,
    words: new Set(nomenclatureWords(`${candidate.name} ${candidate.fullName ?? ""}`))
  }));
  const freq = /* @__PURE__ */ new Map();
  for (const doc of docs) for (const w of doc.words) freq.set(w, (freq.get(w) ?? 0) + 1);
  const total = Math.max(docs.length, 1);
  return {
    docs,
    // Обратная частота: слово из половины названий почти ничего не значит,
    // слово из трёх — почти всё. Не ниже нуля: общее слово не должно
    // вычитать вес у редкого
    weight: (word) => Math.max(Math.log(total / (1 + (freq.get(word) ?? 0))), 0.01)
  };
}
function suggestNomenclature(name, index, options = {}) {
  const limit = options.limit ?? 3;
  const minScore = options.minScore ?? 0.3;
  const words = [...new Set(nomenclatureWords(name))];
  if (words.length === 0) return { suggestions: [], ambiguous: false };
  const denom = words.reduce((s, w) => s + index.weight(w), 0);
  if (denom <= 0) return { suggestions: [], ambiguous: false };
  const scored = [];
  for (const doc of index.docs) {
    let hit = 0;
    for (const w of words) if (doc.words.has(w)) hit += index.weight(w);
    const score = hit / denom;
    if (score >= minScore) {
      scored.push({ ...doc.candidate, score: Math.round(score * 100) / 100 });
    }
  }
  scored.sort((a, b) => b.score - a.score || positionTitle(a).localeCompare(positionTitle(b), "ru"));
  const suggestions = scored.slice(0, limit);
  const top = scored.slice(0, 2);
  const ambiguous = top.length > 1 && Math.round(top[0].score * 100) - Math.round(top[1].score * 100) < 5;
  return { suggestions, ambiguous };
}
function paperArticles(paperCode) {
  if (!paperCode) return [];
  const parts = String(paperCode).split(/[^0-9A-Za-zА-Яа-яёЁ-]+/).map((s) => s.trim()).filter((s) => s.length >= 3 && /^\d/.test(s));
  return [...new Set(parts)];
}
function articleWords(article) {
  return String(article ?? "").toLowerCase().split(/[\s/;|]+/).map((w) => w.replace(/^[,.:]+|[,.:]+$/g, "")).filter((w) => w.length > 0);
}
function titleWords(title) {
  const words = title.toLowerCase().replace(/ё/g, "\u0435").match(/[a-z]+|[а-я]+/g) ?? [];
  return words.filter((w) => w.length >= 3 && !PAPER_NOISE.has(w));
}
function shareTitleWord(a, b) {
  for (const x of a) {
    for (const y of b) {
      if (x === y) return true;
      if (x.length < 5 || y.length < 5) continue;
      let n = 0;
      while (n < x.length && n < y.length && x[n] === y[n]) n += 1;
      if (n >= 5) return true;
    }
  }
  return false;
}
function matchByArticle(paperCode, candidates2, lineName) {
  const wanted = paperArticles(paperCode).map((a) => a.toLowerCase());
  if (wanted.length === 0) return [];
  const lineWords = lineName ? titleWords(lineName) : [];
  const found = [];
  const hitOf = /* @__PURE__ */ new Map();
  for (const candidate of candidates2) {
    if (isObsoleteCandidate(candidate)) continue;
    if (hitOf.has(candidate.externalCode)) continue;
    const whole = String(candidate.article ?? "").trim().toLowerCase();
    if (!whole) continue;
    let hit = wanted.indexOf(whole);
    if (hit < 0) {
      const word = articleWords(whole).find((w) => wanted.includes(w));
      if (!word) continue;
      if (!shareTitleWord(lineWords, titleWords(`${candidate.name} ${candidate.fullName ?? ""}`))) continue;
      hit = wanted.indexOf(word);
    }
    hitOf.set(candidate.externalCode, hit);
    found.push({ ...candidate, score: 1 });
  }
  found.sort(
    (a, b) => hitOf.get(a.externalCode) - hitOf.get(b.externalCode) || positionTitle(a).localeCompare(positionTitle(b), "ru", { numeric: true })
  );
  return found;
}
var UNIT_ALIASES = {
  \u043F\u043C: "\u043C",
  \u043F\u043E\u0433\u043C: "\u043C",
  \u043F\u043E\u0433\u043E\u043D\u043D\u044B\u0439\u043C\u0435\u0442\u0440: "\u043C",
  \u043F\u043E\u0433\u043E\u043D\u043D\u044B\u0445\u043C\u0435\u0442\u0440\u043E\u0432: "\u043C",
  \u0443\u043F: "\u0443\u043F\u0430\u043A"
};
function sameUnit(a, b) {
  const norm2 = (u) => {
    const k = (u ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/[.\s]/g, "");
    return UNIT_ALIASES[k] ?? k;
  };
  return norm2(a) === norm2(b);
}

// src/calc/onec-twins.ts
function twinNameKey(name) {
  return (name ?? "").trim().toLowerCase().replace(/ё/g, "\u0435").replace(/\s+/g, " ").slice(0, 200);
}
function namesOf(good) {
  return [positionTitle(good), good.name, good.fullName ?? ""].map(twinNameKey).filter(Boolean);
}
function pickTwin(chosen, goods) {
  const key = twinNameKey(chosen);
  if (!key) return null;
  const hits = goods.filter((g) => namesOf(g).includes(key));
  return hits.length === 1 ? hits[0] : null;
}
function twinStockKey(code, name) {
  return `${code.trim().toLowerCase()}#${twinNameKey(name)}`;
}
function twinStockKeys(code, good, goods) {
  return [...new Set(namesOf(good))].filter((k) => pickTwin(k, goods) === good).map((k) => twinStockKey(code, k));
}
function stockForLine(stock, code, chosen) {
  if (!stock || !code) return void 0;
  if (chosen) {
    const own = stock[twinStockKey(code, chosen)];
    if (own !== void 0) return own;
  }
  return stock[code];
}

// src/onec-drawings.ts
import { z as z4 } from "zod";
function drawingToken(text3) {
  const m = /^(\d{3,}[A-Za-zА-Яа-яЁё]{0,3})(?![A-Za-zА-Яа-яЁё\d])/.exec((text3 ?? "").trim());
  if (!m?.[1]) return "";
  return m[1].toUpperCase().replace(/N/g, "\u041D").replace(/H/g, "\u041D").replace(/A/g, "\u0410");
}
var ADDRESS_NOISE = /* @__PURE__ */ new Set(["\u0443\u043B", "\u0443\u043B\u0438\u0446\u0430", "\u0434", "\u0434\u043E\u043C", "\u043A\u0432", "\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430", "\u0433", "\u0433\u043E\u0440\u043E\u0434"]);
function drawingAddressKey(address) {
  let s = (address ?? "").toLowerCase().replace(/ё/g, "\u0435").trim();
  s = s.replace(/\([^)]*\)/g, " ").trim();
  s = s.replace(/^(\d{3,}[a-zа-я]{0,3}(?![a-zа-я\d])|б\s*[/\\]?\s*[нд]\.?(?![a-zа-я]))\s*/u, "");
  s = s.replace(/[«»"'(),.;:\-–—]/g, " ");
  return s.split(/\s+/).filter((w) => w && !ADDRESS_NOISE.has(w)).join(" ");
}
var LEGAL_FORMS = /* @__PURE__ */ new Set(["\u043E\u043E\u043E", "\u0438\u043F", "\u043E\u0430\u043E", "\u0437\u0430\u043E", "\u043F\u0430\u043E", "\u0430\u043E", "\u043D\u043A\u043E", "\u0430\u043D\u043E", "\u0442\u0441\u0436"]);
function drawingOwnerWords(name) {
  const k = (name ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/[^\p{L}\p{Nd}]+/gu, " ");
  return [...new Set(k.split(/\s+/).filter((w) => w.length >= 2 && !LEGAL_FORMS.has(w)))];
}
function drawingOwnerIsOrganization(name) {
  const k = (name ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/[^\p{L}\p{Nd}]+/gu, " ");
  return k.split(/\s+/).some((w) => LEGAL_FORMS.has(w));
}
function sameDrawingOwner(a, b) {
  const wa = drawingOwnerWords(a);
  const wb = drawingOwnerWords(b);
  if (wa.length === 0 || wb.length === 0) return false;
  const common = wa.filter((w) => wb.includes(w)).length;
  return common === wa.length || common === wb.length;
}
var DRAWING_PAGE_THRESHOLDS = {
  probeWidth: 496,
  blankInk: 0.03,
  printBlack: 2.5,
  printComps: 1300,
  /*
   * Спецификация (правило 263) — измерено 13.10.2026 на 24 сканах договоров
   * компании (292 страницы) и на первом живом проходе станции (137 страниц
   * бланка). Сетка таблицы — серые линии бланка (яркость ниже 220, без
   * цвета), сшитые в одно пятно: рамка у спецификации — 41–95% листа, у
   * страниц договора — не больше 4% (QR-код оплаты). Таблица бывает и у
   * других бумаг: вложенная «Расходная накладная» (30%, тонера 4,2%),
   * допсоглашение (38%, тонера 6,4–7,3%, графы паспорта заказчика) и акт
   * приёма-передачи (25%, ФИО и подпись заказчика). У бланка спецификации
   * строк сетки 24–58, у них — 15–21; тонера 8,8–17,8% против не больше 7,3%
   * у накладной и допсоглашения.
   */
  specGrid: 0.33,
  specBlack: 8,
  specComps: 600,
  specLines: 22,
  /*
   * СПЕЦИФИКАЦИЯ — НЕ МЕНЬШЕ ДВУХ СТРАНИЦ ФАЙЛА. Бланк печатается на трёх
   * листах, и в каждом скане их две-три. Акт, допсоглашение, фото страницы
   * с телефона — один лист: одинокая «таблица» в файле — не спецификация,
   * и показать её значит показать бумагу с паспортом или подписью
   * заказчика. Поймано первым живым проходом 13.10.2026: так прошли два
   * допсоглашения и акт.
   */
  specMinPages: 2
};
function drawingPageKind(s) {
  const t = DRAWING_PAGE_THRESHOLDS;
  if (s.ink < t.blankInk) return "blank";
  const printed = s.black >= t.printBlack || s.comps >= t.printComps && s.colored < 0.5 * s.ink;
  if (!printed) return "drawing";
  return isSpecPage(s) ? "spec" : "print";
}
function isSpecPage(s) {
  const t = DRAWING_PAGE_THRESHOLDS;
  return s.grid !== void 0 && s.lines !== void 0 && s.grid >= t.specGrid && s.lines >= t.specLines && s.black >= t.specBlack && s.comps >= t.specComps;
}
function drawingFileKinds(pages) {
  const kinds = pages.map((p) => drawingPageKind(p));
  const spec = kinds.filter((k) => k === "spec").length;
  return spec >= DRAWING_PAGE_THRESHOLDS.specMinPages ? kinds : kinds.map((k) => k === "spec" ? "print" : k);
}
var pageSchema = z4.object({
  n: z4.number().int().min(1).max(1e3),
  kind: z4.enum(["drawing", "spec", "print", "blank"]),
  ink: z4.number().min(0).max(100),
  black: z4.number().min(0).max(100),
  colored: z4.number().min(0).max(100),
  comps: z4.number().int().min(0),
  grid: z4.number().min(0).max(1).optional(),
  lines: z4.number().min(0).max(1e4).optional(),
  w: z4.number().int().min(1).max(1e4).optional(),
  h: z4.number().int().min(1).max(2e4).optional(),
  /** Картинка листа, JPEG в base64 — только у рукописного и спецификации */
  jpeg: z4.string().max(4e6).optional()
}).strict();
var DRAWING_LINK_KINDS = ["address", "customer"];
var drawingLinkSchema = z4.object({
  /** Адрес CRM ключом `drawingAddressKey` — тот, что CRM назвала станции */
  key: z4.string().trim().min(1).max(255),
  matchedBy: z4.enum(DRAWING_LINK_KINDS)
}).strict();
var onecDrawingUploadSchema = z4.object({
  base: onecBaseSchema,
  file: z4.object({
    /** Присоединённый файл 1С — УИД его ссылки */
    id: z4.string().trim().min(1).max(64),
    /** Номер заказа из имени файла; пусто — файл назван адресом и едет только с привязками */
    token: z4.string().trim().max(32),
    name: z4.string().trim().min(1).max(255),
    ext: z4.string().trim().max(16),
    owner: z4.string().trim().min(1).max(255),
    ownerCode: z4.string().trim().max(64).nullish(),
    size: z4.number().min(0).nullish(),
    modifiedAt: z4.string().refine((v) => !Number.isNaN(new Date(v).getTime()), "\u0414\u0430\u0442\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0444\u0430\u0439\u043B\u0430 \u043D\u0435 \u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F"),
    modifiedBy: z4.string().trim().max(255).nullish(),
    pageCount: z4.number().int().min(0).max(5e3),
    pages: z4.array(pageSchema).max(1e3),
    /**
     * К каким адресам без номера заказа станция нашла этот файл: договор
     * назван этим адресом (`address`) или файл этого заказчика (`customer`)
     */
    links: z4.array(drawingLinkSchema).max(20).optional()
  }).strict()
}).strict();
var onecDrawingsCheckedSchema = z4.object({
  base: onecBaseSchema,
  tokens: z4.array(z4.string().trim().min(1).max(32)).max(2e3),
  seen: z4.array(z4.string().trim().min(1).max(64)).max(5e3),
  /**
   * О ком станция спрашивала под каждым номером (правило 263). Под одним
   * номером в 1С лежат файлы разных заказчиков; проверенным считается
   * только тот, о ком спросили: чужой файл станция не открывает и
   * увиденным не называет — он не пропал из 1С. Старый агент поля не
   * шлёт — тогда заказчики окна выездов, как было.
   */
  asked: z4.array(
    z4.object({
      token: z4.string().trim().min(1).max(32),
      owners: z4.array(z4.string().trim().min(1).max(255)).max(50)
    }).strict()
  ).max(2e3).optional(),
  /** Адреса без номера, проверенные целиком, и что к ним нашлось: прочие привязки снимаются */
  addresses: z4.array(z4.string().trim().min(1).max(255)).max(2e3).optional(),
  /**
   * Что нашлось к этим адресам; с `matchedBy` — привязка заводится и у файла,
   * который станция не качала заново (он уже лежит в CRM)
   */
  seenLinks: z4.array(
    z4.object({
      key: z4.string().trim().min(1).max(255),
      id: z4.string().trim().min(1).max(64),
      matchedBy: z4.enum(DRAWING_LINK_KINDS).optional()
    }).strict()
  ).max(5e3).optional()
}).strict();
function drawingTokenBase(token) {
  const digits = /^\d+/.exec(token)?.[0] ?? "";
  return digits && digits !== token ? digits : "";
}
function contractNumberToken(contract) {
  const m = /^Договор\s*№\s*(\d[\d\s]*\d|\d)\s+от(?![а-яё])/i.exec((contract ?? "").trim());
  const n = m?.[1]?.replace(/\s+/g, "") ?? "";
  return n.length >= 3 ? n : "";
}
function contractScanFiles(contract, files) {
  const token = drawingToken(contract.contract);
  if (!token) {
    const n = contractNumberToken(contract.contract);
    if (!n) return [];
    return files.filter(
      (f) => f.orderToken.replace(/\D/g, "") === n && sameDrawingOwner(f.ownerName, contract.customer)
    );
  }
  const pick2 = (t) => files.filter((f) => f.onecBase === contract.base && f.orderToken === t && sameDrawingOwner(f.ownerName, contract.customer));
  const own = pick2(token);
  const base = drawingTokenBase(token);
  return own.length > 0 || !base ? own : pick2(base);
}
function scanSignature(pages) {
  if (!Array.isArray(pages)) return null;
  const marks = pages.flatMap((p) => {
    const x = p ?? {};
    return Number.isInteger(x.n) && Number(x.bytes) > 0 ? [`${x.n}:${x.w}x${x.h}:${x.bytes}`] : [];
  });
  return marks.length > 0 ? marks.sort().join("|") : null;
}
function uniqueScanFiles(files) {
  const groups = /* @__PURE__ */ new Map();
  const order = [];
  for (const f of files) {
    const key = scanSignature(f.pages) ?? `id:${f.id}`;
    const g = groups.get(key);
    if (g) g.push(f);
    else {
      groups.set(key, [f]);
      order.push(key);
    }
  }
  return order.map((key) => {
    const g = groups.get(key);
    const keep = g.reduce((a, b) => b.id < a.id ? b : a);
    return { ...keep, twins: g.filter((f) => f !== keep).map((f) => f.id) };
  });
}
var ARC_SLICE_KIND = "arc";
function archiveScanTargets(base, rows) {
  if (!Array.isArray(rows)) return [];
  const out = [];
  for (const r of rows) {
    if (r?.Del === true) continue;
    const token = drawingToken(String(r?.Name ?? ""));
    const owner = String(r?.Customer ?? "").trim();
    if (token && owner) out.push({ base, token, owner, date: "" });
  }
  return out;
}
function archiveSpecContracts(base, rows, files, known) {
  if (!Array.isArray(rows)) return [];
  const hasSpec = (pages) => Array.isArray(pages) && pages.some((p) => !!p && p.kind === "spec");
  const byToken = /* @__PURE__ */ new Map();
  for (const f of files) {
    if (f.onecBase !== base || !hasSpec(f.pages)) continue;
    const list = byToken.get(f.orderToken) ?? [];
    list.push(f);
    byToken.set(f.orderToken, list);
  }
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  for (const r of rows) {
    if (r?.Del === true) continue;
    const name = String(r?.Name ?? "").trim();
    const customer = String(r?.Customer ?? "").trim();
    const token = drawingToken(name);
    if (!name || !customer || !token || seen.has(name)) continue;
    if (known.has(`${base}|${name.replace(/\s+/gu, " ")}`)) continue;
    const candidates2 = [...byToken.get(token) ?? [], ...byToken.get(drawingTokenBase(token)) ?? []];
    if (candidates2.length === 0 || contractScanFiles({ base, contract: name, customer }, candidates2).length === 0) continue;
    seen.add(name);
    out.push(name);
  }
  return out;
}

// src/calc/easyceiling.ts
function parseDate(value) {
  if (!value) return null;
  const m = /^(\d{2})\.(\d{2})\.(\d{4})/.exec(value.trim());
  if (!m) return null;
  return `${m[3]}-${m[2]}-${m[1]}`;
}
function num(value) {
  if (!value) return null;
  const n = Number(value.trim().replace(",", "."));
  return Number.isFinite(n) ? n : null;
}
function text(value) {
  const t = value?.trim();
  return t ? t : null;
}
function parseEasyCeiling(content) {
  const lines = content.replace(/\r\n/g, "\n").split("\n").map((l) => l.trim());
  const at = (i) => lines[i];
  const indexOf = (value, from = 0) => lines.indexOf(value, from);
  const warnings = [];
  const logoAt = indexOf("EmptyLogo");
  const orderNo = logoAt >= 0 ? text(at(logoAt + 4)) : null;
  const orderDate = logoAt >= 0 ? parseDate(at(logoAt + 5)) : null;
  const address = logoAt >= 0 ? text(at(logoAt + 6)) : null;
  const nameAt = indexOf("NameCeiling");
  const roomName = nameAt >= 0 ? text(at(nameAt + 1)) : null;
  const facturaAt = indexOf("<Factura>");
  const materialName = facturaAt >= 0 ? text(at(facturaAt + 2)) : null;
  const widthCm = facturaAt >= 0 ? num(at(facturaAt + 5)) : null;
  const shrinkage = facturaAt >= 0 ? num(at(facturaAt + 6)) : null;
  const facturaEnd = indexOf("</Factura>");
  const harpoonType = facturaEnd >= 0 ? text(at(facturaEnd + 1)) : null;
  const baAt = indexOf("VerBA");
  const vertexAngles = [];
  const imageEnd = indexOf("</Image>");
  const rawCount = imageEnd >= 0 ? num(at(imageEnd + 2)) : null;
  const vertexCount = rawCount !== null && Number.isInteger(rawCount) && rawCount >= 3 ? rawCount : null;
  if (baAt >= 0) {
    for (let i = baAt + 3; i + 1 < lines.length; i += 2) {
      const letter = at(i);
      const angle = num(at(i + 1));
      if (!letter || !/^[A-Z]$/.test(letter) || angle === null) break;
      vertexAngles.push(angle);
    }
  }
  const ecVer5At = indexOf("<ECVer5>");
  const shipAt = ecVer5At >= 0 ? parseDate(at(ecVer5At + 2)) : null;
  const deliveryTo = ecVer5At >= 0 ? text(at(ecVer5At + 3)) : null;
  warnings.push(
    "\u0414\u043B\u0438\u043D\u044B \u0441\u0442\u0435\u043D \u0438 \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u0435\u0439 \u0432 \u0444\u0430\u0439\u043B\u0435 \u0437\u0430\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u044B \u2014 \u0438\u0445 \u043F\u0440\u0438\u0434\u0451\u0442\u0441\u044F \u0432\u0432\u0435\u0441\u0442\u0438 \u0440\u0443\u043A\u0430\u043C\u0438. \u0424\u043E\u0440\u043C\u0430 \u043A\u043E\u043C\u043D\u0430\u0442\u044B, \u0444\u0430\u043A\u0442\u0443\u0440\u0430 \u0438 \u0430\u0434\u0440\u0435\u0441 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0443\u0442\u0441\u044F."
  );
  if (vertexAngles.length === 0) {
    warnings.push("\u0423\u0433\u043B\u044B \u0432 \u0444\u0430\u0439\u043B\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B: \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u044D\u0442\u043E \u0434\u0440\u0443\u0433\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u0444\u043E\u0440\u043C\u0430\u0442\u0430");
  } else if (vertexCount !== null && vertexAngles.length + 1 < vertexCount) {
    warnings.push(
      `\u0423\u0433\u043B\u043E\u0432 \u0432 \u0444\u0430\u0439\u043B\u0435 ${vertexAngles.length} \u043F\u0440\u0438 ${vertexCount} \u0432\u0435\u0440\u0448\u0438\u043D\u0430\u0445 \u2014 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u0441\u0430\u043C`
    );
  }
  return {
    orderNo,
    orderDate,
    address,
    roomName,
    material: {
      name: materialName,
      // У них ширина в сантиметрах: 400 — это 4 метра
      // Ширина есть, только если она положительная: ноль из порченой строки
      // — это «не задана», а не рулон нулевой ширины
      widthMm: widthCm !== null && widthCm > 0 ? Math.round(widthCm * 10) : null,
      // И усадка долей: 0.07 — это 7%
      shrinkagePercent: shrinkage === null ? null : Number((shrinkage * 100).toFixed(2))
    },
    harpoonType,
    vertexAngles,
    vertexCount,
    shipAt,
    deliveryTo,
    warnings
  };
}
function completeVertexAngles(angles, vertexCount) {
  if (angles.length !== vertexCount - 1 || vertexCount < 3) return angles;
  const sum = 180 * (vertexCount - 2);
  const last = sum - angles.reduce((a, b) => a + b, 0);
  return last > 0 && last < 360 ? [...angles, last] : angles;
}
function anglesToWalls(angles) {
  return angles.map((angle) => ({ lengthMm: 0, turnDeg: 180 - angle }));
}

// src/calc/easyceiling-export.ts
function toEcDate(iso) {
  if (!iso) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso.trim());
  if (!m) return "";
  return `${m[3]}.${m[2]}.${m[1]} 00:00:00`;
}
function vertexLetter(index) {
  let n = index;
  let out = "";
  do {
    out = String.fromCharCode(65 + n % 26) + out;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return out;
}
function buildEasyCeiling(order) {
  const angles = order.walls.map((w) => Math.round(180 - w.turnDeg));
  const lengths = order.walls.map((w) => Math.round(w.lengthMm / 10));
  const vertexCount = angles.length;
  const sizes = lengths.length > 0 && lengths.every((l) => l > 0) ? ` ${lengths.join("x")}` : "";
  const roomName = `${order.roomName ?? "\u041A\u043E\u043C\u043D\u0430\u0442\u0430"}${sizes}`;
  const lines = [];
  const push2 = (...values) => {
    for (const v of values) lines.push(String(v));
  };
  push2("VerFile", 1, 58, "Unicode", "Crt1");
  push2("<HowBuildCeiling>", "", "</HowBuildCeiling>");
  push2("NameCeiling", roomName);
  push2(
    order.companyName ?? "",
    order.companyName ?? "",
    order.companyCity ?? "",
    order.companyPhone ?? ""
  );
  push2("Ver2", "NotEmptyLogo", "No", "", "", "", "", "Ver3", "", "", "", "");
  push2("EmptyLogo", "Yes", 0, "");
  push2(order.orderNo ?? "", toEcDate(order.orderDate), order.address ?? "", "", "");
  push2("OnlyCalc=false");
  push2("<EdIzm>", 0, "</EdIzm>");
  push2("<Factura>", "VerCat2", order.material.name ?? "", "", "");
  push2(
    order.material.widthMm === null ? "" : Math.round(order.material.widthMm / 10),
    order.material.shrinkagePercent === null ? "" : (order.material.shrinkagePercent / 100).toFixed(2),
    order.material.shrinkagePercent === null ? "" : (order.material.shrinkagePercent / 100).toFixed(2)
  );
  push2(0, 0, 16777215, "true", "", "</Factura>");
  push2(order.harpoonType ?? "");
  push2("TypeStik", 0, "TypePackage", "", "VerCMDB", 1, "", 1, "", 1, "");
  push2(0, 30, 0, 0, "NoInvert", "NoZamerSteny");
  push2("<Raskroy>", "AB", 0, 0, 0, 0, "0.07", "0.07", 0, "</Raskroy>");
  push2("VerArt3", 1, "", 1, "", -1, 0, -1, -1);
  push2("<Image>", 0, "</Image>");
  const sides = [];
  for (let i = 0; i < vertexCount; i++) {
    sides.push(`${vertexLetter(i)}${vertexLetter((i + 1) % vertexCount)}`);
  }
  const diagonals = [];
  for (let i = 0; i < vertexCount - 1; i++) {
    const before = (i - 1 + vertexCount) % vertexCount;
    const after = (i + 1) % vertexCount;
    if (before === after) continue;
    const [a, b] = before < after ? [before, after] : [after, before];
    const pair2 = `${vertexLetter(a)}${vertexLetter(b)}`;
    if (!sides.includes(pair2) && !diagonals.includes(pair2)) diagonals.push(pair2);
  }
  push2(0, vertexCount, sides.length + diagonals.length);
  for (const pair2 of [...sides, ...diagonals]) push2(pair2, "");
  push2("VerBA", "false", Math.max(0, vertexCount - 1));
  for (let i = 0; i < vertexCount - 1; i++) push2(vertexLetter(i), angles[i] ?? 90);
  push2("<DopForms>", 0);
  push2("VerLamp", 0, "VerLustra2", 0, "VerLightLine1", 0, "DoorAndWindows", 0);
  push2("<RullerDopForms>", "Ver2", 0, "</RullerDopForms>", "</DopForms>");
  push2("<AutoMultiFact>", "false", 0, 0, "</AutoMultiFact>");
  push2("<UserMultiFact>", "Ver4", 0, "", 0, 0, 0, 0, "</UserMultiFact>");
  push2("<MultiHarpoon>", 1, "", "</MultiHarpoon>");
  push2("<LightLine>", "Ver2", 1, "", 0, 0, "</LightLine>");
  push2("<ECVer5>", 0, toEcDate(order.shipAt), order.deliveryTo ?? "", 1, "false", 1, "");
  push2("<TextRaskroy>", "V1;0;</TextRaskroy>");
  push2("MF0", "draw=true");
  push2("<XY>", "</XY>");
  push2("V2", "false", 0, 0, "", "", "");
  return lines.join("\n") + "\n";
}
function encodeEasyCeiling(content) {
  const bytes = new Uint8Array(content.length * 2);
  for (let i = 0; i < content.length; i++) {
    const code = content.charCodeAt(i);
    bytes[i * 2] = code & 255;
    bytes[i * 2 + 1] = code >> 8;
  }
  return bytes;
}
function easyCeilingFileName(orderNo, address) {
  const map = {
    \u0430: "a",
    \u0431: "b",
    \u0432: "v",
    \u0433: "g",
    \u0434: "d",
    \u0435: "e",
    \u0451: "e",
    \u0436: "zh",
    \u0437: "z",
    \u0438: "i",
    \u0439: "y",
    \u043A: "k",
    \u043B: "l",
    \u043C: "m",
    \u043D: "n",
    \u043E: "o",
    \u043F: "p",
    \u0440: "r",
    \u0441: "s",
    \u0442: "t",
    \u0443: "u",
    \u0444: "f",
    \u0445: "h",
    \u0446: "c",
    \u0447: "ch",
    \u0448: "sh",
    \u0449: "sch",
    \u044A: "",
    \u044B: "y",
    \u044C: "",
    \u044D: "e",
    \u044E: "yu",
    \u044F: "ya"
  };
  const translit = (s) => s.toLowerCase().split("").map((ch) => map[ch] ?? ch).join("").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  const parts = [orderNo?.trim(), address ? translit(address) : null].filter(Boolean);
  return `${parts.join("_") || "zakaz"}.ec`;
}

// src/calc/lamp-layout.ts
var LAMP_WALL_MARGIN_MM = 400;
function isPointInside(points, probe) {
  let inside2 = false;
  for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
    const a = points[i];
    const b = points[j];
    const crosses = a.y > probe.y !== b.y > probe.y;
    if (!crosses) continue;
    const x = (b.x - a.x) * (probe.y - a.y) / (b.y - a.y) + a.x;
    if (probe.x < x) inside2 = !inside2;
  }
  return inside2;
}
function distanceToWall(points, probe) {
  let best = Infinity;
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const len2 = dx * dx + dy * dy;
    const t = len2 === 0 ? 0 : Math.max(0, Math.min(1, ((probe.x - a.x) * dx + (probe.y - a.y) * dy) / len2));
    const d = Math.hypot(probe.x - (a.x + dx * t), probe.y - (a.y + dy * t));
    if (d < best) best = d;
  }
  return best;
}
function planLampGrid(params) {
  const { points, rows, cols } = params;
  if (points.length < 3 || rows < 1 || cols < 1) return [];
  const margin = params.marginMm ?? LAMP_WALL_MARGIN_MM;
  const box = boundingBox(points);
  const width = box.maxX - box.minX;
  const height = box.maxY - box.minY;
  const marginX = Math.min(margin, width / 3);
  const marginY = Math.min(margin, height / 3);
  const usableW = width - marginX * 2;
  const usableH = height - marginY * 2;
  if (usableW <= 0 || usableH <= 0) return [];
  const result = [];
  for (let r = 0; r < rows; r++) {
    const y = box.minY + marginY + usableH * (r + 0.5) / rows;
    for (let c = 0; c < cols; c++) {
      const x = box.minX + marginX + usableW * (c + 0.5) / cols;
      const probe = { x, y };
      const keepOut = Math.min(margin, marginX, marginY);
      if (isPointInside(points, probe) && distanceToWall(points, probe) >= keepOut) {
        result.push(probe);
      }
    }
  }
  return result;
}
function planLamps(points, count, marginMm) {
  if (points.length < 3 || count < 1) return [];
  const grid = (rows, cols) => planLampGrid({ points, rows, cols, marginMm });
  const suggested = suggestLampGrid(points, count);
  const base = grid(suggested.rows, suggested.cols);
  if (base.length === count) return base;
  const spread = (pts) => {
    let m = Infinity;
    for (let i = 0; i < pts.length; i++) {
      for (let j = i + 1; j < pts.length; j++) {
        m = Math.min(m, Math.hypot(pts[i].x - pts[j].x, pts[i].y - pts[j].y));
      }
    }
    return m;
  };
  let exact = null;
  let roomy = null;
  const limit = Math.min(40, Math.max(4, count * 2));
  for (let rows = 1; rows <= limit; rows++) {
    for (let cols = 1; cols <= limit; cols++) {
      const size = rows * cols;
      if (size < count || size > Math.max(16, count * 4)) continue;
      const pts = grid(rows, cols);
      if (pts.length === count) {
        const score = count === 1 ? Math.min(...pts.map((p) => distanceToWall(points, p))) : spread(pts);
        if (!exact || score > exact.score) exact = { pts, score };
      } else if (pts.length > count && (!roomy || size < roomy.size)) {
        roomy = { pts, size };
      }
    }
  }
  if (exact) return exact.pts;
  if (!roomy) return base;
  const pool = roomy.pts;
  const taken = [];
  let first = pool[0];
  for (const p of pool) if (distanceToWall(points, p) > distanceToWall(points, first)) first = p;
  taken.push(first);
  while (taken.length < count) {
    let pick2 = null;
    let far = -1;
    for (const p of pool) {
      if (taken.includes(p)) continue;
      const d = Math.min(...taken.map((t) => Math.hypot(p.x - t.x, p.y - t.y)));
      if (d > far) {
        far = d;
        pick2 = p;
      }
    }
    if (!pick2) break;
    taken.push(pick2);
  }
  return pool.filter((p) => taken.includes(p));
}
function suggestLampGrid(points, count) {
  if (count < 1) return { rows: 0, cols: 0 };
  const box = boundingBox(points);
  const wide = box.maxX - box.minX >= box.maxY - box.minY;
  let best = { a: 1, b: count };
  for (let a = 1; a * a <= count; a++) {
    if (count % a === 0) best = { a, b: count / a };
  }
  return wide ? { rows: best.a, cols: best.b } : { rows: best.b, cols: best.a };
}

// src/calc/light-line.ts
var EPS = 1e-6;
function intersect(a, b, c, d) {
  const rx = b.x - a.x;
  const ry = b.y - a.y;
  const sx = d.x - c.x;
  const sy = d.y - c.y;
  const denom = rx * sy - ry * sx;
  if (Math.abs(denom) < EPS) return null;
  const t = ((c.x - a.x) * sy - (c.y - a.y) * sx) / denom;
  const u = ((c.x - a.x) * ry - (c.y - a.y) * rx) / denom;
  if (t < -EPS || t > 1 + EPS || u < -EPS || u > 1 + EPS) return null;
  return { x: Math.round(a.x + t * rx), y: Math.round(a.y + t * ry) };
}
function samePoint(a, b) {
  return Math.abs(a.x - b.x) < 1 && Math.abs(a.y - b.y) < 1;
}
function partOf(points) {
  return {
    points,
    areaSqm: Number((Math.abs(polygonAreaMm2(points)) / 1e6).toFixed(2)),
    perimeterM: Number((polygonPerimeterMm(points) / 1e3).toFixed(2))
  };
}
function lengthMm(line2) {
  return Math.hypot(line2.to.x - line2.from.x, line2.to.y - line2.from.y);
}
function cutOnce(points, line2) {
  const hits = [];
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    const at = intersect(line2.from, line2.to, a, b);
    if (!at) continue;
    if (hits.some((h) => samePoint(h.at, at))) continue;
    hits.push({ edge: i, at });
  }
  if (hits.length !== 2) return null;
  const [first, second] = hits[0].edge <= hits[1].edge ? [hits[0], hits[1]] : [hits[1], hits[0]];
  const mid = { x: (first.at.x + second.at.x) / 2, y: (first.at.y + second.at.y) / 2 };
  if (!isPointInside(points, mid)) return "outside";
  const left = [first.at];
  for (let i = first.edge + 1; i <= second.edge; i++) left.push(points[i % points.length]);
  left.push(second.at);
  const right = [second.at];
  for (let i = second.edge + 1; i <= first.edge + points.length; i++) {
    right.push(points[i % points.length]);
  }
  right.push(first.at);
  if (Math.abs(polygonAreaMm2(left)) < 1e3 || Math.abs(polygonAreaMm2(right)) < 1e3) return null;
  return {
    parts: [left, right],
    // Хорда между точками входа и выхода: столько линии лежит В ЭТОЙ
    // части потолка. Профиль считается по ней, а не по всей линии
    chordMm: Math.hypot(second.at.x - first.at.x, second.at.y - first.at.y)
  };
}
function splitByLightLines(contour, lines) {
  const warnings = [];
  let parts = [contour];
  let profileM = 0;
  for (const line2 of lines) {
    const len = lengthMm(line2);
    if (len < 100) {
      warnings.push("\u0421\u0432\u0435\u0442\u043E\u0432\u0430\u044F \u043B\u0438\u043D\u0438\u044F \u043A\u043E\u0440\u043E\u0447\u0435 10 \u0441\u043C \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u043A\u0443\u0434\u0430 \u0435\u0451 \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u043B\u0438");
      continue;
    }
    const next = [];
    let cutAny = false;
    let outside = false;
    let insideMm = 0;
    for (const part of parts) {
      const cut = cutOnce(part, line2);
      if (cut === "outside") {
        outside = true;
        next.push(part);
      } else if (cut) {
        next.push(...cut.parts);
        insideMm += cut.chordMm;
        cutAny = true;
      } else {
        next.push(part);
      }
    }
    if (!cutAny) {
      warnings.push(
        outside ? "\u0421\u0432\u0435\u0442\u043E\u0432\u0430\u044F \u043B\u0438\u043D\u0438\u044F \u0438\u0434\u0451\u0442 \u043C\u0438\u043C\u043E \u043F\u043E\u0442\u043E\u043B\u043A\u0430: \u043C\u0435\u0436\u0434\u0443 \u044D\u0442\u0438\u043C\u0438 \u0441\u0442\u0435\u043D\u0430\u043C\u0438 \u0432\u043E\u0437\u0434\u0443\u0445, \u0430 \u043D\u0435 \u043F\u043E\u043B\u043E\u0442\u043D\u043E. \u0420\u0430\u0437\u0440\u0435\u0437 \u0434\u0435\u043B\u0430\u044E\u0442 \u043E\u0442 \u0441\u0442\u0435\u043D\u044B \u0434\u043E \u0441\u0442\u0435\u043D\u044B \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u043E\u043C\u043D\u0430\u0442\u044B" : "\u0421\u0432\u0435\u0442\u043E\u0432\u0430\u044F \u043B\u0438\u043D\u0438\u044F \u043D\u0435 \u043F\u0435\u0440\u0435\u0441\u0435\u043A\u0430\u0435\u0442 \u043F\u043E\u0442\u043E\u043B\u043E\u043A \u043D\u0430\u0441\u043A\u0432\u043E\u0437\u044C. \u0420\u0430\u0437\u0440\u0435\u0437 \u0434\u0435\u043B\u0430\u044E\u0442 \u043E\u0442 \u0441\u0442\u0435\u043D\u044B \u0434\u043E \u0441\u0442\u0435\u043D\u044B \u2014 \u0438\u043D\u0430\u0447\u0435 \u043F\u043E\u043B\u043E\u0442\u043D\u043E \u043D\u0435 \u043D\u0430\u0442\u044F\u043D\u0443\u0442\u044C"
      );
      continue;
    }
    parts = next;
    profileM += insideMm / 1e3 * 2;
  }
  return {
    parts: parts.map(partOf),
    profileM: Number(profileM.toFixed(2)),
    // Гарпун по кромкам разреза — столько же, сколько профиля
    extraHarpoonM: Number(profileM.toFixed(2)),
    warnings
  };
}
function unit(d) {
  const len = Math.hypot(d.x, d.y);
  return len > 0 ? { x: d.x / len, y: d.y / len } : null;
}
function extentOf(points) {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const p of points) {
    minX = Math.min(minX, p.x);
    minY = Math.min(minY, p.y);
    maxX = Math.max(maxX, p.x);
    maxY = Math.max(maxY, p.y);
  }
  return Math.hypot(maxX - minX, maxY - minY) || 1;
}
function wallHits(contour, through, d) {
  const tol = extentOf(contour) * 1e-9;
  const ts = [];
  for (let i = 0; i < contour.length; i++) {
    const a = contour[i];
    const b = contour[(i + 1) % contour.length];
    const sx = b.x - a.x;
    const sy = b.y - a.y;
    const denom = d.x * sy - d.y * sx;
    if (Math.abs(denom) < 1e-12 * (Math.hypot(sx, sy) || 1)) continue;
    const t = ((a.x - through.x) * sy - (a.y - through.y) * sx) / denom;
    const u = ((a.x - through.x) * d.y - (a.y - through.y) * d.x) / denom;
    if (u < -1e-9 || u > 1 + 1e-9) continue;
    ts.push(t);
  }
  ts.sort((x, y) => x - y);
  return ts.filter((t, i) => i === 0 || t - ts[i - 1] > tol);
}
function chordsOnLine(contour, through, direction) {
  const d = unit(direction);
  if (!d || contour.length < 3) return [];
  const ts = wallHits(contour, through, d);
  const at = (t) => ({ x: through.x + d.x * t, y: through.y + d.y * t });
  const chords = [];
  const onWall = extentOf(contour) * 1e-6;
  for (let i = 0; i + 1 < ts.length; i++) {
    const mid = at((ts[i] + ts[i + 1]) / 2);
    if (isPointInside(contour, mid) && distanceToWall(contour, mid) > onWall) {
      chords.push({ from: at(ts[i]), to: at(ts[i + 1]) });
    }
  }
  return chords;
}
function chordThrough(contour, at, direction, tolerance = 0) {
  const d = unit(direction);
  if (!d) return null;
  const pos = (p) => (p.x - at.x) * d.x + (p.y - at.y) * d.y;
  const eps = extentOf(contour) * 1e-9;
  let best = null;
  let bestGap = Infinity;
  let bestAhead = -Infinity;
  for (const c of chordsOnLine(contour, at, d)) {
    const a = pos(c.from);
    const b = pos(c.to);
    const gap = a > 0 ? a : b < 0 ? -b : 0;
    const ahead = Math.max(a, b);
    if (gap < bestGap - eps || Math.abs(gap - bestGap) <= eps && ahead > bestAhead) {
      best = c;
      bestGap = gap;
      bestAhead = ahead;
    }
  }
  return best && bestGap <= tolerance + eps ? best : null;
}
function longestChord(contour, through, direction) {
  let best = null;
  let bestLen = 0;
  for (const c of chordsOnLine(contour, through, direction)) {
    const len = Math.hypot(c.to.x - c.from.x, c.to.y - c.from.y);
    if (len > bestLen) {
      best = c;
      bestLen = len;
    }
  }
  return best;
}
function distanceAlong(contour, from, direction) {
  const d = unit(direction);
  if (!d || contour.length < 3) return null;
  const tol = extentOf(contour) * 1e-9;
  const ahead = wallHits(contour, from, d).filter((t) => t > tol);
  if (ahead.length === 0) return null;
  const mid = { x: from.x + d.x * ahead[0] / 2, y: from.y + d.y * ahead[0] / 2 };
  return isPointInside(contour, mid) ? ahead[0] : null;
}
function lightLineGaps(contour, line2, side) {
  const mid = { x: (line2.from.x + line2.to.x) / 2, y: (line2.from.y + line2.to.y) / 2 };
  return {
    first: distanceAlong(contour, mid, side),
    second: distanceAlong(contour, mid, { x: -side.x, y: -side.y }),
    length: Math.hypot(line2.to.x - line2.from.x, line2.to.y - line2.from.y)
  };
}
function evenLightLines(contour, direction, count) {
  const d = unit(direction);
  if (!d || count < 1 || contour.length < 3) return [];
  const n = { x: -d.y, y: d.x };
  let lo = Infinity;
  let hi = -Infinity;
  let along = 0;
  for (const p of contour) {
    const s = p.x * n.x + p.y * n.y;
    lo = Math.min(lo, s);
    hi = Math.max(hi, s);
    along += p.x * d.x + p.y * d.y;
  }
  along /= contour.length;
  const result = [];
  for (let i = 1; i <= count; i++) {
    const s = lo + (hi - lo) * i / (count + 1);
    const through = { x: d.x * along + n.x * s, y: d.y * along + n.y * s };
    const chord = longestChord(contour, through, d);
    if (chord) result.push(chord);
  }
  return result;
}

// src/calc/freehand.ts
var dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
function pointToSegment(p, a, b) {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const len2 = dx * dx + dy * dy;
  if (len2 === 0) return dist(p, a);
  const t = Math.max(0, Math.min(1, ((p.x - a.x) * dx + (p.y - a.y) * dy) / len2));
  return Math.hypot(p.x - (a.x + t * dx), p.y - (a.y + t * dy));
}
function simplify(points, eps, from = 0, to = points.length - 1) {
  if (to - from < 2) return to > from ? [from, to] : [from];
  const first = points[from];
  const last = points[to];
  let worst = 0;
  let at = from;
  for (let i = from + 1; i < to; i++) {
    const d = pointToSegment(points[i], first, last);
    if (d > worst) {
      worst = d;
      at = i;
    }
  }
  if (worst <= eps) return [from, to];
  const left = simplify(points, eps, from, at);
  const right = simplify(points, eps, at, to);
  return [...left.slice(0, -1), ...right];
}
function heading(a, b) {
  const deg = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
  return (deg % 360 + 360) % 360;
}
function turn(h1, h2) {
  const d = Math.abs(h1 - h2) % 360;
  return d > 180 ? 360 - d : d;
}
function snapHeading(h) {
  const right = Math.round(h / 90) * 90;
  if (turn(h, right) <= 25) return right % 360;
  return Math.round(h / 45) * 45 % 360;
}
function intersectLines(a, da, b, db) {
  const den = da.x * db.y - da.y * db.x;
  if (Math.abs(den) < 1e-9) return null;
  const t = ((b.x - a.x) * db.y - (b.y - a.y) * db.x) / den;
  return { x: a.x + da.x * t, y: a.y + da.y * t };
}
var dirOf = (deg) => {
  const r = deg * Math.PI / 180;
  return { x: Math.round(Math.cos(r) * 1e9) / 1e9, y: Math.round(Math.sin(r) * 1e9) / 1e9 };
};
function strokeToPath(stroke) {
  const pts = [];
  for (const p of stroke) {
    if (pts.length === 0 || dist(pts[pts.length - 1], p) >= 0.05) pts.push(p);
  }
  if (pts.length < 3) return null;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const p of pts) {
    minX = Math.min(minX, p.x);
    minY = Math.min(minY, p.y);
    maxX = Math.max(maxX, p.x);
    maxY = Math.max(maxY, p.y);
  }
  const size = Math.hypot(maxX - minX, maxY - minY);
  if (size < 3) return null;
  const closed = dist(pts[0], pts[pts.length - 1]) <= Math.max(1.5, size * 0.15);
  const eps = Math.max(0.5, size * 0.025);
  const line2 = closed ? [...pts, pts[0]] : pts;
  let idx;
  if (closed) {
    let far = 0;
    for (let i = 1; i < line2.length; i++) if (dist(line2[i], line2[0]) > dist(line2[far], line2[0])) far = i;
    const a = simplify(line2, eps, 0, far);
    const b = simplify(line2, eps, far, line2.length - 1);
    idx = [...a.slice(0, -1), ...b];
  } else {
    idx = simplify(line2, eps);
  }
  let edges = [];
  for (let k = 0; k + 1 < idx.length; k++) {
    const i = idx[k];
    const j = idx[k + 1];
    const a = line2[i];
    const b = line2[j];
    const deg = snapHeading(heading(a, b));
    const trim = Math.floor((j - i) * 0.2);
    let sx = 0;
    let sy = 0;
    let cnt = 0;
    for (let m = i + trim; m <= j - trim; m++) {
      sx += line2[m].x;
      sy += line2[m].y;
      cnt++;
    }
    edges.push({
      through: cnt > 0 ? { x: sx / cnt, y: sy / cnt } : { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 },
      deg,
      length: dist(a, b)
    });
  }
  const settle = (list) => {
    let out = list;
    for (let guard = 0; guard < 100; guard++) {
      const n = out.length;
      if (n < 2) break;
      let changed = false;
      const span = closed ? n : n - 1;
      for (let i = 0; i < span && !changed; i++) {
        const e = out[i];
        const f = out[(i + 1) % n];
        const t = turn(e.deg, f.deg);
        if (t < 1 || t > 179) {
          const merged = t < 1 ? {
            deg: e.length >= f.length ? e.deg : f.deg,
            length: e.length + f.length,
            through: {
              x: (e.through.x * e.length + f.through.x * f.length) / (e.length + f.length),
              y: (e.through.y * e.length + f.through.y * f.length) / (e.length + f.length)
            }
          } : e.length >= f.length ? e : f;
          out = closed && i === n - 1 ? [merged, ...out.slice(1, n - 1)] : [...out.slice(0, i), merged, ...out.slice(i + 2)];
          changed = true;
        }
      }
      if (!changed) {
        for (let i = 0; i < n && !changed; i++) {
          if (!closed && (i === 0 || i === n - 1)) continue;
          const prev = out[(i - 1 + n) % n];
          const e = out[i];
          const next = out[(i + 1) % n];
          const diagonal = e.deg % 90 !== 0;
          const square = Math.abs(turn(prev.deg, next.deg) - 90) < 1;
          if (diagonal && square && e.length < size * 0.12) {
            out = out.filter((_, j) => j !== i);
            changed = true;
          }
        }
      }
      if (!changed) break;
    }
    return out;
  };
  const cornersOf = (list) => {
    const n = list.length;
    const out = [];
    const project = (e, p) => {
      const d = dirOf(e.deg);
      const t = (p.x - e.through.x) * d.x + (p.y - e.through.y) * d.y;
      return { x: e.through.x + d.x * t, y: e.through.y + d.y * t };
    };
    if (!closed) out.push(project(list[0], pts[0]));
    const joints = closed ? n : n - 1;
    for (let i = 0; i < joints; i++) {
      const e = list[i];
      const f = list[(i + 1) % n];
      const at = intersectLines(e.through, dirOf(e.deg), f.through, dirOf(f.deg));
      if (!at) return null;
      out.push(at);
    }
    if (!closed) out.push(project(list[n - 1], pts[pts.length - 1]));
    if (closed) out.unshift(out.pop());
    return out;
  };
  const minEdge = Math.max(1, size * 0.04);
  let corners = null;
  edges = settle(edges);
  for (let guard = 0; guard < 50; guard++) {
    if (closed ? edges.length < 3 : edges.length < 1) return null;
    corners = cornersOf(edges);
    if (!corners) return null;
    if (edges.length <= (closed ? 3 : 1)) break;
    let shortest = -1;
    let shortLen = minEdge;
    for (let i = 0; i < edges.length; i++) {
      const a = corners[i];
      const b = corners[(i + 1) % corners.length];
      const len = dist(a, b);
      if (len < shortLen) {
        shortest = i;
        shortLen = len;
      }
    }
    if (shortest < 0) break;
    edges = settle(edges.filter((_, j) => j !== shortest));
  }
  if (!corners) return null;
  const points = [];
  for (const c of corners) {
    const g = { col: Math.max(0, Math.round(c.x)), row: Math.max(0, Math.round(c.y)) };
    const last = points[points.length - 1];
    if (!last || last.col !== g.col || last.row !== g.row) points.push(g);
  }
  if (closed && points.length > 1) {
    const a = points[0];
    const b = points[points.length - 1];
    if (a.col === b.col && a.row === b.row) points.pop();
  }
  if (closed ? points.length < 3 : points.length < 2) return null;
  return { points, closed };
}

// src/calc/amendments.ts
function calcAmendments(contractAmount, amendments) {
  const base = toDecimal(contractAmount);
  let signedDelta = new Decimal(0);
  let pendingDelta = new Decimal(0);
  let signedCount2 = 0;
  let pendingCount = 0;
  for (const a of amendments) {
    const delta = toDecimal(a.amountDelta);
    if (a.signedAt) {
      signedDelta = signedDelta.plus(delta);
      signedCount2++;
    } else {
      pendingDelta = pendingDelta.plus(delta);
      pendingCount++;
    }
  }
  const totalAmount = base.plus(signedDelta);
  return {
    contractAmount: base,
    signedDelta,
    pendingDelta,
    // Итог не уходит в минус: соглашение на снятие работ больше, чем их
    // было, — это ошибка ввода, а не отрицательный договор
    totalAmount: totalAmount.isNegative() ? new Decimal(0) : totalAmount,
    signedCount: signedCount2,
    pendingCount
  };
}
function nextAmendmentNumber(amendments) {
  return amendments.reduce((max, a) => Math.max(max, a.number), 0) + 1;
}

// src/calc/remnants.ts
var REMNANT_MARGIN_MM = 60;
function fits(remnant, need, rotated) {
  const w = rotated ? remnant.lengthMm : remnant.widthMm;
  const l = rotated ? remnant.widthMm : remnant.lengthMm;
  return w >= need.widthMm + REMNANT_MARGIN_MM && l >= need.lengthMm + REMNANT_MARGIN_MM;
}
function matchRemnants(remnants, need) {
  const needSqm = need.widthMm / 1e3 * (need.lengthMm / 1e3);
  const matches = [];
  for (const r of remnants) {
    if (r.materialName !== need.materialName) continue;
    const straight = fits(r, need, false);
    const rotated = !straight && fits(r, need, true);
    if (!straight && !rotated) continue;
    matches.push({
      remnant: r,
      rotated,
      leftoverSqm: Number(
        (r.widthMm / 1e3 * (r.lengthMm / 1e3) - needSqm).toFixed(2)
      )
    });
  }
  return matches.sort((a, b) => a.leftoverSqm - b.leftoverSqm);
}
function remnantAreaSqm(r) {
  return Number((r.widthMm / 1e3 * (r.lengthMm / 1e3)).toFixed(2));
}

// src/calc/roll-plan.ts
function groupKey(room) {
  return `${room.materialId ?? "\u2014"}|${room.rollWidthMm}`;
}
function packPieces(pieces, rollWidthMm) {
  const sorted = [...pieces].sort((a, b) => b.alongMm - a.alongMm);
  const shelves = [];
  for (const piece of sorted) {
    let shelf = shelves.find((s) => s.freeAcrossMm >= piece.acrossMm);
    if (!shelf) {
      shelf = {
        offsetAlongMm: 0,
        // проставим после укладки, когда длины известны
        lengthMm: piece.alongMm,
        pieces: [],
        freeAcrossMm: rollWidthMm
      };
      shelves.push(shelf);
    }
    shelf.pieces.push({
      ...piece,
      offsetAlongMm: 0,
      offsetAcrossMm: rollWidthMm - shelf.freeAcrossMm
    });
    shelf.freeAcrossMm -= piece.acrossMm;
    if (piece.alongMm > shelf.lengthMm) shelf.lengthMm = piece.alongMm;
  }
  let cursor = 0;
  for (const shelf of shelves) {
    shelf.offsetAlongMm = cursor;
    for (const piece of shelf.pieces) piece.offsetAlongMm = cursor;
    cursor += shelf.lengthMm;
  }
  return shelves;
}
function planRollPurchase(rooms) {
  const groups = /* @__PURE__ */ new Map();
  for (const room of rooms) {
    if (room.pieces.length === 0) continue;
    const key = groupKey(room);
    const list = groups.get(key);
    if (list) list.push(room);
    else groups.set(key, [room]);
  }
  const plans = [];
  for (const group2 of groups.values()) {
    const head = group2[0];
    const rollWidthMm = head.rollWidthMm;
    const pieces = [];
    let perRoomMm = 0;
    for (const room of group2) {
      room.pieces.forEach((p, i) => {
        pieces.push({ ...p, roomName: room.roomName, pieceIndex: i + 1 });
      });
      perRoomMm += room.pieces.reduce((acc, p) => acc + p.alongMm, 0);
    }
    const shelves = packPieces(pieces, rollWidthMm);
    const rollLengthMm = shelves.reduce((acc, s) => acc + s.lengthMm, 0);
    const rollAreaMm2 = rollLengthMm * rollWidthMm;
    const usedAreaMm2 = pieces.reduce((acc, p) => acc + p.acrossMm * p.alongMm, 0);
    const wasteMm2 = Math.max(0, rollAreaMm2 - usedAreaMm2);
    plans.push({
      materialId: head.materialId,
      materialName: head.materialName,
      rollWidthMm,
      shelves,
      rollLengthM: mmToM(rollLengthMm),
      perRoomLengthM: mmToM(perRoomMm),
      savedM: mmToM(Math.max(0, perRoomMm - rollLengthMm)),
      rollAreaSqm: mm2ToSqm(rollAreaMm2),
      usedAreaSqm: mm2ToSqm(usedAreaMm2),
      wasteAreaSqm: mm2ToSqm(wasteMm2),
      wastePercent: rollAreaMm2 === 0 ? 0 : Math.round(wasteMm2 / rollAreaMm2 * 1e3) / 10
    });
  }
  return plans.sort((a, b) => b.rollLengthM - a.rollLengthM);
}

// src/calc/write-off.ts
var ConsumptionBase = {
  /** За м² раскроенного полотна */
  FABRIC_SQM: "FABRIC_SQM",
  /** За погонный метр рулона */
  ROLL_M: "ROLL_M",
  /** За погонный метр периметра полотна — так считают гарпун */
  PERIMETER_M: "PERIMETER_M",
  /** За погонный метр профиля своего типа */
  PROFILE_M: "PROFILE_M",
  /** За погонный метр закладной под карниз */
  CURTAIN_NICHE_M: "CURTAIN_NICHE_M",
  /** За светильник: платформа, термокольцо, провод */
  LAMP_PIECE: "LAMP_PIECE",
  /** За обвод трубы или колонну */
  BYPASS_PIECE: "BYPASS_PIECE",
  /** За погонный метр сварного шва */
  SEAM_M: "SEAM_M",
  /** За помещение: то, что тратится на комнату целиком */
  ROOM_PIECE: "ROOM_PIECE",
  /**
   * За единицу работы из наряда: «Стеновой багет 74,41 п.м.» даёт 74,41 м
   * профиля. Работы на выезд называет отдел документов (или смета), а
   * какой позиции 1С какая работа соответствует — таблица стандартов
   * компании (правило 202). Геометрия здесь не нужна: у сделки из старой
   * программы её нет, а лист работ есть всегда.
   */
  WORK_UNIT: "WORK_UNIT"
};
var CONSUMPTION_BASE_LABELS = {
  FABRIC_SQM: "\u0437\u0430 \u043C\xB2 \u043F\u043E\u043B\u043E\u0442\u043D\u0430",
  ROLL_M: "\u0437\u0430 \u043F\u043E\u0433.\u043C \u0440\u0443\u043B\u043E\u043D\u0430",
  PERIMETER_M: "\u0437\u0430 \u043F\u043E\u0433.\u043C \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440\u0430",
  PROFILE_M: "\u0437\u0430 \u043F\u043E\u0433.\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u044F",
  CURTAIN_NICHE_M: "\u0437\u0430 \u043F\u043E\u0433.\u043C \u0437\u0430\u043A\u043B\u0430\u0434\u043D\u043E\u0439",
  LAMP_PIECE: "\u0437\u0430 \u0441\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A",
  BYPASS_PIECE: "\u0437\u0430 \u043E\u0431\u0432\u043E\u0434",
  SEAM_M: "\u0437\u0430 \u043F\u043E\u0433.\u043C \u0448\u0432\u0430",
  ROOM_PIECE: "\u0437\u0430 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435",
  WORK_UNIT: "\u0437\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443 \u0440\u0430\u0431\u043E\u0442\u044B \u043D\u0430\u0440\u044F\u0434\u0430"
};
function normalizeWorkName(name) {
  return name.toLowerCase().replace(/ё/g, "\u0435").replace(/[«»"'“”„]/g, "").replace(/\s+/g, " ").replace(/[.\s]+$/g, "").trim();
}
function parseWorkNames(text3) {
  return (text3 ?? "").split(/[\n;]+/).map((s) => s.trim()).filter(Boolean);
}
var round2 = (v) => Math.round(v * 100) / 100;
function countRooms(rooms) {
  const seen = /* @__PURE__ */ new Set();
  let unnamed = 0;
  for (const room of rooms) {
    if (room.secondLevel) continue;
    if (room.roomId) seen.add(room.roomId);
    else unnamed += 1;
  }
  return seen.size + unnamed;
}
function calcWriteOffBasis(rooms, works = []) {
  const profileM = {
    BAGUETTE: 0,
    FLOAT: 0,
    SHADOW: 0,
    NONE: 0
  };
  const byMaterial = /* @__PURE__ */ new Map();
  let fabricSqm = 0;
  let perimeterM = 0;
  let seamLengthM = 0;
  let curtainNicheM = 0;
  let lampCount = 0;
  let bypassCount = 0;
  for (const room of rooms) {
    const walls = room.walls ?? [];
    if (walls.length >= 3) {
      const contour = contourFromWalls(walls);
      const metrics = roomMetrics(contour);
      perimeterM += metrics.perimeterM;
      const profiles = profileLengths(walls);
      for (const key2 of Object.keys(profileM)) {
        profileM[key2] += profiles[key2] ?? 0;
      }
      curtainNicheM += curtainNicheLengthM(walls);
      const lines = room.lightLines ?? [];
      if (lines.length > 0) {
        const split = splitByLightLines(contour.points, lines);
        perimeterM += split.extraHarpoonM;
        profileM.FLOAT += split.profileM;
      }
    }
    const area = room.cutAreaSqm ?? 0;
    fabricSqm += area;
    seamLengthM += room.seamLengthM ?? 0;
    for (const fixture of room.fixtures ?? []) {
      if (fixture.kind === "PIPE" || fixture.kind === "COLUMN") bypassCount += 1;
      else lampCount += 1;
    }
    const name = room.materialName ?? "\u041F\u043E\u043B\u043E\u0442\u043D\u043E";
    const key = room.materialId ?? name;
    const entry = byMaterial.get(key) ?? {
      materialId: room.materialId ?? null,
      materialName: name,
      areaSqm: 0,
      rollLengthM: 0
    };
    entry.areaSqm += area;
    byMaterial.set(key, entry);
  }
  const plans = planRollPurchase(
    rooms.filter((r) => (r.pieces?.length ?? 0) > 0 && !!r.rollWidthMm).map((r) => ({
      roomName: r.roomName,
      materialId: r.materialId ?? null,
      materialName: r.materialName ?? "\u041F\u043E\u043B\u043E\u0442\u043D\u043E",
      rollWidthMm: r.rollWidthMm,
      pieces: r.pieces ?? []
    }))
  );
  const rollLengthM = plans.reduce((acc, p) => acc + p.rollLengthM, 0);
  for (const plan of plans) {
    const key = plan.materialId ?? plan.materialName ?? "\u041F\u043E\u043B\u043E\u0442\u043D\u043E";
    const entry = byMaterial.get(key);
    if (entry) entry.rollLengthM += plan.rollLengthM;
  }
  return {
    fabricSqm: round2(fabricSqm),
    rollLengthM: round2(rollLengthM),
    perimeterM: round2(perimeterM),
    seamLengthM: round2(seamLengthM),
    curtainNicheM: round2(curtainNicheM),
    profileM: {
      BAGUETTE: round2(profileM.BAGUETTE),
      FLOAT: round2(profileM.FLOAT),
      SHADOW: round2(profileM.SHADOW),
      NONE: round2(profileM.NONE)
    },
    lampCount,
    bypassCount,
    // ПОМЕЩЕНИЙ, А НЕ РАСКРОЕВ. Считаем по идентификатору помещения, а
    // раскрои второго уровня отбрасываем: у них своё полотно, но комната
    // та же (правило 17)
    roomCount: countRooms(rooms),
    // Работы наряда — как есть: имена сверяет норма, количество берётся
    // числом, мусор («чепуха», минус) отбрасывается, а не нулит (правило 128)
    works: works.map((w) => ({ name: w.name, unit: w.unit, quantity: Number(w.quantity) })).filter((w) => w.name.trim().length > 0 && Number.isFinite(w.quantity) && w.quantity > 0),
    fabricByMaterial: [...byMaterial.values()].map((m) => ({
      ...m,
      areaSqm: round2(m.areaSqm),
      rollLengthM: round2(m.rollLengthM)
    }))
  };
}
function buildWriteOffLines(basis, rates) {
  const lines = [];
  for (const rate of rates) {
    if (rate.isActive === false) continue;
    const perUnit = Number(rate.perUnit);
    if (!Number.isFinite(perUnit) || perUnit <= 0) continue;
    for (const part of basisValuesFor(basis, rate)) {
      const quantity = round2(part.value * perUnit);
      if (quantity <= 0) continue;
      lines.push({
        rateId: rate.id,
        name: part.nameSuffix ? `${rate.name} (${part.nameSuffix})` : rate.name,
        externalCode: rate.externalCode ?? null,
        unit: rate.unit,
        basis: rate.base,
        basisValue: round2(part.value),
        perUnit,
        quantity,
        explanation: `${round2(part.value)} ${part.basisLabel ?? CONSUMPTION_BASE_LABELS[rate.base]}` + (perUnit === 1 ? "" : ` \xD7 ${perUnit}`)
      });
    }
  }
  return lines;
}
function basisValuesFor(basis, rate) {
  switch (rate.base) {
    case ConsumptionBase.FABRIC_SQM:
    case ConsumptionBase.ROLL_M: {
      const useRoll = rate.base === ConsumptionBase.ROLL_M;
      const parts = basis.fabricByMaterial.filter((m) => !rate.materialId || m.materialId === rate.materialId).map((m) => ({
        value: useRoll ? m.rollLengthM : m.areaSqm,
        nameSuffix: basis.fabricByMaterial.length > 1 ? m.materialName : void 0
      }));
      if (parts.length > 0) return parts;
      if (rate.materialId) return [];
      return [{ value: useRoll ? basis.rollLengthM : basis.fabricSqm }];
    }
    case ConsumptionBase.PERIMETER_M:
      return [{ value: basis.perimeterM }];
    case ConsumptionBase.SEAM_M:
      return [{ value: basis.seamLengthM }];
    case ConsumptionBase.CURTAIN_NICHE_M:
      return [{ value: basis.curtainNicheM }];
    case ConsumptionBase.PROFILE_M: {
      if (rate.profile) {
        return [
          {
            value: basis.profileM[rate.profile] ?? 0,
            nameSuffix: WALL_PROFILE_LABELS[rate.profile]
          }
        ];
      }
      const total = basis.profileM.BAGUETTE + basis.profileM.FLOAT + basis.profileM.SHADOW;
      return [{ value: round2(total) }];
    }
    case ConsumptionBase.LAMP_PIECE:
      return [{ value: basis.lampCount }];
    case ConsumptionBase.BYPASS_PIECE:
      return [{ value: basis.bypassCount }];
    case ConsumptionBase.ROOM_PIECE:
      return [{ value: basis.roomCount }];
    case ConsumptionBase.WORK_UNIT: {
      const wanted = new Set(parseWorkNames(rate.workNames).map(normalizeWorkName));
      if (wanted.size === 0) return [];
      const hits = basis.works.filter((w) => wanted.has(normalizeWorkName(w.name)));
      const value = hits.reduce((sum, w) => sum + w.quantity, 0);
      if (value <= 0) return [];
      const label = [...new Set(hits.map((w) => w.name.trim()))].join(", ");
      return [{ value: round2(value), basisLabel: `\u043F\u043E \u043D\u0430\u0440\u044F\u0434\u0443: ${label}` }];
    }
    default:
      return [];
  }
}
function findShortages(lines, balances) {
  const byCode = new Map(balances.map((b) => [b.externalCode, Number(b.quantity) || 0]));
  const needByCode = /* @__PURE__ */ new Map();
  for (const line2 of lines) {
    if (!line2.externalCode) continue;
    const entry = needByCode.get(line2.externalCode) ?? { name: line2.name, need: 0 };
    entry.need += line2.quantity;
    needByCode.set(line2.externalCode, entry);
  }
  const out = [];
  for (const [externalCode, { name, need }] of needByCode) {
    if (!byCode.has(externalCode)) continue;
    const have = byCode.get(externalCode);
    const short = round2(need - have);
    if (short > 0) out.push({ name, externalCode, need: round2(need), have: round2(have), short });
  }
  return out.sort((a, b) => b.short - a.short);
}

// src/calc/work-types.ts
function workTypeKeys(workType) {
  const keys = [workType.name, ...parseWorkNames(workType.aliases)].map(normalizeWorkName).filter(Boolean);
  return [...new Set(keys)];
}
function workKeyCollisions(workTypes) {
  const owners = /* @__PURE__ */ new Map();
  for (const wt of workTypes) {
    if (wt.isActive === false) continue;
    for (const key of workTypeKeys(wt)) {
      const list = owners.get(key) ?? [];
      list.push(wt.id);
      owners.set(key, list);
    }
  }
  return [...owners].filter(([, ids]) => ids.length > 1).map(([key, workTypeIds]) => ({ key, workTypeIds }));
}
function workTypeIndex(workTypes) {
  const index = /* @__PURE__ */ new Map();
  for (const wt of workTypes) {
    if (wt.isActive === false) continue;
    for (const key of workTypeKeys(wt)) if (!index.has(key)) index.set(key, wt);
  }
  return index;
}
function findWorkType(name, index) {
  return index.get(normalizeWorkName(name)) ?? null;
}
function workNameBases(name) {
  const t = name.trim();
  const out = [];
  const cuts = [...t.matchAll(/\s[-–—]/g)].map((m) => m.index ?? 0).reverse();
  for (const i of cuts) {
    const base = t.slice(0, i).trim();
    if (base.length >= 3 && !out.includes(base)) out.push(base);
  }
  return out;
}
function findWorkTypeForLine(name, index) {
  const exact = findWorkType(name, index);
  if (exact) return exact;
  for (const base of workNameBases(name)) {
    const wt = findWorkType(base, index);
    if (wt) return wt;
  }
  return null;
}
function workTypesAsRates(workTypes) {
  const rates = [];
  for (const wt of workTypes) {
    if (wt.isActive === false) continue;
    const workNames = [wt.name, ...parseWorkNames(wt.aliases)].join("\n");
    for (const m of wt.materials ?? []) {
      const perUnit = Number(m.perUnit);
      const code = m.externalCode?.trim();
      if (!code || !Number.isFinite(perUnit) || perUnit <= 0) continue;
      rates.push({
        id: `wt:${m.id}`,
        name: m.name,
        externalCode: code,
        unit: m.unit,
        base: ConsumptionBase.WORK_UNIT,
        perUnit,
        workNames,
        isActive: true
      });
    }
  }
  return rates;
}
function isWorkRateOn(rate, day) {
  if (day < ruleDayKey(rate.validFrom)) return false;
  if (rate.validTo && day >= ruleDayKey(rate.validTo)) return false;
  return true;
}
function workRateOn(rates, workTypeId, brigadeId, day) {
  const effective = rates.filter((r) => r.workTypeId === workTypeId && isWorkRateOn(r, day));
  const latest = (list) => [...list].sort((a, b) => ruleDayKey(b.validFrom).localeCompare(ruleDayKey(a.validFrom)))[0] ?? null;
  const own = brigadeId ? latest(effective.filter((r) => r.brigadeId === brigadeId)) : null;
  return own ?? latest(effective.filter((r) => !r.brigadeId));
}
function isMoneyUnit(unit2) {
  const u = unit2.trim().toLowerCase().replace(/[.\s]/g, "");
  return ["\u0440\u0443\u0431", "\u0440\u0443\u0431\u043B\u044C", "\u0440\u0443\u0431\u043B\u044F", "\u0440\u0443\u0431\u043B\u0435\u0439", "\u0440", "\u20BD", "rub", "rur"].includes(u);
}
function workLineKeys(lines) {
  const seen = /* @__PURE__ */ new Map();
  return lines.map((l) => {
    const base = `${normalizeWorkName(l.name)}|${l.unit.trim().toLowerCase().replace(/[.\s]/g, "")}`;
    const n = seen.get(base) ?? 0;
    seen.set(base, n + 1);
    return `${base}#${n}`;
  });
}
function workLineAmount(rate, quantity) {
  return roundMoney(toDecimal(rate).times(roundQuantity(quantity)));
}
function calcWorksPay(works, workTypes, rates, ctx, overrides = {}, rateOverrides = {}) {
  const index = workTypeIndex(workTypes);
  const keys = workLineKeys(works);
  const lines = [];
  const unpriced = [];
  const unknown = [];
  let total = new Decimal(0);
  works.forEach((work, i) => {
    const key = keys[i];
    const wt = findWorkTypeForLine(work.name, index);
    const rate = wt ? workRateOn(rates, wt.id, ctx.brigadeId, ctx.day) : null;
    const direct = isMoneyUnit(work.unit);
    const calc = direct ? roundMoney(work.quantity) : rate ? workLineAmount(rate.amount, work.quantity) : null;
    const ownRate = rateOverrides[key];
    const manualRate = !direct && ownRate !== void 0 && ownRate !== null ? toDecimal(ownRate) : null;
    const manualAmount = overrides[key] !== void 0 && overrides[key] !== null;
    const manual = manualRate !== null || manualAmount;
    const amount = manualRate ? workLineAmount(manualRate, work.quantity) : manualAmount ? roundMoney(overrides[key]) : calc;
    if (amount === null) {
      if (wt) unpriced.push(work.name);
      else unknown.push(work.name);
    } else {
      total = total.plus(amount);
    }
    lines.push({
      key,
      name: work.name,
      unit: work.unit,
      quantity: work.quantity,
      workTypeId: wt?.id ?? null,
      workTypeName: wt?.name ?? null,
      rate: manualRate ? manualRate.toFixed(2) : !direct && rate ? toDecimal(rate.amount).toFixed(2) : null,
      brigadeRate: !manualRate && !direct && Boolean(rate?.brigadeId),
      fromOnec: !manualRate && !direct && isFromOnec(rate?.id),
      direct,
      manual,
      rateManual: manualRate !== null,
      calcRate: !direct && rate ? toDecimal(rate.amount).toFixed(2) : null,
      calcAmount: calc ? calc.toFixed(2) : null,
      amount: amount ? amount.toFixed(2) : null
    });
  });
  return { lines, total: roundMoney(total), unpriced, unknown };
}
var ONEC_ID_PREFIX = "onec:";
function isFromOnec(id) {
  return !!id && id.startsWith(ONEC_ID_PREFIX);
}
function withOnecRates(crm, rows) {
  const crmIndex = workTypeIndex(crm.types);
  const codes = {};
  const byCode = /* @__PURE__ */ new Map();
  for (const r of rows) {
    const code = r.code.trim();
    if (!code || !/^\d{4}-\d{2}-\d{2}$/.test(r.day)) continue;
    const list = byCode.get(code) ?? [];
    list.push(r);
    byCode.set(code, list);
  }
  const ownTypes = [];
  const ownByKey = /* @__PURE__ */ new Map();
  const onecRates = [];
  for (const [code, list] of byCode) {
    const sorted = [...list].sort((a, b) => a.day.localeCompare(b.day));
    const days = [];
    for (const r of sorted) {
      if (days.length > 0 && days[days.length - 1].day === r.day) days[days.length - 1] = r;
      else days.push(r);
    }
    const last = days[days.length - 1];
    const key = normalizeWorkName(last.name);
    let workTypeId = findWorkType(last.name, crmIndex)?.id ?? (key ? ownByKey.get(key) : void 0);
    if (!workTypeId) {
      workTypeId = `${ONEC_ID_PREFIX}${code}`;
      ownTypes.push({ id: workTypeId, name: last.name, unit: last.unit, isActive: true, materials: [] });
      if (key) ownByKey.set(key, workTypeId);
    }
    codes[workTypeId] = workTypeId in codes && codes[workTypeId] !== code ? "" : code;
    days.forEach((r, i) => {
      onecRates.push({
        id: `${ONEC_ID_PREFIX}${code}@${r.day}`,
        workTypeId,
        brigadeId: null,
        amount: r.price,
        validFrom: r.day,
        validTo: days[i + 1]?.day ?? null
      });
    });
  }
  for (const [id, code] of Object.entries(codes)) if (!code) delete codes[id];
  return { types: [...crm.types, ...ownTypes], rates: [...onecRates, ...crm.rates], codes };
}
var SIMILARITY_STOP = /* @__PURE__ */ new Set(["\u043F\u043E\u0434", "\u0434\u043B\u044F", "\u043D\u0430", "\u0441\u043E", "\u0431\u0435\u0437", "\u0432\u043E", "\u043F\u043E", "\u0434\u043E", "\u043E\u0442", "\u0438\u0437", "\u0437\u0430", "\u0438\u043B\u0438", "\u0448\u0442"]);
function workNameWords(name) {
  const text3 = (name ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/(\d),(\d)/g, "$1.$2");
  const parts = text3.match(/\d+(?:\.\d+)?|[a-zа-я]+/g) ?? [];
  return parts.filter((p) => !SIMILARITY_STOP.has(p) && (p.length > 1 || /\d/.test(p)));
}
function sameWord(a, b) {
  if (a === b) return true;
  if (/\d/.test(a) || /\d/.test(b)) return false;
  const [short, long] = a.length <= b.length ? [a, b] : [b, a];
  if (short.length >= 3 && long.startsWith(short)) return true;
  let common = 0;
  while (common < short.length && a[common] === b[common]) common++;
  return common >= 5;
}
function workNameSimilarity(a, b) {
  const wa = workNameWords(a);
  const wb = workNameWords(b);
  if (wa.length === 0 || wb.length === 0) return 0;
  const used = new Array(wb.length).fill(false);
  let hit = 0;
  for (const x of wa) {
    const i = wb.findIndex((y, j) => !used[j] && sameWord(x, y));
    if (i >= 0) {
      used[i] = true;
      hit++;
    }
  }
  return 2 * hit / (wa.length + wb.length);
}
function similarWorkTypes(work, workTypes, options = {}) {
  const min = options.min ?? 0.5;
  const limit = options.limit ?? 3;
  const mine = [work.name, ...parseWorkNames(work.aliases)];
  const scored = [];
  for (const other of workTypes) {
    if (other.isActive === false || work.id && other.id === work.id) continue;
    const theirs = [other.name, ...parseWorkNames(other.aliases)];
    let best = 0;
    for (const a of mine) for (const b of theirs) best = Math.max(best, workNameSimilarity(a, b));
    if (best >= min) scored.push({ work: other, score: Math.round(best * 100) / 100 });
  }
  return scored.sort((x, y) => y.score - x.score || x.work.name.localeCompare(y.work.name, "ru")).slice(0, limit);
}

// src/calc/brigade-money.ts
function writeOffActTitle(act) {
  if (act.kind === "BRIGADE_SALE") return "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0435";
  if (act.kind === "RETURN") return act.refundToBrigade ? "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u043A\u0443\u043F\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0431\u0440\u0438\u0433\u0430\u0434\u043E\u0439" : "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u043E\u0442 \u0431\u0440\u0438\u0433\u0430\u0434\u044B";
  if (act.kind === "BRIGADE_PAY") return "\u041F\u0440\u0438\u0445\u043E\u0434\u043D\u0430\u044F \xAB\u0417\u041F\xBB";
  if (act.kind === "TRANSFER") return act.warehouse?.trim() ? `\u041F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0441 \xAB${act.warehouse.trim()}\xBB` : "\u041F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u0441\u043A\u043B\u0430\u0434\u0430\u043C\u0438";
  return "\u0421\u043F\u0438\u0441\u0430\u043D\u0438\u0435";
}
function onecDocumentTitle(act) {
  if (act.kind === "BRIGADE_SALE") return "\u0420\u0430\u0441\u0445\u043E\u0434\u043D\u0430\u044F \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F";
  if (act.kind === "RETURN") return act.refundToBrigade ? "\u041F\u0440\u0438\u0445\u043E\u0434\u043D\u0430\u044F \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F" : "\u041E\u043F\u0440\u0438\u0445\u043E\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u043F\u0430\u0441\u043E\u0432";
  if (act.kind === "BRIGADE_PAY" && act.payExtra === "CLAIM") return "\u0420\u0430\u0441\u0445\u043E\u0434\u043D\u0430\u044F \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F (\u043D\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E)";
  if (act.kind === "BRIGADE_PAY") return "\u041F\u0440\u0438\u0445\u043E\u0434\u043D\u0430\u044F \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F (\u0417\u041F)";
  if (act.kind === "TRANSFER") return "\u041F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0430\u0441\u043E\u0432";
  return act.cardId ? "\u041F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0430\u0441\u043E\u0432" : "\u0421\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u0430\u043F\u0430\u0441\u043E\u0432";
}
function onecDocumentText(act) {
  const number = act.externalId?.trim();
  return number ? `${onecDocumentTitle(act)} ${number}` : null;
}
function onecPostReason(text3, max = 400) {
  let s = (text3 ?? "").replace(/\s+/g, " ").trim();
  s = s.replace(/^документ\s+\S+\s+создан, но не проведён\s*—\s*проведите его в 1С:\s*/i, "");
  s = s.replace(/^Не удалось провести\s*(?:"[^"]*"|«[^»]*»)?\s*!?\s*(?:—\s*)?/i, "");
  s = s.replace(/^Ошибка:\s*(?:—\s*)?/i, "");
  s = s.replace(/^[—\s]+/, "").replace(/\s*—\s*Ошибка:\s*—\s*/g, "; ").replace(/,\s*—/g, " \u2014");
  if (!s) return null;
  return s.length > max ? `${s.slice(0, max - 1).trimEnd()}\u2026` : s;
}
function crewLabel(people) {
  const names = [];
  const seen = /* @__PURE__ */ new Set();
  for (const raw of people) {
    const words = String(raw ?? "").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) continue;
    const key = words.join(" ").toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    names.push(words);
  }
  const bySurname = /* @__PURE__ */ new Map();
  for (const w of names) bySurname.set(w[0].toLowerCase(), (bySurname.get(w[0].toLowerCase()) ?? 0) + 1);
  return names.map((w) => (bySurname.get(w[0].toLowerCase()) ?? 0) > 1 && w[1] ? `${w[0]} ${w[1]}` : w[0]).join(", ");
}
function priceKey(code) {
  return code.trim().toLowerCase();
}
function priceLines(lines, prices) {
  const out = [];
  const unpriced = [];
  let total = new Decimal(0);
  for (const line2 of lines) {
    const quantity = roundQuantity(line2.quantity);
    if (quantity.lte(0)) continue;
    const found = line2.externalCode ? prices[twinStockKey(line2.externalCode, line2.chosen ?? line2.name)] ?? prices[priceKey(line2.externalCode)] : void 0;
    const price = found && found.price !== null && found.price !== void 0 && found.price !== "" ? toDecimal(found.price) : null;
    if (price === null || !sameUnit(found?.unit ?? null, line2.unit)) {
      unpriced.push(line2.name);
      out.push({ ...pick(line2), quantity: quantity.toString(), price: null, sum: null });
      continue;
    }
    const sum = roundMoney(price.times(quantity));
    total = total.plus(sum);
    out.push({ ...pick(line2), quantity: quantity.toString(), price: roundMoney(price).toFixed(2), sum: sum.toFixed(2) });
  }
  return { lines: out, total: roundMoney(total), unpriced };
}
function pick(line2) {
  return { name: line2.name, externalCode: line2.externalCode, unit: line2.unit };
}
function actRole(act) {
  if (act.kind === "BRIGADE_SALE") return "sale";
  if (act.kind === "RETURN") return act.refundToBrigade ? "refund" : "companyReturn";
  if (act.kind === "TRANSFER") return "transfer";
  return "company";
}
function actMoney(act, prices) {
  const role = actRole(act);
  const estimate = priceLines(act.lines, prices);
  const named = act.amount === null || act.amount === void 0 || act.amount === "" ? null : roundMoney(act.amount);
  const onec = named && named.gt(0) ? named : null;
  const money3 = role === "sale" || role === "refund";
  let state;
  if (act.status === "CANCELLED") state = "cancelledInOnec";
  else if (act.status === "EXPORTED") state = money3 && !onec ? "noAmount" : "onec";
  else state = act.exportError ? "refused" : "waiting";
  return { role, state, onec: money3 ? onec : null, estimate, deducted: roundMoney(toDecimal(act.deducted).abs()) };
}
function emptyTotals() {
  const zero = new Decimal(0);
  return {
    earned: zero,
    charged: zero,
    refunded: zero,
    pendingCharge: zero,
    pendingRefund: zero,
    company: zero,
    net: zero,
    unpriced: 0
  };
}
function addressMoneyTotals(input) {
  const t = emptyTotals();
  t.earned = roundMoney(input.earned);
  for (const act of input.acts) {
    if (act.state === "cancelledInOnec") continue;
    if (act.role === "sale") {
      if (act.state === "onec" && act.onec) t.charged = t.charged.plus(act.onec);
      else {
        t.pendingCharge = t.pendingCharge.plus(act.estimate.total);
        t.unpriced += act.estimate.unpriced.length;
      }
    } else if (act.role === "refund") {
      if (act.state === "onec" && act.onec) t.refunded = t.refunded.plus(act.onec);
      else {
        t.pendingRefund = t.pendingRefund.plus(act.estimate.total);
        t.unpriced += act.estimate.unpriced.length;
      }
    } else if (act.role === "company") {
      t.company = t.company.plus(act.estimate.total);
    }
  }
  for (const card of input.pending) {
    t.pendingCharge = t.pendingCharge.plus(card.charge.total);
    t.pendingRefund = t.pendingRefund.plus(card.refund.total);
    t.company = t.company.plus(card.company.total);
    t.unpriced += card.charge.unpriced.length + card.refund.unpriced.length;
  }
  return withNet(t);
}
function withNet(t) {
  return {
    ...t,
    net: roundMoney(t.earned.minus(t.charged).plus(t.refunded).minus(t.pendingCharge).plus(t.pendingRefund))
  };
}
function sumTotals(list) {
  const t = emptyTotals();
  for (const x of list) {
    t.earned = t.earned.plus(x.earned);
    t.charged = t.charged.plus(x.charged);
    t.refunded = t.refunded.plus(x.refunded);
    t.pendingCharge = t.pendingCharge.plus(x.pendingCharge);
    t.pendingRefund = t.pendingRefund.plus(x.pendingRefund);
    t.company = t.company.plus(x.company);
    t.unpriced += x.unpriced;
  }
  return withNet({
    ...t,
    earned: roundMoney(t.earned),
    charged: roundMoney(t.charged),
    refunded: roundMoney(t.refunded),
    pendingCharge: roundMoney(t.pendingCharge),
    pendingRefund: roundMoney(t.pendingRefund),
    company: roundMoney(t.company)
  });
}
function dayParts(amount, days) {
  if (!(days > 0)) return [];
  return splitAmountByShares(
    amount,
    Array.from({ length: days }, (_, i) => ({ key: i, share: 1 }))
  ).map((p) => p.amount);
}
function crewDecides(crew, dayBrigadeId, installationBrigadeId) {
  return crew.length > 0 && !!dayBrigadeId && dayBrigadeId === installationBrigadeId;
}
function ridesVisitDay(userId, crew, dayBrigadeId, installationBrigadeId, isMember) {
  if (!dayBrigadeId) return false;
  if (crewDecides(crew, dayBrigadeId, installationBrigadeId)) return crew.includes(userId);
  return isMember(dayBrigadeId);
}
function splitAmongPeople(amount, people) {
  const out = /* @__PURE__ */ new Map();
  if (people.length === 0) return out;
  for (const part of splitAmountByShares(amount, people.map((p) => ({ key: p.userId, share: p.share })))) {
    out.set(part.key, (out.get(part.key) ?? new Decimal(0)).plus(part.amount));
  }
  return out;
}
function memberMoney(m) {
  const e = roundMoney(m.earned);
  const c = roundMoney(m.consumables);
  const p = roundMoney(m.pending);
  const s = roundMoney(m.shifts);
  const o = roundMoney(m.other);
  return {
    userId: m.userId,
    earned: e,
    consumables: c,
    pending: p,
    shifts: s,
    other: o,
    net: roundMoney(e.minus(c).minus(p).minus(s).minus(o))
  };
}
function allocateByLines(amount, lines) {
  const out = lines.map((l) => l.amount === null ? null : new Decimal(0));
  const priced = lines.map((l, i) => ({ i, amount: l.amount === null ? null : toDecimal(l.amount) })).filter((x) => x.amount !== null && !x.amount.isZero());
  if (priced.length === 0) return out;
  for (const part of splitAmountByShares(
    amount,
    priced.map((p) => ({ key: p.i, share: p.amount.abs() }))
  )) {
    out[part.key] = part.amount;
  }
  return out;
}
function splitDayWithOverrides(amount, roster, overrides) {
  const day = roundMoney(amount);
  const manual = new Set(Object.keys(overrides));
  const parts = /* @__PURE__ */ new Map();
  let fixed = new Decimal(0);
  for (const [userId, value] of Object.entries(overrides)) {
    const v = roundMoney(value);
    parts.set(userId, v);
    fixed = fixed.plus(v);
  }
  const others = roster.filter((p) => !manual.has(p.userId));
  const rest = day.minus(fixed);
  const over = rest.isNegative() && others.length > 0 ? rest.negated() : new Decimal(0);
  if (others.length > 0) {
    for (const [userId, v] of splitAmongPeople(Decimal.max(rest, 0), others)) parts.set(userId, v);
  }
  const total = [...parts.values()].reduce((s, v) => s.plus(v), new Decimal(0));
  return { parts, manual, total: roundMoney(total), over: roundMoney(over), delta: roundMoney(total.minus(day)) };
}

// src/calc/brigade-pay.ts
var ROAD_EXPENSE = "\u0414\u043E\u0440\u043E\u0436\u043D\u044B\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u044B";
function isRoadExpenseLine(name) {
  return normalizeWorkName(name).startsWith(normalizeWorkName(ROAD_EXPENSE));
}
function withRoadExpenses(pay, amounts) {
  const listRoad = pay.lines.filter((l) => !l.road && isRoadExpenseLine(l.name));
  if (amounts.length === 0 && listRoad.length === 0) return pay;
  const roadNames = new Set(listRoad.map((l) => l.name));
  const unpriced = pay.unpriced.filter((n) => !roadNames.has(n));
  const unknown = pay.unknown.filter((n) => !roadNames.has(n));
  if (amounts.length === 0) {
    return { ...pay, lines: pay.lines.map((l) => listRoad.includes(l) ? { ...l, road: true } : l), unpriced, unknown };
  }
  const lines = pay.lines.filter((l) => !listRoad.includes(l));
  let total = listRoad.reduce((s, l) => s.minus(toDecimal(l.amount ?? 0)), pay.total);
  amounts.forEach((a, i) => {
    const amount = roundMoney(a);
    lines.push({
      key: `road:${i}`,
      name: ROAD_EXPENSE,
      unit: "\u0440\u0443\u0431",
      quantity: Number(amount.toFixed(2)),
      workTypeId: null,
      workTypeName: null,
      rate: null,
      brigadeRate: false,
      fromOnec: false,
      direct: true,
      manual: false,
      rateManual: false,
      calcRate: null,
      calcAmount: amount.toFixed(2),
      amount: amount.toFixed(2),
      road: true
    });
    total = total.plus(amount);
  });
  return { ...pay, lines, total: roundMoney(total), unpriced, unknown };
}
var REVIEW_BONUS = "\u041F\u0440\u0435\u043C\u0438\u044F \u043E\u0442 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0437\u0430 \u043E\u0442\u0437\u044B\u0432";
var REVIEW_BONUS_PER_PERSON = 300;
function reviewBonusTitle(reviews, note) {
  const n = Math.max(1, Math.floor(reviews));
  const mod10 = n % 10;
  const mod100 = n % 100;
  const word = mod10 === 1 && mod100 !== 11 ? "\u043E\u0442\u0437\u044B\u0432" : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14) ? "\u043E\u0442\u0437\u044B\u0432\u0430" : "\u043E\u0442\u0437\u044B\u0432\u043E\u0432";
  const head = n === 1 ? REVIEW_BONUS : `\u041F\u0440\u0435\u043C\u0438\u044F \u043E\u0442 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0437\u0430 ${n} ${word}`;
  const where = (note ?? "").trim();
  return where ? `${head}: ${where}` : head;
}
function reviewBonusAmount(b) {
  const count = Math.max(0, Math.floor(b.people)) * Math.max(0, Math.floor(b.reviews));
  return roundMoney(toDecimal(b.perPerson).times(count));
}
function withReviewBonus(pay, bonus, opts = {}) {
  if (!bonus) return pay;
  const amount = reviewBonusAmount(bonus);
  const count = Math.max(0, Math.floor(bonus.people)) * Math.max(0, Math.floor(bonus.reviews));
  const price = roundMoney(bonus.perPerson);
  return {
    ...pay,
    lines: [
      ...pay.lines,
      {
        key: "bonus",
        name: reviewBonusTitle(bonus.reviews, bonus.note),
        unit: "\u0440\u0443\u0431",
        quantity: Number(amount.toFixed(2)),
        workTypeId: null,
        workTypeName: null,
        rate: null,
        brigadeRate: false,
        fromOnec: false,
        direct: true,
        manual: false,
        rateManual: false,
        calcRate: null,
        calcAmount: amount.toFixed(2),
        amount: amount.toFixed(2),
        bonus: true,
        bonusCount: count,
        bonusPrice: price.toFixed(2),
        ...opts.apart ? { apart: true } : {}
      }
    ],
    total: roundMoney(pay.total.plus(amount))
  };
}
function serviceCode(line2, codes) {
  const id = line2.workTypeId ?? "";
  if (codes) return id && codes[id] || null;
  if (id.startsWith(ONEC_ID_PREFIX)) return id.slice(ONEC_ID_PREFIX.length) || null;
  return null;
}
function planBrigadePay(input) {
  const codes = input.codes;
  const all = input.lines.reduce((s, l) => s.plus(toDecimal(l.amount ?? 0)), new Decimal(0));
  const source = input.lines.filter((l) => !l.road && !l.apart);
  const unpriced = [...new Set(source.filter((l) => l.amount === null).map((l) => l.name))];
  if (unpriced.length > 0) return { lines: [], total: "0.00", unpriced };
  const full = source.reduce((s, l) => s.plus(toDecimal(l.amount)), new Decimal(0));
  const share = source.length === input.lines.length || all.isZero() ? roundMoney(input.share) : roundMoney(toDecimal(input.share).times(full).dividedBy(all));
  const scaled = share.equals(roundMoney(full)) ? source.map((l) => toDecimal(l.amount)) : allocateByLines(share, source);
  const fraction = input.fraction !== void 0 && input.fraction > 0 && input.fraction < 1 ? input.fraction : 1;
  const groups = /* @__PURE__ */ new Map();
  source.forEach((l, i) => {
    const amount = roundMoney(scaled[i] ?? 0);
    if (l.bonus) {
      const count = l.bonusCount && l.bonusCount > 0 ? l.bonusCount : 1;
      groups.set("bonus", {
        line: { bonus: true, name: l.name.trim(), workName: null, code: null, unit: "\u0448\u0442", quantity: "0", price: "0.00", amount: "0.00" },
        quantity: new Decimal(count),
        amount,
        direct: false
      });
      return;
    }
    const code = serviceCode(l, codes);
    const unit2 = l.direct ? "\u0448\u0442" : l.unit.trim();
    const key = `${code ?? normalizeWorkName(l.name)}|${unit2.toLowerCase()}`;
    const quantity = l.direct ? new Decimal(1) : roundQuantity(toDecimal(l.quantity).times(fraction));
    const at = groups.get(key);
    if (at) {
      if (!(at.direct && l.direct)) at.quantity = at.quantity.plus(quantity);
      at.amount = at.amount.plus(amount);
      return;
    }
    groups.set(key, {
      line: {
        name: l.name.trim(),
        workName: l.workTypeName?.trim() || null,
        code,
        unit: unit2,
        quantity: "0",
        price: "0.00",
        amount: "0.00"
      },
      quantity,
      amount,
      direct: l.direct === true
    });
  });
  const lines = [];
  let total = new Decimal(0);
  for (const g of groups.values()) {
    if (g.amount.lte(0)) continue;
    const quantity = g.quantity.gt(0) ? g.quantity : new Decimal(1);
    lines.push({
      ...g.line,
      quantity: quantity.toString(),
      price: roundMoney(g.amount.dividedBy(quantity)).toFixed(2),
      amount: g.amount.toFixed(2)
    });
    total = total.plus(g.amount);
  }
  return { lines, total: total.toFixed(2), unpriced: [] };
}

// src/calc/pay-sheet.ts
var PAY_SHEET_MONTHS = [
  "\u042F\u043D\u0432\u0430\u0440\u044C",
  "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
  "\u041C\u0430\u0440\u0442",
  "\u0410\u043F\u0440\u0435\u043B\u044C",
  "\u041C\u0430\u0439",
  "\u0418\u044E\u043D\u044C",
  "\u0418\u044E\u043B\u044C",
  "\u0410\u0432\u0433\u0443\u0441\u0442",
  "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
  "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
  "\u041D\u043E\u044F\u0431\u0440\u044C",
  "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
];
var PAY_SHEET_PREFIX = "CRM \u0418\u0416 - ";
function paySheetLive(month, liveFrom) {
  return !!liveFrom && /^\d{4}-\d{2}$/.test(liveFrom) && month >= liveFrom;
}
function paySheetTitles(month, live = false) {
  const [y, m] = month.split("-").map(Number);
  const name = PAY_SHEET_MONTHS[(m ?? 1) - 1];
  const prefix = live ? "\u0418\u0416 - " : PAY_SHEET_PREFIX;
  return { month: `${prefix}${name} ${y}`, total: `${prefix}${name} \u0418\u0442\u043E\u0433 ${y}` };
}
function payBrigadeKey(name) {
  const words = (name ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/[^а-яa-z0-9 ]/g, " ").split(/\s+/).filter((w) => w && w !== "\u0431\u0440\u0438\u0433\u0430\u0434\u0430" && w.length > 1);
  const first = words[0] ?? "";
  return first.length > 4 ? first.replace(/[аы]$/, "") : first;
}
var isRoad = (item) => item.trim().toLowerCase().startsWith(ROAD_EXPENSE.toLowerCase());
function addDays(day, n) {
  const d = /* @__PURE__ */ new Date(`${day}T00:00:00.000Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
function dayDistance(a, b) {
  return Math.round((Date.parse(`${a}T00:00:00Z`) - Date.parse(`${b}T00:00:00Z`)) / 864e5);
}
var vKey = (installationId, brigadeId) => `${installationId}|${brigadeId}`;
function isConditionerPay(contract) {
  const token = drawingToken(contract);
  return !!token && /К/.test(token.replace(/^\d+/, ""));
}
var visitBrigadeKeys = (v) => new Set([payBrigadeKey(v.counterparty), payBrigadeKey(v.brigade)].filter(Boolean));
function attachPayDocs(visits, docs, known) {
  const money3 = /* @__PURE__ */ new Map();
  const at = (v) => {
    const k = vKey(v.installationId, v.brigadeId);
    let m = money3.get(k);
    if (!m) {
      m = { main: new Decimal(0), road: new Decimal(0), bonus: new Decimal(0), docs: [], paid: false };
      money3.set(k, m);
    }
    return m;
  };
  const byKey = new Map(visits.map((v) => [vKey(v.installationId, v.brigadeId), v]));
  const keysOf = new Map(visits.map((v) => [v, visitBrigadeKeys(v)]));
  const span = (v) => {
    const days = v.days.map((d) => d.day).sort();
    return { first: days[0] ?? "", last: days[days.length - 1] ?? "" };
  };
  const inWindow = (v, day) => {
    const s = span(v);
    return !!s.first && day >= addDays(s.first, -3) && day <= addDays(s.last, 10);
  };
  const unplaced = [];
  const ordered = [...docs].sort((a, b) => Number(!!b.installationId) - Number(!!a.installationId));
  for (const doc of ordered) {
    let visit = doc.installationId && doc.brigadeId ? byKey.get(vKey(doc.installationId, doc.brigadeId)) : void 0;
    if (!visit && doc.installationId) visit = visits.find((v) => v.installationId === doc.installationId);
    if (!visit && !doc.installationId && isConditionerPay(doc.contract)) continue;
    if (!visit) {
      const brig = payBrigadeKey(doc.counterparty);
      const token = drawingToken(doc.contract);
      const distance = (v) => Math.min(...v.days.map((d) => Math.abs(dayDistance(doc.day, d.day))));
      const near3 = visits.filter((v) => keysOf.get(v).has(brig) && inWindow(v, doc.day));
      if (token) {
        visit = near3.filter((v) => drawingToken(v.address) === token).sort((a, b) => distance(a) - distance(b))[0];
        const sameDay = !known || known.has(brig);
        visit ??= visits.filter((v) => drawingToken(v.address) === token && (sameDay ? distance(v) <= 1 : inWindow(v, doc.day))).sort((a, b) => distance(a) - distance(b))[0];
      } else {
        const same = near3.filter((v) => v.days.some((d) => d.day === doc.day) && !money3.get(vKey(v.installationId, v.brigadeId))?.paid);
        if (same.length === 1) visit = same[0];
      }
    }
    if (!visit) {
      unplaced.push(doc);
      continue;
    }
    const m = at(visit);
    const bonus = roundMoney(toDecimal(doc.bonus ?? 0));
    let road = new Decimal(0);
    let rest = new Decimal(0);
    for (const l of doc.lines) {
      if (isRoad(l.item)) road = road.plus(toDecimal(l.sum));
      else rest = rest.plus(toDecimal(l.sum));
    }
    const inside2 = bonus.greaterThan(0) && rest.greaterThanOrEqualTo(bonus) ? bonus : new Decimal(0);
    m.main = m.main.plus(rest.minus(inside2));
    m.road = m.road.plus(road);
    m.bonus = m.bonus.plus(inside2);
    m.docs.push(doc.num);
    m.paid = true;
  }
  return { money: money3, unplaced };
}
function payShortName(name) {
  return name.replace(/\s+/g, " ").trim().split(" ").slice(0, 2).join(" ");
}
var num2 = (d) => roundMoney(d).toNumber();
var numOrNull = (d) => d.isZero() ? null : num2(d);
function weekday(day) {
  return (/* @__PURE__ */ new Date(`${day}T00:00:00.000Z`)).getUTCDay();
}
function buildPayGrid(input) {
  const nameOf = new Map(input.people.map((p) => [p.userId, payShortName(p.name)]));
  const staffed = new Set(input.roster.filter((r) => r.brigadeId).map((r) => r.brigadeId));
  const brigadeByKey = /* @__PURE__ */ new Map();
  for (const r of input.roster) if (r.brigadeId && r.brigade) brigadeByKey.set(payBrigadeKey(r.brigade), r.brigadeId);
  for (const v of input.visits) {
    if (!staffed.has(v.brigadeId)) continue;
    for (const k of visitBrigadeKeys(v)) if (!brigadeByKey.has(k)) brigadeByKey.set(k, v.brigadeId);
  }
  const { money: money3, unplaced } = attachPayDocs(input.visits, input.docs, new Set(brigadeByKey.keys()));
  const docOwner = (d) => brigadeByKey.get(payBrigadeKey(d.counterparty)) ?? null;
  const ownDocs = unplaced.filter((d) => docOwner(d) && d.day.startsWith(input.month) && d.day <= input.today);
  const items = /* @__PURE__ */ new Map();
  for (const v of input.visits) {
    const m = money3.get(vKey(v.installationId, v.brigadeId));
    const days = [...v.days].sort((a, b) => a.day.localeCompare(b.day));
    const shares = (amount) => splitAmountByShares(
      amount,
      days.map((d, i) => ({ key: i, share: d.weight }))
    ).map((x) => x.amount);
    const main = m?.paid ? shares(m.main) : null;
    const road = m ? shares(m.road) : [];
    days.forEach((d, i) => {
      if (!d.day.startsWith(input.month) || d.day > input.today) return;
      const list = items.get(d.day) ?? [];
      list.push({
        visit: v,
        day: d,
        main: main ? main[i] ?? new Decimal(0) : null,
        road: road[i] ?? new Decimal(0),
        // Премия — в последний день бригады на выезде, отдельной строкой, как у девочек
        bonus: m && i === days.length - 1 ? m.bonus : new Decimal(0)
      });
      items.set(d.day, list);
    });
  }
  const rosterOrder = /* @__PURE__ */ new Map();
  [...input.roster].sort((a, b) => (a.brigade ?? "~").localeCompare(b.brigade ?? "~", "ru") || Number(!!b.lead) - Number(!!a.lead)).forEach((r, i) => {
    if (!rosterOrder.has(r.userId)) rosterOrder.set(r.userId, i);
  });
  const inRoster = (r, day) => (!r.from || r.from <= day) && (!r.to || day < r.to);
  const absence = new Map(input.absences.map((a) => [`${a.day}|${a.userId}`, a.reason]));
  const byOrder = (a, b) => (rosterOrder.get(a) ?? 1e9) - (rosterOrder.get(b) ?? 1e9) || (nameOf.get(a) ?? "").localeCompare(nameOf.get(b) ?? "", "ru");
  const allDays = [];
  for (let d = `${input.month}-01`; d.startsWith(input.month) && d <= input.today; d = addDays(d, 1)) {
    const wd = weekday(d);
    if (wd !== 0 || items.has(d) || ownDocs.some((x) => x.day === d)) allDays.push(d);
  }
  const leftovers = [];
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  for (const day of allDays) {
    const list = [];
    for (const it of items.get(day) ?? []) {
      const same = list.find((x) => x.visit.installationId === it.visit.installationId);
      if (!same) {
        list.push({ ...it, day: { ...it.day, people: [...it.day.people] } });
        continue;
      }
      same.day.people = [.../* @__PURE__ */ new Set([...same.day.people, ...it.day.people])];
      same.main = same.main || it.main ? (same.main ?? new Decimal(0)).plus(it.main ?? 0) : null;
      same.road = same.road.plus(it.road);
      same.bonus = same.bonus.plus(it.bonus);
    }
    const groups = /* @__PURE__ */ new Map();
    for (const it of list) {
      const crew = [...new Set(it.day.people)].sort(byOrder);
      const key = crew.length ? crew.join(",") : `brigade:${it.visit.brigadeId}`;
      groups.set(key, [...groups.get(key) ?? [], it]);
    }
    const counted = /* @__PURE__ */ new Set();
    const blocks = [...groups.entries()].map(([crewKey, its]) => {
      const crew = [...new Set(its.flatMap((x) => x.day.people))].sort(byOrder);
      const brigade = input.roster.find((r) => r.brigadeId === its[0].visit.brigadeId)?.brigade ?? null;
      const addresses = [];
      let road = new Decimal(0);
      for (const it of [...its].sort((a, b) => a.visit.address.localeCompare(b.visit.address, "ru"))) {
        const twin = addresses.find((x) => x.text === it.visit.address && !x.key.includes("#"));
        if (twin) {
          if (it.main) twin.pay = num2(toDecimal(twin.pay ?? 0).plus(it.main));
          twin.surcharge ??= it.visit.surcharge;
        } else {
          addresses.push({
            key: it.visit.installationId,
            text: it.visit.address,
            surcharge: it.visit.surcharge,
            pay: it.main ? num2(it.main) : null
          });
        }
        if (it.bonus.greaterThan(0)) {
          addresses.push({ key: `${it.visit.installationId}#bonus`, text: it.visit.address, surcharge: "\u041F\u0440\u0435\u043C\u0438\u044F \u0437\u0430 \u043E\u0442\u0437\u044B\u0432", pay: num2(it.bonus) });
        }
        road = road.plus(it.road);
      }
      return {
        key: `${day}|${crewKey}`,
        brigade,
        persons: crew.map((userId) => {
          const first = !counted.has(userId);
          counted.add(userId);
          return { userId, name: nameOf.get(userId) ?? "\u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A", role: "\u0420", m: first ? 1 : 0, reason: null };
        }),
        addresses,
        j: null,
        k: null,
        v: numOrNull(road),
        off: false,
        visits: its.map((x) => x.visit)
      };
    }).sort((a, b) => byOrder(a.persons[0]?.userId ?? "", b.persons[0]?.userId ?? "") || a.key.localeCompare(b.key));
    for (const doc of ownDocs.filter((d) => d.day === day)) {
      const brigadeId = docOwner(doc);
      let pay = new Decimal(0);
      let road = new Decimal(0);
      for (const l of doc.lines) {
        if (isRoad(l.item)) road = road.plus(toDecimal(l.sum));
        else pay = pay.plus(toDecimal(l.sum));
      }
      const row = {
        key: `doc:${doc.num}`,
        text: doc.contract || doc.lines.find((l) => !isRoad(l.item))?.item?.trim() || `\xAB\u0417\u041F\xBB ${doc.num}`,
        surcharge: null,
        pay: num2(pay)
      };
      let block = blocks.find((b) => b.visits.some((v) => v.brigadeId === brigadeId));
      if (!block) {
        const busy = new Set(blocks.flatMap((b) => b.persons.map((x) => x.userId)));
        const team = input.roster.filter((r) => r.brigadeId === brigadeId && inRoster(r, day)).map((r) => r.userId);
        const free = team.filter((id) => !busy.has(id));
        const crew = [...new Set(free.length ? free : team)].sort(byOrder);
        block = {
          key: `${day}|brigade:${brigadeId}|doc`,
          brigade: input.roster.find((r) => r.brigadeId === brigadeId)?.brigade ?? null,
          persons: crew.map((userId) => {
            const first = !counted.has(userId);
            counted.add(userId);
            return { userId, name: nameOf.get(userId) ?? "\u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A", role: "\u0420", m: first ? 1 : 0, reason: null };
          }),
          addresses: [],
          j: null,
          k: null,
          v: null,
          off: false,
          visits: [{ installationId: `doc:${doc.num}`, brigadeId, counterparty: doc.counterparty, address: row.text, surcharge: null, days: [] }]
        };
        blocks.push(block);
      }
      block.addresses.push(row);
      if (road.greaterThan(0)) block.v = num2(toDecimal(block.v ?? 0).plus(road));
    }
    const cons = /* @__PURE__ */ new Map();
    for (const c of input.consumables.filter((x) => x.day === day)) {
      const block = c.installationId && blocks.find((b) => b.visits.some((v) => v.installationId === c.installationId && v.brigadeId === c.brigadeId)) || c.installationId && blocks.find((b) => b.visits.some((v) => v.installationId === c.installationId)) || blocks.find((b) => b.visits.some((v) => v.brigadeId === c.brigadeId));
      if (!block) {
        const sale = toDecimal(c.sale);
        const refund = toDecimal(c.refund);
        if (!sale.isZero() || !refund.isZero()) {
          const who = input.roster.find((r) => r.brigadeId === c.brigadeId)?.brigade ?? "\u0431\u0440\u0438\u0433\u0430\u0434\u0430";
          leftovers.push(`${day.slice(8)}.${day.slice(5, 7)} ${who}: \u0440\u0430\u0441\u0445\u043E\u0434\u043D\u0438\u043A\u0438 ${num2(sale)}${refund.isZero() ? "" : `, \u0432\u043E\u0437\u0432\u0440\u0430\u0442 ${num2(refund)}`} \u2014 \u0432 \u044D\u0442\u043E\u0442 \u0434\u0435\u043D\u044C \u0443 \u0431\u0440\u0438\u0433\u0430\u0434\u044B \u043D\u0435\u0442 \u0430\u0434\u0440\u0435\u0441\u0430`);
        }
        continue;
      }
      const cur = cons.get(block) ?? { sale: new Decimal(0), refund: new Decimal(0) };
      cur.sale = cur.sale.plus(toDecimal(c.sale));
      cur.refund = cur.refund.plus(toDecimal(c.refund));
      cons.set(block, cur);
    }
    for (const [b, c] of cons) {
      b.j = numOrNull(c.sale);
      b.k = numOrNull(c.refund);
    }
    const working = new Set(blocks.flatMap((b) => b.persons.map((p) => p.userId)));
    const off = [];
    const wd = weekday(day);
    if (wd !== 0) {
      const byBrigade = /* @__PURE__ */ new Map();
      for (const r of input.roster) {
        if (working.has(r.userId) || !inRoster(r, day)) continue;
        const k = r.brigadeId ?? `solo:${r.userId}`;
        const list2 = byBrigade.get(k) ?? [];
        if (!list2.includes(r.userId) && ![...byBrigade.values()].some((l) => l.includes(r.userId))) list2.push(r.userId);
        byBrigade.set(k, list2);
      }
      for (const [k, ids] of byBrigade) {
        if (ids.length === 0) continue;
        const sorted = [...ids].sort(byOrder);
        off.push({
          key: `${day}|off|${k}`,
          brigade: input.roster.find((r) => r.brigadeId === k)?.brigade ?? null,
          persons: sorted.map((userId) => ({
            userId,
            name: nameOf.get(userId) ?? "\u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A",
            role: "\u0412",
            m: 0,
            reason: absence.get(`${day}|${userId}`) ?? null
          })),
          addresses: [],
          j: null,
          k: null,
          v: null,
          off: true
        });
      }
      off.sort((a, b) => byOrder(a.persons[0].userId, b.persons[0].userId));
    }
    for (const b of blocks) for (const p of b.persons) seen.add(p.userId);
    for (const b of off) for (const p of b.persons) seen.add(p.userId);
    out.push({
      day,
      blocks: [...blocks.map(({ visits: _v, ...b }) => b), ...off]
    });
  }
  for (const doc of unplaced.filter((d) => d.day.startsWith(input.month) && d.day <= input.today && !ownDocs.includes(d))) {
    const total = doc.lines.reduce((s, l) => s.plus(toDecimal(l.sum)), new Decimal(0));
    leftovers.push(`${doc.day.slice(8)}.${doc.day.slice(5, 7)} \xAB\u0417\u041F\xBB ${doc.num} ${doc.counterparty} \u043D\u0430 ${num2(total)} \u2014 \u043D\u0435 \u043A \u0447\u0435\u043C\u0443 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u0442\u044C`);
  }
  return {
    month: input.month,
    days: out,
    people: [...seen].sort(byOrder).map((userId) => ({ userId, name: nameOf.get(userId) ?? "\u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A" })),
    unplaced: leftovers
  };
}

// src/doc-number.ts
var PAD = 6;
function documentNumber(no, prefix) {
  if (no == null) return "________";
  return `${prefix?.trim() ?? ""}${String(no).padStart(PAD, "0")}`;
}
function contractNumber(contractNo, dealNumber, prefix) {
  if (contractNo != null) return documentNumber(contractNo, prefix);
  return dealNumber == null ? "\u2014" : String(dealNumber);
}

// src/org-sample.ts
var SAMPLES = [
  { field: "name", value: "\u043E\u043E\u043E \xAB\u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\xBB", label: "\u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" },
  { field: "name", value: '\u043E\u043E\u043E "\u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440"', label: "\u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" },
  { field: "signerName", value: "\u0438\u0432\u0430\u043D\u043E\u0432 \u0438\u0432\u0430\u043D \u0438\u0432\u0430\u043D\u043E\u0432\u0438\u0447", label: "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0442" },
  {
    field: "signerGenitive",
    value: "\u0433\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u0438\u0432\u0430\u043D\u043E\u0432\u0430 \u0438\u0432\u0430\u043D\u0430 \u0438\u0432\u0430\u043D\u043E\u0432\u0438\u0447\u0430",
    label: "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0442 \u0432 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043C \u043F\u0430\u0434\u0435\u0436\u0435"
  }
];
var SAMPLE_ADDRESS = "\u043D\u043E\u0432\u043E-\u0441\u0430\u0434\u043E\u0432\u0430\u044F";
function sampleRequisiteFields(org) {
  if (!org) return [];
  const found = [];
  for (const sample of SAMPLES) {
    const value = (org[sample.field] ?? "").toString().trim().toLowerCase();
    if (value && value === sample.value && !found.includes(sample.label)) {
      found.push(sample.label);
    }
  }
  const addresses = [org.legalAddress, org.actualAddress];
  if (addresses.some((a) => (a ?? "").toLowerCase().includes(SAMPLE_ADDRESS))) {
    found.push("\u0430\u0434\u0440\u0435\u0441");
  }
  const digits = (org.phone ?? "").replace(/\D/g, "");
  if (digits.length >= 10 && /0{6,}$/.test(digits)) found.push("\u0442\u0435\u043B\u0435\u0444\u043E\u043D");
  return found;
}
function missingRequisiteFields(org) {
  if (!org) return [];
  const empty = (v) => !(v ?? "").toString().trim();
  const missing = [];
  if (empty(org.name)) missing.push("\u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435");
  if (empty(org.actualAddress) && empty(org.legalAddress)) missing.push("\u0430\u0434\u0440\u0435\u0441");
  if (empty(org.inn)) missing.push("\u0418\u041D\u041D");
  if (org.isCompany && empty(org.signerName)) missing.push("\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0442");
  if (empty(org.phone)) missing.push("\u0442\u0435\u043B\u0435\u0444\u043E\u043D");
  return missing;
}

// src/party.ts
function partyGender(party) {
  return party.isCompany ? "\u0438\u043C\u0435\u043D\u0443\u0435\u043C\u043E\u0435" : "\u0438\u043C\u0435\u043D\u0443\u0435\u043C\u044B\u0439";
}
function signerPhrase(party) {
  if (!party.isCompany) return "";
  const who = party.signerGenitive?.trim() || (party.signerName?.trim() ? `${party.signerTitle?.trim() ? `${party.signerTitle.trim().toLowerCase()} ` : ""}${party.signerName.trim()}` : "");
  if (!who) return "";
  const basis = party.signerBasis?.trim();
  return basis ? `\u0432 \u043B\u0438\u0446\u0435 ${who}, \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 ${basis}` : `\u0432 \u043B\u0438\u0446\u0435 ${who}`;
}
function partyPreamble(party) {
  const phrase = signerPhrase(party);
  return phrase ? `${party.name}, ${phrase},` : `${party.name},`;
}
function partyTaxIds(party) {
  if (!party.inn?.trim()) return "";
  const kpp = party.kpp?.trim();
  return kpp ? `\u0418\u041D\u041D ${party.inn.trim()} / \u041A\u041F\u041F ${kpp}` : `\u0418\u041D\u041D ${party.inn.trim()}`;
}

// src/payment-qr.ts
function paymentQrProblems(params) {
  const problems = [];
  if (!params.name?.trim()) problems.push("\u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F");
  if (!params.personalAcc?.trim()) problems.push("\u0440\u0430\u0441\u0447\u0451\u0442\u043D\u044B\u0439 \u0441\u0447\u0451\u0442");
  if (!params.bankName?.trim()) problems.push("\u0431\u0430\u043D\u043A");
  if (!params.bic?.trim()) problems.push("\u0411\u0418\u041A");
  if (!params.correspAcc?.trim()) problems.push("\u043A\u043E\u0440\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0442\u0441\u043A\u0438\u0439 \u0441\u0447\u0451\u0442");
  return problems;
}
function clean(value) {
  return (value ?? "").replace(/[|\r\n]/g, " ").replace(/\s+/g, " ").trim();
}
function buildPaymentQr(params) {
  if (paymentQrProblems(params).length > 0) return null;
  const fields = [
    ["Name", clean(params.name)],
    ["PersonalAcc", clean(params.personalAcc)],
    ["BankName", clean(params.bankName)],
    ["BIC", clean(params.bic)],
    ["CorrespAcc", clean(params.correspAcc)]
  ];
  if (params.inn?.trim()) fields.push(["PayeeINN", clean(params.inn)]);
  if (params.kpp?.trim()) fields.push(["KPP", clean(params.kpp)]);
  if (params.sumKopecks && params.sumKopecks > 0) {
    fields.push(["Sum", String(Math.round(params.sumKopecks))]);
  }
  if (params.purpose?.trim()) fields.push(["Purpose", clean(params.purpose)]);
  if (params.payerName?.trim()) fields.push(["LastName", clean(params.payerName)]);
  return `ST00012|${fields.map(([k, v]) => `${k}=${v}`).join("|")}`;
}

// src/amount-words.ts
var ONES = [
  "",
  "\u043E\u0434\u0438\u043D",
  "\u0434\u0432\u0430",
  "\u0442\u0440\u0438",
  "\u0447\u0435\u0442\u044B\u0440\u0435",
  "\u043F\u044F\u0442\u044C",
  "\u0448\u0435\u0441\u0442\u044C",
  "\u0441\u0435\u043C\u044C",
  "\u0432\u043E\u0441\u0435\u043C\u044C",
  "\u0434\u0435\u0432\u044F\u0442\u044C",
  "\u0434\u0435\u0441\u044F\u0442\u044C",
  "\u043E\u0434\u0438\u043D\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0434\u0432\u0435\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0442\u0440\u0438\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0447\u0435\u0442\u044B\u0440\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u043F\u044F\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0448\u0435\u0441\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0441\u0435\u043C\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0432\u043E\u0441\u0435\u043C\u043D\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0434\u0435\u0432\u044F\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u044C"
];
var ONES_FEMININE = [...ONES];
ONES_FEMININE[1] = "\u043E\u0434\u043D\u0430";
ONES_FEMININE[2] = "\u0434\u0432\u0435";
var TENS = [
  "",
  "",
  "\u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C",
  "\u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C",
  "\u0441\u043E\u0440\u043E\u043A",
  "\u043F\u044F\u0442\u044C\u0434\u0435\u0441\u044F\u0442",
  "\u0448\u0435\u0441\u0442\u044C\u0434\u0435\u0441\u044F\u0442",
  "\u0441\u0435\u043C\u044C\u0434\u0435\u0441\u044F\u0442",
  "\u0432\u043E\u0441\u0435\u043C\u044C\u0434\u0435\u0441\u044F\u0442",
  "\u0434\u0435\u0432\u044F\u043D\u043E\u0441\u0442\u043E"
];
var HUNDREDS = [
  "",
  "\u0441\u0442\u043E",
  "\u0434\u0432\u0435\u0441\u0442\u0438",
  "\u0442\u0440\u0438\u0441\u0442\u0430",
  "\u0447\u0435\u0442\u044B\u0440\u0435\u0441\u0442\u0430",
  "\u043F\u044F\u0442\u044C\u0441\u043E\u0442",
  "\u0448\u0435\u0441\u0442\u044C\u0441\u043E\u0442",
  "\u0441\u0435\u043C\u044C\u0441\u043E\u0442",
  "\u0432\u043E\u0441\u0435\u043C\u044C\u0441\u043E\u0442",
  "\u0434\u0435\u0432\u044F\u0442\u044C\u0441\u043E\u0442"
];
function pluralRu(n, forms) {
  const mod100 = Math.abs(n) % 100;
  const mod10 = Math.abs(n) % 10;
  if (mod100 >= 11 && mod100 <= 19) return forms[2];
  if (mod10 === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4) return forms[1];
  return forms[2];
}
function groupToWords(value, feminine) {
  const words = [];
  const hundreds = Math.floor(value / 100);
  const rest = value % 100;
  if (hundreds > 0) words.push(HUNDREDS[hundreds]);
  if (rest >= 20) {
    words.push(TENS[Math.floor(rest / 10)]);
    const ones = rest % 10;
    if (ones > 0) words.push((feminine ? ONES_FEMININE : ONES)[ones]);
  } else if (rest > 0) {
    words.push((feminine ? ONES_FEMININE : ONES)[rest]);
  }
  return words;
}
function amountInWords(value) {
  const safe = Number.isFinite(value) ? Math.abs(value) : 0;
  const rubles2 = Math.floor(safe);
  const kopecks = Math.round((safe - rubles2) * 100);
  const totalRubles = kopecks === 100 ? rubles2 + 1 : rubles2;
  const restKopecks = kopecks === 100 ? 0 : kopecks;
  const kopecksText = `${String(restKopecks).padStart(2, "0")} ${pluralRu(restKopecks, [
    "\u043A\u043E\u043F\u0435\u0439\u043A\u0430",
    "\u043A\u043E\u043F\u0435\u0439\u043A\u0438",
    "\u043A\u043E\u043F\u0435\u0435\u043A"
  ])}`;
  if (totalRubles === 0) return `\u041D\u043E\u043B\u044C \u0440\u0443\u0431\u043B\u0435\u0439 ${kopecksText}`;
  const words = [];
  const billions = Math.floor(totalRubles / 1e9);
  const millions = Math.floor(totalRubles % 1e9 / 1e6);
  const thousands = Math.floor(totalRubles % 1e6 / 1e3);
  const units = totalRubles % 1e3;
  if (billions > 0) {
    words.push(...groupToWords(billions, false));
    words.push(pluralRu(billions, ["\u043C\u0438\u043B\u043B\u0438\u0430\u0440\u0434", "\u043C\u0438\u043B\u043B\u0438\u0430\u0440\u0434\u0430", "\u043C\u0438\u043B\u043B\u0438\u0430\u0440\u0434\u043E\u0432"]));
  }
  if (millions > 0) {
    words.push(...groupToWords(millions, false));
    words.push(pluralRu(millions, ["\u043C\u0438\u043B\u043B\u0438\u043E\u043D", "\u043C\u0438\u043B\u043B\u0438\u043E\u043D\u0430", "\u043C\u0438\u043B\u043B\u0438\u043E\u043D\u043E\u0432"]));
  }
  if (thousands > 0) {
    words.push(...groupToWords(thousands, true));
    words.push(pluralRu(thousands, ["\u0442\u044B\u0441\u044F\u0447\u0430", "\u0442\u044B\u0441\u044F\u0447\u0438", "\u0442\u044B\u0441\u044F\u0447"]));
  }
  if (units > 0) words.push(...groupToWords(units, false));
  const rublesText = pluralRu(totalRubles, ["\u0440\u0443\u0431\u043B\u044C", "\u0440\u0443\u0431\u043B\u044F", "\u0440\u0443\u0431\u043B\u0435\u0439"]);
  const text3 = `${words.join(" ")} ${rublesText} ${kopecksText}`;
  return text3.charAt(0).toUpperCase() + text3.slice(1);
}

// src/csv.ts
var FORMULA_LEAD = /^[=+\-@\t\r]/;
var NUMERIC = /^-?\d+([.,]\d+)?%?$/;
function csvCell(value) {
  let text3 = value === null || value === void 0 ? "" : String(value);
  if (FORMULA_LEAD.test(text3) && !NUMERIC.test(text3)) text3 = ` ${text3}`;
  return /[";\n\r]/.test(text3) ? `"${text3.replace(/"/g, '""')}"` : text3;
}
function csvText(head, rows) {
  return [head, ...rows].map((row) => row.map(csvCell).join(";")).join("\r\n");
}

// src/calc/ceiling-cut.ts
var ANGLE_EPSILON_DEG = 0.5;
var MIN_LAYOUT_EDGE_MM = 1e3;
var DEG_TO_RAD2 = Math.PI / 180;
var DEFAULT_PVC_SHRINKAGE_PERCENT = 7;
var TYPICAL_FABRIC_SHRINKAGE_PERCENT = -3;
var SEAM_CLEARANCE_MM = 40;
var SEAM_SHIFT_STEP_MM = 10;
function clearanceToFixture(seamY, fixture) {
  return Math.abs(seamY - fixture.y) - fixture.diameterMm / 2;
}
function conflictsAt(seamY, fixtures) {
  for (const f of fixtures) {
    if (clearanceToFixture(seamY, f) < SEAM_CLEARANCE_MM) return f;
  }
  return null;
}
function placeSeams(minY, maxY, rollWidthMm, pieces, fixtures) {
  const offsets = [];
  let prev = minY;
  for (let k = 1; k < pieces; k++) {
    const upper = Math.min(prev + rollWidthMm, maxY);
    const remaining = pieces - k;
    const lower = Math.max(prev, maxY - remaining * rollWidthMm);
    let chosen = upper;
    if (fixtures.length > 0) {
      for (let y = upper; y >= lower; y -= SEAM_SHIFT_STEP_MM) {
        if (!conflictsAt(y, fixtures)) {
          chosen = y;
          break;
        }
        chosen = upper;
      }
    }
    offsets.push(chosen);
    prev = chosen;
  }
  return offsets;
}
function collectConflicts(offsets, fixtures) {
  const conflicts = [];
  offsets.forEach((y, i) => {
    for (const f of fixtures) {
      const clearance = clearanceToFixture(y, f);
      if (clearance < SEAM_CLEARANCE_MM) {
        conflicts.push({
          seamIndex: i + 1,
          fixtureId: f.id,
          shortfallMm: Math.round(SEAM_CLEARANCE_MM - clearance)
        });
      }
    }
  });
  return conflicts;
}
function layoutFor(points, fixtures, rollWidthMm, rotationDeg, forcedOffsets) {
  const rotated = rotatePolygon(points, rotationDeg);
  const rotatedFixtures = rotateFixtures(fixtures, rotationDeg);
  const box = boundingBox(rotated);
  const pieces = Math.max(1, Math.ceil(box.heightMm / rollWidthMm));
  const cleanForced = forcedOffsets ? [...new Set(forcedOffsets.map((o) => box.minY + o))].filter((y) => y > box.minY && y < box.maxY).sort((a, b) => a - b) : null;
  const offsets = cleanForced && cleanForced.length === pieces - 1 ? cleanForced : placeSeams(box.minY, box.maxY, rollWidthMm, pieces, rotatedFixtures);
  const bounds = [box.minY, ...offsets, box.maxY];
  let rollLengthMm = 0;
  let seamLengthMm = 0;
  const bands = [];
  for (let i = 0; i < bounds.length - 1; i++) {
    const extent = extentInBand(rotated, bounds[i], bounds[i + 1]);
    rollLengthMm += extent;
    bands.push({ acrossMm: bounds[i + 1] - bounds[i], alongMm: extent });
    if (i > 0) {
      const prevExtent = extentInBand(rotated, bounds[i - 1], bounds[i]);
      seamLengthMm += Math.min(prevExtent, extent);
    }
  }
  return {
    rotationDeg,
    pieces,
    seamOffsetsMm: offsets.map((o) => o - box.minY),
    rollLengthMm,
    seamLengthMm,
    conflicts: collectConflicts(offsets, rotatedFixtures),
    bands
  };
}
function candidateAngles(points) {
  const angles = [0, 90];
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    if (Math.hypot(dx, dy) < MIN_LAYOUT_EDGE_MM) continue;
    const along = (-Math.atan2(dy, dx) / DEG_TO_RAD2 + 360) % 180;
    angles.push(along, (along + 90) % 180);
  }
  const unique = [];
  for (const angle of angles.sort((x, y) => x - y)) {
    const last = unique[unique.length - 1];
    if (last === void 0 || angle - last > ANGLE_EPSILON_DEG) unique.push(angle);
  }
  return unique;
}
function betterLayout(candidate, best) {
  if (best === null) return true;
  if (candidate.conflicts.length !== best.conflicts.length) {
    return candidate.conflicts.length < best.conflicts.length;
  }
  if (candidate.pieces !== best.pieces) return candidate.pieces < best.pieces;
  return candidate.rollLengthMm < best.rollLengthMm;
}
function betterPlansForOrder(candidate, best) {
  if (best === null) return true;
  const sum = (plans, pick2) => plans.reduce((acc, p) => acc + pick2(p), 0);
  const conflicts = (plans) => sum(plans, (p) => p.seamConflicts.length);
  if (conflicts(candidate) !== conflicts(best)) return conflicts(candidate) < conflicts(best);
  const pieces = (plans) => sum(plans, (p) => p.piecesCount);
  if (pieces(candidate) !== pieces(best)) return pieces(candidate) < pieces(best);
  return sum(candidate, (p) => p.rollLengthM) < sum(best, (p) => p.rollLengthM);
}
function mergePlans(plans, lightLineProfileM, lightLineWarnings) {
  const first = plans[0];
  const sum = (pick2) => plans.reduce((acc, p) => acc + pick2(p), 0);
  return {
    // Потолок с линией не бывает «без шва»: сама линия и есть разрез
    seamless: false,
    piecesCount: sum((p) => p.piecesCount),
    seamsCount: sum((p) => p.seamsCount),
    seamLengthM: Number(sum((p) => p.seamLengthM).toFixed(2)),
    rollLengthM: Number(sum((p) => p.rollLengthM).toFixed(2)),
    rotationDeg: first.rotationDeg,
    seamOffsetsMm: plans.flatMap((p) => p.seamOffsetsMm),
    pieces: plans.flatMap((p) => p.pieces),
    cutAreaSqm: Number(sum((p) => p.cutAreaSqm).toFixed(2)),
    rollAreaSqm: Number(sum((p) => p.rollAreaSqm).toFixed(2)),
    wasteAreaSqm: Number(sum((p) => p.wasteAreaSqm).toFixed(2)),
    wastePercent: (() => {
      const roll = sum((p) => p.rollAreaSqm);
      return roll === 0 ? 0 : Math.round(sum((p) => p.wasteAreaSqm) / roll * 1e3) / 10;
    })(),
    seamConflicts: plans.flatMap((p) => p.seamConflicts),
    lightLineProfileM: Number(lightLineProfileM.toFixed(2)),
    ...lightLineWarnings.length ? { lightLineWarnings } : {}
  };
}
function seamSegments(input) {
  const offsets = input.seamOffsetsMm;
  if (offsets.length === 0 || input.contour.length < 3) return [];
  const shrinkage = input.shrinkagePercent ?? DEFAULT_PVC_SHRINKAGE_PERCENT;
  const factor = 1 - shrinkage / 100;
  if (factor <= 0) return [];
  const lines = (input.lightLines ?? []).map((l, i) => ({
    id: l.id ?? String(i),
    from: l.from,
    to: l.to
  }));
  const split = lines.length > 0 ? splitByLightLines(input.contour, lines) : null;
  let parts = split && split.parts.length > 1 ? split.parts.map((p) => p.points) : [input.contour];
  const seamsOf = (points) => {
    const box = boundingBox(rotatePolygon(scalePolygon(points, factor), input.rotationDeg));
    return Math.max(1, Math.ceil(box.heightMm / input.rollWidthMm)) - 1;
  };
  let counts = parts.length > 1 && input.rollWidthMm > 0 ? parts.map(seamsOf) : [offsets.length];
  if (counts.reduce((s, n) => s + n, 0) !== offsets.length) {
    parts = [input.contour];
    counts = [offsets.length];
  }
  const segments = [];
  let cursor = 0;
  parts.forEach((points, index) => {
    const own = offsets.slice(cursor, cursor + counts[index]);
    cursor += counts[index];
    const center2 = centroid(points);
    const rotated = rotatePolygon(scalePolygon(points, factor), input.rotationDeg);
    const box = boundingBox(rotated);
    const back = (p) => ({
      x: center2.x + (p.x - center2.x) / factor,
      y: center2.y + (p.y - center2.y) / factor
    });
    for (const offset of own) {
      const y = box.minY + offset;
      const xs = crossingsAt(rotated, y);
      for (let k = 0; k + 1 < xs.length; k += 2) {
        const [a, b] = rotatePolygon(
          [
            { x: xs[k], y },
            { x: xs[k + 1], y }
          ],
          -input.rotationDeg
        );
        segments.push([back(a), back(b)]);
      }
    }
  });
  return segments;
}
function crossingsAt(points, y) {
  const xs = [];
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    if (a.y <= y !== b.y <= y) {
      xs.push(a.x + (y - a.y) * (b.x - a.x) / (b.y - a.y));
    }
  }
  return xs.sort((p, q) => p - q);
}
var ROLL_WIDTHS_MM = [1800, 2700, 3200, 4e3, 5e3];
function calcCutPlan(input) {
  const lines = input.lightLines ?? [];
  let lineWarnings = [];
  if (lines.length > 0) {
    const split = splitByLightLines(input.contour, lines);
    lineWarnings = split.warnings;
    if (split.parts.length > 1) {
      const centroid2 = (points) => ({
        x: points.reduce((s, p) => s + p.x, 0) / points.length,
        y: points.reduce((s, p) => s + p.y, 0) / points.length
      });
      const partPlan = (part, rotationDeg) => calcCutPlan({
        ...input,
        contour: part.points,
        holes: (input.holes ?? []).filter(
          (hole) => isPointInside(part.points, centroid2(hole))
        ),
        fixtures: (input.fixtures ?? []).filter(
          (f) => isPointInside(part.points, { x: f.x, y: f.y })
        ),
        lightLines: void 0,
        ...rotationDeg === void 0 ? {} : { rotationDeg }
      });
      if (input.rotationDeg !== null && input.rotationDeg !== void 0) {
        const plans = split.parts.map((part) => partPlan(part));
        return mergePlans(plans, split.profileM, split.warnings);
      }
      const angles = [];
      for (const part of split.parts) angles.push(...candidateAngles(part.points));
      angles.sort((a, b) => a - b);
      const unique = angles.filter((a, i) => i === 0 || a - angles[i - 1] > ANGLE_EPSILON_DEG);
      let bestPlans = null;
      for (const deg of unique) {
        const candidate = split.parts.map((part) => partPlan(part, deg));
        if (betterPlansForOrder(candidate, bestPlans)) bestPlans = candidate;
      }
      return mergePlans(bestPlans, split.profileM, split.warnings);
    }
  }
  const shrinkage = input.shrinkagePercent ?? DEFAULT_PVC_SHRINKAGE_PERCENT;
  const factor = 1 - shrinkage / 100;
  const cutContour = scalePolygon(input.contour, factor);
  const cutFixtures = scaleFixtures(input.fixtures ?? [], input.contour, factor);
  const holes = (input.holes ?? []).map(
    (hole) => scalePolygon(hole, factor).map((p) => ({ ...p }))
  );
  const holesAreaMm2 = holes.reduce((acc, hole) => acc + polygonAreaMm2(hole), 0);
  const outerAreaMm2 = polygonAreaMm2(cutContour);
  const cutAreaMm2 = Math.max(0, outerAreaMm2 - holesAreaMm2);
  let best = null;
  if (input.rotationDeg !== null && input.rotationDeg !== void 0) {
    best = layoutFor(
      cutContour,
      cutFixtures,
      input.rollWidthMm,
      input.rotationDeg,
      input.seamOffsetsMm
    );
  } else {
    for (const deg of candidateAngles(cutContour)) {
      const candidate = layoutFor(cutContour, cutFixtures, input.rollWidthMm, deg);
      if (betterLayout(candidate, best)) best = candidate;
    }
  }
  const layout = best ?? {
    rotationDeg: 0,
    pieces: 1,
    seamOffsetsMm: [],
    rollLengthMm: 0,
    seamLengthMm: 0,
    conflicts: [],
    bands: []
  };
  const rollAreaMm2 = layout.rollLengthMm * input.rollWidthMm;
  const wasteMm2 = Math.max(0, rollAreaMm2 - cutAreaMm2);
  return {
    seamless: layout.pieces === 1,
    piecesCount: layout.pieces,
    seamsCount: layout.pieces - 1,
    seamLengthM: mmToM(layout.seamLengthMm),
    rollLengthM: mmToM(layout.rollLengthMm),
    rotationDeg: layout.rotationDeg,
    seamOffsetsMm: layout.seamOffsetsMm.map((o) => Math.round(o)),
    pieces: layout.bands.map((b) => ({
      acrossMm: Math.round(b.acrossMm),
      alongMm: Math.round(b.alongMm)
    })),
    cutAreaSqm: mm2ToSqm(cutAreaMm2),
    rollAreaSqm: mm2ToSqm(rollAreaMm2),
    wasteAreaSqm: mm2ToSqm(wasteMm2),
    wastePercent: rollAreaMm2 === 0 ? 0 : Math.round(wasteMm2 / rollAreaMm2 * 1e3) / 10,
    seamConflicts: layout.conflicts,
    ...lineWarnings.length ? { lightLineWarnings: lineWarnings } : {}
  };
}
function calcCutSnapshot(input) {
  const plan = calcCutPlan({
    contour: contourFromWalls(input.walls).points,
    rollWidthMm: input.rollWidthMm,
    shrinkagePercent: input.shrinkagePercent,
    fixtures: input.fixtures,
    lightLines: input.lightLines,
    rotationDeg: input.rotationDeg,
    seamOffsetsMm: input.seamOffsetsMm,
    holes: (input.holeWalls ?? []).map((walls) => contourFromWalls(walls).points).filter((points) => points.length >= 3)
  });
  return {
    ...plan,
    rollWidthMm: input.rollWidthMm,
    shrinkagePercent: input.shrinkagePercent
  };
}

// src/calc/dxf.ts
var DXF_LAYERS = {
  contour: "KONTUR",
  seams: "SHVY",
  fixtures: "SVETILNIKI",
  text: "RAZMERY",
  /** Световые линии — своим слоем: в CAD их гасят отдельно от швов */
  lightLines: "SVET_LINII"
};
function pair(code, value) {
  return `${code}
${value}
`;
}
function layerEntry(name, color) {
  return pair(0, "LAYER") + pair(2, name) + pair(70, 0) + pair(62, color) + pair(6, "CONTINUOUS");
}
function line(layer, from, to) {
  return pair(0, "LINE") + pair(8, layer) + pair(10, round(from.x)) + pair(20, round(from.y)) + pair(30, 0) + pair(11, round(to.x)) + pair(21, round(to.y)) + pair(31, 0);
}
function circle(layer, center2, radius) {
  return pair(0, "CIRCLE") + pair(8, layer) + pair(10, round(center2.x)) + pair(20, round(center2.y)) + pair(30, 0) + pair(40, round(radius));
}
function text2(layer, at, height, value) {
  return pair(0, "TEXT") + pair(8, layer) + pair(10, round(at.x)) + pair(20, round(at.y)) + pair(30, 0) + pair(40, round(height)) + pair(1, value);
}
function round(value) {
  return Math.round(value * 10) / 10;
}
function buildDxf(rooms) {
  const GAP_MM = 1e3;
  let body = "";
  let offsetX = 0;
  for (const room of rooms) {
    const contour = contourFromWalls(room.walls);
    if (contour.points.length < 3) continue;
    const minX = Math.min(...contour.points.map((p) => p.x));
    const minY = Math.min(...contour.points.map((p) => p.y));
    const maxX = Math.max(...contour.points.map((p) => p.x));
    const shift = (p) => ({ x: p.x - minX + offsetX, y: p.y - minY });
    for (let i = 0; i < contour.points.length; i++) {
      const a = shift(contour.points[i]);
      const b = shift(contour.points[(i + 1) % contour.points.length]);
      body += line(DXF_LAYERS.contour, a, b);
    }
    const labelHeight = 80;
    for (let i = 0; i < contour.vertices.length; i++) {
      const wall = room.walls[i];
      if (!wall) continue;
      const a = shift(contour.vertices[i]);
      const b = shift(contour.vertices[(i + 1) % contour.vertices.length]);
      body += text2(
        DXF_LAYERS.text,
        { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 },
        labelHeight,
        String(wall.lengthMm)
      );
    }
    for (const [from, to] of room.seams ?? []) {
      body += line(DXF_LAYERS.seams, shift(from), shift(to));
    }
    for (const l of room.lightLines ?? []) {
      body += line(DXF_LAYERS.lightLines, shift(l.from), shift(l.to));
    }
    for (const mark of fixtureMarks(room.fixtures ?? [])) {
      const center2 = shift({ x: mark.fixture.x, y: mark.fixture.y });
      body += circle(DXF_LAYERS.fixtures, center2, mark.fixture.diameterMm / 2);
      body += text2(
        DXF_LAYERS.text,
        { x: center2.x + mark.fixture.diameterMm / 2 + 30, y: center2.y },
        labelHeight * 0.8,
        `${mark.index} ${FIXTURE_LABELS[mark.fixture.kind]}`
      );
    }
    body += text2(
      DXF_LAYERS.text,
      { x: offsetX, y: -labelHeight * 2.5 },
      labelHeight * 1.4,
      room.roomName
    );
    offsetX += maxX - minX + GAP_MM;
  }
  const header = pair(0, "SECTION") + pair(2, "HEADER") + // Единицы файла: 4 — миллиметры. Без этого CAD открывает чертёж
  // в «безразмерных» единицах, и печать выходит не в масштабе
  pair(9, "$INSUNITS") + pair(70, 4) + pair(0, "ENDSEC");
  const tables = pair(0, "SECTION") + pair(2, "TABLES") + pair(0, "TABLE") + pair(2, "LAYER") + // Счётчик слоёв обязан совпадать с их числом: строгий CAD сверяет
  pair(70, 5) + layerEntry(DXF_LAYERS.contour, 7) + layerEntry(DXF_LAYERS.seams, 1) + layerEntry(DXF_LAYERS.fixtures, 3) + layerEntry(DXF_LAYERS.text, 5) + // 2 — жёлтый: линия и на CAD-чертеже выглядит как свет
  layerEntry(DXF_LAYERS.lightLines, 2) + pair(0, "ENDTAB") + pair(0, "ENDSEC");
  const entities = pair(0, "SECTION") + pair(2, "ENTITIES") + body + pair(0, "ENDSEC");
  return header + tables + entities + pair(0, "EOF");
}

// src/vision.ts
import { z as z5 } from "zod";
var RECOGNITION_LABELS = {
  SKETCH: "\u042D\u0441\u043A\u0438\u0437 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F",
  ESTIMATE: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0438\u043B\u0438 \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
  FLOORPLAN: "\u041F\u043B\u0430\u043D \u0411\u0422\u0418"
};
var recognizedWallSchema = z5.object({
  lengthMm: z5.number().int(),
  /** Поворот ПОСЛЕ стены: +90 налево, −90 направо, 0 прямо */
  turnDeg: z5.number()
});
var recognizedRoomSchema = z5.object({
  name: z5.string(),
  /** Обход стен, если он читается. Пустой список — контура на фото нет */
  walls: z5.array(recognizedWallSchema),
  areaSqm: z5.number().nullable(),
  perimeterM: z5.number().nullable(),
  heightM: z5.number().nullable(),
  ceilingType: z5.string().nullable(),
  /**
   * Где комната стояла на листе, 0..1 от габарита снимка.
   *
   * Поля НЕТ в схеме ответа модели, и это намеренно: его заполняет код,
   * собравший геометрию из чисел OCR (правило 54). Модель координат не
   * знает, а спрашивать её о том, что уже посчитано, значит дать ей
   * шанс ответить иначе.
   *
   * В расчёт не идёт. Нужно одному: разложить комнаты на плане в том же
   * порядке, в каком они на листе, — иначе сверка глазом не работает.
   */
  sheet: z5.object({ x: z5.number(), y: z5.number() }).nullish()
});
var recognizedItemSchema = z5.object({
  name: z5.string(),
  quantity: z5.number(),
  unit: z5.nativeEnum(PriceUnit),
  /** Цена за единицу, если она указана на фото */
  unitPrice: z5.number().nullable()
});
var recognitionResultSchema = z5.object({
  /**
   * Читается ли фотография вообще. Смазанный снимок или чужой почерк —
   * нормальная ситуация, и честное «не читается» лучше выдуманных цифр.
   */
  legible: z5.boolean(),
  rooms: z5.array(recognizedRoomSchema),
  items: z5.array(recognizedItemSchema),
  /**
   * Что осталось непонятным: перечёркнутая цифра, обрезанный край,
   * два размера на одной стене. Показывается человеку рядом с цифрами.
   */
  warnings: z5.array(z5.string()),
  /**
   * ЧИСЛА, ПРОЧИТАННЫЕ С ЛИСТА, вместе с их местом на снимке.
   *
   * Нужны не расчёту, а ЧЕЛОВЕКУ: они показываются метками поверх
   * фотографии. Замерщик видит не «распозналось пять комнат», а какое
   * именно число программа прочла и ГДЕ — и сразу находит то, что
   * прочитано криво: «здесь 227, а не 9.97».
   *
   * Без этого сверка идёт вслепую: таблица цифр против листа в руке, и
   * найти расхождение можно только пересчитав всё заново (правило 56 —
   * ошибку формы видно раньше, чем дочитаны размеры).
   *
   * Доля от ширины и высоты снимка, а не пиксели: на планшете картинка
   * показывается в своём размере, и координаты OCR к нему не привязаны.
   */
  numbers: z5.array(
    z5.object({
      value: z5.number(),
      /** 0..1 по ширине снимка */
      x: z5.number(),
      /** 0..1 по высоте снимка */
      y: z5.number(),
      /** Ушло ли число в собранную геометрию */
      used: z5.boolean()
    })
  ).optional()
});
var nullableNumber = { anyOf: [{ type: "number" }, { type: "null" }] };
var nullableString = { anyOf: [{ type: "string" }, { type: "null" }] };
var RECOGNITION_JSON_SCHEMA = {
  type: "object",
  additionalProperties: false,
  required: ["legible", "rooms", "items", "warnings"],
  properties: {
    legible: {
      type: "boolean",
      description: "\u0427\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043B\u0438 \u0441\u043D\u0438\u043C\u043E\u043A. false \u2014 \u0446\u0438\u0444\u0440\u044B \u0440\u0430\u0437\u043E\u0431\u0440\u0430\u0442\u044C \u043D\u0435\u043B\u044C\u0437\u044F"
    },
    rooms: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: false,
        required: ["name", "walls", "areaSqm", "perimeterM", "heightM", "ceilingType"],
        properties: {
          name: { type: "string", description: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u0441 \u0444\u043E\u0442\u043E" },
          walls: {
            type: "array",
            description: "\u041E\u0431\u0445\u043E\u0434 \u0441\u0442\u0435\u043D \u043F\u043E \u043A\u0440\u0443\u0433\u0443. \u041F\u0443\u0441\u0442\u043E, \u0435\u0441\u043B\u0438 \u043A\u043E\u043D\u0442\u0443\u0440\u0430 \u043D\u0430 \u0444\u043E\u0442\u043E \u043D\u0435\u0442",
            items: {
              type: "object",
              additionalProperties: false,
              required: ["lengthMm", "turnDeg"],
              properties: {
                lengthMm: { type: "integer", description: "\u0414\u043B\u0438\u043D\u0430 \u0441\u0442\u0435\u043D\u044B, \u0446\u0435\u043B\u044B\u0435 \u043C\u0438\u043B\u043B\u0438\u043C\u0435\u0442\u0440\u044B" },
                turnDeg: {
                  type: "number",
                  description: "\u041F\u043E\u0432\u043E\u0440\u043E\u0442 \u043F\u043E\u0441\u043B\u0435 \u0441\u0442\u0435\u043D\u044B: 90 \u043D\u0430\u043B\u0435\u0432\u043E, -90 \u043D\u0430\u043F\u0440\u0430\u0432\u043E, 0 \u043F\u0440\u044F\u043C\u043E"
                }
              }
            }
          },
          areaSqm: { ...nullableNumber, description: "\u041F\u043B\u043E\u0449\u0430\u0434\u044C, \u043C\xB2" },
          perimeterM: { ...nullableNumber, description: "\u041F\u0435\u0440\u0438\u043C\u0435\u0442\u0440, \u043F\u043E\u0433.\u043C" },
          heightM: { ...nullableNumber, description: "\u0412\u044B\u0441\u043E\u0442\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0430, \u043C" },
          ceilingType: { ...nullableString, description: "\u0422\u0438\u043F \u043F\u043E\u0442\u043E\u043B\u043A\u0430, \u0435\u0441\u043B\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D" }
        }
      }
    },
    items: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: false,
        required: ["name", "quantity", "unit", "unitPrice"],
        properties: {
          name: { type: "string", description: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u044B \u0438\u043B\u0438 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430" },
          quantity: { type: "number" },
          unit: {
            type: "string",
            enum: ["SQM", "LINEAR_M", "PIECE", "SET", "HOUR", "JOB", "MOUNT_POINT"],
            description: "SQM \u2014 \u043C\xB2, LINEAR_M \u2014 \u043F\u043E\u0433.\u043C, PIECE \u2014 \u0448\u0442, SET \u2014 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442, MOUNT_POINT \u2014 \u0442\u043E\u0447\u043A\u0430 \u043A\u0440\u0435\u043F\u043B\u0435\u043D\u0438\u044F \u043A\u0430\u0440\u043D\u0438\u0437\u0430 (\xAB\u0422.\u043A\u0440.\xBB \u043D\u0430 \u043B\u0438\u0441\u0442\u0435)"
          },
          unitPrice: { ...nullableNumber, description: "\u0426\u0435\u043D\u0430 \u0437\u0430 \u0435\u0434\u0438\u043D\u0438\u0446\u0443, \u20BD" }
        }
      }
    },
    warnings: {
      type: "array",
      description: "\u0427\u0442\u043E \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u043D\u0435\u043F\u043E\u043D\u044F\u0442\u043D\u044B\u043C. \u041F\u043E-\u0440\u0443\u0441\u0441\u043A\u0438, \u043A\u043E\u0440\u043E\u0442\u043A\u043E",
      items: { type: "string" }
    }
  }
};
var recognizeRequestSchema = z5.object({
  kind: z5.enum(["SKETCH", "ESTIMATE", "FLOORPLAN"])
});
var recognitionAcceptedSchema = z5.object({
  rooms: z5.array(recognizedRoomSchema),
  items: z5.array(recognizedItemSchema),
  /** Цифры, подставленные с листа в стены холста (правило 183) */
  numbers: z5.array(z5.number()).optional(),
  /**
   * Обвод с листа взят в замер (правило 198): контур, каким он ушёл, и
   * сохранилась ли форма обвода (`kept` — те же стены и повороты, длины
   * правит человек). По этому видно, сколько обводов оставили, а сколько
   * перечертили, и копятся пары «снимок + точки → контур» для дообучения.
   */
  outline: z5.object({
    walls: z5.array(z5.object({ lengthMm: z5.number(), turnDeg: z5.number() })).max(40),
    kept: z5.boolean()
  }).optional()
});
var RECOGNITION_LIMITS = {
  minWallMm: 100,
  maxWallMm: 5e4,
  maxWalls: 40,
  maxRooms: 20,
  maxItems: 100,
  maxAreaSqm: 500,
  maxQuantity: 1e4
};
function sanitizeRecognition(result) {
  const warnings = [...result.warnings];
  const L2 = RECOGNITION_LIMITS;
  if (result.rooms.length > L2.maxRooms) {
    warnings.push(
      `\u041F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0439 \u043D\u0430 \u043B\u0438\u0441\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 ${L2.maxRooms}: \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0435\u0440\u0432\u044B\u0435 ${L2.maxRooms}, \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 ${result.rooms.length - L2.maxRooms} \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0440\u0443\u043A\u0430\u043C\u0438`
    );
  }
  const rooms = result.rooms.slice(0, L2.maxRooms).map((room) => {
    const walls = room.walls.filter((w) => {
      const ok = w.lengthMm >= L2.minWallMm && w.lengthMm <= L2.maxWallMm;
      if (!ok) {
        warnings.push(`\xAB${room.name}\xBB: \u0441\u0442\u0435\u043D\u0430 ${w.lengthMm} \u043C\u043C \u043D\u0435 \u043F\u043E\u0445\u043E\u0436\u0430 \u043D\u0430 \u0437\u0430\u043C\u0435\u0440 \u2014 \u043E\u0442\u0431\u0440\u043E\u0448\u0435\u043D\u0430`);
      }
      return ok;
    });
    const area = room.areaSqm !== null && room.areaSqm > 0 && room.areaSqm <= L2.maxAreaSqm ? room.areaSqm : null;
    if (room.areaSqm !== null && area === null) {
      warnings.push(`\xAB${room.name}\xBB: \u043F\u043B\u043E\u0449\u0430\u0434\u044C ${room.areaSqm} \u043C\xB2 \u043D\u0435 \u043F\u043E\u0445\u043E\u0436\u0430 \u043D\u0430 \u043F\u0440\u0430\u0432\u0434\u0443`);
    }
    const kept = walls.slice(0, L2.maxWalls);
    if (kept.length >= 3) {
      const turnSum = kept.reduce((acc, w) => acc + w.turnDeg, 0);
      if (Math.abs(Math.abs(turnSum) - 360) > 1) {
        warnings.push(
          `\xAB${room.name}\xBB: \u043E\u0431\u0445\u043E\u0434 \u043D\u0435 \u0437\u0430\u043C\u044B\u043A\u0430\u0435\u0442\u0441\u044F \u2014 \u0441\u0443\u043C\u043C\u0430 \u043F\u043E\u0432\u043E\u0440\u043E\u0442\u043E\u0432 ${turnSum}\xB0 \u0432\u043C\u0435\u0441\u0442\u043E \xB1360\xB0. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u0441\u043A\u0438\u0437\u0443`
        );
      }
    }
    if (kept.length >= 3) {
      const contour = contourFromWalls(kept);
      if (contour.closureErrorMm > RECOGNITION_CLOSURE_TOLERANCE_MM) {
        const gapCm = Math.round(contour.closureErrorMm / 10);
        warnings.push(
          `\xAB${room.name}\xBB: \u0441\u0442\u0435\u043D\u044B \u043D\u0435 \u0441\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u2014 \u043E\u0431\u0445\u043E\u0434 \u043D\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u0432 \u043D\u0430\u0447\u0430\u043B\u043E \u043D\u0430 ${gapCm} \u0441\u043C. \u0421\u0432\u0435\u0440\u044C\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0441 \u043B\u0438\u0441\u0442\u043E\u043C: \u043E\u0434\u043D\u0430 \u0438\u0437 \u0446\u0438\u0444\u0440 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0430 \u043D\u0435\u0432\u0435\u0440\u043D\u043E`
        );
      }
    }
    if (area !== null && kept.length >= 4) {
      const fromWalls = rectangleAreaSqm(kept);
      if (fromWalls !== null) {
        const diff = Math.abs(fromWalls - area) / area;
        if (diff > AREA_TOLERANCE2) {
          warnings.push(
            `\xAB${room.name}\xBB: \u043F\u043B\u043E\u0449\u0430\u0434\u044C ${area} \u043C\xB2 \u043D\u0435 \u0441\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0441 \u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043C\u0438 \u0441\u0442\u0435\u043D (\u043F\u043E \u043D\u0438\u043C ${fromWalls.toFixed(2)} \u043C\xB2). \u0421\u0432\u0435\u0440\u044C\u0442\u0435 \u0446\u0438\u0444\u0440\u044B \u0441 \u044D\u0441\u043A\u0438\u0437\u043E\u043C`
          );
        }
      }
    }
    const heightOk = room.heightM !== null && room.heightM > 1 && room.heightM < 10;
    if (room.heightM !== null && !heightOk) {
      warnings.push(`\xAB${room.name}\xBB: \u0432\u044B\u0441\u043E\u0442\u0430 ${room.heightM} \u043C \u043D\u0435 \u043F\u043E\u0445\u043E\u0436\u0430 \u043D\u0430 \u043F\u0440\u0430\u0432\u0434\u0443 \u2014 \u043D\u0435 \u0432\u0437\u044F\u0442\u0430`);
    }
    return {
      ...room,
      walls: kept,
      areaSqm: area,
      perimeterM: room.perimeterM !== null && room.perimeterM > 0 ? room.perimeterM : null,
      heightM: heightOk ? room.heightM : null
    };
  });
  if (result.items.length > L2.maxItems) {
    warnings.push(
      `\u041F\u043E\u0437\u0438\u0446\u0438\u0439 \u043D\u0430 \u043B\u0438\u0441\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 ${L2.maxItems}: \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0435\u0440\u0432\u044B\u0435 ${L2.maxItems}, \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 ${result.items.length - L2.maxItems} \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0440\u0443\u043A\u0430\u043C\u0438`
    );
  }
  const items = result.items.slice(0, L2.maxItems).filter((item) => {
    const ok = item.quantity > 0 && item.quantity <= L2.maxQuantity;
    if (!ok) {
      warnings.push(
        item.quantity > 0 ? `\xAB${item.name}\xBB: \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E ${item.quantity} \u043D\u0435 \u043F\u043E\u0445\u043E\u0436\u0435 \u043D\u0430 \u043F\u0440\u0430\u0432\u0434\u0443 \u2014 \u043F\u043E\u0437\u0438\u0446\u0438\u044F \u043D\u0435 \u0432\u0437\u044F\u0442\u0430` : `\xAB${item.name}\xBB: \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E ${item.quantity} \u2014 \u043F\u043E\u0437\u0438\u0446\u0438\u044F \u043D\u0435 \u0432\u0437\u044F\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0440\u0443\u043A\u0430\u043C\u0438, \u0435\u0441\u043B\u0438 \u043E\u043D\u0430 \u043D\u0443\u0436\u043D\u0430`
      );
    }
    return ok;
  });
  return { ...result, rooms, items, warnings };
}
var RECOGNITION_CLOSURE_TOLERANCE_MM = 50;
var AREA_TOLERANCE2 = 0.03;
function rectangleAreaSqm(walls) {
  if (walls.length !== 4) return null;
  const len = walls.map((w) => w.lengthMm);
  const a = len[0] ?? 0;
  const b = len[1] ?? 0;
  const c = len[2] ?? 0;
  const d = len[3] ?? 0;
  if (a <= 0 || b <= 0 || c <= 0 || d <= 0) return null;
  const sameOpposite = Math.abs(a - c) / Math.max(a, c) < 0.02 && Math.abs(b - d) / Math.max(b, d) < 0.02;
  if (!sameOpposite) return null;
  return a / 1e3 * (b / 1e3);
}
var RECOGNITION_LOG_LABELS = {
  ...RECOGNITION_LABELS,
  NUMBERS: "\u0426\u0438\u0444\u0440\u044B \u0434\u043B\u044F \u0445\u043E\u043B\u0441\u0442\u0430",
  OUTLINE: "\u041E\u0431\u0432\u043E\u0434 \u043A\u043E\u043C\u043D\u0430\u0442\u044B"
};
var sheetTapSchema = z5.object({
  x: z5.number().min(0).max(1),
  y: z5.number().min(0).max(1)
}).strict();
var sheetOutlineRequestSchema = sheetTapSchema.extend({
  /**
   * Ещё нажатия той же комнаты. Комната с диагоналями внутри выходит
   * треугольником, и точка в недостающей части складывает их — станция
   * подаёт все точки одной модели разом, а не объединяет два обвода.
   */
  more: z5.array(sheetTapSchema).max(7).optional()
});

// src/calc/estimate-lines.ts
var PROFILE_PRICE_CODE = {
  BAGUETTE: "BAGUETTE",
  FLOAT: "PROF-FLOAT",
  SHADOW: "PROF-SHADOW"
};
var FIXTURE_PRICE_CODE = {
  LAMP: "LAMP-SPOT",
  CHANDELIER: "CHANDELIER",
  TRACK: "LAMP-TRACK",
  PIPE: "PIPE-BYPASS"
};
var SEAM_PRICE_CODE = "SEAM";
var CURTAIN_NICHE_PRICE_CODE = "CURTAIN-NICHE";
var CORNER_EXTRA_PRICE_CODE = "CORNER-EXTRA";
var MOUNT_PRICE_CODE = "MOUNT";
var FREE_CORNERS = 4;
var RECONCILED_PRICE_CODES = [
  MOUNT_PRICE_CODE,
  SEAM_PRICE_CODE,
  CURTAIN_NICHE_PRICE_CODE,
  CORNER_EXTRA_PRICE_CODE,
  ...Object.values(PROFILE_PRICE_CODE),
  ...Object.values(FIXTURE_PRICE_CODE)
];
function expectedEstimateLines(input) {
  const lines = [];
  const push2 = (code, quantity) => {
    if (quantity > 0) lines.push({ code, quantity });
  };
  push2(MOUNT_PRICE_CODE, input.areaSqm ?? 0);
  const lengths = profileLengths(input.walls);
  lengths.FLOAT += input.lightLineProfileM ?? 0;
  for (const [profile, code] of Object.entries(PROFILE_PRICE_CODE)) {
    push2(code, lengths[profile]);
  }
  push2(CURTAIN_NICHE_PRICE_CODE, curtainNicheLengthM(input.walls));
  push2(SEAM_PRICE_CODE, input.seamLengthM ?? 0);
  const fixtures = input.fixtures ?? [];
  for (const [kind, code] of Object.entries(FIXTURE_PRICE_CODE)) {
    push2(code, fixtures.filter((f) => f.kind === kind).length);
  }
  push2(CORNER_EXTRA_PRICE_CODE, Math.max(0, (input.cornersCount ?? FREE_CORNERS) - FREE_CORNERS));
  return lines;
}
var ESTIMATE_TOLERANCE = 0.05;
function diffEstimate(expected, actual) {
  const sum = (lines) => {
    const totals = /* @__PURE__ */ new Map();
    for (const line2 of lines) {
      totals.set(line2.code, (totals.get(line2.code) ?? 0) + line2.quantity);
    }
    return totals;
  };
  const expectedTotals = sum(expected);
  const actualTotals = sum(actual);
  const codes = RECONCILED_PRICE_CODES;
  const diffs = [];
  for (const code of codes) {
    const exp = Math.round((expectedTotals.get(code) ?? 0) * 100) / 100;
    const act = Math.round((actualTotals.get(code) ?? 0) * 100) / 100;
    const diffQuantity = Math.round((exp - act) * 100) / 100;
    if (Math.abs(diffQuantity) <= ESTIMATE_TOLERANCE) continue;
    diffs.push({ code, expected: exp, actual: act, diffQuantity });
  }
  return diffs.sort((a, b) => Math.abs(b.diffQuantity) - Math.abs(a.diffQuantity));
}

// src/calc/project-check.ts
function approvalBlockers(cuts) {
  const blockers = [];
  for (const cut of cuts) {
    if (cut.walls.length < 3) {
      blockers.push(`\xAB${cut.roomName}\xBB: \u043D\u0435 \u0437\u0430\u0434\u0430\u043D \u043A\u043E\u043D\u0442\u0443\u0440`);
      continue;
    }
    const contour = contourFromWalls(cut.walls);
    if (!isContourClosed(contour)) {
      blockers.push(
        `\xAB${cut.roomName}\xBB: \u043A\u043E\u043D\u0442\u0443\u0440 \u043D\u0435 \u0437\u0430\u043C\u043A\u043D\u0443\u043B\u0441\u044F, \u043D\u0435\u0432\u044F\u0437\u043A\u0430 ${contour.closureErrorMm} \u043C\u043C`
      );
    }
    if (!cut.hasMaterial) {
      blockers.push(`\xAB${cut.roomName}\xBB: \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430 \u0444\u0430\u043A\u0442\u0443\u0440\u0430 \u043F\u043E\u043B\u043E\u0442\u043D\u0430`);
    }
    if (cut.seamConflicts.length > 0) {
      const worst = Math.max(...cut.seamConflicts.map((c) => c.shortfallMm));
      blockers.push(
        `\xAB${cut.roomName}\xBB: \u0448\u043E\u0432 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0447\u0435\u0440\u0435\u0437 \u043E\u0442\u0432\u0435\u0440\u0441\u0442\u0438\u0435, \u043D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442 ${worst} \u043C\u043C. \u041D\u0430 \u0441\u0432\u0430\u0440\u043D\u043E\u0439 \u0448\u043E\u0432 \u043D\u0435\u043B\u044C\u0437\u044F \u043F\u043E\u0441\u0430\u0434\u0438\u0442\u044C \u043A\u043E\u043B\u044C\u0446\u043E \u0441\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A\u0430`
      );
    }
  }
  return blockers;
}

// src/calc/warranty.ts
function addMonths(date, months) {
  const result = new Date(date.getTime());
  const day = result.getDate();
  result.setMonth(result.getMonth() + months);
  if (result.getDate() !== day) result.setDate(0);
  return result;
}
var DAY_MS = 24 * 60 * 60 * 1e3;
function warrantyState(params) {
  const dates = params.completedAt.filter((d) => d !== null && d !== void 0).map((d) => d instanceof Date ? d : new Date(d)).filter((d) => !Number.isNaN(d.getTime()));
  if (dates.length === 0 || params.warrantyMonths <= 0) {
    return { active: false, expiresAt: null, daysLeft: null, since: null };
  }
  const since = new Date(Math.max(...dates.map((d) => d.getTime())));
  const expiresAt = addMonths(since, params.warrantyMonths);
  const at = params.at ?? /* @__PURE__ */ new Date();
  const endOfDay = new Date(expiresAt.getTime());
  endOfDay.setHours(23, 59, 59, 999);
  return {
    active: at.getTime() <= endOfDay.getTime(),
    expiresAt,
    daysLeft: Math.ceil((endOfDay.getTime() - at.getTime()) / DAY_MS),
    since
  };
}
function warrantyLabel(state) {
  if (!state.expiresAt) return "\u043C\u043E\u043D\u0442\u0430\u0436 \u043D\u0435 \u043F\u0440\u0438\u043D\u044F\u0442 \u2014 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0435 \u043D\u0430\u0447\u0438\u043D\u0430\u043B\u0430\u0441\u044C";
  const date = state.expiresAt.toLocaleDateString("ru-RU");
  if (!state.active) {
    const days = state.daysLeft === null ? 0 : Math.abs(state.daysLeft);
    return `\u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u0438\u0441\u0442\u0435\u043A\u043B\u0430 ${date} (${days} \u0434\u043D. \u043D\u0430\u0437\u0430\u0434)`;
  }
  return `\u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u0434\u043E ${date} (\u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C ${state.daysLeft} \u0434\u043D.)`;
}

// src/calc/travel-fit.ts
var TRAVEL_SLACK_MIN = 10;
function endOf(stop) {
  return new Date(stop.startsAt.getTime() + stop.durationMin * 6e4);
}
function formatTime(date) {
  return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}
function minutesBetween(from, to) {
  return Math.floor((to.getTime() - from.getTime()) / 6e4);
}
function checkTravelFit(input) {
  const warnings = [];
  if (input.previous && typeof input.fromPreviousMin === "number") {
    const free = minutesBetween(endOf(input.previous), input.next.startsAt);
    const need = input.fromPreviousMin;
    if (free < need) {
      warnings.push({
        level: "late",
        minutes: need - free,
        message: `\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0432\u044B\u0435\u0437\u0434 \u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0432 ${formatTime(endOf(input.previous))} (${input.previous.address}), \u0434\u043E\u0440\u043E\u0433\u0430 ${need} \u043C\u0438\u043D \u2014 \u043D\u0435 \u0443\u0441\u043F\u0435\u0432\u0430\u0435\u0442 \u043D\u0430 ${need - free} \u043C\u0438\u043D.`
      });
    } else if (free < need + TRAVEL_SLACK_MIN) {
      warnings.push({
        level: "tight",
        minutes: free - need,
        message: `\u041E\u0442 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0433\u043E \u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u0445\u0430\u0442\u044C ${need} \u043C\u0438\u043D, \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E ${free} \u043C\u0438\u043D \u2014 \u0432\u043F\u0440\u0438\u0442\u044B\u043A, \u0431\u0435\u0437 \u0437\u0430\u043F\u0430\u0441\u0430 \u043D\u0430 \u043F\u0430\u0440\u043A\u043E\u0432\u043A\u0443 \u0438 \u043F\u043E\u0434\u044A\u0435\u0437\u0434.`
      });
    }
  }
  if (input.following && typeof input.toFollowingMin === "number") {
    const free = minutesBetween(endOf(input.next), input.following.startsAt);
    const need = input.toFollowingMin;
    if (free < need) {
      warnings.push({
        level: "late",
        minutes: need - free,
        message: `\u041D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0432\u044B\u0435\u0437\u0434 \u0432 ${formatTime(input.following.startsAt)} (${input.following.address}) \u0435\u0445\u0430\u0442\u044C ${need} \u043C\u0438\u043D \u2014 \u043E\u043F\u043E\u0437\u0434\u0430\u0435\u0442 \u043D\u0430 ${need - free} \u043C\u0438\u043D.`
      });
    } else if (free < need + TRAVEL_SLACK_MIN) {
      warnings.push({
        level: "tight",
        minutes: free - need,
        message: `\u0414\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u0435\u0437\u0434\u0430 \u0435\u0445\u0430\u0442\u044C ${need} \u043C\u0438\u043D, \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E ${free} \u043C\u0438\u043D \u2014 \u0432\u043F\u0440\u0438\u0442\u044B\u043A.`
      });
    }
  }
  return warnings;
}
function travelSummary(minutes) {
  if (typeof minutes !== "number") return "\u0432\u0440\u0435\u043C\u044F \u0432 \u043F\u0443\u0442\u0438 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E";
  if (minutes < 1) return "\u0440\u044F\u0434\u043E\u043C";
  if (minutes < 60) return `${minutes} \u043C\u0438\u043D \u0432 \u043F\u0443\u0442\u0438`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0 ? `${hours} \u0447 \u0432 \u043F\u0443\u0442\u0438` : `${hours} \u0447 ${rest} \u043C\u0438\u043D \u0432 \u043F\u0443\u0442\u0438`;
}

// src/calc/specification.ts
var HEADER_WORDS = ["\u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435", "\u0444\u0430\u043A\u0442\u0443\u0440\u0430", "\u043E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043C\u043E\u043D\u0442\u0430\u0436\u0430", "\u0438\u0442\u043E\u0433\u043E"];
function parseSpecTable(rows) {
  const lines = [];
  let section = "";
  for (const raw of rows) {
    const cells = raw.map((c) => c.replace(/[ \t]+/g, " ").replace(/\s*\n\s*/g, "\n").trim());
    const filled = cells.filter(Boolean);
    if (filled.length === 0) continue;
    const lower = filled[0].toLowerCase();
    if (HEADER_WORDS.some((w) => lower.startsWith(w))) continue;
    if (filled.length === 1) {
      section = filled[0].replace(/\s+/g, " ").replace(/[:\s]+$/, "");
      continue;
    }
    const unitIndex = cells.findIndex((c, i) => i > 0 && /^\/\s*\S/.test(c));
    const articleIndex = cells.findIndex(
      (c, i) => i > 0 && (unitIndex === -1 || i < unitIndex) && /^\d{4,6}(\s*\/\s*\d+)?$/.test(c)
    );
    if (unitIndex === -1 && articleIndex === -1) continue;
    const nameEnd = articleIndex !== -1 ? articleIndex : unitIndex;
    const lineName = cells.slice(0, nameEnd).filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
    if (!lineName) continue;
    const article = articleIndex !== -1 ? cells[articleIndex].match(/^\d+/)[0] : null;
    const unitLabel = (unitIndex !== -1 ? cells[unitIndex] : "").replace(/\s+/g, " ");
    const after = unitIndex !== -1 ? unitIndex + 1 : articleIndex + 1;
    const priceCells = cells.slice(after).filter(Boolean).slice(0, 2);
    lines.push({ section, article, lineName, unitLabel, priceCells });
  }
  return lines;
}
function specLineKey(line2) {
  const words = (text3, count) => text3.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim().split(" ").slice(0, count).join(" ");
  return `${words(line2.section ?? "", 3)}|${line2.article ?? ""}|${words(line2.lineName, 6)}`;
}
function parsePrice(text3) {
  const cleaned = text3.replace(/\s/g, "").replace(",", ".");
  const range = cleaned.match(/^(\d+(?:\.\d+)?)[-–—](\d+(?:\.\d+)?)$/);
  if (range) return { from: sane(range[1]), to: sane(range[2]) };
  const single = cleaned.match(/^(\d+(?:\.\d+)?)$/);
  if (single) return { from: sane(single[1]), to: null };
  return { from: null, to: null };
}
function sane(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0 || n > 1e6) return null;
  return value;
}
function priceEntries(cells) {
  const parts = [];
  for (const cell of cells) {
    for (const part of cell.split(/\s*\/\s*|\s*\\\s*|\n/)) {
      const piece = part.trim();
      if (!piece) continue;
      if (/^\d[\d.,–—-]*(\s+\d[\d.,–—-]*)+$/.test(piece)) parts.push(...piece.split(/\s+/));
      else parts.push(piece);
    }
  }
  return parts.map(parsePrice);
}
function variantLabels(lineName, count) {
  const parts = lineName.split(/\s*\/\/?\s*|\s*\\\s*/).map((p) => p.trim()).filter(Boolean);
  if (parts.length !== count || count < 2) return null;
  const rest = parts.slice(1);
  const words = Math.max(1, Math.round(rest.reduce((s, p) => s + p.split(" ").length, 0) / rest.length));
  const firstWords = parts[0].split(" ");
  const first = firstWords.length > words ? firstWords.slice(-words).join(" ") : parts[0];
  return [first, ...rest];
}
function expandSpecLine(line2) {
  const entries = priceEntries(line2.priceCells);
  if (entries.length === 0) return [{ label: null, price: "0", priceTo: null, unknown: true }];
  const listed = line2.priceCells.some((c) => /\//.test(c) || /\n/.test(c) || /\d\s+\d/.test(c));
  if (entries.length === 2 && !listed) {
    const labels2 = variantLabels(line2.lineName, 2);
    if (!labels2) {
      const [a, b] = entries;
      return [
        {
          label: null,
          price: a.from ?? "0",
          priceTo: b.from ?? a.to,
          unknown: a.from === null
        }
      ];
    }
  }
  if (entries.length === 1) {
    const [only] = entries;
    return [
      { label: null, price: only.from ?? "0", priceTo: only.to, unknown: only.from === null }
    ];
  }
  const labels = variantLabels(line2.lineName, entries.length);
  return entries.map((entry, i) => ({
    label: labels ? labels[i] : (entry.from ?? "?") + (entry.to ? `\u2013${entry.to}` : ""),
    price: entry.from ?? "0",
    priceTo: entry.to,
    unknown: entry.from === null
  }));
}
function specUnit(label) {
  const l = label.replace(/^\/\s*/, "").toLowerCase().replace(/\s|\./g, "");
  if (l.startsWith("\u043C\u043F") || l === "\u043C" || l.startsWith("\u043F\u043E\u0433\u043C")) return PriceUnit.LINEAR_M;
  if (l.startsWith("\u0448\u0442")) return PriceUnit.PIECE;
  if (l.startsWith("\u0442\u043A\u0440") || l.startsWith("\u0442,\u043A\u0440")) return PriceUnit.MOUNT_POINT;
  if (l.startsWith("\u043A\u043E\u043C\u043F")) return PriceUnit.SET;
  if (l.startsWith("\u043A\u043C")) return PriceUnit.KM;
  if (l.startsWith("\u043C2") || l.startsWith("\u043A\u0432") || l.startsWith("\u043C\xB2")) return PriceUnit.SQM;
  if (l.startsWith("\u0447\u0430\u0441")) return PriceUnit.HOUR;
  return PriceUnit.JOB;
}
function textFingerprint(text3) {
  let hash = 2166136261;
  for (const ch of text3.toLowerCase().replace(/\s+/g, " ").trim()) {
    hash ^= ch.codePointAt(0);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  return hash.toString(36).padStart(7, "0").slice(-7);
}
function specItemCode(line2, variant) {
  return `${line2.article ?? "S"}-${textFingerprint(`${line2.section ?? ""}|${line2.lineName}`)}-${variant + 1}`;
}
function priceForPayment(item, paymentMethod) {
  const cashless = paymentMethod === PaymentMethod.CASHLESS;
  const price = cashless && item.priceCashless != null ? item.priceCashless : item.price;
  const to = cashless && item.priceCashless != null ? item.priceToCashless : item.priceTo;
  return { price: String(price), priceTo: to == null ? null : String(to) };
}
function groupSpecification(items, categoryId) {
  const own = items.filter((i) => i.categoryId === categoryId).sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || a.name.localeCompare(b.name, "ru"));
  const sections = [];
  const bySection = /* @__PURE__ */ new Map();
  const byLine = /* @__PURE__ */ new Map();
  for (const item of own) {
    const title = item.lineName ? item.section || "\u0411\u0435\u0437 \u0440\u0430\u0437\u0434\u0435\u043B\u0430" : "\u041F\u0440\u043E\u0447\u0435\u0435";
    let section = bySection.get(title);
    if (!section) {
      section = { title, lines: [] };
      bySection.set(title, section);
      sections.push(section);
    }
    const lineName = item.lineName ?? item.name;
    const key = `${title}|${item.article ?? ""}|${lineName}`;
    let line2 = byLine.get(key);
    if (!line2) {
      line2 = { key, article: item.article ?? null, lineName, unit: item.unit, variants: [] };
      byLine.set(key, line2);
      section.lines.push(line2);
    }
    line2.variants.push(item);
  }
  const other = sections.find((s) => s.title === "\u041F\u0440\u043E\u0447\u0435\u0435");
  return other ? [...sections.filter((s) => s !== other), other] : sections;
}

// src/calc/nonclosure-addr.ts
var GENERIC = /* @__PURE__ */ new Set([
  "\u043B\u0435\u043C\u0430\u043D\u0430",
  "\u0440\u0435\u043C\u043E\u043D\u0442",
  "\u0433\u0432\u043E\u0437\u0434\u044C",
  "\u0433",
  "\u0433\u043E\u0440\u043E\u0434",
  "\u0443\u043B",
  "\u0443\u043B\u0438\u0446\u0430",
  "\u043F\u0440",
  "\u043F\u0440\u043E\u0441\u043F",
  "\u043F\u0440\u043E\u0441\u043F\u0435\u043A\u0442",
  "\u043F\u0435\u0440",
  "\u043F\u0435\u0440\u0435\u0443\u043B\u043E\u043A",
  "\u0434",
  "\u0434\u043E\u043C",
  "\u043A\u0432",
  "\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430",
  "\u0441\u043D\u0442",
  "\u0434\u043D\u0442",
  "\u0442\u0441\u043D",
  "\u0434\u043D\u043F",
  "\u0441\u0442",
  "\u043C\u043A\u0440",
  "\u043C\u0438\u043A\u0440\u043E\u0440\u0430\u0439\u043E\u043D",
  "\u043F\u043E\u0441",
  "\u043F\u043E\u0441\u0435\u043B\u043E\u043A",
  "\u0441\u0435\u043B\u043E",
  "\u0434\u0435\u0440\u0435\u0432\u043D\u044F",
  "\u0434\u0435\u0440",
  "\u0442\u0440\u0430\u043A\u0442",
  "\u0448\u043E\u0441\u0441\u0435",
  "\u0431\u0443\u043B\u044C\u0432\u0430\u0440",
  "\u043D\u0430\u0431\u0435\u0440\u0435\u0436\u043D\u0430\u044F",
  "\u043F\u0440\u043E\u0435\u0437\u0434",
  "\u0442\u0443\u043F\u0438\u043A",
  "\u043F\u043B\u043E\u0449\u0430\u0434\u044C",
  "\u043F\u043B",
  "\u043E\u0444\u0438\u0441",
  "\u043A\u043E\u0440\u043F",
  "\u0441\u0442\u0440",
  "\u0443\u0447",
  "\u0443\u0447\u0430\u0441\u0442\u043E\u043A",
  "\u043E\u043E\u043E",
  "\u0438\u043F",
  "\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443",
  "\u043D\u0435",
  "\u0443\u043A\u0430\u0437\u0430\u043B",
  "\u0443\u043A\u0430\u0437\u0430\u043B\u0430",
  "\u0447\u0430\u0441\u0442\u043D\u044B\u0439",
  "\u0443\u0434\u043C\u0443\u0440\u0442\u0441\u043A\u0430\u044F",
  "\u0440\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "\u0438\u0436\u0435\u0432\u0441\u043A",
  "\u043F\u0440\u043E"
]);
var W = "[\\p{L}\\p{N}_]";
var B_BEFORE = `(?<!${W})`;
var B_AFTER = `(?!${W})`;
var L = "[\u0430-\u044F](?![\u0430-\u044F])";
var HOUSE = `\\d+(?:\\s?${L})?(?:/\\d+(?:${L})?)?`;
var NUM = new RegExp(`(${HOUSE})(?:\\s*-\\s*(\\d+(?:${L})?))?`, "gu");
var DKV = new RegExp(`(?:${B_BEFORE}(?:\u0434|\u0434\u043E\u043C)\\s+)?(${HOUSE})\\s+(?:\u043A\u0432|\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430)\\s+(\\d+[\u0430-\u044F]?)${B_AFTER}`, "gu");
var LEAD = /^\s*(?:б\/д|б\/н|№)?\s*\d+[а-яa-z]*\s+(?=\D)/iu;
function normalizeAddress(s) {
  let t = (s ?? "").toLowerCase().replace(/ё/g, "\u0435").replace(/ /g, " ");
  t = t.replace(/\(.*?\)/gu, " ");
  t = t.replace(/[«»"'\[\],;:.#№]/gu, " ");
  t = t.replace(/\s+/gu, " ").trim();
  return t.replace(DKV, "$1-$2");
}
function parseAddress(addr, contract = false) {
  let s = normalizeAddress(addr);
  if (contract) s = s.replace(LEAD, "");
  const ms = [...s.matchAll(NUM)];
  if (ms.length === 0) return null;
  const m = ms[ms.length - 1];
  const house = m[1].replace(/ /g, "");
  const flat = m[2] ?? null;
  const before = s.slice(0, m.index);
  const words = (before.match(/[а-яa-z]+|\d+/gu) ?? []).filter((w) => !GENERIC.has(w) && w.length >= 2);
  const street = words.map((w) => w.slice(0, 5));
  const lastWord = [...street].reverse().find((w) => !/^\d+$/.test(w));
  const last = lastWord ?? street[street.length - 1] ?? "";
  return { street, last, house, flat };
}
function compareParsedAddresses(a, c) {
  return compare(a, c);
}
function compare(a, c) {
  if (!a || !c || !a.last) return null;
  if (a.house !== c.house) return null;
  if (!c.street.includes(a.last)) return null;
  if (a.flat && c.flat) return a.flat === c.flat ? "exact" : null;
  if (!a.flat && !c.flat) return "exact";
  return "house";
}
function matchAddress(addr, contract) {
  return compare(parseAddress(addr), parseAddress(contract, true));
}
function addressRelation(addr, other, contract = true) {
  const a = parseAddress(addr);
  const c = parseAddress(other, contract);
  if (!a || !c || !a.last || !c.last) return "unknown";
  return compare(a, c) ?? "conflict";
}
function escapeRe(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function addressInText(addr, text3) {
  const a = parseAddress(addr);
  if (!a || !a.last || a.last.length < 3 || !text3) return null;
  const t = normalizeAddress(text3);
  const h = escapeRe(a.house).replace(/(\d)([а-я])/gu, "$1\\s?$2");
  const pat = new RegExp(
    `${B_BEFORE}${escapeRe(a.last)}[\u0430-\u044F]*(?:\\s+(?:[\u0430-\u044F]+|\\d+)){0,2}?\\s+${h}(?![\\d/])(?!\\s?[\u0430-\u044F](?![\u0430-\u044F]))(?:\\s*-\\s*(\\d+[\u0430-\u044F]?))?`,
    "gu"
  );
  let best = null;
  for (const m of t.matchAll(pat)) {
    const flat = m[1] ?? null;
    if (a.flat && flat) {
      if (a.flat === flat) return "exact";
      continue;
    }
    const r = !a.flat && !flat ? "exact" : "house";
    best = best ?? r;
  }
  return best;
}
function addressScore(addr, contract) {
  const m = matchAddress(addr, contract);
  return m === "exact" ? 2 : m === "house" ? 1 : 0;
}

// src/calc/nonclosure-kinds.ts
var B = "(?<![\\p{L}\\p{N}_])";
var E = "(?![\\p{L}\\p{N}_])";
var WORD = "[\\p{L}\\p{N}_]";
var COND = new RegExp(
  "\u043A\u043E\u043D\u0434|\u0441\u043F\u043B\u0438\u0442|\u0438\u043D\u0432\u0435\u0440\u0442\u043E\u0440|\u0431\u0430\u043B\u043B?\u0443" + E + "|ballu|\u043C\u0434\u0432|mdv|\u043B\u043E\u0440\u0438\u043E\u0442|loriot|haier|\u0445\u0430\u0439\u0435\u0440|" + B + "gree" + E + "|\u0433\u0440\u0438\u0438|daikin|\u0434\u0430\u0439\u043A\u0438\u043D|mitsubishi|\u043C\u0438\u0446\u0443\u0431\u0438\u0441\u0438|samsung|\u0441\u0430\u043C\u0441\u0443\u043D\u0433|" + B + "aux" + E + "|" + B + "tcl" + E + "|hisense|\u0445\u0430\u0439\u0441\u0435\u043D\u0441|royal|\u0440\u043E\u044F\u043B|electrolux|\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043B\u044E\u043A\u0441|kentatsu|\u043A\u0435\u043D\u0442\u0430\u0442\u0441\u0443|\u0442\u043E\u0448\u0438\u0431\u0430|toshiba|fujitsu|\u0444\u0443\u0434\u0436\u0438\u0442\u0441\u0443|midea|\u043C\u0438\u0434\u0435\u0430|lessar|\u043B\u0435\u0441\u0441\u0430\u0440|centek|\u0446\u0435\u043D\u0442\u0435\u043A|\u0442\u0440\u0430\u0441\u0441|\u043D\u0430\u0440\u0443\u0436\u043D|\u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D" + WORD + "* \u0431\u043B\u043E\u043A|\u0434\u0440\u0435\u043D\u0430\u0436|\u043A\u043E\u043C\u043F\u0440\u0435\u0441\u0441\u043E\u0440|\u043E\u0445\u043B\u0430\u0436\u0434|\u0432\u0435\u043D\u0442\u0438\u043B\u044F\u0446",
  "iu"
);
var CEIL = new RegExp(
  "\u043F\u043E\u0442\u043E\u043B|\u043F\u043E\u043C\u0435\u0449|\u043F\u043E\u043B\u043E\u0442\u043D|\u0441\u0432\u0435\u0442\u0438\u043B\u044C\u043D|\u043B\u044E\u0441\u0442\u0440|\\d\\s*\u043A\u0432" + E + "|\\d\\s*\u043A\u0432\\.|" + B + "\u043A\u0432" + E + "|\u043C2|\u043C\xB2|\u043A\u0432\\.?\\s*\u043C|\u043A\u0432\u0430\u0434\u0440|\u043A\u0443\u0445\u043D|\u0432\u0430\u043D\u043D|" + B + "\u0441\u0443" + E + "|\u0441/\u0443|\u0441\u0430\u043D\u0443\u0437\u0435\u043B|\u043A\u043E\u0440\u0438\u0434\u043E\u0440|\u043F\u0440\u0438\u0445\u043E\u0436|\u0441\u043F\u0430\u043B\u044C\u043D|" + B + "\u0437\u0430\u043B" + E + "|\u043A\u043E\u043C\u043D\u0430\u0442|\u043A\u0432\u0430\u0440\u0442\u0438\u0440|" + B + "\u0434\u043E\u043C" + E + "|\u043D\u0438\u0448[\u0430\u0438]|\u0431\u0430\u0433\u0435\u0442|\u0433\u0430\u0440\u0434\u0438\u043D|\u043A\u0430\u0440\u043D\u0438\u0437|\u0442\u0435\u043D\u0435\u0432\u043E\u0439|\u043F\u0430\u0440\u044F\u0449|\u0434\u0432\u0443\u0445\u0443\u0440\u043E\u0432|\u0443\u0440\u043E\u0432\u043D|\u0433\u043B\u044F\u043D\u0435\u0446|\u0441\u0430\u0442\u0438\u043D|\u0442\u043A\u0430\u043D\u0435\u0432|\u043B\u043E\u0434\u0436\u0438|\u0431\u0430\u043B\u043A\u043E\u043D",
  "iu"
);
var REPAIR = /ремонт|отделк|штукатур|плитк|электрик|сантех/iu;
var COND_STRONG = /конд|сплит|ballu|mdv|лориот|loriot|инвертор/iu;
function kindByText(...texts) {
  const t = texts.map((x) => x ?? "").join(" ");
  const c = COND.test(t);
  const p = CEIL.test(t);
  if (c && !p) return "cond";
  if (p && !c) return "ceil";
  if (c && p) {
    return COND_STRONG.test(t) && !/потол/iu.test(t) ? "cond" : "both";
  }
  if (REPAIR.test(t)) return "repair";
  return null;
}

// src/calc/onec-measurements.ts
var LIVE_NO_MEASURER = "\u0417\u0430\u043C\u0435\u0440\u0449\u0438\u043A \u0432 1\u0421 \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D";
var LIVE_MEASURE_KIND = "zml";
var LIVE_MEASURE_DAYS_BACK = 7;
var LIVE_MEASURE_DAYS_AHEAD = 14;
var str = (v) => v === null || v === void 0 ? "" : String(v).trim();
function phoneOf(v) {
  const raw = str(v);
  const phone = normalizePhone(raw);
  if (phone) return { phone };
  return raw.replace(/\D/g, "").length >= 5 ? { phone: "", phoneRaw: raw } : { phone: "" };
}
var LIVE_POOL_NAME = "\u041D\u0435\u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C";
function isUnassignedMeasurer(name) {
  const s = str(name).toLowerCase();
  return s === "" || s.startsWith("\u043D\u0435\u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B");
}
function liveMeasureState(status) {
  const s = str(status).toLowerCase().replace(/ё/g, "\u0435");
  if (s === "" || s.startsWith("\u043D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D") || s.startsWith("\u043F\u0440\u0438\u043D\u044F\u0442")) return "open";
  if (s.startsWith("\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D")) return "won";
  if (s.startsWith("\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D")) return "lost";
  if (s.startsWith("\u043E\u0442\u043C\u0435\u043D\u0435\u043D")) return "cancelled";
  return "done";
}
function parseLiveMeasures(rows, base) {
  const out = [];
  rows.forEach((r, i) => {
    const m = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}):(\d{2})/.exec(str(r.At));
    if (!m) return;
    const status = str(r.Status);
    out.push({
      key: `${base}:${str(r.Uid) || `${m[1]}-${m[2]}${m[3]}-${i}`}`,
      base,
      uid: str(r.Uid),
      day: m[1],
      time: `${m[2]}:${m[3]}`,
      measurer: isUnassignedMeasurer(r.Measurer) ? null : str(r.Measurer),
      status: status || "\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D",
      state: liveMeasureState(status),
      customer: str(r.Customer),
      address: str(r.Address),
      ...phoneOf(r.Phone),
      comment: str(r.Comment),
      operator: str(r.Resp),
      contract: str(r.Contract),
      source: str(r.Source)
    });
  });
  return out;
}
function staffPhonesFor(names, staff) {
  const word = (s) => s.toLowerCase().replace(/ё/g, "\u0435").split(/\s+/).filter(Boolean);
  const real = staff.filter((u) => u.phone && !u.phone.startsWith("+7000"));
  const out = {};
  for (const name of names) {
    const words = word(name);
    const hits = real.filter((u) => {
      const [surname] = word(u.fullName);
      return !!surname && words.includes(surname);
    });
    const phones = [...new Set(hits.map((u) => u.phone))];
    if (phones.length === 1) out[name] = phones[0];
  }
  return out;
}
function shiftDayKey(day, n) {
  const [y, mo, d] = day.split("-").map(Number);
  const t = new Date(Date.UTC(y, mo - 1, d + n));
  return t.toISOString().slice(0, 10);
}
function liveMeasuresWindow(today) {
  return { from: shiftDayKey(today, -LIVE_MEASURE_DAYS_BACK), to: shiftDayKey(today, LIVE_MEASURE_DAYS_AHEAD + 1) };
}
var byTime = (a, b) => a.day.localeCompare(b.day) || a.time.localeCompare(b.time) || a.address.localeCompare(b.address, "ru");
function liveMeasuresDay(all, date, today) {
  const day = all.filter((m) => m.day === date && (m.measurer !== null || m.state !== "open")).sort(byTime);
  const groups = /* @__PURE__ */ new Map();
  for (const m of day) {
    const who = m.measurer ?? LIVE_NO_MEASURER;
    const list = groups.get(who) ?? [];
    list.push(m);
    groups.set(who, list);
  }
  const surveyors = [...groups.entries()].map(([name, items]) => {
    const live = items.filter((m) => m.state !== "cancelled");
    return { name, items, total: live.length, done: live.filter((m) => m.state !== "open").length };
  }).sort((a, b) => a.name.localeCompare(b.name, "ru"));
  const known = new Set(all.filter((m) => m.measurer !== null).map((m) => m.measurer));
  const idle = [...known].filter((n) => !groups.has(n)).sort((a, b) => a.localeCompare(b, "ru"));
  const waiting = all.filter((m) => m.measurer === null && m.state === "open").sort(byTime);
  const count = (s) => day.filter((m) => m.state === s).length;
  return {
    date,
    surveyors,
    idle,
    waiting: {
      overdue: waiting.filter((m) => m.day < today),
      today: waiting.filter((m) => m.day === today),
      later: waiting.filter((m) => m.day > today)
    },
    totals: {
      total: day.length - count("cancelled"),
      won: count("won"),
      lost: count("lost"),
      done: count("done"),
      open: count("open"),
      cancelled: count("cancelled")
    }
  };
}
var LIVE_MEASURERS_KIND = "zmq";
function parseLiveMeasurers(rows, base) {
  const out = [];
  for (const r of rows) {
    const name = str(r.Name);
    const code = str(r.Code);
    if (!name || !code || r.Active === false || r.Slot === true || isUnassignedMeasurer(name)) continue;
    const off = (Array.isArray(r.Off) ? r.Off : []).map((v) => /^(\d{4}-\d{2}-\d{2})[ T](\d{2})/.exec(str(v))).filter((m) => !!m).map((m) => `${m[1]} ${m[2]}`);
    out.push({ base, name, code, off: [...new Set(off)].sort() });
  }
  return out.sort((a, b) => a.name.localeCompare(b.name, "ru"));
}
function assignOptions(all, measurers, m) {
  const hour = m.time.slice(0, 2);
  return measurers.filter((x) => x.base === m.base && x.name !== m.measurer).map((x) => {
    const times = all.filter((v) => v.base === m.base && v.day === m.day && v.measurer === x.name && v.state !== "cancelled" && v.key !== m.key).map((v) => v.time).sort();
    return { name: x.name, code: x.code, times, busy: times.some((t) => t.slice(0, 2) === hour), off: x.off.includes(`${m.day} ${hour}`) };
  }).sort(
    (a, b) => Number(a.busy || a.off) - Number(b.busy || b.off) || a.times.length - b.times.length || a.name.localeCompare(b.name, "ru")
  );
}
function canMoveMeasure(m) {
  return m.measurer !== null && m.state === "open" && !!m.uid;
}
var LIVE_RESULTS = [
  { key: "won", status: "\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D", label: "\u0417\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440" },
  { key: "lost", status: "\u041D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D", label: "\u041D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438" },
  { key: "done", status: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D (\u043F\u0440\u043E\u0447\u0435\u0435)", label: "\u0421\u044A\u0435\u0437\u0434\u0438\u043B, \u0431\u0435\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 (\u0434\u0440\u0443\u0433\u043E\u0435)" },
  { key: "cancelled", status: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D", label: "\u0412\u044B\u0435\u0437\u0434 \u043D\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043B\u0441\u044F" }
];
function ownMeasurers(fullName, measurers) {
  const words = (s) => s.toLowerCase().replace(/ё/g, "\u0435").split(/\s+/).filter(Boolean);
  const [surname] = words(fullName);
  if (!surname) return [];
  const out = [];
  for (const base of [...new Set(measurers.map((m) => m.base))]) {
    const hits = measurers.filter((m) => m.base === base && words(m.name).includes(surname));
    if (hits.length === 1) out.push(hits[0]);
  }
  return out;
}

// src/calc/nonclosures.ts
var NC_BASES = ["unf_18", "unf_10"];
var NC_BASE_LABEL = { unf_18: "\u0417\u0430\u043A\u0438\u0440\u043E\u0432\u0430 \u0423\u041D\u0424", unf_10: "\u0417\u0430\u043A\u0438\u0440\u043E\u0432 \u043D\u043E\u0432\u0430\u044F" };
var NC_START = "2026-06-01";
var LOOKAHEAD = 150;
var SMALL = 3e3;
var NAMES = {
  "\u0414\u0430\u043D\u0438\u0438\u043B \u0418\u0432\u0430\u043D\u0446\u043E\u0432": "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u0438\u043B": "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B": "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u043C\u0438\u0442\u0440\u0438\u0439": "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u0438\u043C\u0430",
  "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F": "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F",
  "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442": "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442",
  "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D": "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D",
  "\u0417\u043E\u0440\u0438\u043D \u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440": "\u0417\u043E\u0440\u0438\u043D \u0421\u0430\u0448\u0430",
  "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u043E\u0440": "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u044F",
  "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0451\u0434\u043E\u0440": "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u044F",
  "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439": "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439"
};
var NC_ORDER = [
  "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u0438\u043C\u0430",
  "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F",
  "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442",
  "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D",
  "\u0417\u043E\u0440\u0438\u043D \u0421\u0430\u0448\u0430",
  "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u044F",
  "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439"
];
var NC_REPAIR = "\u041C\u0438\u0448\u0430 (\u0440\u0435\u043C\u043E\u043D\u0442)";
var NC_SHEETS = {
  "\u0417\u043E\u0440\u0438\u043D": "\u0417\u043E\u0440\u0438\u043D \u0421\u0430\u0448\u0430",
  "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D": "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u044F",
  "\u041D\u0430\u0443\u043C\u043E\u0432": "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F",
  "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D": "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439",
  "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432": "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u0438\u043C\u0430",
  "\u041F\u0430\u0440\u044B\u0433\u0438\u043D": "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D",
  "\u0418\u0432\u0430\u043D\u0446\u043E\u0432": "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0410\u0448\u043E\u0442": "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442",
  "\u041C\u0438\u0448\u0430 (\u0440\u0435\u043C\u043E\u043D\u0442)": NC_REPAIR
};
var KC_TO_1C = {
  "\u0417\u043E\u0440\u0438\u043D \u0421\u0430\u0448\u0430": "\u0417\u043E\u0440\u0438\u043D \u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440",
  "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u044F": "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u043E\u0440",
  "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F": "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F",
  "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439": "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439",
  "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u0438\u043C\u0430": "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u043C\u0438\u0442\u0440\u0438\u0439",
  "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D": "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D",
  "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B": "\u0414\u0430\u043D\u0438\u0438\u043B \u0418\u0432\u0430\u043D\u0446\u043E\u0432",
  "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442": "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442",
  [NC_REPAIR]: null
};
var DECIDED = /* @__PURE__ */ new Set(["\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D", "\u041D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D", "\u041D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D (\u043F\u0440\u043E\u0447\u0435\u0435)"]);
var AGENT_CUSTOMERS = /* @__PURE__ */ new Set(["\u041E\u041E\u041E \u041B\u0415 \u041C\u041E\u041D\u041B\u0418\u0414"]);
var STRONG_STATES = /* @__PURE__ */ new Set(["\u0412 \u0440\u0430\u0431\u043E\u0442\u0435", "\u0421\u043E\u0431\u0440\u0430\u043D\u043E", "\u0412\u044B\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0441\u0447\u0435\u0442"]);
var NC_SLICE_KINDS = ["zam", "ord", "pay", "rn", "mon", "dog"];
function kcDirection(text3) {
  const t = (text3 ?? "").toUpperCase();
  if (t.includes("\u041A\u041E\u041D\u0414") || t.includes("\u0421\u041F\u041B\u0418\u0422")) return "cond";
  if (t.includes("\u041F\u041E\u0422\u041E\u041B")) return "ceil";
  if (t.includes("\u0420\u0415\u041C\u041E\u041D\u0422")) return "repair";
  return null;
}
function ncKcRows(sheets, from, toExclusive) {
  const start = dayOf(from);
  const end = dayOf(toExclusive);
  const rows = [];
  for (const ws of sheets) {
    const measurer = NC_SHEETS[ws.title.trim()];
    if (!measurer) continue;
    for (const r of ws.rows) {
      if (!r.at) continue;
      const day = dayOf(r.at);
      if (!(day >= start && day < end)) continue;
      const cell = (i) => (r.cells[i] ?? "").trim();
      const st = cell(5).toLowerCase();
      const status = st.startsWith("\u0437\u0430\u043A\u043B\u044E\u0447") ? "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D" : st.startsWith("\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447") ? "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D" : ["", "-", "\u2014"].includes(st) ? "" : st.slice(0, 60);
      rows.push({
        measurer,
        sheet: ws.title.trim(),
        row: r.row,
        date: dayStr(day),
        address: cell(0),
        reason: cell(1),
        cc: cell(2),
        comment: cell(3),
        next: cell(4),
        status,
        extra: cell(6),
        dir: kcDirection(cell(1)) ?? kcDirection(cell(0)) ?? kcDirection(r.cells[3] ?? "")
      });
    }
  }
  return rows;
}
function ncMatchKcRows(rows, register) {
  const reg = register.map((z6) => ({
    z: z6,
    day: dayOf(z6.At),
    addr: parseAddress(z6.Address ?? "", true),
    contract: parseAddress(z6.Contract ?? "", true)
  }));
  return rows.map((r) => {
    const a = parseAddress(r.address);
    const day = dayOf(r.date);
    let best = null;
    for (const x of reg) {
      const dd = Math.abs(x.day - day);
      if (dd > 5) continue;
      const sc = scoreOf(compareParsedAddresses(a, x.addr)) || scoreOf(compareParsedAddresses(a, x.contract));
      if (!sc) continue;
      const same = KC_TO_1C[r.measurer] === x.z.Measurer;
      const key = [same ? 0 : 1, dd, -sc];
      if (!best || lessTuple(key, best.key)) best = { key, z: x.z };
    }
    return { ...r, reg: best ? pickReg(best.z) : null };
  });
}
function scoreOf(m) {
  return m === "exact" ? 2 : m === "house" ? 1 : 0;
}
function lessTuple(a, b) {
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return a[i] < b[i];
  }
  return false;
}
function pickReg(z6) {
  const out = { At: z6.At, Measurer: z6.Measurer, Uid: z6.Uid };
  for (const k of ["Status", "Contract", "Customer", "CustCode", "Address", "Phone", "Comment", "OrderDoc", "Source"]) {
    if (k in z6) out[k] = z6[k];
  }
  return out;
}
var DAY_MS2 = 864e5;
function dayOf(s) {
  const t = String(s ?? "").slice(0, 10);
  const [y = 1970, m = 1, d = 1] = t.split("-").map(Number);
  return Math.round(Date.UTC(y, (m || 1) - 1, d || 1) / DAY_MS2);
}
function dayStr(n) {
  return new Date(n * DAY_MS2).toISOString().slice(0, 10);
}
function ddmm(n) {
  if (n === null) return "";
  const s = dayStr(n);
  return `${s.slice(8, 10)}.${s.slice(5, 7)}`;
}
function money(x) {
  const v = Math.round(x || 0);
  return String(Math.abs(v)).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/^/, v < 0 ? "-" : "");
}
function clean2(s) {
  return String(s ?? "").replace(/ /g, " ").replace(/\s+/gu, " ").trim();
}
var ADDRESS_CONTRACT = /^\s*(?:б\/д\s+)?\d+[а-яА-ЯёЁa-zA-Z]*\s+\S/u;
var AUTO_RE = /^Договор\s*№\s*([\d ]+?)\s+от\s+(\d\d)\.(\d\d)\.(\d{4})/u;
var OWN_DATE = /(?<![\p{L}\p{N}_])от\s+(\d\d)\.(\d\d)\.(\d{4})/u;
var COMPANY = /(?<![А-Яа-яЁё])(ООО|ИП|АО|ЗАО|ПАО|ОАО|МУП|МБУ|МБОУ|МАОУ|ГБУ|ГБУЗ|БУЗ|ГКУ|ФГБУ|АНО|ТСЖ|УК)(?![А-Яа-яЁё])/u;
function contractNum(name) {
  const s = clean2(name);
  const m = AUTO_RE.exec(s);
  if (m) return [m[1].replace(/ /g, ""), ""];
  const m2 = /^(?:б\/д\s+)?(\d{3,5})([а-яА-ЯёЁa-zA-Z]*)\s+\S/u.exec(s);
  if (m2) return [m2[1], m2[2].toUpperCase()];
  return [null, null];
}
function textDir(...texts) {
  const t = texts.join(" ");
  if (/тих[\p{L}\p{N}_]*\s+стен/iu.test(t)) return "walls";
  if (/кондиц|кондер|сплит/iu.test(t)) return "cond";
  return null;
}
function dealDir(contract, suffix, comments, agent) {
  if (suffix && suffix.includes("\u041A")) return "cond";
  const t = textDir(...comments);
  if (t) return t;
  if (agent || ADDRESS_CONTRACT.test(contract ?? "")) return "ceil";
  return null;
}
function group(x) {
  if (x === "walls") return "ceil";
  if (x === "both") return null;
  return x;
}
function compatible(md, dd) {
  const a = group(md);
  const b = group(dd);
  return a === null || b === null || a === b;
}
var WHO = {
  "\u0438\u0432\u0430\u043D\u0446\u043E\u0432": "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0434\u0430\u043D\u0438\u0438\u043B": "\u0418\u0432\u0430\u043D\u0446\u043E\u0432 \u0414\u0430\u043D\u0438\u043B",
  "\u0433\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432": "\u0413\u0440\u0435\u0431\u0435\u043D\u0449\u0438\u043A\u043E\u0432 \u0414\u0438\u043C\u0430",
  "\u043D\u0430\u0443\u043C\u043E\u0432": "\u041D\u0430\u0443\u043C\u043E\u0432 \u0418\u043B\u044C\u044F",
  "\u043C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D": "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442",
  "\u0430\u0448\u043E\u0442": "\u041C\u0430\u0440\u0442\u0438\u0440\u043E\u0441\u044F\u043D \u0410\u0448\u043E\u0442",
  "\u043F\u0430\u0440\u044B\u0433\u0438\u043D": "\u041F\u0430\u0440\u044B\u0433\u0438\u043D \u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u0438\u043D",
  "\u0437\u043E\u0440\u0438\u043D": "\u0417\u043E\u0440\u0438\u043D \u0421\u0430\u0448\u0430",
  "\u043A\u043E\u0441\u0442\u044E\u043D\u0438\u043D": "\u041A\u043E\u0441\u0442\u044E\u043D\u0438\u043D \u0424\u0435\u0434\u044F",
  "\u043C\u043E\u043A\u0440\u0443\u0448\u0438\u043D": "\u041C\u043E\u043A\u0440\u0443\u0448\u0438\u043D \u0421\u0435\u0440\u0433\u0435\u0439"
};
var WHO_RE = new RegExp(`(?<![\u0430-\u044F\u0451])(${Object.keys(WHO).join("|")})`, "iu");
function whoIn(comments) {
  for (const t of comments) {
    const m = WHO_RE.exec(t ?? "");
    if (m) return WHO[m[1].toLowerCase()] ?? null;
  }
  return null;
}
function ncMeasurerName(raw) {
  const s = clean2(raw);
  return NAMES[String(raw ?? "")] ?? NAMES[s] ?? s;
}
function ncWhoIn(comments) {
  return whoIn(comments);
}
function ncContractNum(name) {
  return contractNum(name);
}
var HOUSE_TOKEN = /\d+(?:\s?[а-я](?![а-я]))?(?:\/\d+(?:[а-я](?![а-я]))?)?/gu;
function analyzeNonclosures(input) {
  const TODAY = dayOf(input.today);
  const data = input.slices;
  const AUTO = /* @__PURE__ */ new Map();
  const AUTO_KEYS = /* @__PURE__ */ new Map();
  for (const b of NC_BASES) {
    const names = [...data[b].dog.map((x) => x.Name), ...data[b].zam.map((x) => x.Contract), ...data[b].ord.map((x) => x.Contract)];
    const keys = /* @__PURE__ */ new Set();
    for (const name of names) {
      const m = AUTO_RE.exec(clean2(name));
      if (m) {
        const n = Number(m[1].replace(/ /g, ""));
        AUTO.set(`${b}|${n}`, dayOf(`${m[4]}-${m[3]}-${m[2]}`));
        keys.add(n);
      }
    }
    AUTO_KEYS.set(b, [...keys].sort((x, y) => x - y));
  }
  const estDate = (base, num4, suffix) => {
    if (!num4 || [..."\u0410\u0411\u041D"].some((ch) => (suffix ?? "").includes(ch))) return null;
    const keys = AUTO_KEYS.get(base) ?? [];
    if (keys.length < 20) return null;
    const n = Number(num4);
    let lo = 0;
    let hi = keys.length;
    while (lo < hi) {
      const mid = lo + hi >> 1;
      if (keys[mid] < n) lo = mid + 1;
      else hi = mid;
    }
    if (lo >= keys.length) return null;
    return AUTO.get(`${base}|${keys[lo]}`) ?? null;
  };
  const signedDate = (base, name, num4, suffix) => {
    if ((name ?? "").toLowerCase().includes("\u0430\u0433\u0435\u043D\u0442\u0441\u043A")) return null;
    const m = OWN_DATE.exec(clean2(name));
    if (m) return dayOf(`${m[3]}-${m[2]}-${m[1]}`);
    if (COMPANY.test(name ?? "")) return null;
    return estDate(base, num4, suffix);
  };
  const MEAS = [];
  for (const b of NC_BASES) {
    for (const z6 of data[b].zam) {
      MEAS.push({
        uid: z6.Uid,
        base: b,
        date: dayOf(z6.At),
        measurer: NAMES[z6.Measurer] ?? z6.Measurer,
        cust: z6.CustCode ?? "",
        cname: z6.Customer ?? "",
        addr: z6.Address ?? "",
        phone: normalizePhone(String(z6.Phone ?? "")),
        phoneRaw: String(z6.Phone ?? "").trim(),
        status: z6.Status ?? "",
        contract: clean2(z6.Contract),
        comment: clean2(z6.Comment),
        table: null,
        dir: null,
        signedBy: [],
        signingFor: null,
        akey: void 0,
        source: clean2(z6.Source)
      });
    }
  }
  const BY_UID = /* @__PURE__ */ new Map();
  for (const m of MEAS) BY_UID.set(m.uid, m);
  const PAYS = /* @__PURE__ */ new Map();
  const RNS = /* @__PURE__ */ new Map();
  const MONS = [];
  for (const b of NC_BASES) {
    for (const p of data[b].pay) push(PAYS, `${b}|${p.CustCode ?? ""}`, [dayOf(p.PDate), p.Sum || 0]);
    for (const r of data[b].rn) push(RNS, `${b}|${r.CustCode ?? ""}`, r);
    for (const m of data[b].mon) {
      MONS.push({ base: b, date: dayOf(m.At), cust: m.CustCode ?? "", cname: m.Customer ?? "", addr: clean2(m.Address), brigade: m.Brigade || "" });
    }
  }
  const DEALS = [];
  const byName = /* @__PURE__ */ new Map();
  for (const b of NC_BASES) {
    const groups = /* @__PURE__ */ new Map();
    for (const o of data[b].ord) {
      const c = clean2(o.Contract);
      const agent = AGENT_CUSTOMERS.has(o.Customer ?? "") || c.toLowerCase().includes("\u0430\u0433\u0435\u043D\u0442\u0441\u043A");
      const key = agent ? JSON.stringify([o.CustCode ?? null, c, o.Num]) : JSON.stringify([o.CustCode ?? null, c]);
      if (!groups.has(key)) groups.set(key, { cust: o.CustCode ?? "", contract: c, ords: [] });
      groups.get(key).ords.push(o);
    }
    for (const g of groups.values()) {
      const ords = [...g.ords].sort((x, y) => x.ODate < y.ODate ? -1 : x.ODate > y.ODate ? 1 : 0);
      const o0 = ords[0];
      const c = g.contract;
      const agent = AGENT_CUSTOMERS.has(o0.Customer ?? "") || c.toLowerCase().includes("\u0430\u0433\u0435\u043D\u0442\u0441\u043A");
      const first = dayOf(o0.ODate);
      const [num4, suffix] = contractNum(c);
      const signed = signedDate(b, c, num4, suffix);
      const start = signed !== null ? Math.min(first, signed) : first;
      const live = ords.filter((o) => o.Variant !== "\u041E\u0442\u043C\u0435\u043D\u0435\u043D");
      const comments = ords.filter((o) => o.Comment).map((o) => clean2(o.Comment));
      const states = /* @__PURE__ */ new Map();
      for (const o of ords) {
        const k = (o.State ?? "") + (o.Variant ? " / " + o.Variant : "");
        states.set(k, (states.get(k) ?? 0) + 1);
      }
      const deal = {
        base: b,
        contract: c,
        cust: g.cust,
        cname: o0.Customer ?? "",
        orders: ords,
        start,
        first,
        agent,
        num: num4,
        suffix,
        monitor: false,
        addrContract: ADDRESS_CONTRACT.test(c) ? c : "",
        comments,
        sum: live.reduce((s, o) => s + (o.Sum || 0), 0),
        cancelled: live.length === 0,
        states,
        dir: dealDir(c, suffix, comments, agent),
        mons: [],
        who: agent ? whoIn(comments) : null,
        paid: 0,
        rn: [],
        real: false,
        small: false,
        strong: false,
        weak: false
      };
      deal.paid = agent ? 0 : (PAYS.get(`${b}|${g.cust}`) ?? []).filter(([pd]) => pd >= start - 7).reduce((s, [, v]) => s + v, 0);
      deal.rn = agent ? [] : (RNS.get(`${b}|${g.cust}`) ?? []).filter((r) => clean2(r.Contract) === c);
      DEALS.push(deal);
      if (c && !agent) {
        const k = `${b}|${c.toLowerCase()}`;
        if (!byName.has(k)) byName.set(k, deal);
      }
    }
  }
  const loose = /* @__PURE__ */ new Map();
  for (const m of MONS) {
    const deal = byName.get(`${m.base}|${m.addr.toLowerCase()}`);
    if (deal && m.date >= deal.start - 3) {
      deal.mons.push(m);
    } else {
      const k = `${m.base}|${m.addr.toLowerCase()}`;
      if (!loose.has(k)) loose.set(k, { base: m.base, ms: [] });
      loose.get(k).ms.push(m);
    }
  }
  for (const { base: b, ms: raw } of loose.values()) {
    const ms = [...raw].sort((x, y) => x.date - y.date);
    const m0 = ms[0];
    const a = m0.addr;
    const [num4, suffix] = contractNum(a);
    const signed = signedDate(b, a, num4, suffix);
    const start = signed !== null ? Math.min(m0.date, signed) : m0.date;
    const isAddr = ADDRESS_CONTRACT.test(a);
    DEALS.push({
      base: b,
      contract: a,
      cust: m0.cust,
      cname: m0.cname,
      orders: [],
      start,
      first: m0.date,
      agent: false,
      num: num4,
      suffix,
      monitor: true,
      addrContract: isAddr ? a : "",
      comments: isAddr ? [] : [a],
      sum: 0,
      cancelled: false,
      states: /* @__PURE__ */ new Map(),
      paid: 0,
      rn: [],
      mons: ms,
      dir: dealDir(a, suffix, [], false),
      who: null,
      real: false,
      small: false,
      strong: false,
      weak: false
    });
  }
  for (const deal of DEALS) {
    const good = deal.orders.some((o) => o.State === "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D" && o.Variant === "\u0423\u0441\u043F\u0435\u0448\u043D\u043E") || !deal.agent && deal.orders.some((o) => STRONG_STATES.has(o.State ?? ""));
    deal.real = !deal.agent && !deal.monitor && Boolean(deal.addrContract || AUTO_RE.test(deal.contract));
    const evidence = good || deal.paid > 0 || deal.rn.length > 0 || deal.mons.length > 0 || deal.real;
    deal.small = deal.orders.length > 0 && deal.sum >= 0 && deal.sum < SMALL;
    deal.strong = !deal.cancelled && evidence && !deal.small;
    deal.weak = !deal.cancelled && !deal.strong;
  }
  const describe = (deal) => {
    const past = deal.mons.filter((m) => m.date <= TODAY);
    const fut = deal.mons.filter((m) => m.date > TODAY);
    let st;
    if (deal.cancelled) st = "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u043E\u0442\u043C\u0435\u043D\u0451\u043D (\u0437\u0430\u043A\u0430\u0437 \u0437\u0430\u043A\u0440\u044B\u0442 \xAB\u041E\u0442\u043C\u0435\u043D\u0435\u043D\xBB)";
    else if (deal.small && !deal.strong) st = `\u0422\u043E\u043B\u044C\u043A\u043E \u043C\u0435\u043B\u043A\u0438\u0439 \u0437\u0430\u043A\u0430\u0437 \u043D\u0430 ${money(deal.sum)} \u20BD (\u0434\u043E\u043F/\u0443\u0441\u043B\u0443\u0433\u0430), \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043D\u0435\u0442`;
    else if (fut.length) st = `\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0435\u0441\u0442\u044C; \u0432 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0435 1\u0421 \u043C\u043E\u043D\u0442\u0430\u0436 \u0441\u0442\u043E\u0438\u0442 \u043D\u0430 ${ddmm(fut[0].date)} (${fut[0].brigade || "\u0431\u0440\u0438\u0433\u0430\u0434\u0430 ?"})`;
    else if (past.length) st = `\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0435\u0441\u0442\u044C; \u0432 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0435 1\u0421 \u043C\u043E\u043D\u0442\u0430\u0436 \u0441\u0442\u043E\u044F\u043B \u043D\u0430 ${ddmm(past[past.length - 1].date)} (${past[past.length - 1].brigade || "\u0431\u0440\u0438\u0433\u0430\u0434\u0430 ?"})`;
    else if (deal.strong && !deal.orders.some((o) => o.State !== "\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D") && !deal.paid) {
      st = "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u0437\u0430\u043A\u0430\u0437 \u0435\u0449\u0451 \xAB\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\xBB, \u043E\u043F\u043B\u0430\u0442\u044B \u043D\u0435\u0442), \u043C\u043E\u043D\u0442\u0430\u0436\u0430 \u0432 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0435 \u043D\u0435\u0442";
    } else if (deal.strong) st = "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D, \u043C\u043E\u043D\u0442\u0430\u0436\u0430 \u0432 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0435 \u0435\u0449\u0451 \u043D\u0435\u0442";
    else if (deal.agent && deal.orders.some((o) => STRONG_STATES.has(o.State ?? ""))) {
      st = "\u041B\u0435\u043C\u0430\u043D\u0430: \u0437\u0430\u043A\u0430\u0437 \xAB\u0412 \u0440\u0430\u0431\u043E\u0442\u0435\xBB, \u043D\u0435 \u0441\u043C\u043E\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D \u0438 \u043D\u0435 \u0437\u0430\u043A\u0440\u044B\u0442 \u2014 \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u043B\u0438 \u0447\u0435\u0440\u0435\u0437 \u043C\u0430\u0433\u0430\u0437\u0438\u043D, \u043D\u0435 \u0432\u0438\u0434\u043D\u043E";
    } else if (deal.agent) st = "\u041B\u0435\u043C\u0430\u043D\u0430: \u0437\u0430\u043A\u0430\u0437 \xAB\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\xBB \u2014 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435, \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043D\u0435\u0442";
    else st = "\u0422\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0441\u0447\u0451\u0442: \u0437\u0430\u043A\u0430\u0437 \xAB\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\xBB, \u0431\u0435\u0437 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u043C\u043E\u043D\u0442\u0430\u0436\u0430";
    if (deal.monitor) {
      return [st, `${NC_BASE_LABEL[deal.base]}: \u043C\u043E\u043D\u0442\u0430\u0436 \u0432 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0435 \xAB${deal.contract}\xBB, \u0437\u0430\u043A\u0430\u0437\u0430 \u0432 \u0432\u044B\u0433\u0440\u0443\u0437\u043A\u0435 \u043D\u0435\u0442`];
    }
    const first = deal.orders[0];
    const states = [...deal.states.entries()].map(([k, v]) => v > 1 ? `${k} \xD7${v}` : k).join(", ");
    let det = `${NC_BASE_LABEL[deal.base]}: ${deal.agent ? "\u041B\u0435\u043C\u0430\u043D\u0430, " : ""}\u0434\u043E\u0433\u043E\u0432\u043E\u0440 \xAB${deal.contract}\xBB, \u0437\u0430\u043A\u0430\u0437 ${first.Num} \u043E\u0442 ${ddmm(deal.first)}; \u0437\u0430\u043A\u0430\u0437\u043E\u0432 ${deal.orders.length} \u043D\u0430 ${money(deal.sum)} \u20BD [${states}]`;
    if (!deal.agent) det += `; \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E ${money(deal.paid)} \u20BD`;
    if (deal.rn.length) det += `; \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u044B\u0445 ${deal.rn.length} \u043D\u0430 ${money(deal.rn.reduce((s, r) => s + (r.Sum || 0), 0))} \u20BD`;
    if (deal.agent && deal.comments.length) det += `; \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439: ${deal.comments[0].slice(0, 120)}`;
    return [st, det];
  };
  const DEAL_BY_HOUSE = /* @__PURE__ */ new Map();
  const DEAL_BY_NUM = /* @__PURE__ */ new Map();
  const DEAL_BY_CUST = /* @__PURE__ */ new Map();
  const parsedContract = /* @__PURE__ */ new Map();
  DEALS.forEach((deal, i) => {
    if (deal.addrContract) {
      const p = parseAddress(deal.addrContract, true);
      parsedContract.set(i, p);
      if (p) addTo(DEAL_BY_HOUSE, p.house, i);
    }
    for (const t of deal.comments) {
      for (const tok of new Set(t.toLowerCase().match(HOUSE_TOKEN) ?? [])) addTo(DEAL_BY_HOUSE, tok.replace(/ /g, ""), i);
    }
    if (deal.num) addTo(DEAL_BY_NUM, deal.num, i);
    if (deal.cust) addTo(DEAL_BY_CUST, `${deal.base}|${deal.cust}`, i);
  });
  const dealLink = (m, deal) => {
    if (deal.who && deal.who !== m.measurer) return 0;
    if (m.contract && m.base === deal.base && m.contract === deal.contract) return 3;
    const [mn] = contractNum(m.contract);
    if (mn && mn === deal.num && Math.abs(deal.start - m.date) <= 60) {
      const rel = deal.addrContract ? addressRelation(m.addr, deal.addrContract) : "unknown";
      if (rel !== "conflict") return 3;
    }
    const same = m.base === deal.base && Boolean(m.cust) && m.cust === deal.cust && !deal.agent;
    if (deal.addrContract) {
      const r = matchAddress(m.addr, deal.addrContract);
      if (r === "exact" || r === "house" && same) return 2;
      if (same && addressRelation(m.addr, deal.addrContract) === "unknown") return 1;
      if (deal.comments.some((t) => addressInText(m.addr, t) === "exact")) return 2;
      return 0;
    }
    const rs = deal.comments.map((t) => addressInText(m.addr, t));
    if (rs.includes("exact") || rs.includes("house") && same) return 2;
    if (same) return 1;
    return 0;
  };
  const candidates2 = (m) => {
    const out = /* @__PURE__ */ new Set();
    const p = parseAddress(m.addr);
    if (p) for (const i of DEAL_BY_HOUSE.get(p.house) ?? []) out.add(i);
    const [mn] = contractNum(m.contract);
    if (mn) for (const i of DEAL_BY_NUM.get(mn) ?? []) out.add(i);
    if (m.cust) for (const i of DEAL_BY_CUST.get(`${m.base}|${m.cust}`) ?? []) out.add(i);
    return [...out].sort((x, y) => x - y);
  };
  const measDir = (m) => {
    const r = m.table;
    if (/^\s*ремонт/iu.test(m.addr) || m.measurer.startsWith("\u041C\u0438\u0448\u0430")) return "repair";
    if (r?.dir && r.dir !== "repair") return r.dir;
    const [, suf] = contractNum(m.contract);
    if (suf && suf.includes("\u041A")) return "cond";
    const t = textDir(m.comment, r?.reason ?? "");
    if (t) return t;
    return kindByText(m.comment, r?.reason ?? "");
  };
  const addrKey = (m) => {
    if (m.akey === void 0) {
      const p = parseAddress(m.addr);
      m.akey = !p || !p.last ? null : JSON.stringify([p.last, p.house, p.flat ?? ""]);
    }
    return m.akey;
  };
  const rows = input.rows.map((r) => ({ ...r }));
  for (const r of rows) {
    const z6 = r.reg;
    let m = z6 ? BY_UID.get(z6.Uid) ?? null : null;
    if (!m) {
      let best = null;
      const rd = dayOf(r.date);
      for (const x of MEAS) {
        if (x.base !== "unf_10" || matchAddress(r.address, x.addr) !== "exact") continue;
        const dd = Math.abs(x.date - rd);
        if (dd <= 5 && (best === null || dd < best[0])) best = [dd, x];
      }
      m = best ? best[1] : null;
    }
    if (!m || m.table !== null) {
      m = {
        uid: `table-${r.sheet}-${r.row}`,
        base: null,
        date: dayOf(r.date),
        measurer: r.measurer,
        cust: "",
        cname: "",
        addr: r.address,
        phone: null,
        status: "\u2014",
        contract: "",
        comment: "",
        table: null,
        dir: null,
        signedBy: [],
        signingFor: null,
        akey: void 0
      };
      MEAS.push(m);
      BY_UID.set(m.uid, m);
    }
    m.table = r;
    r.m = m;
    if (r.measurer.startsWith("\u041C\u0438\u0448\u0430")) m.measurer = r.measurer;
  }
  const counted = (m) => m.table !== null || DECIDED.has(m.status) && (NC_ORDER.includes(m.measurer) || m.measurer.startsWith("\u041C\u0438\u0448\u0430"));
  const CNT = MEAS.filter(counted);
  for (const m of CNT) m.dir = measDir(m);
  const owner = /* @__PURE__ */ new Map();
  for (const m of CNT) {
    for (const i of candidates2(m)) {
      const deal = DEALS[i];
      if (!(m.date - 3 <= deal.start && deal.start <= m.date + LOOKAHEAD)) continue;
      if (!compatible(m.dir, deal.dir)) continue;
      const k = dealLink(m, deal);
      if (!k) continue;
      const key = [m.date, k];
      const cur = owner.get(i);
      if (!cur || lessTuple(cur.key, key)) owner.set(i, { key, uid: m.uid });
    }
  }
  const signing = /* @__PURE__ */ new Map();
  for (const [i, { key, uid }] of [...owner.entries()]) {
    const w = BY_UID.get(uid);
    if (w.table !== null || !/заключ/iu.test(w.comment || "")) continue;
    const k = addrKey(w);
    if (!k) continue;
    const prev = CNT.filter((m2) => m2.measurer !== w.measurer && addrKey(m2) === k && w.date - m2.date > 0 && w.date - m2.date <= LOOKAHEAD);
    if (!prev.length) continue;
    const m = prev.reduce((best, x) => x.date > best.date ? x : best);
    owner.set(i, { key, uid: m.uid });
    signing.set(w.uid, m.uid);
    m.signedBy.push(w);
  }
  const won = /* @__PURE__ */ new Map();
  for (const [i, { uid }] of owner) push(won, uid, DEALS[i]);
  const verdict = (m) => {
    const ds = won.get(m.uid) ?? [];
    const strong = ds.filter((x) => x.strong).sort((x, y) => x.start - y.start);
    if (strong.length) {
      let [st, det] = describe(strong[0]);
      if (m.signedBy.length) {
        const w = m.signedBy[0];
        st = `\u041F\u043E\u0434\u043F\u0438\u0441\u044B\u0432\u0430\u0442\u044C \u0435\u0437\u0434\u0438\u043B ${w.measurer} ${ddmm(w.date)}; ` + st.charAt(0).toLowerCase() + st.slice(1);
      }
      if (strong.length > 1) det += ` (+ \u0435\u0449\u0451 ${strong.length - 1}: ` + strong.slice(1).map((x) => `\xAB${x.contract}\xBB`).join("; ") + ")";
      return ["\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D", st, det];
    }
    const cancelled = ds.filter((x) => x.cancelled);
    const weak = ds.filter((x) => x.weak).sort((x, y) => x.start - y.start);
    if (m.status === "\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D" && !cancelled.length) {
      const extra = weak.length ? "; \u0432 1\u0421: " + describe(weak[0])[1] : "";
      return [
        "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D",
        "\u041E\u0442\u043C\u0435\u0447\u0435\u043D \xAB\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB \u0432 \u0437\u0430\u043C\u0435\u0440\u0430\u0445 1\u0421, \u0437\u0430\u043A\u0430\u0437\u0430 \u0432 \u0432\u044B\u0433\u0440\u0443\u0437\u043A\u0435 \u043D\u0435\u0442",
        (m.contract ? `\u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0432 \u0437\u0430\u043C\u0435\u0440\u0435: \xAB${m.contract}\xBB` : "\u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0432 \u0437\u0430\u043C\u0435\u0440\u0435 \u043D\u0435\u0442") + extra
      ];
    }
    if (cancelled.length) return ["\u043E\u0442\u043C\u0435\u043D\u0451\u043D", ...describe(cancelled[0])];
    if (weak.length) return ["\u0440\u0430\u0441\u0447\u0451\u0442", ...describe(weak[0])];
    return ["\u043D\u0435\u0442", "", ""];
  };
  const V = /* @__PURE__ */ new Map();
  for (const m of CNT) V.set(m.uid, verdict(m));
  const RANK = { "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D": 0, "\u043E\u0442\u043C\u0435\u043D\u0451\u043D": 1, "\u0440\u0430\u0441\u0447\u0451\u0442": 2, "\u043D\u0435\u0442": 3 };
  const by = /* @__PURE__ */ new Map();
  for (const m of CNT) {
    const k = addrKey(m);
    push(by, k ? JSON.stringify([m.measurer, k]) : JSON.stringify(["uid", m.uid]), m);
  }
  const CL = /* @__PURE__ */ new Map();
  const rawClusters = [];
  for (const list of by.values()) {
    const ms = [...list].sort((x, y) => x.date - y.date);
    let cur = [ms[0]];
    for (const m of ms.slice(1)) {
      if (m.date - cur[cur.length - 1].date <= 90) cur.push(m);
      else {
        rawClusters.push(cur);
        cur = [m];
      }
    }
    rawClusters.push(cur);
  }
  for (const c of rawClusters) {
    const best = c.reduce((b, m) => RANK[V.get(m.uid)[0]] < RANK[V.get(b.uid)[0]] ? m : b);
    for (const m of c) CL.set(m.uid, { c, best });
  }
  const later = /* @__PURE__ */ new Map();
  for (const [i, { uid }] of owner) {
    const deal = DEALS[i];
    if (!deal.strong) continue;
    const w = BY_UID.get(uid);
    const wk = addrKey(w);
    if (!wk) continue;
    for (const m of CNT) {
      if (m.uid === uid || m.measurer === w.measurer || !(m.date < w.date)) continue;
      if (addrKey(m) === wk && w.date - m.date <= LOOKAHEAD && !later.has(m.uid)) later.set(m.uid, { w, deal });
    }
  }
  for (const [uid, forUid] of signing) BY_UID.get(uid).signingFor = forUid;
  const clusters = [];
  const seen = /* @__PURE__ */ new Set();
  for (const m of CNT) {
    const { c, best } = CL.get(m.uid);
    if (seen.has(c)) continue;
    seen.add(c);
    if (c.every((x) => x.signingFor)) continue;
    const first = c[0];
    const kind = c.find((x) => x.table && x.dir)?.dir ?? c.find((x) => x.dir)?.dir ?? c.flatMap((x) => won.get(x.uid) ?? []).find((dl) => dl.dir)?.dir ?? null;
    const v1c = V.get(best.uid)[0];
    const tableClosed = c.some((x) => x.table && x.table.status === "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D");
    const final = v1c === "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D" ? "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D" : tableClosed ? "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u043F\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435)" : "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D";
    clusters.push({
      measurer: first.measurer,
      date: first.date,
      month: dayStr(first.date).slice(0, 7),
      kind,
      block: kind === "cond" ? "cond" : kind === "repair" ? "repair" : "ceil",
      final,
      v1c,
      visits: c,
      best,
      inTable: c.some((x) => x.table !== null)
    });
  }
  const have10 = data.unf_10.zam.length > 0 || data.unf_10.ord.length > 0;
  const strangerVisits = MEAS.filter(
    (m) => DECIDED.has(m.status) && !NC_ORDER.includes(m.measurer) && !m.measurer.startsWith("\u041C\u0438\u0448\u0430") && !isUnassignedMeasurer(m.measurer)
  ).map((m) => ({ measurer: m.measurer, date: m.date }));
  return { rows, clusters, verdicts: V, cl: CL, later, won, have10, today: TODAY, describe, strangerVisits };
}
function push(map, key, value) {
  const list = map.get(key);
  if (list) list.push(value);
  else map.set(key, [value]);
}
function addTo(map, key, i) {
  const s = map.get(key);
  if (s) s.add(i);
  else map.set(key, /* @__PURE__ */ new Set([i]));
}
var NC_KIND_RU = {
  ceil: "\u043F\u043E\u0442\u043E\u043B\u043A\u0438",
  walls: "\u0442\u0438\u0445\u0438\u0435 \u0441\u0442\u0435\u043D\u044B",
  cond: "\u043A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440\u044B",
  repair: "\u0440\u0435\u043C\u043E\u043D\u0442",
  both: "\u043F\u043E\u0442\u043E\u043B\u043A\u0438 + \u043A\u043E\u043D\u0434."
};
function kindRu(k) {
  return k ? NC_KIND_RU[k] ?? k : "\u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043E";
}
var W2 = "[\\p{L}\\p{N}_]";
var REASONS = [
  ["\u0443\u0448\u0451\u043B \u043A \u0434\u0440\u0443\u0433\u0438\u043C", new RegExp(`\u0434\u0440\u0443\u0433\u0438[\u0435\u0445\u043C]|\u043A\u043E\u043D\u043A\u0443\u0440\u0435\u043D\u0442|\u0447\u0430\u0441\u0442\u043D\u0438\u043A|\u0443 \u0434\u0440\u0443\u0433\u0438\u0445|\u0443\u0436\u0435 (?:\u0443\u0441\u0442\u0430\u043D\u043E\u0432|\u0441\u0434\u0435\u043B\u0430|\u043F\u043E\u0441\u0442\u0430\u0432|\u043A\u0443\u043F\u0438\u043B)|\u0432\u044B\u0431\u0440\u0430\u043B${W2}* \u0434\u0440\u0443\u0433|\u0440\u0430\u0431\u043E\u0442\u0430${W2}* \u0441 \u0434\u0440\u0443\u0433|\u043D\u0430\u0448\u043B[\u0430\u0438]|\u0441\u0432\u043E\u0438\u043C\u0438 \u0441\u0438\u043B|\u0441\u0430\u043C\u0438 (?:\u0441\u0434\u0435\u043B\u0430|\u043F\u043E\u0441\u0442\u0430\u0432|\u0443\u0441\u0442\u0430\u043D\u043E\u0432)|\u0441\u0430\u043C[\u0430\u0438]? (?:\u0441\u0434\u0435\u043B\u0430|\u043F\u043E\u0441\u0442\u0430\u0432|\u0443\u0441\u0442\u0430\u043D\u043E\u0432)`, "u")],
  ["\u0434\u043E\u0440\u043E\u0433\u043E", new RegExp(`\u0434\u043E\u0440\u043E\u0433|\u0434\u0435\u0448\u0435\u0432\u043B|\u0446\u0435\u043D[\u0430\u044B] \u043D\u0435|\u043D\u0435 \u0443\u0441\u0442\u0440\u043E${W2}+ \u0446\u0435\u043D|\u043D\u0435 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u043C|\u0431\u044E\u0434\u0436\u0435\u0442|\u043D\u0435\u0442 \u0434\u0435\u043D\u0435\u0433|\u0434\u0435\u043D\u0435\u0433 \u043D\u0435\u0442|\u0444\u0438\u043D\u0430\u043D\u0441`, "u")],
  ["\u043D\u0435 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0441\u0432\u044F\u0437\u044C", /не бер[её]т|недозвон|не отвеча|трубк|вне сети|недоступ|не выходит на связь|сбрасыва|автоотв|не доз/u],
  ["\u043E\u0442\u043A\u0430\u0437 / \u043D\u0435\u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E", /передумал|отказ|не будут|не будет делать|не актуал|неактуал|не нужн|не интерес/u],
  ["\u0434\u0443\u043C\u0430\u0435\u0442 / \u043E\u0442\u043B\u043E\u0436\u0438\u043B", /дума|подума|совет|реш[аи]|перезвон|позже|отлож|не готов|рано|после|ремонт|стены|осень|весн|месяц|недел|пока|жд[её]т/u]
];
function reasonCat(...texts) {
  for (const raw of texts) {
    const t = (raw ?? "").toLowerCase();
    if (!t.trim()) continue;
    for (const [name, re] of REASONS) if (re.test(t)) return name;
  }
  return "\u043F\u0440\u043E\u0447\u0435\u0435";
}
var BLOCKS = [["ceil", "\u041F\u043E\u0442\u043E\u043B\u043A\u0438"], ["cond", "\u041A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440\u044B"], ["repair", "\u0420\u0435\u043C\u043E\u043D\u0442 (\u0434\u043B\u044F \u0441\u043F\u0440\u0430\u0432\u043A\u0438)"]];
var MONTH_RU = ["\u044F\u043D\u0432\u0430\u0440\u044C", "\u0444\u0435\u0432\u0440\u0430\u043B\u044C", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0435\u043B\u044C", "\u043C\u0430\u0439", "\u0438\u044E\u043D\u044C", "\u0438\u044E\u043B\u044C", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C", "\u043E\u043A\u0442\u044F\u0431\u0440\u044C", "\u043D\u043E\u044F\u0431\u0440\u044C", "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"];
function nonclosureReport(a, from, to) {
  const p0 = dayOf(from);
  const p1 = dayOf(to);
  const inPeriod = (c) => p0 <= c.date && c.date <= p1;
  const who = (c) => NC_ORDER.includes(c.measurer) ? c.measurer : c.measurer.startsWith("\u041C\u0438\u0448\u0430") ? NC_REPAIR : null;
  const stats = (cs) => ({
    measurements: cs.length,
    notConcluded: cs.filter((c) => !c.final.startsWith("\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D")).length
  });
  const describe = a.describe;
  const blocks = BLOCKS.map(([key, title]) => {
    const cs = a.clusters.filter((c) => inPeriod(c) && c.block === key && who(c));
    const names = key === "repair" ? [...NC_ORDER, NC_REPAIR] : NC_ORDER;
    const rows = [];
    for (const name of names) {
      const s = stats(cs.filter((c) => who(c) === name));
      if (key === "repair" && s.measurements === 0) continue;
      rows.push({ measurer: name, ...s });
    }
    return { key, title, rows, total: stats(cs) };
  });
  const months = [];
  for (let m = dayStr(p0).slice(0, 7); m <= dayStr(p1).slice(0, 7); ) {
    const [y = 1970, mo = 1] = m.split("-").map(Number);
    const firstDay = dayOf(`${m}-01`);
    const lastDay = dayOf(mo === 12 ? `${y + 1}-01-01` : `${y}-${String(mo + 1).padStart(2, "0")}-01`) - 1;
    const a1 = Math.max(firstDay, p0);
    const b1 = Math.min(lastDay, p1);
    const partial = a1 !== firstDay || b1 !== lastDay;
    months.push({ key: m, title: MONTH_RU[mo - 1] + (partial ? ` (${Number(dayStr(a1).slice(8))}\u2013${Number(dayStr(b1).slice(8))})` : "") });
    m = mo === 12 ? `${y + 1}-01` : `${y}-${String(mo + 1).padStart(2, "0")}`;
  }
  const monthBlocks = BLOCKS.map(([key, title]) => {
    const cs = a.clusters.filter((c) => inPeriod(c) && c.block === key && who(c));
    const names = key === "repair" ? [...NC_ORDER, NC_REPAIR] : NC_ORDER;
    const rows = [];
    for (const name of [...names, "\u0418\u0442\u043E\u0433\u043E"]) {
      const sub = name === "\u0418\u0442\u043E\u0433\u043E" ? cs : cs.filter((c) => who(c) === name);
      if (name !== "\u0418\u0442\u043E\u0433\u043E" && key === "repair" && !sub.length) continue;
      const cells = [...months.map((mo) => mo.key), "all"].map((mk) => {
        const s = stats(mk === "all" ? sub : sub.filter((c) => c.month === mk));
        return s.measurements ? s : null;
      });
      rows.push({ measurer: name, cells });
    }
    return { key, title, months: [...months, { key: "all", title: "\u0432\u0435\u0441\u044C \u043F\u0435\u0440\u0438\u043E\u0434" }], rows };
  });
  const allp = a.clusters.filter((c) => inPeriod(c) && who(c));
  const strange = /* @__PURE__ */ new Map();
  for (const v of a.strangerVisits ?? []) {
    if (v.date < p0 || v.date > p1) continue;
    strange.set(v.measurer, (strange.get(v.measurer) ?? 0) + 1);
  }
  const strangers = [...strange.entries()].map(([measurer, measurements]) => ({ measurer, measurements })).sort((x, y) => y.measurements - x.measurements || x.measurer.localeCompare(y.measurer, "ru"));
  const counts = {
    unknownKind: allp.filter((c) => c.kind === null).length,
    byTable: allp.filter((c) => c.final === "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u043F\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435)").length,
    cancelled: allp.filter((c) => c.v1c === "\u043E\u0442\u043C\u0435\u043D\u0451\u043D").length,
    have10: a.have10
  };
  const notes = [
    "\u0417\u0430\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u043C \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u0437\u0430\u043C\u0435\u0440, \u0443 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0432 1\u0421 \u0435\u0441\u0442\u044C \u0434\u043E\u0433\u043E\u0432\u043E\u0440: \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0441 \u043D\u043E\u043C\u0435\u0440\u043E\u043C (\xAB2246 \u0430\u0434\u0440\u0435\u0441\xBB, \xAB\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 N\xBB), \u0437\u0430\u043A\u0430\u0437 \xAB\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D \u2014 \u0423\u0441\u043F\u0435\u0448\u043D\u043E\xBB \u0438\u043B\u0438 \xAB\u0412 \u0440\u0430\u0431\u043E\u0442\u0435\xBB, \u043E\u043F\u043B\u0430\u0442\u0430, \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F \u0438\u043B\u0438 \u043C\u043E\u043D\u0442\u0430\u0436 \u0432 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0435. \u0417\u0430\u043A\u0430\u0437 \xAB\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\xBB \u043D\u0430 \xAB\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\xBB \u0431\u0435\u0437 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u043C\u043E\u043D\u0442\u0430\u0436\u0430 \u2014 \u0442\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0441\u0447\u0451\u0442; \u0443 \u041B\u0435\u043C\u0430\u043D\u044B \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2014 \u0437\u0430\u043A\u0430\u0437 \xAB\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\xBB.",
    "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043A \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u043C\u0443 \u0437\u0430\u043C\u0435\u0440\u0443 \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443: \u0435\u0441\u043B\u0438 \u043F\u0435\u0440\u0432\u044B\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A \u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B, \u0430 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0440\u0443\u0433\u043E\u0439, \u043F\u0435\u0440\u0432\u043E\u043C\u0443 \u0437\u0430\u0441\u0447\u0438\u0442\u0430\u043D \u043D\u0435\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u0439, \u0432\u0442\u043E\u0440\u043E\u043C\u0443 \u2014 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0432\u0438\u0437\u0438\u0442 \u0442\u043E\u0433\u043E \u0436\u0435 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A\u0430 \u043A \u0442\u043E\u043C\u0443 \u0436\u0435 \u0437\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u2014 \u043E\u0434\u0438\u043D \u0437\u0430\u043C\u0435\u0440.",
    (counts.have10 ? "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u044B \u0431\u0430\u0437\u044B 1\u0421 \xAB\u0417\u0430\u043A\u0438\u0440\u043E\u0432\u0430 \u0423\u041D\u0424\xBB \u0438 \xAB\u0417\u0430\u043A\u0438\u0440\u043E\u0432 \u043D\u043E\u0432\u0430\u044F\xBB" : "\u041F\u0420\u0415\u0414\u0412\u0410\u0420\u0418\u0422\u0415\u041B\u042C\u041D\u041E: \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0430\u0437\u0430 \xAB\u0417\u0430\u043A\u0438\u0440\u043E\u0432\u0430 \u0423\u041D\u0424\xBB; \xAB\u0417\u0430\u043A\u0438\u0440\u043E\u0432 \u043D\u043E\u0432\u0430\u044F\xBB (\u0437\u0430\u043A\u0430\u0437\u044B \xAB\u2026\u041D\xBB) \u0435\u0449\u0451 \u043D\u0435 \u043F\u0440\u0438\u0448\u043B\u0430 \u2014 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u044B \u043E\u0442\u0442\u0443\u0434\u0430 \u0434\u043E\u0431\u0430\u0432\u044F\u0442\u0441\u044F") + "; \u041B\u0435\u043C\u0430\u043D\u0430 \u2014 \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E \u0430\u0433\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E \u0437\u0430\u043A\u0430\u0437\u0430 (\u0430\u0434\u0440\u0435\u0441 \u0442\u0430\u043C). \u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u044F\u0442\u044C \u0431\u0430\u0437 \u0418\u041F \u043D\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u043B\u0438\u0441\u044C.",
    `\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u2014 \u043F\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u041A\u0426 (\xAB\u041F\u041E\u0422\u041E\u041B\u041A\u0418\xBB, \xAB\u041A\u041E\u041D\u0414.\xBB), \u043F\u043E \u0431\u0443\u043A\u0432\u0435 \xAB\u041A\xBB \u0432 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u0438 \u043F\u043E \u0441\u043B\u043E\u0432\u0430\u043C \u0432 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0437\u0430\u043C\u0435\u0440\u0430; \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u043B\u043E\u0441\u044C \u0443 ${counts.unknownKind} \u0437\u0430\u043C\u0435\u0440\u043E\u0432 \u2014 \u043E\u043D\u0438 \u0432 \u0431\u043B\u043E\u043A\u0435 \xAB\u043F\u043E\u0442\u043E\u043B\u043A\u0438\xBB.`,
    `${counts.byTable} \u0437\u0430\u043C\u0435\u0440\u043E\u0432 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u041A\u0426 \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \xAB\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB, \u0430 \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043D\u0435 \u043D\u0430\u0448\u043B\u043E\u0441\u044C \u2014 \u043F\u043E\u0441\u0447\u0438\u0442\u0430\u043D\u044B \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u043C\u0438 (\u0441\u043F\u0438\u0441\u043E\u043A \u2014 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \xAB\u0420\u0430\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F\xBB). ${counts.cancelled} \u2014 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0431\u044B\u043B, \u043D\u043E \u0437\u0430\u043A\u0430\u0437 \u0437\u0430\u043A\u0440\u044B\u0442 \xAB\u041E\u0442\u043C\u0435\u043D\u0435\u043D\xBB: \u043F\u043E\u0441\u0447\u0438\u0442\u0430\u043D\u044B \u043D\u0435\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u043C\u0438.`
  ];
  const stageFor = (m, row) => {
    let [v, st, det] = a.verdicts.get(m.uid);
    const { best } = a.cl.get(m.uid);
    const [cv2, cst, cdet] = a.verdicts.get(best.uid);
    if (v !== "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D" && cv2 === "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D") {
      v = cv2;
      st = `${cst} (\u043F\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u043C\u0443 \u0432\u0438\u0437\u0438\u0442\u0443 ${ddmm(best.date)})`;
      det = cdet;
    }
    const lt = a.later.get(m.uid);
    if (v !== "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D" && lt) {
      const [st2, det2] = describe(lt.deal);
      return ["\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D", `\u0417\u0430\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0440\u0443\u0433\u043E\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A: ${lt.w.measurer}, \u0432\u0438\u0437\u0438\u0442 ${ddmm(lt.w.date)} \u2014 ${st2}`, det2];
    }
    if (v === "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D") return ["\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D", st, det];
    const label = { "\u043D\u0435\u0442": "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D", "\u0440\u0430\u0441\u0447\u0451\u0442": "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u0432 1\u0421 \u0442\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0441\u0447\u0451\u0442)", "\u043E\u0442\u043C\u0435\u043D\u0451\u043D": "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043E\u0442\u043C\u0435\u043D\u0451\u043D)" }[v];
    const why = reasonCat(row.extra, row.comment, row.reason);
    const stage = v === "\u043D\u0435\u0442" ? `\u041D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D \u2014 ${why}` : st;
    if (v === "\u043D\u0435\u0442") {
      det = m.base ? `\u0437\u0430\u043A\u0430\u0437\u043E\u0432, \u043E\u043F\u043B\u0430\u0442 \u0438 \u043C\u043E\u043D\u0442\u0430\u0436\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u0432 1\u0421 \u043D\u0435\u0442; \u0437\u0430\u043C\u0435\u0440 \u0432 1\u0421: \xAB${m.status}\xBB` + (m.comment ? `, \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A\u0430: ${m.comment.slice(0, 160)}` : "") : "\u0432 \xAB\u0417\u0430\u043C\u0435\u0440\u0430\u0445\xBB 1\u0421 \u0430\u0434\u0440\u0435\u0441\u0430 \u043D\u0435\u0442; \u0437\u0430\u043A\u0430\u0437\u043E\u0432, \u043E\u043F\u043B\u0430\u0442 \u0438 \u043C\u043E\u043D\u0442\u0430\u0436\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u043D\u0435\u0442";
    }
    return [label, stage, det];
  };
  const checkText = (row, verdict, stage) => {
    const ts = row.status;
    if (stage.startsWith("\u0417\u0430\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0440\u0443\u0433\u043E\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A")) {
      if (ts === "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D") return "\u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442: \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0440\u0443\u0433\u043E\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A";
      if (ts === "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D") return "\u0420\u0410\u0421\u0425\u041E\u0416\u0414\u0415\u041D\u0418\u0415: \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0435\u0441\u0442\u044C, \u043D\u043E \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u043B \u0434\u0440\u0443\u0433\u043E\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A";
      return "\u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0435\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0430; \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0440\u0443\u0433\u043E\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A";
    }
    if (stage.startsWith("\u041B\u0435\u043C\u0430\u043D\u0430: \u0437\u0430\u043A\u0430\u0437 \xAB\u0412 \u0440\u0430\u0431\u043E\u0442\u0435\xBB")) {
      return ts === "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D" ? "\u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442: \u0443 \u041B\u0435\u043C\u0430\u043D\u044B \u0437\u0430\u043A\u0430\u0437 \xAB\u0412 \u0440\u0430\u0431\u043E\u0442\u0435\xBB" : "\u041F\u0420\u041E\u0412\u0415\u0420\u0418\u0422\u042C: \u0443 \u041B\u0435\u043C\u0430\u043D\u044B \u0437\u0430\u043A\u0430\u0437 \xAB\u0412 \u0440\u0430\u0431\u043E\u0442\u0435\xBB \u2014 \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0447\u0435\u0440\u0435\u0437 \u043C\u0430\u0433\u0430\u0437\u0438\u043D?";
    }
    if (verdict === "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D") {
      if (ts === "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D") return "\u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442";
      if (ts === "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D") return "\u0420\u0410\u0421\u0425\u041E\u0416\u0414\u0415\u041D\u0418\u0415: \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0435\u0441\u0442\u044C";
      return "\u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0435\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0430; \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0435\u0441\u0442\u044C";
    }
    if (ts === "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D") {
      return {
        "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D": "\u0420\u0410\u0421\u0425\u041E\u0416\u0414\u0415\u041D\u0418\u0415: \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB, \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043D\u0435\u0442",
        "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u0432 1\u0421 \u0442\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0441\u0447\u0451\u0442)": "\u041F\u0420\u041E\u0412\u0415\u0420\u0418\u0422\u042C: \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB, \u0432 1\u0421 \u0442\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0441\u0447\u0451\u0442 \u0431\u0435\u0437 \u043E\u043F\u043B\u0430\u0442\u044B",
        "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D (\u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043E\u0442\u043C\u0435\u043D\u0451\u043D)": "\u0420\u0410\u0421\u0425\u041E\u0416\u0414\u0415\u041D\u0418\u0415: \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB, \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043E\u0442\u043C\u0435\u043D\u0451\u043D"
      }[verdict] ?? verdict;
    }
    if (ts === "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D") return "\u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442";
    return "\u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0435\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0430; \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043D\u0435\u0442";
  };
  const order = (name) => {
    const i = NC_ORDER.indexOf(name);
    return i >= 0 ? i : 99;
  };
  const detailKeyed = [];
  for (const row of a.rows) {
    const rd = dayOf(row.date);
    if (rd < p0 || rd > p1) continue;
    const m = row.m;
    const [verdict, stage, det] = stageFor(m, row);
    const register = m.base ? `${m.status} \xB7 ${NC_BASE_LABEL[m.base]} \xB7 ${ddmm(m.date)}` + (m.contract ? ` \xB7 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \xAB${m.contract}\xBB` : "") : "\u0432 \xAB\u0417\u0430\u043C\u0435\u0440\u0430\u0445\xBB 1\u0421 \u043D\u0435 \u043D\u0430\u0448\u043B\u0438";
    const date = m.base ? m.date : rd;
    detailKeyed.push({
      key: [order(row.measurer), row.measurer, date],
      row: {
        measurer: row.measurer,
        date: dayStr(date),
        address: row.address,
        kind: kindRu(m.dir),
        kcStatus: row.status || "\u2014",
        register,
        verdict,
        check: checkText(row, verdict, stage),
        stage,
        data: det,
        lastKc: (row.extra || row.comment || "").trim(),
        reason: (row.reason || "").trim(),
        next: (row.next || "").trim()
      }
    });
  }
  detailKeyed.sort((x, y) => x.key[0] - y.key[0] || (x.key[1] < y.key[1] ? -1 : x.key[1] > y.key[1] ? 1 : 0) || x.key[2] - y.key[2]);
  const detail = detailKeyed.map((x) => x.row);
  const extraKeyed = [];
  for (const c of a.clusters) {
    if (!inPeriod(c) || c.inTable || !who(c) || c.final !== "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D") continue;
    const m = c.visits[0];
    let [, st, det] = a.verdicts.get(c.best.uid);
    const lt = a.later.get(m.uid);
    if (lt) {
      st = `\u0417\u0430\u043A\u043B\u044E\u0447\u0438\u043B \u0434\u0440\u0443\u0433\u043E\u0439 \u0437\u0430\u043C\u0435\u0440\u0449\u0438\u043A: ${lt.w.measurer}, \u0432\u0438\u0437\u0438\u0442 ${ddmm(lt.w.date)}`;
      det = describe(lt.deal)[1];
    }
    extraKeyed.push({
      key: [order(c.measurer), m.date],
      row: {
        measurer: c.measurer,
        date: dayStr(m.date),
        address: m.addr,
        kind: kindRu(c.kind),
        status: m.status,
        base: m.base ? NC_BASE_LABEL[m.base] : "\u2014",
        customer: m.cname,
        stage: st || "\u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0432 1\u0421 \u043D\u0435\u0442",
        data: det,
        comment: m.comment
      }
    });
  }
  extraKeyed.sort((x, y) => x.key[0] - y.key[0] || x.key[1] - y.key[1]);
  return {
    ...strangers.length ? { strangers } : {},
    from,
    to,
    blocks,
    months: monthBlocks,
    notes,
    counts,
    detail,
    discrepancies: detail.filter((x) => x.check.startsWith("\u0420\u0410\u0421\u0425\u041E\u0416\u0414\u0415\u041D\u0418\u0415") || x.check.startsWith("\u041F\u0420\u041E\u0412\u0415\u0420\u0418\u0422\u042C")),
    extra: extraKeyed.map((x) => x.row)
  };
}
var NC_CALL_OUTCOMES = ["NO_ANSWER", "CALL_BACK", "AGREED", "REFUSED", "WON"];
var NC_CALL_OUTCOME_RU = {
  NO_ANSWER: "\u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0441\u044F",
  CALL_BACK: "\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
  AGREED: "\u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438\u0441\u044C \u2014 \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0442",
  REFUSED: "\u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0438\u0441\u044C",
  WON: "\u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440"
};
var NC_REFUSAL_REASONS = [
  "\u0434\u043E\u0440\u043E\u0433\u043E",
  "\u0443\u0448\u0451\u043B \u043A \u0434\u0440\u0443\u0433\u0438\u043C",
  "\u043E\u0442\u043A\u0430\u0437 / \u043D\u0435\u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E",
  "\u043D\u0435 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0441\u0432\u044F\u0437\u044C",
  "\u043F\u0440\u043E\u0447\u0435\u0435"
];
var NC_ONEC_NOTE_MAX = 400;
function ncOnecNote(call, who, day) {
  const w = callWhat(call);
  if (!w) return null;
  const head = `\u041E\u0431\u0437\u0432\u043E\u043D ${ddmm(dayOf(day))}${who.trim() ? `, ${who.trim()}` : ""}: ${w.what}`;
  return clip(w.words ? `${head}. ${w.words}` : head, NC_ONEC_NOTE_MAX);
}
function callWhat(call) {
  const words = (call.comment ?? "").replace(/\s+/g, " ").trim().replace(/[.\s]+$/u, "");
  const back = call.callBackAt ? ddmm(dayOf(call.callBackAt)) : "";
  if (call.outcome === "NO_ANSWER" && !words && !back) return null;
  const what = call.outcome === "REFUSED" ? `\u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0438\u0441\u044C \u2014 ${(call.reason ?? "").trim() || "\u043F\u0440\u043E\u0447\u0435\u0435"}` : call.outcome === "CALL_BACK" ? `\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C${back ? ` ${back}` : ""}` : call.outcome === "NO_ANSWER" ? `\u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0441\u044F${back ? `, \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430 ${back}` : ""}` : NC_CALL_OUTCOME_RU[call.outcome];
  return { what, words };
}
function clip(text3, max) {
  return text3.length > max ? `${text3.slice(0, max - 1).trimEnd()}\u2026` : text3;
}
function ncSheetNote(call, fullName, day) {
  const w = callWhat(call);
  if (!w) return null;
  const surname = fullName.trim().split(/\s+/)[0] ?? "";
  const name = surname || "\u043E\u0431\u0437\u0432\u043E\u043D";
  const head = `${ddmm(dayOf(day))} ${name}: ${w.what}`;
  return {
    line: clip(w.words ? `${head}. ${w.words}` : head, NC_ONEC_NOTE_MAX),
    next: call.callBackAt ? `${ddmm(dayOf(call.callBackAt))} ${name}` : null,
    who: surname.toLowerCase()
  };
}
function staffOf(c) {
  return NC_ORDER.includes(c.measurer) ? c.measurer : c.measurer.startsWith("\u041C\u0438\u0448\u0430") ? NC_REPAIR : null;
}
function ncSourceLabel(raw) {
  const t = (raw ?? "").replace(/\s+/g, " ").trim();
  if (!t) return "\u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D";
  const letters = t.replace(/[^A-Za-zА-Яа-яЁё]/g, "");
  if (letters.length > 3 && letters === letters.toUpperCase()) {
    return t.toLowerCase().replace(/(^|[\s(«"-])([a-zа-яё])/g, (_, p, c) => p + c.toUpperCase());
  }
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function nonclosureBySource(a, from, to, block) {
  const p0 = dayOf(from);
  const p1 = dayOf(to);
  const by = /* @__PURE__ */ new Map();
  const total = { measurements: 0, concluded: 0 };
  for (const c of a.clusters) {
    if (c.date < p0 || c.date > p1 || c.block !== block || !staffOf(c)) continue;
    const visits = [...c.visits].sort((x, y) => x.date - y.date);
    const source = ncSourceLabel(visits.find((v) => v.source)?.source);
    const key = source.toLowerCase();
    const row = by.get(key) ?? { source, measurements: 0, concluded: 0 };
    const won = c.final.startsWith("\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D");
    row.measurements += 1;
    if (won) row.concluded += 1;
    total.measurements += 1;
    if (won) total.concluded += 1;
    by.set(key, row);
  }
  const rows = [...by.values()].sort((x, y) => y.measurements - x.measurements || x.source.localeCompare(y.source, "ru"));
  return { rows, total };
}
function nonclosureCallList(a, from, to) {
  const p0 = dayOf(from);
  const p1 = dayOf(to);
  const out = [];
  for (const c of a.clusters) {
    if (c.date < p0 || c.date > p1 || c.final !== "\u043D\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D" || !staffOf(c)) continue;
    const visits = [...c.visits].sort((x, y) => x.date - y.date);
    if (visits.some((v) => a.later.get(v.uid))) continue;
    const first = visits[0];
    const newest = [...visits].reverse();
    const key = (visits.find((v) => v.base) ?? first).uid;
    const phones = [];
    for (const v of newest) if (v.phone && !phones.includes(v.phone)) phones.push(v.phone);
    const phonesRaw = [];
    for (const v of newest) {
      const raw = (v.phoneRaw ?? "").trim();
      if (!v.phone && raw.replace(/\D/g, "").length >= 5 && !phonesRaw.includes(raw)) phonesRaw.push(raw);
    }
    const [v1c, st, det] = a.verdicts.get(c.best.uid) ?? ["\u043D\u0435\u0442", "", ""];
    const why = {
      "\u043D\u0435\u0442": "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0432 1\u0421 \u043D\u0435\u0442",
      "\u0440\u0430\u0441\u0447\u0451\u0442": "\u0412 1\u0421 \u0442\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0441\u0447\u0451\u0442, \u0431\u0435\u0437 \u043E\u043F\u043B\u0430\u0442\u044B",
      "\u043E\u0442\u043C\u0435\u043D\u0451\u043D": "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0431\u044B\u043B, \u043D\u043E \u0437\u0430\u043A\u0430\u0437 \u043E\u0442\u043C\u0435\u043D\u0451\u043D",
      "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D": "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0432 1\u0421 \u0435\u0441\u0442\u044C"
    }[v1c];
    const details = v1c === "\u043D\u0435\u0442" ? "" : [st, det].filter(Boolean).join(" \xB7 ");
    const t = newest.find((v) => v.table)?.table ?? null;
    const src = newest.find((v) => v.base);
    out.push({
      date: first.date,
      item: {
        key,
        ...src ? { source: { base: src.base, uid: src.uid, day: dayStr(src.date) } } : {},
        // Итог звонка — в последний визит замера в 1С: в замер идут только
        // визиты с итогом, то есть уже прошедшие
        ...src ? { noteTo: { base: src.base, uid: src.uid, day: dayStr(src.date), measurer: src.measurer, status: src.status.trim() } } : {},
        ...t ? { sheetTo: { sheet: t.sheet, row: t.row, address: t.address, date: t.date } } : {},
        measurer: staffOf(c),
        date: dayStr(first.date),
        kind: kindRu(c.kind),
        block: c.block,
        customer: newest.find((v) => v.cname)?.cname ?? "",
        address: newest.find((v) => v.base && v.addr)?.addr ?? first.addr,
        phones,
        ...phonesRaw.length ? { phonesRaw } : {},
        base: visits.find((v) => v.base)?.base ? NC_BASE_LABEL[visits.find((v) => v.base).base] : "\u2014",
        why,
        details,
        measurerComment: newest.find((v) => v.comment)?.comment ?? "",
        kc: t ? {
          status: t.status || "\u2014",
          reason: (t.reason || "").trim(),
          comment: (t.extra || t.comment || "").trim(),
          next: (t.next || "").trim(),
          why: callWhy(t)
        } : null,
        visits: visits.length
      }
    });
  }
  out.sort((x, y) => y.date - x.date);
  return out.map((x) => x.item);
}
function callWhy(t) {
  const cat = reasonCat(t.extra, t.comment, t.reason);
  return cat === "\u043F\u0440\u043E\u0447\u0435\u0435" && !(t.extra ?? "").trim() && !(t.comment ?? "").trim() ? "" : cat;
}
var NC_AGREED_WAIT_DAYS = 7;
var NC_WON_CHECK_DAYS = 7;
function ncCallState(calls, today) {
  if (calls.length === 0) return "new";
  const last = [...calls].sort((x, y) => x.at < y.at ? -1 : x.at > y.at ? 1 : 0)[calls.length - 1];
  if (last.outcome === "WON") return "won";
  if (last.outcome === "AGREED") {
    return dayOf(today) - dayOf(last.at.slice(0, 10)) >= NC_AGREED_WAIT_DAYS ? "due" : "agreed";
  }
  if (last.outcome === "REFUSED") return "refused";
  if (last.callBackAt && last.callBackAt > today) return "later";
  return "due";
}
function ncRefusalWhy(calls, kcWhy) {
  const last = [...calls].sort((x, y) => x.at < y.at ? -1 : x.at > y.at ? 1 : 0)[calls.length - 1];
  if (last?.outcome === "REFUSED") return last.reason || "\u043F\u0440\u043E\u0447\u0435\u0435";
  return kcWhy || null;
}
function ncConfirmation(a, key) {
  const entry = a.cl.get(key);
  if (!entry) return null;
  const { c, best } = entry;
  const [v] = a.verdicts.get(best.uid) ?? ["\u043D\u0435\u0442"];
  if (v === "\u0437\u0430\u043A\u043B\u044E\u0447\u0451\u043D") {
    const deal = (a.won.get(best.uid) ?? []).filter((d) => d.strong).sort((x, y) => x.start - y.start)[0];
    const measurer = best.signedBy[0]?.measurer ?? best.measurer;
    if (deal) return { source: "1c", contract: deal.contract, sum: deal.sum, day: dayStr(deal.start), measurer };
    return { source: "1c", contract: best.contract || "\u043E\u0442\u043C\u0435\u0447\u0435\u043D \xAB\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB \u0432 \u0437\u0430\u043C\u0435\u0440\u0430\u0445 1\u0421", sum: 0, day: dayStr(best.date), measurer };
  }
  for (const m of c) {
    const lt = a.later.get(m.uid);
    if (lt) return { source: "1c", contract: lt.deal.contract, sum: lt.deal.sum, day: dayStr(lt.deal.start), measurer: lt.w.measurer };
  }
  if (c.some((x) => x.table && x.table.status === "\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D")) return { source: "table", contract: "", sum: 0, day: "", measurer: "" };
  return null;
}

// src/calc/lead-sources.ts
var LEAD_KIND_RU = { ceil: "\u041F\u043E\u0442\u043E\u043B\u043A\u0438", cond: "\u041A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440\u044B" };
var MONTH_STEMS = ["\u044F\u043D\u0432\u0430\u0440", "\u0444\u0435\u0432\u0440\u0430\u043B", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0435\u043B", "\u043C\u0430\u0439", "\u0438\u044E\u043D", "\u0438\u044E\u043B", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440", "\u043E\u043A\u0442\u044F\u0431\u0440", "\u043D\u043E\u044F\u0431\u0440", "\u0434\u0435\u043A\u0430\u0431\u0440"];
var CITY = { "\u0438\u0436": "\u0418\u0416", "\u0435\u043A\u0431": "\u0415\u041A\u0411", "\u043F\u0435\u0440\u043C\u044C": "\u041F\u0435\u0440\u043C\u044C" };
function parseLeadSheetTitle(title) {
  const t = title.replace(/\s+/g, " ").trim().toLowerCase();
  if (/бюджет|итог/.test(t)) return null;
  const m = /^(иж|екб|пермь) (\S+)(.*)$/.exec(t);
  if (!m) return null;
  const mi = MONTH_STEMS.findIndex((p) => m[2].startsWith(p));
  if (mi < 0) return null;
  const year = /\b(20\d\d)\b/.exec(m[3]);
  if (!year) return null;
  const rest = m[3].replace(year[1], " ").replace(/конд\S*/, " ").replace(/[.\s]+/g, "");
  if (rest) return null;
  return {
    city: CITY[m[1]],
    kind: /конд/.test(m[3]) ? "cond" : "ceil",
    month: `${year[1]}-${String(mi + 1).padStart(2, "0")}`
  };
}
function leadKey(s) {
  return s.toLowerCase().replace(/ё/g, "\u0435").replace(/[^a-zа-я0-9]+/g, " ").trim();
}
function cellNumber(text3) {
  const t = (text3 ?? "").replace(/[\s  ]/g, "").replace(",", ".");
  if (!t) return 0;
  const n = Number(t);
  if (Number.isFinite(n)) return n;
  const lead = /^-?\d+(?:\.\d+)?/.exec(t);
  return lead ? Number(lead[0]) : 0;
}
function leadMonthFromGrid(title, header, rows) {
  const head = parseLeadSheetTitle(title);
  if (!head) return null;
  const names = header.map((h) => (h ?? "").replace(/\s+/g, " ").trim());
  let totalCol = -1;
  const countCols = [];
  const spendCols = [];
  names.forEach((name, col) => {
    if (col === 0) return;
    const k = leadKey(name);
    if (!k) return;
    if (k === "\u0441\u0443\u043C\u043C\u0430") {
      if (totalCol < 0) totalCol = col;
      return;
    }
    if (/(^| )цена лида$/.test(k)) return;
    if (/(^| )затраты$/.test(k)) {
      spendCols.push({ col, base: k.replace(/ ?затраты$/, "").trim(), name: name.replace(/\s*затраты\s*$/i, "").trim() });
      return;
    }
    countCols.push({ col, name, key: k });
  });
  if (countCols.length === 0) return null;
  const partOf2 = /* @__PURE__ */ new Map();
  for (const c of countCols) {
    const m = /пришедш\S* с (\S+)/.exec(c.key);
    if (!m) continue;
    const stem = m[1];
    const own = (p) => p.key.length >= 3 && stem.startsWith(p.key);
    const parent = countCols.find((p) => p !== c && own(p)) ?? (stem.startsWith("\u0441\u0430\u0439\u0442") ? countCols.find((p) => p !== c && p.key === "\u0434\u0438\u0440\u0435\u043A\u0442") : void 0);
    if (parent) partOf2.set(c.name, parent.name);
  }
  const spendOf = /* @__PURE__ */ new Map();
  const extra = [];
  for (const s of spendCols) {
    const owner = countCols.find((c) => c.key === s.base) ?? countCols.find((c) => c.key.replace(/ /g, "") === s.base.replace(/ /g, ""));
    const name = owner?.name ?? (s.name || s.base);
    spendOf.set(s.col, name);
    if (!owner && !extra.some((e) => e.name === name)) extra.push({ name, paid: true });
  }
  const paid = new Set(spendOf.values());
  const sources = [
    ...countCols.map((c) => ({ name: c.name, paid: paid.has(c.name), ...partOf2.has(c.name) ? { partOf: partOf2.get(c.name) } : {} })),
    ...extra
  ];
  const days = [];
  for (const r of rows) {
    if (!r.at) continue;
    const day = r.at.slice(0, 10);
    if (day.slice(0, 7) !== head.month) continue;
    if (/заявк/i.test(r.cells[0] ?? "")) continue;
    const counts = {};
    for (const c of countCols) {
      const n = cellNumber(r.cells[c.col] ?? "");
      if (n) counts[c.name] = (counts[c.name] ?? 0) + n;
    }
    const spend = {};
    for (const s of spendCols) {
      const n = cellNumber(r.cells[s.col] ?? "");
      if (!n) continue;
      const name = spendOf.get(s.col);
      spend[name] = sumMoney([spend[name] ?? "0", n]).toString();
    }
    const raw = totalCol >= 0 ? r.cells[totalCol] ?? "" : "";
    days.push({ day, counts, spend, sheetTotal: totalCol >= 0 ? cellNumber(raw) : null });
  }
  if (days.length === 0) return null;
  days.sort((a, b) => a.day.localeCompare(b.day));
  return { ...head, title: title.trim(), sources, days };
}
function daysInMonth2(month) {
  const [y, m] = month.split("-").map(Number);
  return new Date(Date.UTC(y, m, 0)).getUTCDate();
}
function leadPeriodEnd(month, today) {
  const last = `${month}-${String(daysInMonth2(month)).padStart(2, "0")}`;
  return today.slice(0, 7) === month && today < last ? today : last;
}
function leadMonthSummary(m, upTo) {
  const days = m.days.filter((d) => d.day <= upTo);
  const parentOf = new Map(m.sources.filter((s) => s.partOf).map((s) => [s.name, s.partOf]));
  const counts = /* @__PURE__ */ new Map();
  const parts = /* @__PURE__ */ new Map();
  const spend = /* @__PURE__ */ new Map();
  for (const d of days) {
    for (const [name, n2] of Object.entries(d.counts)) {
      const owner = parentOf.get(name) ?? name;
      counts.set(owner, (counts.get(owner) ?? 0) + n2);
      if (owner !== name) {
        const p = parts.get(owner) ?? /* @__PURE__ */ new Map();
        p.set(name, (p.get(name) ?? 0) + n2);
        parts.set(owner, p);
      }
    }
    for (const [name, v] of Object.entries(d.spend)) spend.set(name, sumMoney([spend.get(name) ?? "0", v]).toString());
  }
  const total = [...counts.values()].reduce((s, n2) => s + n2, 0);
  const rows = [];
  for (const s of m.sources) {
    if (s.partOf) continue;
    const count = counts.get(s.name) ?? 0;
    const money3 = spend.get(s.name);
    if (!count && !money3) continue;
    const row = { name: s.name, count, share: total ? Math.round(count / total * 100) : 0 };
    const p = parts.get(s.name);
    if (p) row.includes = [...p.entries()].map(([name, n2]) => ({ name, count: n2 }));
    if (s.paid) {
      row.spend = roundMoney(money3 ?? "0").toString();
      row.costPer = count ? roundMoney(toDecimal(money3 ?? "0").div(count)).toFixed(0) : null;
    }
    rows.push(row);
  }
  rows.sort((a, b) => b.count - a.count || Number(b.spend ?? 0) - Number(a.spend ?? 0));
  const paidRows = rows.filter((r) => r.spend !== void 0);
  const spendTotal = sumMoney(paidRows.map((r) => r.spend));
  const paidCount = paidRows.reduce((s, r) => s + r.count, 0);
  const mismatches = [];
  const byDay = days.map((d) => {
    const columns = Object.values(d.counts).reduce((s, n2) => s + n2, 0);
    if (d.sheetTotal !== null && Math.abs(d.sheetTotal - columns) > 1e-9) mismatches.push({ day: d.day, sheet: d.sheetTotal, columns });
    return { day: d.day, total: columns };
  });
  const n = days.length;
  return {
    city: m.city,
    kind: m.kind,
    month: m.month,
    title: m.title,
    days: n,
    upTo: days.length ? days[days.length - 1].day : `${m.month}-01`,
    total,
    perDay: n ? Math.round(total / n * 10) / 10 : 0,
    rows,
    byDay,
    ...paidRows.length ? {
      spend: {
        total: roundMoney(spendTotal).toString(),
        paidCount,
        costPer: paidCount ? roundMoney(spendTotal.div(paidCount)).toFixed(0) : null
      }
    } : {},
    mismatches
  };
}
function leadTotalFirstDays(m, days) {
  const n = Math.min(days, daysInMonth2(m.month));
  const last = `${m.month}-${String(n).padStart(2, "0")}`;
  const total = m.days.filter((d) => d.day <= last).reduce((s, d) => s + Object.values(d.counts).reduce((a, b) => a + b, 0), 0);
  return { total, days: n };
}
function leadPrevMonth(month) {
  const [y, m] = month.split("-").map(Number);
  return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, "0")}`;
}

// src/calc/contract-profit.ts
var CP_SLICE_KIND = "oln";
var CP_PRICE_KIND = "prc";
var CP_PAY_KIND = "zpl";
var CP_ACQ_KIND = "acq";
var CP_ARCHIVE_KIND = "olx";
var CP_SHARE_KINDS = ["DOCUMENTS", "CALL_CENTER", "SURVEYOR", "SERVICE", "DESIGN"];
var CP_RATE_KINDS = [
  ...CP_SHARE_KINDS,
  "CANVAS_SQM",
  "MATERIALS_SQM",
  "ACQUIRING",
  "TAX_USN",
  "TAX_MIN",
  "TAX_VAT"
];
var CP_RATE_LABEL = {
  DOCUMENTS: "\u041E\u0442\u0434\u0435\u043B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
  CALL_CENTER: "\u041A\u043E\u043B\u043B-\u0446\u0435\u043D\u0442\u0440",
  SURVEYOR: "\u0417\u0430\u043C\u0435\u0440\u0449\u0438\u043A",
  SERVICE: "\u041E\u0442\u0434\u0435\u043B \u0441\u0435\u0440\u0432\u0438\u0441\u0430",
  DESIGN: "\u041A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0441\u043A\u0438\u0439 \u043E\u0442\u0434\u0435\u043B",
  CANVAS_SQM: "\u041F\u043E\u043B\u043E\u0442\u043D\u043E, \u20BD \u0437\u0430 \u043C\xB2",
  MATERIALS_SQM: "\u0420\u0430\u0441\u0445\u043E\u0434\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438, \u20BD \u0437\u0430 \u043C\xB2",
  ACQUIRING: "\u042D\u043A\u0432\u0430\u0439\u0440\u0438\u043D\u0433, % \u0441\u0443\u043C\u043C\u044B \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
  TAX_USN: "\u0423\u0421\u041D \xAB\u0434\u043E\u0445\u043E\u0434\u044B \u043C\u0438\u043D\u0443\u0441 \u0440\u0430\u0441\u0445\u043E\u0434\u044B\xBB, %",
  TAX_MIN: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u0423\u0421\u041D, % \u0434\u043E\u0445\u043E\u0434\u0430",
  TAX_VAT: "\u041D\u0414\u0421 \u0438\u0437 \u0441\u0442\u0440\u043E\u043A \u0437\u0430\u043A\u0430\u0437\u0430 1\u0421, % \u043E\u0442 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u043D\u043E\u0433\u043E"
};
function cpRateOn(rates, kind, day, base) {
  const live = rates.filter((r) => r.kind === kind && isWorkRateOn(r, day)).sort((a, b) => ruleDayKey(b.validFrom).localeCompare(ruleDayKey(a.validFrom)));
  return (base ? live.find((r) => r.base === base) : void 0) ?? live.find((r) => !r.base) ?? null;
}
var WORK_TYPES = /* @__PURE__ */ new Set(["\u0443\u0441\u043B\u0443\u0433\u0430", "\u0440\u0430\u0431\u043E\u0442\u0430", "\u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F"]);
var CANVAS_WORK = "\u043C\u043E\u043D\u0442\u0430\u0436 \u043F\u043E\u0442\u043E\u043B\u043E\u0447\u043D\u043E\u0433\u043E \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F";
var AUTO_DATE = /^Договор\s*№\s*[\d ]+?\s+от\s+(\d\d)\.(\d\d)\.(\d{4})/u;
function clean3(s) {
  return String(s ?? "").replace(/ /g, " ").replace(/\s+/gu, " ").trim();
}
function num3(x) {
  const n = typeof x === "number" ? x : Number(String(x ?? "").replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}
function isSqm(unit2) {
  const u = unit2.toLowerCase().replace(/[.\s]/g, "");
  return u.includes("\u043A\u0432") || u === "\u043C2" || u === "\u043C\xB2";
}
function pct(part, whole) {
  if (whole.lte(0)) return null;
  return Math.round(part.dividedBy(whole).times(1e3).toNumber()) / 10;
}
function money2(d) {
  return roundMoney(d).toFixed(2);
}
function contractTitle(contract) {
  return clean3(contract).replace(/\s*\(руб\.?\)\s*$/u, "");
}
function contractProfits(input) {
  const prices = /* @__PURE__ */ new Map();
  for (const p of input.prices ?? []) {
    const code = clean3(p.Code).toUpperCase();
    if (code && !prices.has(code)) prices.set(code, { cost: num3(p.Cost), book: num3(p.Book) });
  }
  const preps = [];
  const payBy = /* @__PURE__ */ new Map();
  const bases = input.bases ?? NC_BASES;
  for (const base of bases) {
    for (const r of input.pay?.[base] ?? []) {
      const c = clean3(r.Contract);
      if (!c) continue;
      const k = `${base}|${c}`;
      const list = payBy.get(k) ?? [];
      list.push(r);
      payBy.set(k, list);
    }
  }
  for (const base of bases) {
    const rows = input.lines[base] ?? [];
    const zam = input.zam[base] ?? [];
    const zamByContract = /* @__PURE__ */ new Map();
    for (const z6 of zam) {
      const c = clean3(z6.Contract);
      if (!c) continue;
      const list = zamByContract.get(c) ?? [];
      list.push(z6);
      zamByContract.set(c, list);
    }
    const byContract = /* @__PURE__ */ new Map();
    for (const r of rows) {
      const c = clean3(r.Contract);
      if (!c) continue;
      const list = byContract.get(c) ?? [];
      list.push(r);
      byContract.set(c, list);
    }
    for (const [contract, lines] of byContract) {
      preps.push(prepareContract(base, contract, lines, zamByContract.get(contract) ?? []));
    }
  }
  const acqBy = /* @__PURE__ */ new Map();
  for (const base of bases) {
    for (const r of input.acq?.[base] ?? []) {
      const c = clean3(r.Contract);
      if (!c) continue;
      const k = `${base}|${c}`;
      const a = acqBy.get(k) ?? { sum: new Decimal(0), fee: new Decimal(0) };
      const refund = clean3(r.Kind).startsWith("\u0412\u043E\u0437\u0432\u0440\u0430\u0442");
      a.sum = refund ? a.sum.minus(toDecimal(num3(r.Sum))) : a.sum.plus(toDecimal(num3(r.Sum)));
      a.fee = a.fee.plus(toDecimal(num3(r.Fee)));
      acqBy.set(k, a);
    }
  }
  const ctx = {
    prices,
    brigadePaid: new Set((input.brigadePaid ?? []).map((c) => c.trim().toUpperCase())),
    history: input.payHistory ?? cpPayHistory(preps, payBy),
    payBy,
    acqBy
  };
  return preps.map((p) => priceContract(p, input, ctx)).sort((a, b) => b.date.localeCompare(a.date) || a.title.localeCompare(b.title, "ru"));
}
var MONEY_UNITS = /* @__PURE__ */ new Set(["\u0440\u0443\u0431", "\u0440", "\u20BD", "\u0440\u0443\u0431\u043B\u044C", "\u0440\u0443\u0431\u043B\u0435\u0439"]);
function isMoneyUnit2(unit2) {
  return MONEY_UNITS.has(unit2.toLowerCase().replace(/[.\s]/g, ""));
}
var HISTORY_MIN = 5;
function cv(values) {
  if (values.length < 2) return 0;
  const mean = values.reduce((s, v) => s + v, 0) / values.length;
  if (mean <= 0) return Infinity;
  const variance = values.reduce((s, v) => s + (v - mean) ** 2, 0) / (values.length - 1);
  return Math.sqrt(variance) / mean;
}
function cpPayHistoryOf(input) {
  const bases = input.bases ?? NC_BASES;
  const payBy = /* @__PURE__ */ new Map();
  for (const base of bases) {
    for (const r of input.pay?.[base] ?? []) {
      const c = clean3(r.Contract);
      if (!c) continue;
      const k = `${base}|${c}`;
      const list = payBy.get(k) ?? [];
      list.push(r);
      payBy.set(k, list);
    }
  }
  const preps = [];
  for (const base of bases) {
    const byContract = /* @__PURE__ */ new Map();
    for (const r of input.lines[base] ?? []) {
      const c = clean3(r.Contract);
      if (!c) continue;
      const list = byContract.get(c) ?? [];
      list.push(r);
      byContract.set(c, list);
    }
    for (const [contract, lines] of byContract) preps.push(prepareContract(base, contract, lines, []));
  }
  return cpPayHistory(preps, payBy);
}
function cpPayHistory(preps, payBy) {
  const orderAgg = /* @__PURE__ */ new Map();
  const payAgg = /* @__PURE__ */ new Map();
  for (const p of preps) {
    const k = `${p.base}|${p.contract}`;
    const pay = payBy.get(k);
    if (!p.done || !pay?.length) continue;
    const om = /* @__PURE__ */ new Map();
    for (const r of p.live) {
      if (!WORK_TYPES.has(clean3(r.IType).toLowerCase())) continue;
      const n = normalizeWorkName(clean3(r.Item));
      const a = om.get(n) ?? { qty: 0, sum: 0, unit: clean3(r.Unit) };
      a.qty += num3(r.Qty);
      a.sum += num3(r.Sum);
      om.set(n, a);
    }
    const pm = /* @__PURE__ */ new Map();
    for (const r of pay) {
      const n = normalizeWorkName(clean3(r.Item));
      const a = pm.get(n) ?? { qty: 0, sum: 0 };
      a.qty += num3(r.Qty);
      a.sum += num3(r.Sum);
      pm.set(n, a);
    }
    orderAgg.set(k, om);
    payAgg.set(k, pm);
  }
  const names = /* @__PURE__ */ new Set();
  for (const om of orderAgg.values()) for (const n of om.keys()) names.add(n);
  const out = /* @__PURE__ */ new Map();
  for (const name of names) {
    const keys = [...orderAgg.keys()].filter((k) => orderAgg.get(k).has(name));
    if (keys.length < HISTORY_MIN) continue;
    const same = keys.filter((k) => payAgg.get(k).has(name)).length;
    let via = null;
    if (same < keys.length * 0.3) {
      const hits = /* @__PURE__ */ new Map();
      const asOrder = /* @__PURE__ */ new Map();
      for (const k of keys) {
        const oq = orderAgg.get(k).get(name).qty;
        for (const [y, a] of payAgg.get(k)) {
          if (oq > 0 && Math.abs(a.qty - oq) <= oq * 0.1) hits.set(y, (hits.get(y) ?? 0) + 1);
        }
        for (const y of orderAgg.get(k).keys()) asOrder.set(y, (asOrder.get(y) ?? 0) + 1);
      }
      const best = [...hits.entries()].filter(([y]) => y !== name && (asOrder.get(y) ?? 0) <= keys.length * 0.2).sort((a, b) => b[1] - a[1])[0];
      if (best && best[1] >= Math.max(HISTORY_MIN, keys.length * 0.5)) via = best[0];
    }
    const payName = via ?? name;
    const pairs = keys.map((k) => {
      const o = orderAgg.get(k).get(name);
      const z6 = payAgg.get(k).get(payName);
      return { oq: o.qty, os: o.sum, unit: o.unit, zs: z6?.sum ?? 0 };
    });
    const paid = pairs.filter((x) => x.zs > 0);
    const base = { contracts: pairs.length, paid: paid.length, via };
    if (paid.length === 0) {
      if (pairs.length >= 10) out.set(name, { method: "zero", value: 0, ...base });
      continue;
    }
    if (paid.length < 3) continue;
    const sumZ = pairs.reduce((s, x) => s + x.zs, 0);
    const sumQ = pairs.reduce((s, x) => s + x.oq, 0);
    const sumS = pairs.reduce((s, x) => s + x.os, 0);
    const money3 = pairs.some((x) => isMoneyUnit2(x.unit));
    const unitCv = cv(paid.filter((x) => x.oq > 0).map((x) => x.zs / x.oq));
    const shareCv = cv(paid.filter((x) => x.os > 0).map((x) => x.zs / x.os));
    const useShare = money3 || sumQ <= 0 || sumS > 0 && shareCv < unitCv;
    if (useShare) {
      if (sumS <= 0) continue;
      out.set(name, { method: "share", value: sumZ / sumS, ...base });
    } else {
      out.set(name, { method: "unit", value: sumZ / sumQ, ...base });
    }
  }
  return out;
}
function dayRu(day) {
  return `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`;
}
function historyNote(h, unit2) {
  const via = h.via ? `; \u0432 \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u0435 \u044D\u0442\u0430 \u0440\u0430\u0431\u043E\u0442\u0430 \u043D\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \xAB${h.via}\xBB` : "";
  if (h.method === "zero") return `\u0431\u0440\u0438\u0433\u0430\u0434\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E \u043D\u0435 \u043F\u043B\u0430\u0442\u0438\u043C \u2014 \u0442\u0430\u043A \u043F\u043E ${h.contracts} \u043F\u0440\u043E\u0448\u043B\u044B\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C`;
  if (h.method === "share") {
    return `\u043E\u0431\u044B\u0447\u043D\u043E \u043F\u043B\u0430\u0442\u0438\u043C \u0431\u0440\u0438\u0433\u0430\u0434\u0435 ${(Math.round(h.value * 1e3) / 10).toLocaleString("ru-RU")}% \u043E\u0442 \u0446\u0435\u043D\u044B \u2014 \u0442\u0430\u043A \u043F\u043E ${h.contracts} \u043F\u0440\u043E\u0448\u043B\u044B\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C${via}`;
  }
  return `\u043E\u0431\u044B\u0447\u043D\u043E \u043F\u043B\u0430\u0442\u0438\u043C \u0431\u0440\u0438\u0433\u0430\u0434\u0435 ~${Math.round(h.value).toLocaleString("ru-RU")} \u20BD \u0437\u0430 ${unit2 || "\u0435\u0434."} \u2014 \u0442\u0430\u043A \u043F\u043E ${h.contracts} \u043F\u0440\u043E\u0448\u043B\u044B\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C${via}`;
}
function planRate(rates, workTypeId, day) {
  const own = rates.filter((r) => r.workTypeId === workTypeId);
  const avg = (list) => {
    const byBrigade = /* @__PURE__ */ new Map();
    for (const r of list) {
      const prev = byBrigade.get(r.brigadeId ?? "");
      if (!prev || ruleDayKey(r.validFrom) > ruleDayKey(prev.validFrom)) byBrigade.set(r.brigadeId ?? "", r);
    }
    const values = [...byBrigade.values()].map((r) => toDecimal(r.amount));
    return values.length ? values.reduce((s, v2) => s.plus(v2), new Decimal(0)).dividedBy(values.length) : null;
  };
  const brigadeOn = own.filter((r) => r.brigadeId && isWorkRateOn(r, day));
  const onDay = avg(brigadeOn);
  if (onDay) return { amount: onDay, note: "\u0441\u0440\u0435\u0434\u043D\u044F\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0431\u0440\u0438\u0433\u0430\u0434 \u2014 \u0431\u0440\u0438\u0433\u0430\u0434\u0430 \u0435\u0449\u0451 \u043D\u0435 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0430" };
  const later = own.filter((r) => ruleDayKey(r.validFrom) > day);
  if (later.length === 0) return null;
  const first = later.map((r) => ruleDayKey(r.validFrom)).sort()[0];
  const generalLater = later.filter((r) => !r.brigadeId && ruleDayKey(r.validFrom) === first);
  if (generalLater.length) return { amount: toDecimal(generalLater[0].amount), note: `\u0441\u0442\u0430\u0432\u043A\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0435, \u0432\u0432\u0435\u0434\u0451\u043D\u043D\u0430\u044F \u043F\u043E\u0437\u0436\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 (\u0441 ${dayRu(first)})` };
  const brigadeLater = later.filter((r) => r.brigadeId && ruleDayKey(r.validFrom) === first);
  const v = avg(brigadeLater);
  return v ? { amount: v, note: `\u0441\u0440\u0435\u0434\u043D\u044F\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0431\u0440\u0438\u0433\u0430\u0434, \u0432\u0432\u0435\u0434\u0451\u043D\u043D\u0430\u044F \u043F\u043E\u0437\u0436\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 (\u0441 ${dayRu(first)})` } : null;
}
var NOT_AN_ORDER = /общий заказ|для сметы|смета только|для сч[её]та|для чека|не делаем|ошибочн|для тестирован|перенос с ип/i;
function prepareContract(base, contract, rows, zam) {
  const orders = /* @__PURE__ */ new Map();
  for (const r of rows) {
    const key = clean3(r.Num);
    const o = orders.get(key) ?? {
      num: key,
      date: dayStr(dayOf(r.ODate)),
      state: clean3(r.State),
      variant: clean3(r.Variant),
      comment: clean3(r.Comment),
      sum: "0.00",
      counted: clean3(r.Variant) !== "\u041E\u0442\u043C\u0435\u043D\u0435\u043D",
      note: clean3(r.Variant) === "\u041E\u0442\u043C\u0435\u043D\u0435\u043D" ? "\u0437\u0430\u043A\u0430\u0437 \u043E\u0442\u043C\u0435\u043D\u0451\u043D \u2014 \u0432 \u0441\u0443\u043C\u043C\u0443 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442" : "",
      total: new Decimal(0)
    };
    o.total = o.total.plus(toDecimal(num3(r.Sum)));
    orders.set(key, o);
  }
  const orderList = [...orders.values()].map(({ total, ...o }) => ({ ...o, sum: money2(total) })).sort((a, b) => a.date.localeCompare(b.date) || a.num.localeCompare(b.num));
  const accepted = orderList.filter((o) => o.counted && o.state !== "\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D");
  for (const o of orderList) {
    if (!o.counted || o.state !== "\u041D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D") continue;
    const marker = NOT_AN_ORDER.exec(o.comment);
    if (marker) {
      o.counted = false;
      o.note = `\u0432 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u043E \xAB${marker[0]}\xBB \u2014 \u044D\u0442\u043E \u043D\u0435 \u0437\u0430\u043A\u0430\u0437, \u0432 \u0441\u0443\u043C\u043C\u0443 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442`;
      continue;
    }
    if (accepted.length === 0) continue;
    if (o.comment && accepted.some((a) => a.comment === o.comment)) {
      o.counted = false;
      o.note = "\u044D\u0442\u043E \u043E\u0431\u0449\u0438\u0439 \u0440\u0430\u0441\u0447\u0451\u0442, \u0435\u0433\u043E \u0443\u0436\u0435 \u0440\u0430\u0437\u043D\u0435\u0441\u043B\u0438 \u043F\u043E \u0434\u0440\u0443\u0433\u0438\u043C \u0437\u0430\u043A\u0430\u0437\u0430\u043C \u2014 \u0432 \u0441\u0443\u043C\u043C\u0443 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442";
    } else {
      o.note = "\u0437\u0430\u043A\u0430\u0437 \u0435\u0449\u0451 \u043D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D, \u043D\u043E \u0432 \u0441\u0443\u043C\u043C\u0443 \u0432\u0445\u043E\u0434\u0438\u0442; \u0435\u0441\u043B\u0438 \u044D\u0442\u043E \u043F\u0440\u043E\u0441\u0442\u043E \u0440\u0430\u0441\u0447\u0451\u0442, \u0430 \u043D\u0435 \u0437\u0430\u043A\u0430\u0437, \u2014 \u043D\u0430 \u0441\u0430\u043C\u043E\u043C \u0434\u0435\u043B\u0435 \u0441\u0443\u043C\u043C\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043C\u0435\u043D\u044C\u0448\u0435";
    }
  }
  const counted = new Set(orderList.filter((o) => o.counted).map((o) => o.num));
  const live = rows.filter((r) => counted.has(clean3(r.Num))).sort((a, b) => clean3(a.Num).localeCompare(clean3(b.Num)) || num3(a.N) - num3(b.N));
  const signed = zam.filter((z6) => clean3(z6.Status) === "\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D");
  const visit = [...signed.length ? signed : zam].sort((a, b) => String(b.At).localeCompare(String(a.At)))[0] ?? null;
  const fromComment = visit ? null : ncWhoIn(orderList.map((o) => o.comment));
  const measurer = visit ? ncMeasurerName(visit.Measurer) || null : fromComment;
  const operator = visit ? clean3(visit["Resp"]) || null : null;
  const auto = AUTO_DATE.exec(clean3(contract));
  const firstOrder = orderList[0]?.date ?? dayStr(dayOf(rows[0]?.ODate));
  const signedDay = signed.length ? dayStr(Math.min(...signed.map((z6) => dayOf(z6.At)))) : null;
  const date = auto ? `${auto[3]}-${auto[2]}-${auto[1]}` : signedDay ?? firstOrder;
  const inCount = orderList.filter((o) => o.counted);
  return {
    base,
    contract,
    rows,
    orderList,
    live,
    measurer,
    operator,
    measurerFrom: visit ? "\u0437\u0430\u043C\u0435\u0440" : fromComment ? "\u0437\u0430\u043A\u0430\u0437" : null,
    date,
    done: inCount.length > 0 && inCount.every((o) => o.state === "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D")
  };
}
function priceContract(prep, input, ctx) {
  const { base, contract, rows, orderList, live, measurer, operator, date } = prep;
  const canvasRate = cpRateOn(input.rates, "CANVAS_SQM", date, base);
  const materialsRate = cpRateOn(input.rates, "MATERIALS_SQM", date, base);
  const workRows = live.filter((r) => WORK_TYPES.has(clean3(r.IType).toLowerCase()));
  const pay = calcWorksPay(
    workRows.map((r) => ({ name: clean3(r.Item), unit: clean3(r.Unit), quantity: num3(r.Qty) })),
    input.workTypes,
    input.workRates,
    { brigadeId: null, day: date }
  );
  const lines = [];
  const missing = { works: [], goods: [], materials: [], canvas: false, rates: [] };
  const estimated = [];
  let revenue = new Decimal(0);
  let works = new Decimal(0);
  let materials = new Decimal(0);
  let goods = new Decimal(0);
  let canvas = new Decimal(0);
  let canvasSqm = 0;
  let vat = new Decimal(0);
  let workIdx = 0;
  for (const r of live) {
    const name = clean3(r.Item);
    const unit2 = clean3(r.Unit);
    const qty = num3(r.Qty);
    const sum = roundMoney(num3(r.Sum));
    revenue = revenue.plus(sum);
    vat = vat.plus(toDecimal(num3(r.Vat)));
    const isWork = WORK_TYPES.has(clean3(r.IType).toLowerCase());
    let cost = null;
    let note = "";
    let isCanvas = false;
    if (isWork) {
      const p = pay.lines[workIdx++];
      const hist = p.amount === null ? ctx.history.get(normalizeWorkName(name)) ?? null : null;
      const fallback = p.amount === null && !hist && p.workTypeId ? planRate(input.workRates, p.workTypeId, date) : null;
      if (p.amount !== null) {
        cost = toDecimal(p.amount);
        works = works.plus(cost);
        note = p.direct ? "\u0441\u0443\u043C\u043C\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0432 \u0437\u0430\u043A\u0430\u0437\u0435" : p.fromOnec ? "\u0441\u0442\u0430\u0432\u043A\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0435 \u0438\u0437 1\u0421" : "\u0441\u0442\u0430\u0432\u043A\u0430 \u0431\u0440\u0438\u0433\u0430\u0434\u0435 \u0438\u0437 CRM";
      } else if (hist) {
        cost = roundMoney(hist.method === "share" ? sum.times(hist.value) : toDecimal(hist.value).times(qty));
        works = works.plus(cost);
        note = historyNote(hist, unit2);
        if (!estimated.includes(name)) estimated.push(name);
      } else if (fallback) {
        cost = roundMoney(fallback.amount.times(qty));
        works = works.plus(cost);
        note = fallback.note;
      } else {
        note = p.workTypeId ? "\u0441\u0442\u0430\u0432\u043A\u0438 \u0431\u0440\u0438\u0433\u0430\u0434\u0435 \u043D\u0435\u0442 \u2014 \u0440\u0430\u0441\u0445\u043E\u0434 \u043D\u0435 \u043F\u043E\u0441\u0447\u0438\u0442\u0430\u043D" : "\u0442\u0430\u043A\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B \u043D\u0435\u0442 \u0432 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0435 \u2014 \u0440\u0430\u0441\u0445\u043E\u0434 \u043D\u0435 \u043F\u043E\u0441\u0447\u0438\u0442\u0430\u043D";
        if (!missing.works.includes(name)) missing.works.push(name);
      }
      const mats = p.workTypeId && !p.direct ? input.workTypes.find((t) => t.id === p.workTypeId)?.materials ?? [] : [];
      let matCost = null;
      for (const m of mats) {
        const code = m.externalCode.trim().toUpperCase();
        if (ctx.brigadePaid.has(code)) continue;
        const pr = ctx.prices.get(code);
        const unitPrice = pr && pr.cost > 0 ? pr.cost : pr && pr.book > 0 ? pr.book : null;
        if (unitPrice === null) {
          if (!missing.materials.includes(m.name)) missing.materials.push(m.name);
          continue;
        }
        const c = roundMoney(toDecimal(unitPrice).times(toDecimal(m.perUnit)).times(qty));
        matCost = (matCost ?? new Decimal(0)).plus(c);
      }
      if (matCost) {
        materials = materials.plus(matCost);
        cost = (cost ?? new Decimal(0)).plus(matCost);
        note = note ? `${note}, \u043F\u043B\u044E\u0441 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B` : "\u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B";
      }
      if (normalizeWorkName(name).startsWith(CANVAS_WORK) && isSqm(unit2)) {
        isCanvas = true;
        canvasSqm += qty;
        if (canvasRate) {
          const c = roundMoney(toDecimal(canvasRate.value).times(qty));
          canvas = canvas.plus(c);
          cost = (cost ?? new Decimal(0)).plus(c);
          note = note ? `${note}, \u043F\u043B\u044E\u0441 \u043F\u043E\u043B\u043E\u0442\u043D\u043E` : "\u043F\u043E\u043B\u043E\u0442\u043D\u043E";
        } else {
          missing.canvas = true;
        }
      }
    } else {
      const unitCost = num3(r.Cost) > 0 ? num3(r.Cost) : num3(r.Book) > 0 ? num3(r.Book) : null;
      if (unitCost !== null) {
        cost = roundMoney(toDecimal(unitCost).times(qty));
        goods = goods.plus(cost);
        note = num3(r.Cost) > 0 ? "\u0446\u0435\u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u043A\u0438" : "\u0443\u0447\u0451\u0442\u043D\u0430\u044F \u0446\u0435\u043D\u0430 (\u0437\u0430\u043A\u0443\u043F\u043E\u0447\u043D\u043E\u0439 \u043D\u0435\u0442)";
      } else {
        note = "\u0446\u0435\u043D\u044B \u0437\u0430\u043A\u0443\u043F\u043A\u0438 \u0432 1\u0421 \u043D\u0435\u0442 \u2014 \u0440\u0430\u0441\u0445\u043E\u0434 \u043D\u0435 \u043F\u043E\u0441\u0447\u0438\u0442\u0430\u043D";
        if (!missing.goods.includes(name)) missing.goods.push(name);
      }
    }
    const margin = cost !== null ? sum.minus(cost) : null;
    lines.push({
      order: clean3(r.Num),
      name,
      code: clean3(r.Code),
      unit: unit2,
      qty,
      price: money2(toDecimal(num3(r.Price))),
      sum: money2(sum),
      kind: isWork ? "work" : "goods",
      canvas: isCanvas,
      unitCost: cost !== null && qty > 0 ? cost.dividedBy(qty).toFixed(2) : null,
      cost: cost !== null ? money2(cost) : null,
      costNote: note,
      margin: margin !== null ? money2(margin) : null,
      marginPct: margin !== null ? pct(margin, sum) : null
    });
  }
  let materialsNote = materials.gt(0) ? "\u043F\u043E \u043D\u043E\u0440\u043C\u0430\u043C \u0440\u0430\u0431\u043E\u0442" : "";
  if (materialsRate && canvasSqm > 0) {
    const floor = roundMoney(toDecimal(materialsRate.value).times(canvasSqm));
    if (floor.gt(materials)) {
      const extra = floor.minus(materials);
      const canvasLines = lines.filter((l) => l.canvas && l.qty > 0);
      const parts = splitAmountByShares(extra, canvasLines.map((l, i) => ({ key: i, share: l.qty })));
      canvasLines.forEach((l, i) => {
        const add = parts[i]?.amount ?? new Decimal(0);
        const cost = toDecimal(l.cost ?? 0).plus(add);
        const sum = toDecimal(l.sum);
        l.cost = money2(cost);
        l.unitCost = l.qty > 0 ? cost.dividedBy(l.qty).toFixed(2) : null;
        l.margin = money2(sum.minus(cost));
        l.marginPct = pct(sum.minus(cost), sum);
        l.costNote = l.costNote ? `${l.costNote}, \u043F\u043B\u044E\u0441 \u0440\u0430\u0441\u0445\u043E\u0434\u043A\u0430 \u0437\u0430 \u043C\xB2` : "\u0440\u0430\u0441\u0445\u043E\u0434\u043A\u0430 \u0437\u0430 \u043C\xB2";
      });
      materials = floor;
      materialsNote = `${String(materialsRate.value).replace(".", ",")} \u20BD \u0437\u0430 \u043C\xB2 \xD7 ${(Math.round(canvasSqm * 100) / 100).toLocaleString("ru-RU")} \u043C\xB2`;
    }
  }
  const factRows = ctx.payBy.get(`${base}|${contract}`) ?? [];
  const worksFact = factRows.length ? money2(factRows.reduce((s, r) => s.plus(toDecimal(num3(r.Sum))), new Decimal(0))) : null;
  const shares = {};
  let sharesTotal = new Decimal(0);
  for (const kind of CP_SHARE_KINDS) {
    const rate = cpRateOn(input.rates, kind, date, base);
    if (!rate) {
      shares[kind] = null;
      missing.rates.push(kind);
      continue;
    }
    const share = roundMoney(percentOf(revenue, rate.value));
    shares[kind] = money2(share);
    sharesTotal = sharesTotal.plus(share);
  }
  const acqRate = cpRateOn(input.rates, "ACQUIRING", date, base);
  const acquiring = acqRate ? roundMoney(percentOf(revenue, acqRate.value)) : null;
  if (!acqRate) missing.rates.push("ACQUIRING");
  const acqFact = ctx.acqBy.get(`${base}|${contract}`) ?? null;
  const vatRate = cpRateOn(input.rates, "TAX_VAT", date, base);
  vat = roundMoney(vatRate ? percentOf(vat, vatRate.value) : vat);
  const income = revenue.minus(vat);
  const beforeTax = works.plus(materials).plus(goods).plus(canvas).plus(sharesTotal).plus(acquiring ?? 0);
  const usnRate = cpRateOn(input.rates, "TAX_USN", date, base);
  const minRate = cpRateOn(input.rates, "TAX_MIN", date, base);
  let usn = null;
  let usnNote = "";
  if (usnRate) {
    const byProfit = roundMoney(percentOf(Decimal.max(income.minus(beforeTax), 0), usnRate.value));
    const floor = minRate ? roundMoney(percentOf(income, minRate.value)) : new Decimal(0);
    usn = Decimal.max(byProfit, floor);
    usnNote = byProfit.gte(floor) ? `${String(usnRate.value).replace(".", ",")}% \u0441 \u043F\u0440\u0438\u0431\u044B\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430` : `\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u2014 ${String(minRate.value).replace(".", ",")}% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B: \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043F\u043E\u0447\u0442\u0438 \u0431\u0435\u0437 \u043F\u0440\u0438\u0431\u044B\u043B\u0438`;
  } else {
    missing.rates.push("TAX_USN");
  }
  const costs = beforeTax.plus(vat).plus(usn ?? 0);
  const profit = revenue.minus(costs);
  const [no] = ncContractNum(contract);
  const customer = clean3(rows[0]?.Customer);
  return {
    key: `${base}|${contract}`,
    base,
    baseLabel: input.baseLabels?.[base] ?? NC_BASE_LABEL[base] ?? base,
    contract,
    number: no,
    title: contractTitle(contract),
    customer,
    date,
    measurer,
    measurerFrom: prep.measurerFrom,
    operator,
    orders: orderList,
    revenue: money2(revenue),
    works: money2(works),
    materials: money2(materials),
    materialsNote,
    goods: money2(goods),
    canvas: canvasSqm > 0 && !canvasRate ? null : money2(canvas),
    canvasSqm: Math.round(canvasSqm * 100) / 100,
    shares,
    sharesTotal: money2(sharesTotal),
    costs: money2(costs),
    profit: money2(profit),
    marginPct: pct(profit, revenue),
    missing,
    estimated,
    vat: money2(vat),
    usn: usn ? money2(usn) : null,
    usnNote,
    acquiring: acquiring ? money2(acquiring) : null,
    cardPaid: acqFact ? money2(acqFact.sum) : null,
    acquiringFact: acqFact ? money2(acqFact.fee) : null,
    worksFact,
    factDocs: new Set(factRows.map((r) => clean3(r.Num))).size,
    complete: missing.works.length === 0 && missing.goods.length === 0 && missing.materials.length === 0 && !missing.canvas && missing.rates.length === 0,
    lines
  };
}
function cpTotals(list) {
  const sum = (f) => list.reduce((s, c) => s.plus(toDecimal(f(c) ?? 0)), new Decimal(0));
  const revenue = sum((c) => c.revenue);
  const profit = sum((c) => c.profit);
  const shares = {};
  for (const k of CP_SHARE_KINDS) shares[k] = money2(sum((c) => c.shares[k]));
  return {
    contracts: list.length,
    incomplete: list.filter((c) => !c.complete).length,
    revenue: money2(revenue),
    works: money2(sum((c) => c.works)),
    materials: money2(sum((c) => c.materials)),
    goods: money2(sum((c) => c.goods)),
    canvas: money2(sum((c) => c.canvas)),
    shares,
    sharesTotal: money2(sum((c) => c.sharesTotal)),
    profit: money2(profit),
    marginPct: pct(profit, revenue),
    vat: money2(sum((c) => c.vat)),
    usn: money2(sum((c) => c.usn)),
    acquiring: money2(sum((c) => c.acquiring)),
    acquiringFact: money2(sum((c) => c.acquiringFact)),
    factContracts: list.filter((c) => c.worksFact !== null).length,
    worksPlanFact: money2(sum((c) => c.worksFact !== null ? c.works : null)),
    worksFact: money2(sum((c) => c.worksFact))
  };
}
function groupBy(list, keyOf) {
  const groups = /* @__PURE__ */ new Map();
  for (const c of list) {
    const [key, title] = keyOf(c);
    const g = groups.get(key) ?? { title, items: [] };
    g.items.push(c);
    groups.set(key, g);
  }
  return [...groups.entries()].map(([key, g]) => ({ key, title: g.title, ...cpTotals(g.items) }));
}
function cpByMeasurer(list) {
  return groupBy(list, (c) => [c.measurer ?? "", c.measurer ?? "\u0417\u0430\u043C\u0435\u0440\u0449\u0438\u043A \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D"]).sort(
    (a, b) => toDecimal(b.profit).comparedTo(toDecimal(a.profit))
  );
}
var MONTHS = ["\u044F\u043D\u0432\u0430\u0440\u044C", "\u0444\u0435\u0432\u0440\u0430\u043B\u044C", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0435\u043B\u044C", "\u043C\u0430\u0439", "\u0438\u044E\u043D\u044C", "\u0438\u044E\u043B\u044C", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C", "\u043E\u043A\u0442\u044F\u0431\u0440\u044C", "\u043D\u043E\u044F\u0431\u0440\u044C", "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"];
function cpByMonth(list) {
  return groupBy(list, (c) => [c.date.slice(0, 7), `${MONTHS[Number(c.date.slice(5, 7)) - 1] ?? ""} ${c.date.slice(0, 4)}`]).sort(
    (a, b) => b.key.localeCompare(a.key)
  );
}
function cpByItem(list) {
  const groups = /* @__PURE__ */ new Map();
  for (const c of list) {
    for (const l of c.lines) {
      const key = `${l.kind}|${normalizeWorkName(l.name)}|${l.unit.toLowerCase()}`;
      const g = groups.get(key) ?? {
        kind: l.kind,
        name: l.name,
        unit: l.unit,
        contracts: /* @__PURE__ */ new Set(),
        qty: 0,
        revenue: new Decimal(0),
        pricedRevenue: new Decimal(0),
        pricedQty: 0,
        cost: new Decimal(0),
        unpriced: 0
      };
      g.contracts.add(c.key);
      g.qty += l.qty;
      g.revenue = g.revenue.plus(toDecimal(l.sum));
      if (l.cost !== null) {
        g.pricedRevenue = g.pricedRevenue.plus(toDecimal(l.sum));
        g.pricedQty += l.qty;
        g.cost = g.cost.plus(toDecimal(l.cost));
      } else {
        g.unpriced += 1;
      }
      groups.set(key, g);
    }
  }
  return [...groups.values()].map((g) => {
    const priced = g.pricedQty > 0 || g.cost.gt(0);
    const margin = priced ? g.pricedRevenue.minus(g.cost) : null;
    return {
      kind: g.kind,
      name: g.name,
      unit: g.unit,
      contracts: g.contracts.size,
      qty: Math.round(g.qty * 100) / 100,
      revenue: money2(g.revenue),
      avgPrice: g.qty > 0 ? g.revenue.dividedBy(g.qty).toFixed(2) : null,
      cost: priced ? money2(g.cost) : null,
      avgCost: g.pricedQty > 0 ? g.cost.dividedBy(g.pricedQty).toFixed(2) : null,
      margin: margin ? money2(margin) : null,
      marginPct: margin ? pct(margin, g.pricedRevenue) : null,
      unpriced: g.unpriced
    };
  }).sort((a, b) => toDecimal(b.revenue).comparedTo(toDecimal(a.revenue)));
}
function cpInPeriod(list, from, to) {
  return list.filter((c) => c.date >= from && c.date <= to);
}

// src/calc/payment-switch.ts
var PAY_FORM_DIFF = 0.11;
function payFormFactor(from) {
  const k = new Decimal(1).minus(PAY_FORM_DIFF);
  return from === "CASH" ? new Decimal(1).dividedBy(k) : k;
}
function payFormDiffPct(a, b) {
  const x = Number(a);
  const y = Number(b);
  const hi = Math.max(x, y);
  return hi > 0 ? Math.round(Math.abs(x - y) / hi * 1e3) / 10 : 0;
}
function cellText(cell) {
  if (!cell) return "";
  if (cell.t != null) return cell.t;
  return (cell.r ?? []).map((x) => x.t).join("");
}
function parsePriceCell(text3) {
  const t = (text3 ?? "").trim();
  if (!t) return [];
  return t.split("/").map((part) => {
    const m = part.replace(/(\d)[\s  ]+(?=\d)/g, "$1").match(/\d+(?:[.,]\d+)?/);
    if (!m) return null;
    const n = Number(m[0].replace(",", "."));
    return Number.isFinite(n) && n > 0 ? n : null;
  });
}
function priceBlocks(data) {
  const heads = [];
  for (const row of data.rows.slice(0, 5)) {
    for (const cell of row.cells) {
      const t = cellText(cell).toLowerCase();
      if (!t.trim()) continue;
      let form = null;
      if (/налич/.test(t)) form = "CASH";
      else if (/безнал|ндс/.test(t)) form = "CASHLESS";
      else if (/лемана/.test(t)) form = "other";
      if (form && !heads.some((h) => h.col === cell.c)) heads.push({ form, col: cell.c });
    }
    if (heads.some((h) => h.form === "CASH") && heads.some((h) => h.form === "CASHLESS")) break;
  }
  heads.sort((a, b) => a.col - b.col);
  return heads.map((h, i) => ({ form: h.form, from: h.col, to: (heads[i + 1]?.col ?? 1e4) - 1 }));
}
function titleDate(title) {
  const m = title.match(/(\d{1,2})\.(\d{1,2})(?:\.(\d{2,4}))?/);
  if (!m) return 0;
  const year = m[3] ? Number(m[3].length === 2 ? `20${m[3]}` : m[3]) : 2e3;
  return year * 1e4 + Number(m[2]) * 100 + Number(m[1]);
}
function isNumberCell(cell) {
  if (!cell) return false;
  const t = cellText(cell).trim();
  if (!t || !/\d/.test(t)) return false;
  return cell.n === 1 || /^[\d\s  .,]+(₽|р\.?|руб\.?)?$/i.test(t);
}
function cellsByCol(row) {
  return new Map(row.cells.map((c) => [c.c, c]));
}
function cleanName(s) {
  return s.replace(/\s+/g, " ").trim();
}
function readSpecSheet(title, data) {
  const blocks = priceBlocks(data);
  const cash = blocks.find((b) => b.form === "CASH");
  const cashless = blocks.find((b) => b.form === "CASHLESS");
  if (!cash || !cashless) return null;
  let headerR = -1;
  const colsOf = (row, b) => {
    let from = null;
    let to = null;
    let unit2 = null;
    for (const cell of row.cells) {
      if (cell.c < b.from || cell.c > b.to) continue;
      const t = cellText(cell).trim().toLowerCase();
      if (t === "\u043E\u0442") from = cell.c;
      else if (t === "\u0434\u043E") to = cell.c;
      else if (/ед\.?\s*изм/.test(t)) unit2 = cell.c;
    }
    return from == null ? null : { name: b.from, unit: unit2, from, to };
  };
  let cashCols = null;
  let cashlessCols = null;
  for (let i = 0; i < Math.min(data.rows.length, 8); i++) {
    const a = colsOf(data.rows[i], cash);
    const b = colsOf(data.rows[i], cashless);
    if (a && b) {
      headerR = i;
      cashCols = a;
      cashlessCols = b;
      break;
    }
  }
  if (headerR < 0 || !cashCols || !cashlessCols) return null;
  const rows = [];
  const problems = [];
  let section = "";
  for (const row of data.rows.slice(headerR + 1)) {
    const by = cellsByCol(row);
    const name = cleanName(cellText(by.get(cashlessCols.name)) || cellText(by.get(cashCols.name)));
    if (!name) continue;
    const read = (c) => {
      const from = parsePriceCell(cellText(by.get(c.from)));
      const to = c.to == null ? [] : parsePriceCell(cellText(by.get(c.to)));
      return { from, to, unit: c.unit == null ? "" : cleanName(cellText(by.get(c.unit))) };
    };
    const a = read(cashCols);
    const b = read(cashlessCols);
    const anyPrice = [...a.from, ...a.to, ...b.from, ...b.to].some((v) => v != null);
    if (!anyPrice) {
      if (!a.unit && !b.unit) section = name;
      continue;
    }
    const cashList = [...a.from, ...a.to];
    const cashlessList = [...b.from, ...b.to];
    if (!cashList.some((v) => v != null) || !cashlessList.some((v) => v != null)) continue;
    if (cashList.length !== cashlessList.length) {
      problems.push(`\xAB${title}\xBB, \u0441\u0442\u0440\u043E\u043A\u0430 ${row.r} \xAB${name}\xBB: \u0446\u0435\u043D \u043D\u0430\u043B\u043E\u043C ${cashList.length}, \u0431\u0435\u0437\u043D\u0430\u043B\u043E\u043C ${cashlessList.length}`);
      continue;
    }
    const pairs = [];
    cashList.forEach((v, i) => {
      const w = cashlessList[i];
      if (v != null && w != null) pairs.push({ cash: v, cashless: w });
    });
    if (pairs.length === 0) continue;
    rows.push({
      key: `${title}#${row.r}`,
      sheet: title,
      r: row.r,
      name,
      section,
      unit: b.unit || a.unit,
      group: "spec",
      pairs
    });
  }
  return { rows, problems };
}
function readCanvasSheet(title, data) {
  const blocks = priceBlocks(data);
  const cash = blocks.find((b) => b.form === "CASH");
  const cashless = blocks.find((b) => b.form === "CASHLESS");
  if (!cash || !cashless) return null;
  const priceCols = (b) => {
    const votes = /* @__PURE__ */ new Map();
    for (const row of data.rows) {
      const cells = row.cells.filter((c) => c.c >= b.from && c.c <= b.to && cellText(c).trim());
      cells.forEach((cell, i) => {
        const prev = cells[i - 1];
        if (!prev || !isNumberCell(cell) || isNumberCell(prev)) return;
        if (prev.c !== cell.c - 1) return;
        votes.set(cell.c, (votes.get(cell.c) ?? 0) + 1);
      });
    }
    return [...votes.entries()].filter(([, n2]) => n2 >= 2).map(([c]) => c).sort((x, y) => x - y);
  };
  const cashCols = priceCols(cash);
  const cashlessCols = priceCols(cashless);
  const n = Math.min(cashCols.length, cashlessCols.length);
  if (n === 0) return null;
  const rows = [];
  let section = "";
  const lastName = [];
  for (const row of data.rows) {
    const by = cellsByCol(row);
    const blockTexts = row.cells.filter((c) => c.c >= cash.from && c.c <= cash.to && cellText(c).trim());
    const hasPrice2 = cashCols.some((c) => isNumberCell(by.get(c)));
    if (!hasPrice2) {
      if (blockTexts.length === 1) section = cleanName(cellText(blockTexts[0]));
      continue;
    }
    for (let i = 0; i < n; i++) {
      const cashCell = by.get(cashCols[i]);
      const cashlessCell = by.get(cashlessCols[i]);
      const cashV = isNumberCell(cashCell) ? parsePriceCell(cellText(cashCell))[0] : null;
      const cashlessV = isNumberCell(cashlessCell) ? parsePriceCell(cellText(cashlessCell))[0] : null;
      const own = cleanName(cellText(by.get(cashCols[i] - 1)));
      if (own) lastName[i] = own;
      if (cashV == null || cashlessV == null) continue;
      const name = own || (lastName[i] ? `${lastName[i]} (\u0432\u0442\u043E\u0440\u0430\u044F \u0446\u0435\u043D\u0430)` : "\u043F\u043E\u043B\u043E\u0442\u043D\u043E");
      rows.push({
        key: `${title}#${row.r}#${i}`,
        sheet: title,
        r: row.r,
        name,
        section,
        unit: "\u043C\xB2",
        group: "canvas",
        pairs: [{ cash: cashV, cashless: cashlessV }]
      });
    }
  }
  return rows;
}
function switchPriceTable(sheets) {
  const byDate = [...sheets].sort((a, b) => titleDate(b.title) - titleDate(a.title));
  const rows = [];
  const sources = [];
  let problems = [];
  const spec = byDate.filter((s) => /спецификац/i.test(s.title) && !/кондиц/i.test(s.title)).map((s) => ({ s, read: readSpecSheet(s.title, s.data) })).find((x) => x.read && x.read.rows.length > 0);
  if (spec?.read) {
    rows.push(...spec.read.rows);
    problems = spec.read.problems;
    sources.push(spec.s.title);
  }
  const aircon = byDate.filter((s) => /спецификац/i.test(s.title) && /кондиц/i.test(s.title)).map((s) => ({ s, read: readSpecSheet(s.title, s.data) })).find((x) => x.read && x.read.rows.length > 0);
  if (aircon?.read) {
    rows.push(...aircon.read.rows);
    problems = [...problems, ...aircon.read.problems];
    sources.push(aircon.s.title);
  }
  const canvas = byDate.filter((s) => /пл[её]нк|полотн/i.test(s.title)).map((s) => ({ s, read: readCanvasSheet(s.title, s.data) })).find((x) => x.read && x.read.length > 0);
  if (canvas?.read) {
    rows.push(...canvas.read);
    sources.push(canvas.s.title);
  }
  return { rows, sources, problems };
}
function switchIndex(table) {
  return {
    table,
    names: indexNomenclature(
      table.rows.filter((r) => r.group === "spec").map((r) => ({ externalCode: r.key, name: r.name }))
    )
  };
}
var NAME_WEAK = 0.3;
var NAME_SURE = 0.4;
var NAME_NAMED = 0.6;
function near(a, b) {
  return Math.abs(a - b) <= Math.max(b * 5e-3, 0.02);
}
function fmtRub(n) {
  return `${n.toLocaleString("ru-RU", { maximumFractionDigits: 2 })} \u20BD`;
}
var FORM_WORD = { CASH: "\u043D\u0430\u043B\u043E\u043C", CASHLESS: "\u0431\u0435\u0437\u043D\u0430\u043B\u043E\u043C" };
function switchLine(line2, from, index) {
  const price = Number(line2.price);
  const oldPrice = toDecimal(line2.price);
  const oldSum = toDecimal(line2.sum);
  const to = from === "CASH" ? "CASHLESS" : "CASH";
  const src = (p) => from === "CASH" ? p.cash : p.cashless;
  const dst = (p) => from === "CASH" ? p.cashless : p.cash;
  const keep = (how, note) => ({
    newPrice: roundMoney(oldPrice).toFixed(2),
    newSum: roundMoney(oldSum).toFixed(2),
    how,
    check: how !== "goods",
    row: null,
    note
  });
  const scaled = (factor2, how, row, pair2, note, exactPrice) => {
    const newPrice = exactPrice != null ? roundMoney(exactPrice) : roundMoney(oldPrice.times(factor2));
    const newSum = roundMoney(oldPrice.isZero() ? oldSum.times(factor2) : oldSum.times(newPrice).dividedBy(oldPrice));
    return {
      newPrice: newPrice.toFixed(2),
      newSum: newSum.toFixed(2),
      how,
      // Своя цена узнанной строки меняется на разницу форм оплаты — это
      // правило компании, а не догадка; сверить — только неузнанное
      check: how === "diff",
      row: row && pair2 ? { key: row.key, name: row.name, section: row.section, cash: pair2.cash, cashless: pair2.cashless } : null,
      note
    };
  };
  if (!Number.isFinite(price) || price < 1) return keep("zero", "\u0446\u0435\u043D\u0430-\u0437\u0430\u0433\u043B\u0443\u0448\u043A\u0430 \u2014 \u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u043A\u0430\u043A \u0435\u0441\u0442\u044C");
  if (line2.goods) return keep("goods", "\u0442\u043E\u0432\u0430\u0440 \u2014 \u043F\u0440\u0438 \u0441\u043C\u0435\u043D\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u0446\u0435\u043D\u0430 \u0442\u0430 \u0436\u0435");
  const rows = index.table.rows.filter((r) => line2.canvas ? r.group === "canvas" : r.group === "spec");
  const nameScore = /* @__PURE__ */ new Map();
  if (!line2.canvas) {
    for (const s of suggestNomenclature(line2.name, index.names, { limit: 400, minScore: 0.01 }).suggestions) {
      nameScore.set(s.externalCode, s.score);
    }
  }
  const score = (r) => nameScore.get(r.key) ?? 0;
  for (const [mult, how] of [[1, "exact"], [2, "half"]]) {
    const hits = [];
    for (const row of rows) {
      if (how === "half" && !line2.canvas && score(row) < NAME_SURE) continue;
      for (const pair2 of row.pairs) if (near(price * mult, src(pair2))) hits.push({ row, pair: pair2 });
    }
    if (hits.length === 0) continue;
    hits.sort((a, b) => score(b.row) - score(a.row) || Math.abs(price * mult - src(a.pair)) - Math.abs(price * mult - src(b.pair)));
    const best = hits[0];
    if (!line2.canvas && score(best.row) < NAME_SURE && rows.some((r) => score(r) >= NAME_NAMED)) continue;
    const sure = score(best.row) >= NAME_SURE;
    const ratios = (sure ? hits.filter((h) => score(h.row) >= score(best.row)) : hits).map((h) => dst(h.pair) / src(h.pair));
    const named = rows.find((r) => score(r) >= NAME_SURE && r !== best.row && score(r) > score(best.row));
    if (score(best.row) < NAME_WEAK) ratios.push(payFormFactor(from).toNumber());
    if (named) ratios.push(...named.pairs.map((p) => dst(p) / src(p)));
    const spread = Math.max(...ratios) - Math.min(...ratios);
    const unsure = !line2.canvas && spread > 0.01;
    const exactPrice = how === "exact" && near(price, src(best.pair)) && Math.abs(price - src(best.pair)) < 5e-3 ? dst(best.pair) : void 0;
    const factor2 = toDecimal(dst(best.pair)).dividedBy(src(best.pair));
    const where = `${best.row.section ? `${best.row.section} \xB7 ` : ""}${best.row.name}`;
    const res = scaled(
      factor2,
      how,
      best.row,
      best.pair,
      `${how === "half" ? "50 % \u043E\u0442 " : ""}${fmtRub(src(best.pair))} ${FORM_WORD[from]} \u2192 ${fmtRub(dst(best.pair))} ${FORM_WORD[to]} \u043F\u043E \u0431\u043B\u0430\u043D\u043A\u0443: ${where}`,
      exactPrice
    );
    if (unsure) {
      res.check = true;
      res.note += score(best.row) < NAME_WEAK ? " \u2014 \u0446\u0435\u043D\u0430 \u0441\u043E\u0432\u043F\u0430\u043B\u0430, \u0430 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043D\u0430 \u0431\u043B\u0430\u043D\u043A\u0435 \u0434\u0440\u0443\u0433\u043E\u0435, \u0441\u0432\u0435\u0440\u044C\u0442\u0435" : " \u2014 \u0442\u0430\u043A\u0430\u044F \u0446\u0435\u043D\u0430 \u0441\u0442\u043E\u0438\u0442 \u0443 \u0441\u0442\u0440\u043E\u043A \u0431\u043B\u0430\u043D\u043A\u0430 \u0441 \u0440\u0430\u0437\u043D\u043E\u0439 \u043F\u0430\u0440\u043E\u0439, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u0442\u0440\u043E\u043A\u0443";
    } else if (!line2.canvas && score(best.row) < NAME_WEAK) {
      res.note = `${how === "half" ? "50 % \u043E\u0442 " : ""}\u0446\u0435\u043D\u0430 ${fmtRub(src(best.pair))} ${FORM_WORD[from]} \u0441\u0442\u043E\u0438\u0442 \u043D\u0430 \u0431\u043B\u0430\u043D\u043A\u0435, ${FORM_WORD[to]} \u2014 ${fmtRub(dst(best.pair))}`;
    }
    return res;
  }
  const factor = payFormFactor(from);
  const rule = "\u043D\u0430\u043B \u043D\u0430 11 % \u0434\u0435\u0448\u0435\u0432\u043B\u0435 \u0431\u0435\u0437\u043D\u0430\u043B\u0430";
  if (!line2.canvas) {
    const row = rows.filter((r) => score(r) >= NAME_NAMED).sort((a, b) => score(b) - score(a))[0];
    if (row) {
      const where = `${row.section ? `${row.section} \xB7 ` : ""}${row.name}`;
      return scaled(factor, "own", row, row.pairs[0], `\u0446\u0435\u043D\u0430 \u0441\u0432\u043E\u044F, \u043D\u0430 \u0431\u043B\u0430\u043D\u043A\u0435 \u0435\u0451 \u043D\u0435\u0442 \u2014 ${rule}; \u0441\u0442\u0440\u043E\u043A\u0430 \u0431\u043B\u0430\u043D\u043A\u0430: ${where}`);
    }
  }
  return scaled(factor, "diff", null, null, `\u043D\u0430 \u0431\u043B\u0430\u043D\u043A\u0435 \u043D\u0435 \u043D\u0430\u0448\u043B\u043E\u0441\u044C \u2014 ${rule}, \u0441\u0432\u0435\u0440\u044C\u0442\u0435`);
}
function switchTotals(lines, results, overrides = {}) {
  let oldSum = new Decimal(0);
  let newSum = new Decimal(0);
  let toCheck = 0;
  lines.forEach((line2, i) => {
    const res = results[i];
    oldSum = oldSum.plus(toDecimal(line2.sum));
    newSum = newSum.plus(toDecimal(overriddenSum(line2, res, overrides[i])));
    if (res.check && overrides[i] == null) toCheck += 1;
  });
  return {
    oldSum: roundMoney(oldSum).toFixed(2),
    newSum: roundMoney(newSum).toFixed(2),
    diff: roundMoney(newSum.minus(oldSum)).toFixed(2),
    toCheck
  };
}
function overriddenSum(line2, res, override) {
  if (override == null || override.trim() === "") return res.newSum;
  const p = Number(override.replace(",", ".").replace(/\s/g, ""));
  if (!Number.isFinite(p) || p < 0) return res.newSum;
  const oldPrice = toDecimal(line2.price);
  const oldSum = toDecimal(line2.sum);
  const sum = oldPrice.isZero() ? toDecimal(p).times(line2.qty) : oldSum.times(p).dividedBy(oldPrice);
  return roundMoney(sum).toFixed(2);
}
var SWITCH_HOW_LABEL = {
  exact: "\u043F\u043E \u0431\u043B\u0430\u043D\u043A\u0443",
  half: "\u043F\u043E \u0431\u043B\u0430\u043D\u043A\u0443 \xB7 50 %",
  own: "\u0441\u0432\u043E\u044F \u0446\u0435\u043D\u0430 \xB7 11 %",
  diff: "\u043D\u0435\u0442 \u043D\u0430 \u0431\u043B\u0430\u043D\u043A\u0435 \u2014 \u0441\u0432\u0435\u0440\u044C\u0442\u0435",
  goods: "\u0442\u043E\u0432\u0430\u0440 \u2014 \u0442\u0430 \u0436\u0435 \u0446\u0435\u043D\u0430",
  zero: "\u0437\u0430\u0433\u043B\u0443\u0448\u043A\u0430"
};
function payFormOfBase(base) {
  return base === "unf_10" ? "CASH" : "CASHLESS";
}
var PAY_FORM_LABEL = { CASH: "\u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0435", CASHLESS: "\u0431\u0435\u0437\u043D\u0430\u043B" };
var PAY_FORM_BASE = { CASH: "unf_10", CASHLESS: "unf_18" };
function overriddenPrice(res, override) {
  if (override == null || override.trim() === "") return res.newPrice;
  const p = Number(override.replace(",", ".").replace(/\s/g, ""));
  if (!Number.isFinite(p) || p < 0) return res.newPrice;
  return roundMoney(toDecimal(p)).toFixed(2);
}
function switchContractName(contract, to) {
  const m = /^(\d{3,6}[а-яё]?)(Н)?\s+(\S.*)$/u.exec(contract.trim());
  if (!m) return null;
  const number = to === "CASH" ? `${m[1]}\u041D` : m[1];
  return { name: `${number} ${m[3].trim()}`, number };
}

// src/calc/measurers-month.ts
function mmHeadWork(input) {
  const inPeriod = (day) => day >= input.from && day <= input.to;
  const by = /* @__PURE__ */ new Map();
  const get = (user) => {
    let w = by.get(user);
    if (!w) {
      w = {
        user,
        calls: { total: 0, customers: 0, noAnswer: 0, callBack: 0, agreed: 0, refused: 0, won: 0 },
        visits: [],
        totals: { visits: 0, won: 0, lost: 0, done: 0, cancelled: 0, open: 0 }
      };
      by.set(user, w);
    }
    return w;
  };
  const customers = /* @__PURE__ */ new Map();
  const key = {
    NO_ANSWER: "noAnswer",
    CALL_BACK: "callBack",
    AGREED: "agreed",
    REFUSED: "refused",
    WON: "won"
  };
  for (const c of input.calls) {
    if (!inPeriod(c.day)) continue;
    const w = get(c.user);
    w.calls.total += 1;
    const k = key[c.outcome];
    if (k) w.calls[k] += 1;
    const set = customers.get(c.user) ?? /* @__PURE__ */ new Set();
    set.add(c.measureKey);
    customers.set(c.user, set);
  }
  for (const [user, set] of customers) get(user).calls.customers = set.size;
  for (const v of input.visits) {
    if (!inPeriod(v.at.slice(0, 10))) continue;
    const w = get(v.user);
    w.visits.push({ at: v.at, customer: v.customer, address: v.address, status: v.status, state: v.state });
    w.totals.visits += 1;
    if (v.state === "won" || v.state === "lost" || v.state === "done" || v.state === "cancelled") w.totals[v.state] += 1;
    else w.totals.open += 1;
  }
  for (const w of by.values()) w.visits.sort((a, b) => a.at.localeCompare(b.at));
  return [...by.values()].sort((a, b) => b.totals.visits - a.totals.visits || b.calls.total - a.calls.total || a.user.localeCompare(b.user, "ru"));
}
var pct2 = (part, whole) => whole > 0 ? Math.round(part * 100 / whole) : null;
var COUNTED = ["ceil", "cond"];
function measurersMonth(input) {
  const counted = input.blocks.filter((b) => COUNTED.includes(b.key));
  const measurements = counted.reduce((s, b) => s + b.total.measurements, 0);
  const notConcluded = counted.reduce((s, b) => s + b.total.notConcluded, 0);
  const measures = {
    measurements,
    concluded: measurements - notConcluded,
    notConcluded,
    share: pct2(measurements - notConcluded, measurements),
    byKind: input.blocks.map((b) => ({ key: b.key, title: b.title, measurements: b.total.measurements, notConcluded: b.total.notConcluded }))
  };
  const rows = /* @__PURE__ */ new Map();
  const row = (name) => {
    const r = rows.get(name) ?? { measurer: name, measurements: 0, concluded: 0, notConcluded: 0, share: null };
    rows.set(name, r);
    return r;
  };
  for (const b of counted) {
    for (const x of b.rows) {
      if (x.measurements === 0) continue;
      const r = row(x.measurer);
      r.measurements += x.measurements;
      r.notConcluded += x.notConcluded;
      r.concluded = r.measurements - r.notConcluded;
    }
  }
  let calls;
  if (input.calls) {
    const list2 = input.calls.filter((c) => COUNTED.includes(c.block));
    const reasons = /* @__PURE__ */ new Map();
    const tally = { todo: 0, later: 0, agreed: 0, refused: 0, won: 0 };
    const blank = () => ({ todo: 0, later: 0, agreed: 0, refused: 0, won: 0, returned: 0, returnedSum: 0 });
    for (const c of list2) {
      const k = c.state === "new" || c.state === "due" ? "todo" : c.state;
      tally[k] += 1;
      if (c.refusal && c.state !== "agreed" && c.state !== "won") reasons.set(c.refusal, (reasons.get(c.refusal) ?? 0) + 1);
      const r = row(c.measurer);
      r.calls ??= blank();
      r.calls[k] += 1;
    }
    let returned = 0;
    let returnedSum = 0;
    for (const x of input.returned ?? []) {
      returned += 1;
      returnedSum += x.sum;
      const r = row(x.measurer);
      r.calls ??= blank();
      r.calls.returned += 1;
      r.calls.returnedSum += x.sum;
    }
    calls = {
      ...tally,
      returned,
      returnedSum,
      total: list2.length,
      reasons: [...reasons.entries()].map(([reason, n]) => ({ reason, n })).sort((a, b) => b.n - a.n || a.reason.localeCompare(b.reason, "ru"))
    };
  }
  let profit;
  if (input.profitTotals) {
    const t = input.profitTotals;
    profit = "revenue" in t ? { contracts: t.contracts, revenue: t.revenue, profit: t.profit, marginPct: t.marginPct, incomplete: t.incomplete } : { contracts: t.contracts, incomplete: t.incomplete };
    for (const g of input.profitByMeasurer ?? []) {
      if (!g.key) continue;
      const r = row(g.key);
      r.contracts = g.contracts;
      r.incomplete = g.incomplete;
      r.revenue = g.revenue;
      r.profit = g.profit;
      r.marginPct = g.marginPct;
    }
  }
  for (const r of rows.values()) r.share = pct2(r.concluded, r.measurements);
  const list = [...rows.values()].sort(
    (a, b) => Number(b.profit ?? 0) - Number(a.profit ?? 0) || b.measurements - a.measurements || a.measurer.localeCompare(b.measurer, "ru")
  );
  return {
    from: input.from,
    to: input.to,
    measures,
    rows: list,
    ...calls ? { calls } : {},
    ...profit ? { profit } : {},
    ...input.today ? { today: input.today } : {},
    stale: [...new Set(input.stale ?? [])],
    ...input.strangers?.length ? { strangers: [...input.strangers] } : {}
  };
}

// src/calc/head-work.ts
var HW_OUTCOME_RU = {
  contract: "\u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0432 1\u0421",
  before: "\u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0431\u044B\u043B \u0434\u043E \u0437\u0432\u043E\u043D\u043A\u0430",
  table: "\u041A\u0426 \u043E\u0442\u043C\u0435\u0442\u0438\u043B \xAB\u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\xBB",
  claimed: "\u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043E \xAB\u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438\xBB, \u0432 1\u0421 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0435\u0449\u0451 \u043D\u0435\u0442",
  agreed: "\u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438\u0441\u044C, \u0436\u0434\u0451\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440",
  later: "\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u043F\u043E\u0437\u0436\u0435",
  callAgain: "\u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430",
  refused: "\u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0438\u0441\u044C",
  gone: "\u0443\u0448\u0451\u043B \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430, \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0432 1\u0421 \u043D\u0435\u0442"
};
var OUTCOME_ORDER = ["contract", "claimed", "agreed", "table", "later", "callAgain", "refused", "gone", "before"];
var dayNum = (d) => Date.UTC(Number(d.slice(0, 4)), Number(d.slice(5, 7)) - 1, Number(d.slice(8, 10))) / 864e5;
function emptyOutcomes() {
  return { contract: 0, before: 0, table: 0, claimed: 0, agreed: 0, later: 0, callAgain: 0, refused: 0, gone: 0 };
}
function outcomeOf(c, firstCallDay) {
  if (!c.listed) {
    if (c.confirm?.source === "1c") return c.confirm.day && c.confirm.day < firstCallDay ? "before" : "contract";
    if (c.confirm?.source === "table") return "table";
    return "gone";
  }
  switch (c.state) {
    case "won":
      return "claimed";
    case "agreed":
      return "agreed";
    case "later":
      return "later";
    case "refused":
      return "refused";
    default:
      return "callAgain";
  }
}
function headWorkReport(input) {
  const inPeriod = (day) => day >= input.from && day <= input.to;
  const people = /* @__PURE__ */ new Map();
  const get = (user) => {
    let p = people.get(user);
    if (!p) {
      p = {
        user,
        calls: { total: 0, customers: 0, noAnswer: 0, callBack: 0, agreed: 0, refused: 0, won: 0 },
        outcomes: emptyOutcomes(),
        contracts: 0,
        contractsSum: 0,
        customers: [],
        reasons: [],
        days: [],
        onec: { done: 0, pending: 0, failed: 0 },
        visits: [],
        visitTotals: { visits: 0, won: 0, lost: 0, done: 0, cancelled: 0, open: 0 }
      };
      people.set(user, p);
    }
    return p;
  };
  const callKey = {
    NO_ANSWER: "noAnswer",
    CALL_BACK: "callBack",
    AGREED: "agreed",
    REFUSED: "refused",
    WON: "won"
  };
  const days = /* @__PURE__ */ new Map();
  for (const c of input.customers) {
    const byUser = /* @__PURE__ */ new Map();
    for (const call of c.calls) byUser.set(call.who, [...byUser.get(call.who) ?? [], call]);
    for (const [user, all] of byUser) {
      const mine = [...all].sort((x, y) => x.at < y.at ? -1 : x.at > y.at ? 1 : 0);
      const inSpan = mine.filter((x) => inPeriod(x.day));
      if (inSpan.length === 0) continue;
      const p = get(user);
      for (const call of inSpan) {
        p.calls.total += 1;
        p.calls[callKey[call.outcome]] += 1;
        if (call.onec?.state === "DONE") p.onec.done += 1;
        else if (call.onec?.state === "PENDING") p.onec.pending += 1;
        else if (call.onec?.state === "FAILED") p.onec.failed += 1;
        const perDay = days.get(user) ?? /* @__PURE__ */ new Map();
        const d = perDay.get(call.day) ?? { calls: 0, customers: /* @__PURE__ */ new Set() };
        d.calls += 1;
        d.customers.add(c.key);
        perDay.set(call.day, d);
        days.set(user, perDay);
      }
      p.calls.customers += 1;
      const firstCallDay = mine[0].day;
      const outcome = outcomeOf(c, firstCallDay);
      const last = [...c.calls].sort((x, y) => x.at < y.at ? -1 : x.at > y.at ? 1 : 0)[c.calls.length - 1];
      const lastRefusal = [...mine].reverse().find((x) => x.outcome === "REFUSED");
      const lastWon = [...c.calls].reverse().find((x) => x.outcome === "WON");
      const row = {
        key: c.key,
        customer: c.customer,
        address: c.address,
        measurer: c.measurer,
        date: c.date,
        outcome,
        firstCallDay,
        calls: [...mine].reverse(),
        ...c.confirm && (outcome === "contract" || outcome === "before") ? { confirm: c.confirm } : {},
        ...outcome === "refused" ? { reason: (lastRefusal ?? last).reason || "\u043F\u0440\u043E\u0447\u0435\u0435" } : {},
        ...outcome === "later" ? { callBackAt: last.callBackAt } : {},
        ...outcome === "claimed" && lastWon ? { overdue: dayNum(input.today) - dayNum(lastWon.day) >= NC_WON_CHECK_DAYS } : {}
      };
      p.customers.push(row);
      p.outcomes[outcome] += 1;
      if (outcome === "contract") {
        p.contracts += 1;
        p.contractsSum += c.confirm?.sum ?? 0;
      }
    }
  }
  for (const w of input.work) {
    if (w.visits.length === 0) continue;
    const p = get(w.user);
    p.visits = w.visits;
    p.visitTotals = w.totals;
  }
  for (const p of people.values()) {
    const rank = (o) => OUTCOME_ORDER.indexOf(o);
    p.customers.sort(
      (x, y) => rank(x.outcome) - rank(y.outcome) || (x.calls[0].at < y.calls[0].at ? 1 : x.calls[0].at > y.calls[0].at ? -1 : 0)
    );
    const reasons = /* @__PURE__ */ new Map();
    for (const r of p.customers) if (r.outcome === "refused") reasons.set(r.reason ?? "\u043F\u0440\u043E\u0447\u0435\u0435", (reasons.get(r.reason ?? "\u043F\u0440\u043E\u0447\u0435\u0435") ?? 0) + 1);
    p.reasons = [...reasons].map(([reason, n]) => ({ reason, n })).sort((a, b) => b.n - a.n || a.reason.localeCompare(b.reason, "ru"));
    p.days = [...days.get(p.user) ?? /* @__PURE__ */ new Map()].map(([day, d]) => ({ day, calls: d.calls, customers: d.customers.size })).sort((a, b) => a.day < b.day ? 1 : -1);
  }
  return {
    from: input.from,
    to: input.to,
    people: [...people.values()].sort(
      (a, b) => b.calls.total + b.visitTotals.visits - (a.calls.total + a.visitTotals.visits) || a.user.localeCompare(b.user, "ru")
    )
  };
}

// src/calc/spec-read.ts
var CODE_RE = /^4[3-6]\d{2,3}(?:\/\d{0,2})?$/;
var UNIT_RE = /^\/?\s*(м\.?\s*п|п\.?\s*м|шт|т\.?\s*кр|кв\.?\s*м|м2|м²)/i;
var LETTER_DIGITS = {
  \u0427: "4",
  \u0447: "4",
  \u041E: "0",
  \u043E: "0",
  O: "0",
  o: "0",
  D: "0",
  \u0417: "3",
  \u0437: "3",
  \u0431: "6",
  \u0411: "6",
  \u0412: "8",
  S: "5",
  s: "5",
  Z: "2",
  z: "2",
  l: "1",
  I: "1",
  "|": "1",
  i: "1",
  \u0422: "7",
  g: "9",
  q: "9",
  \u0441: "0",
  c: "0",
  \u0421: "0",
  C: "0"
};
var cx = (w) => (w.x0 + w.x1) / 2;
var cy = (w) => (w.y0 + w.y1) / 2;
function median(values) {
  if (values.length === 0) return NaN;
  const s = [...values].sort((a, b) => a - b);
  const m = s.length >> 1;
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
}
function specNumber(text3) {
  const t = text3.trim().replace(/^[+=~-]+/, "").replace(/(?:р|руб|₽)\.?$/i, "").replace(/[.,]$/, "");
  if (!/^\d+(?:[.,]\d+)?$/.test(t)) return null;
  const n = Number(t.replace(",", "."));
  return Number.isFinite(n) ? n : null;
}
function sumNumber(text3) {
  const t = text3.trim().replace(/^[+=~-]+/, "");
  if (/^\d{1,3}[.,]\d{3}$/.test(t)) return Number(t.replace(/[.,]/, ""));
  return specNumber(t);
}
function qtyGuesses(text3, asSum = false) {
  const out = [];
  const add = (value, how) => {
    if (value !== null && value > 0 && !out.some((g) => g.value === value)) out.push({ value, how });
  };
  const num4 = asSum ? sumNumber : specNumber;
  add(num4(text3), "read");
  const prefix = /^[+=~]?(\d+(?:[.,]\d+)?)[^\d.,]/.exec(text3.trim());
  if (prefix) add(num4(prefix[1]), "prefix");
  const t = text3.trim().replace(/[.,]$/, "");
  if (t.length > 0 && t.length <= 5) {
    let mapped = "";
    for (const ch of t) {
      if (/\d/.test(ch) || ch === "," || ch === ".") mapped += ch;
      else if (LETTER_DIGITS[ch]) mapped += LETTER_DIGITS[ch];
      else {
        mapped = "";
        break;
      }
    }
    if (mapped) add(num4(mapped), "letters");
  }
  return out;
}
var fmt = (n) => String(Math.round(n * 100) / 100).replace(".", ",");
function specPriceFits(price, prices) {
  const tol = Math.max(1, price * 0.01);
  if (prices.variants.some((v) => Math.abs(v - price) <= tol)) return true;
  const { from, to } = prices;
  if (from !== null && to !== null && to >= from) return price >= from - tol && price <= to + tol;
  if (from !== null && to === null) return price >= from - tol;
  if (to !== null && Math.abs(to - price) <= tol) return true;
  return false;
}
function hasPrice(p) {
  return p.variants.length > 0 || p.from !== null || p.to !== null;
}
function priceCandidates(p) {
  return [.../* @__PURE__ */ new Set([...p.variants, ...p.from !== null ? [p.from] : [], ...p.to !== null ? [p.to] : []])].filter(
    (v) => v > 0
  );
}
function exactQty(q, unit2) {
  if (!(q > 0 && q <= 2e3)) return false;
  const cents = q * 100;
  if (Math.abs(cents - Math.round(cents)) > 1e-6) return false;
  return !/шт|т\.?\s*кр/i.test(unit2) || Math.abs(q - Math.round(q)) < 1e-9;
}
function qtyFromSum(sum, unit2, prices, near3) {
  const found = priceCandidates(prices).map((p) => ({ price: p, qty: Math.round(sum / p * 100) / 100 })).filter(({ qty, price }) => exactQty(sum / price, unit2) && qty > 0);
  const uniq = found.filter((f, i) => found.findIndex((g) => g.qty === f.qty) === i);
  if (uniq.length === 1) return uniq[0];
  if (uniq.length > 1 && near3 !== null) {
    return [...uniq].sort((a, b) => Math.abs(a.qty - near3) - Math.abs(b.qty - near3))[0];
  }
  const whole = uniq.filter((f) => Number.isInteger(f.qty));
  return whole.length === 1 ? whole[0] : null;
}
function checkSpecRow(input) {
  const { unit: unit2, prices, qtyRead, sumRead } = input;
  const qs = qtyRead ? qtyGuesses(qtyRead) : [];
  const ss = sumRead ? qtyGuesses(sumRead, true) : [];
  const priced = hasPrice(prices);
  const q0 = qs[0] ?? null;
  const s0 = ss[0] ?? null;
  const said = (g, read) => g.how === "read" ? "" : `\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \xAB${read}\xBB \u2014 ${fmt(g.value)}`;
  if (q0 && s0) {
    if (!priced) {
      return { qty: q0.value, sum: s0.value, price: s0.value / q0.value, check: "unchecked", note: "\u0443 \u0441\u0442\u0440\u043E\u043A\u0438 \u043D\u0435\u0442 \u0446\u0435\u043D\u044B \u043D\u0430 \u0431\u043B\u0430\u043D\u043A\u0435 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043D\u0435\u0447\u0435\u043C" };
    }
    for (const sg of ss) {
      for (const qg of qs) {
        if (specPriceFits(sg.value / qg.value, prices)) {
          const note = [said(qg, qtyRead), said(sg, sumRead)].filter(Boolean).join("; ");
          return { qty: qg.value, sum: sg.value, price: sg.value / qg.value, check: "ok", note: note ? `${note}: \u0441\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0441 \u0446\u0435\u043D\u043E\u0439 \u0431\u043B\u0430\u043D\u043A\u0430` : "" };
        }
      }
    }
    for (const qg of qs) {
      for (const k of [10, 100]) {
        const q = qg.value / k;
        if (exactQty(q, unit2) && specPriceFits(s0.value / q, prices)) {
          return { qty: q, sum: s0.value, price: s0.value / q, check: "fixed", note: `\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \xAB${qtyRead}\xBB, \u043F\u043E\u0445\u043E\u0436\u0435 \u043D\u0430 ${fmt(q)}` };
        }
      }
    }
    const by = qtyFromSum(s0.value, unit2, prices, q0.how === "read" ? q0.value : null);
    if (by) {
      return {
        qty: by.qty,
        sum: s0.value,
        price: by.price,
        check: "fixed",
        note: `\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \xAB${qtyRead}\xBB, \u0430 \u043F\u043E \u0441\u0443\u043C\u043C\u0435 \u0438 \u0446\u0435\u043D\u0435 \u0431\u043B\u0430\u043D\u043A\u0430 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 ${fmt(by.qty)} (${fmt(s0.value)} \xF7 ${fmt(by.price)})`
      };
    }
    if (q0.how === "read" && s0.how === "read") {
      const price = s0.value / q0.value;
      return { qty: q0.value, sum: s0.value, price, check: "outside", note: `\u0446\u0435\u043D\u0430 ${fmt(price)} \u20BD \u043D\u0435 \u043F\u043E\u043F\u0430\u0434\u0430\u0435\u0442 \u0432 \u0446\u0435\u043D\u044B \u0431\u043B\u0430\u043D\u043A\u0430: \u043F\u0440\u043E\u0434\u0430\u043B\u0438 \u043F\u043E \u0434\u0440\u0443\u0433\u043E\u0439 \u0446\u0435\u043D\u0435 \u0438\u043B\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \u043D\u0435\u0432\u0435\u0440\u043D\u043E` };
    }
    if (q0.how !== "read") return checkSpecRow({ qtyRead: null, sumRead, unit: unit2, prices });
    return checkSpecRow({ qtyRead, sumRead: null, unit: unit2, prices });
  }
  if (s0) {
    if (!priced) return { qty: null, sum: s0.value, price: null, check: "sum-only", note: "\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u043E\u0441\u044C" };
    const by = qtyFromSum(s0.value, unit2, prices, null);
    if (by) {
      return {
        qty: by.qty,
        sum: s0.value,
        price: by.price,
        check: "derived",
        note: `\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u043E\u0441\u044C \u2014 \u043F\u043E \u0441\u0443\u043C\u043C\u0435 \u0438 \u0446\u0435\u043D\u0435 \u0431\u043B\u0430\u043D\u043A\u0430: ${fmt(s0.value)} \xF7 ${fmt(by.price)}`
      };
    }
    return { qty: null, sum: s0.value, price: null, check: "sum-only", note: "\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u043E\u0441\u044C" };
  }
  if (q0) return { qty: q0.value, sum: null, price: null, check: "qty-only", note: "\u0441\u0443\u043C\u043C\u0430 \u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0430\u0441\u044C" };
  return { qty: null, sum: null, price: null, check: "sum-only", note: "" };
}
function textLines(words, gap) {
  const sorted = [...words].sort((a, b) => cy(a) - cy(b));
  const lines = [];
  for (const w of sorted) {
    const last = lines[lines.length - 1];
    if (last && cy(w) - median(last.map(cy)) <= gap) last.push(w);
    else lines.push([w]);
  }
  return lines.map((l) => l.sort((a, b) => a.x0 - b.x0));
}
function numberGroups(words) {
  const out = [];
  const h = median(words.map((w) => w.y1 - w.y0)) || 12;
  for (const line2 of textLines(words, 0.5 * h)) {
    let cluster = [];
    const flush = () => {
      if (!cluster.length) return;
      const pieces = cluster.map((p) => p.map((w) => w.text.trim()).join(""));
      out.push({ text: pieces.join(""), y: median(cluster.flat().map(cy)), pieces });
      cluster = [];
    };
    for (const w of line2) {
      const piece = cluster[cluster.length - 1];
      const prev = piece?.[piece.length - 1];
      if (!piece || !prev || w.x0 - prev.x1 >= 0.6 * h) {
        flush();
        cluster = [[w]];
      } else if (!/^\d/.test(w.text.trim()) || /[.,]$/.test(prev.text.trim())) piece.push(w);
      else cluster.push([w]);
    }
    flush();
  }
  return out;
}
function readPrices(words, splitX) {
  const lines = textLines(words, 6);
  const text3 = lines.map((l) => l.map((w) => w.text).join(" ")).join(" ");
  const open = /\.{3,}|…/.test(text3);
  const nums = (t2) => [...t2.matchAll(/(\d+(?:[.,]\d+)?)(\s*%)?/g)].filter((m) => !m[2]).map((m) => Number(m[1].replace(",", ".")));
  if (/\//.test(text3)) return { from: null, to: null, variants: [...new Set(nums(text3))], open };
  const from = nums(words.filter((w) => cx(w) < splitX).map((w) => w.text).join(" "));
  const to = nums(words.filter((w) => cx(w) >= splitX).map((w) => w.text).join(" "));
  const f = from[0] ?? null;
  const t = to[0] ?? null;
  if (f !== null && t !== null && t < f) return { from: null, to: null, variants: [f, t], open };
  return { from: f, to: t, variants: [], open };
}
var CANVAS_HEADS = [
  ["fabric", /^фактур/i],
  ["color", /^цвет/i],
  ["corners", /^угл/i],
  ["maker", /^изготов/i],
  ["width", /^ширин/i],
  ["price", /^цена/i],
  ["areaRead", /^площад/i],
  ["sumRead", /^сумм/i]
];
function canvasArea(read, sum) {
  const n = specNumber(read);
  if (n === null) return { area: null, note: "" };
  if (/[.,]/.test(read) || n < 100) return { area: n, note: "" };
  const fixed = n / 100;
  const plausible2 = sum === null || sum / fixed >= 50 && sum / fixed <= 5e3;
  return plausible2 ? { area: fixed, note: `\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \xAB${read}\xBB, \u043F\u043E\u0445\u043E\u0436\u0435 \u043D\u0430 ${fmt(fixed)}` } : { area: n, note: "" };
}
function readCanvas(page, height, words) {
  const heads = words.filter((w) => CANVAS_HEADS.some(([, re]) => re.test(w.text)));
  if (heads.length < 4) return { rows: [], total: null };
  const headY = median(heads.map(cy));
  const cols = CANVAS_HEADS.map(([key, re]) => {
    const w = heads.find((h) => re.test(h.text) && Math.abs(cy(h) - headY) < 12);
    return w ? { key, x: cx(w) } : null;
  }).filter((c) => c !== null);
  if (cols.length < 4) return { rows: [], total: null };
  const below = words.filter((w) => cy(w) > headY + 8);
  const stop = below.filter((w) => /^(итого|натяжка)/i.test(w.text)).map(cy);
  const bottom = stop.length ? Math.min(...stop) - 4 : headY + height * 0.11;
  const inTable = below.filter((w) => cy(w) < bottom);
  const lines = textLines(inTable, 12).map((line2) => {
    const cells = {};
    for (const w of line2) {
      const col = cols.reduce((best, c) => Math.abs(c.x - cx(w)) < Math.abs(best.x - cx(w)) ? c : best);
      (cells[col.key] ??= []).push(w.text.trim());
    }
    return { line: line2, cells, y: median(line2.map(cy)) };
  });
  const digits = (parts) => (parts ?? []).filter((t) => /\d/.test(t));
  const rooms = lines.filter((l) => digits(l.cells.areaRead).length || digits(l.cells.sumRead).length);
  const rows = rooms.map((l) => ({
    page,
    fabric: "",
    color: "",
    corners: "",
    maker: "",
    width: "",
    price: "",
    areaRead: "",
    area: null,
    sumRead: "",
    sum: null,
    note: "",
    top: Math.min(...l.line.map((w) => w.y0)) / height,
    bottom: Math.max(...l.line.map((w) => w.y1)) / height
  }));
  lines.forEach((l) => {
    if (!rooms.length) return;
    const k = rooms.reduce((best, r, j) => Math.abs(r.y - l.y) < Math.abs(rooms[best].y - l.y) ? j : best, 0);
    const row = rows[k];
    for (const [key, parts] of Object.entries(l.cells)) row[key] = [row[key], ...parts].filter(Boolean).join(" ");
  });
  for (const row of rows) {
    const area = row.areaRead.split(" ").filter(Boolean);
    if (!digits([row.sumRead]).length && area.length === 2 && /[.,]/.test(area[0]) && /^\d{3,6}$/.test(area[1])) {
      row.areaRead = area[0];
      row.sumRead = area[1];
    }
    row.sum = sumNumber(/^\d+(?: \d+)+$/.test(row.sumRead) ? row.sumRead.replace(/ /g, "") : row.sumRead) ?? row.sumRead.split(" ").map(sumNumber).find((v) => v !== null) ?? null;
    const a = canvasArea(row.areaRead, row.sum);
    row.area = a.area;
    row.note = a.note;
  }
  const totalWord = words.find((w) => /^итого/i.test(w.text) && cy(w) > headY && cy(w) < headY + height * 0.15);
  const total = totalWord ? words.filter((w) => w !== totalWord && w.x0 > totalWord.x1 && Math.abs(cy(w) - cy(totalWord)) < 12).map((w) => w.text).join(" ") || null : null;
  return { rows, total };
}
function afterLabel(words, label, isRow) {
  const labels = words.filter((w) => label.test(w.text.trim()) && !isRow(w));
  const at = labels[labels.length - 1];
  if (!at) return null;
  const hand = words.filter((w) => Math.abs(cy(w) - cy(at)) < 16 && w.x0 > at.x1 && /\d/.test(w.text) && !CODE_RE.test(w.text.trim())).sort((a, b) => a.x0 - b.x0).map((w) => w.text.replace(/_+/g, "").trim()).filter(Boolean);
  return hand.length ? hand.join(" ") : null;
}
function readSpecPage(input) {
  const { page, width, height } = input;
  const words = input.words.filter(
    (w) => w.text.trim() && w.x1 > w.x0 && w.y1 > w.y0 && (w.x1 - w.x0 >= 0.3 * (w.y1 - w.y0) || w.text.trim().length > 1)
  );
  const canvas = readCanvas(page, height, words);
  const codeLike = words.filter((w) => CODE_RE.test(w.text.trim()));
  const onCodeLine = (w) => codeLike.some((c) => Math.abs(cy(c) - cy(w)) < 10);
  const result = {
    page,
    rows: [],
    canvas: canvas.rows,
    canvasTotal: canvas.total,
    height: afterLabel(words, /^высот/i, onCodeLine),
    road: afterLabel(words, /^дорожн/i, onCodeLine),
    blank: []
  };
  if (codeLike.length < 3) return result;
  let codeX = median(codeLike.map(cx));
  codeX = median(codeLike.filter((w) => Math.abs(cx(w) - codeX) < width * 0.04).map(cx));
  const units = words.filter((w) => UNIT_RE.test(w.text.trim()) && cx(w) > codeX + width * 0.05);
  let unitX = median(units.map(cx));
  if (!(unitX - codeX > width * 0.06 && unitX - codeX < width * 0.25)) unitX = codeX + width * 0.122;
  const d = unitX - codeX;
  const codes = codeLike.filter((w) => Math.abs(cx(w) - codeX) < 0.25 * d).sort((a, b) => cy(a) - cy(b));
  if (codes.length < 3) return result;
  const tails = /* @__PURE__ */ new Set();
  const anchors = [];
  for (const w of codes) {
    let code = w.text.trim();
    const tail = words.find((o) => {
      if (o === w || Math.abs(cy(o) - cy(w)) >= 6 || o.x0 < w.x1 - 2 || o.x0 - w.x1 >= 12) return false;
      const t = o.text.trim();
      return /^\/\d{1,2}$/.test(t) || code.endsWith("/") && /^\d{1,2}$/.test(t);
    });
    if (tail && !/\/\d/.test(code)) {
      code = `${code.replace(/\/$/, "")}/${tail.text.trim().replace(/^\//, "")}`;
      tails.add(tail);
    }
    anchors.push({ code: code.replace(/\/$/, ""), y: cy(w) });
  }
  const gaps = anchors.slice(1).map((a, i) => a.y - anchors[i].y);
  const gap = median(gaps.filter((g) => g > 4)) || height * 0.016;
  const bands = anchors.map((a, i) => ({
    ...a,
    top: i > 0 ? (anchors[i - 1].y + a.y) / 2 : a.y - gap / 2,
    bottom: i < anchors.length - 1 ? (a.y + anchors[i + 1].y) / 2 : a.y + gap / 2
  }));
  const nameMaxX = codeX - 0.25 * d;
  const qtyMin = codeX + 0.1 * d;
  const qtyMax = unitX + 0.1 * d;
  const priceMin = unitX + 0.2 * d;
  const sumMin = unitX + 1.3 * d;
  const priceSplit = unitX + 0.85 * d;
  const inBand = (w, b) => cy(w) >= b.top && cy(w) < b.bottom;
  const tableTop = bands[0].top;
  const tableBottom = bands[bands.length - 1].bottom;
  const qtyWords = [];
  const sumWords = [];
  for (const w of words) {
    const y = cy(w);
    if (y < tableTop - gap || y > tableBottom + gap || tails.has(w) || codes.includes(w)) continue;
    const x = cx(w);
    const t = w.text.trim();
    if (x > qtyMin && x < qtyMax && !t.startsWith("/") && !UNIT_RE.test(t) && !CODE_RE.test(t) && qtyGuesses(t).length) {
      qtyWords.push(w);
    } else if (x >= sumMin && (qtyGuesses(t, true).length || /^[.,]?\d/.test(t))) {
      sumWords.push(w);
    }
  }
  const pricesOf = (i) => readPrices(
    words.filter((w) => inBand(w, bands[i]) && cx(w) > priceMin && cx(w) < sumMin),
    priceSplit
  );
  const unitOf = (i) => {
    const u = words.filter((w) => UNIT_RE.test(w.text.trim()) && inBand(w, bands[i]) && Math.abs(cx(w) - unitX) < 0.4 * d).sort((a, b) => Math.abs(cy(a) - bands[i].y) - Math.abs(cy(b) - bands[i].y))[0];
    return u ? u.text.trim().replace(/^\/\s*/, "") : "";
  };
  const nameOf = (i) => textLines(
    words.filter((w) => inBand(w, bands[i]) && cx(w) < nameMaxX && !/^[●•·_]+$/.test(w.text.trim())),
    7
  ).filter((l) => l[0].x0 < codeX * 0.3).map((l) => l.map((w) => w.text).join(" ")).join(" ").replace(/\s+/g, " ").slice(0, 200);
  result.blank = bands.map((b, i) => ({
    page,
    code: b.code,
    name: nameOf(i),
    unit: unitOf(i),
    prices: pricesOf(i),
    top: b.top / height,
    bottom: b.bottom / height
  }));
  const split = (g, kind) => {
    const parts = g.text.replace(/^\+/, "").split(/[+/]/);
    return parts.length > 1 && parts.every((t) => /^\d+(?:[.,]\d+)?$/.test(t)) ? parts.map((t) => ({ text: t, y: g.y, kind })) : [{ text: g.text, y: g.y, kind, ...g.pieces.length > 1 ? { pieces: g.pieces } : {} }];
  };
  const vals = [
    ...numberGroups(qtyWords).flatMap((g) => split(g, "qty")),
    ...numberGroups(sumWords).flatMap((g) => split(g, "sum"))
  ];
  const nearest = (y) => bands.map((b, i) => ({ i, dist: Math.abs(b.y - y) })).sort((a, b) => a.dist - b.dist).slice(0, 2);
  const byRow = /* @__PURE__ */ new Map();
  const put = (i, v) => byRow.set(i, [...byRow.get(i) ?? [], v]);
  const readings = (v) => [v.text, ...v.pieces ?? []];
  const fits2 = (i, qty, sum) => qtyGuesses(sum, true).some((s) => qtyGuesses(qty).some((g) => specPriceFits(s.value / g.value, pricesOf(i))));
  const ambiguous = [];
  for (const v of vals) {
    const [a, b] = nearest(v.y);
    if (!a) continue;
    if (b && b.dist - a.dist < gap * 0.3) ambiguous.push(v);
    else put(a.i, v);
  }
  const fitsAt = (i, v) => vals.filter((o) => o.kind !== v.kind && Math.abs(o.y - v.y) < gap * 0.6).some(
    (o) => readings(v).some((a) => readings(o).some((b) => v.kind === "qty" ? fits2(i, a, b) : fits2(i, b, a)))
  );
  for (const v of ambiguous) {
    const [a, b] = nearest(v.y);
    if (!a) continue;
    put(b && !fitsAt(a.i, v) && fitsAt(b.i, v) ? b.i : a.i, v);
  }
  const pairUp = (i, got, low) => {
    let qtys = got.filter((v) => v.kind === "qty");
    let sums = got.filter((v) => v.kind === "sum");
    const small = (v) => {
      const n = sumNumber(v.text);
      return Number.isFinite(low) && low >= 50 && n !== null && n < low * 0.9;
    };
    const smalls = sums.filter(small);
    sums = sums.filter((v) => !small(v));
    if (smalls.length === 1 && qtys.length === 0) qtys = [{ ...smalls[0], kind: "qty" }];
    qtys.sort((a, b) => a.y - b.y);
    sums.sort((a, b) => a.y - b.y);
    const pairs = [];
    const usedQ = /* @__PURE__ */ new Set();
    let score = 0;
    for (const sv of sums) {
      const free = qtys.filter((x) => !usedQ.has(x));
      const fit = free.find((x) => fits2(i, x.text, sv.text));
      const q = fit ?? (qtys.length === sums.length || sums.length === 1 ? [...free].sort((a, b) => Math.abs(a.y - sv.y) - Math.abs(b.y - sv.y))[0] : void 0);
      if (fit) score++;
      if (q) usedQ.add(q);
      pairs.push({ qty: q ?? null, sum: sv });
    }
    for (const q of qtys) {
      if (!usedQ.has(q) && !(score > 0 && q.text.replace(/\D/g, "").length <= 1)) pairs.push({ qty: q, sum: null });
    }
    return { pairs, score };
  };
  for (const [i, got] of [...byRow.entries()].sort((a, b) => a[0] - b[0])) {
    const band = bands[i];
    const prices = pricesOf(i);
    const unit2 = unitOf(i);
    const low = Math.min(...priceCandidates(prices));
    const soft = got.filter((v) => v.pieces && v.pieces.length > 1).slice(0, 4);
    let best = pairUp(i, got, low);
    for (let mask = 1; mask < 1 << soft.length; mask++) {
      const vs = got.flatMap((v) => {
        const k = soft.indexOf(v);
        return k >= 0 && mask & 1 << k ? v.pieces.map((t) => ({ text: t, y: v.y, kind: v.kind })) : [v];
      });
      const r = pairUp(i, vs, low);
      if (r.score > best.score) best = r;
    }
    const pairs = best.pairs;
    const name = result.blank[i].name;
    let slot = 0;
    for (const p of pairs) {
      const checked = checkSpecRow({ qtyRead: p.qty?.text ?? null, sumRead: p.sum?.text ?? null, unit: unit2, prices });
      if (checked.qty === null && checked.sum === null) continue;
      result.rows.push({
        page,
        code: band.code,
        name,
        unit: unit2,
        prices,
        qty: checked.qty,
        qtyRead: p.qty?.text ?? null,
        sum: checked.sum,
        sumRead: p.sum?.text ?? null,
        price: checked.price,
        check: checked.check,
        note: checked.note,
        top: band.top / height,
        bottom: band.bottom / height,
        slot: slot++
      });
    }
  }
  return result;
}
var LATIN_TWINS = {
  A: "\u0410",
  B: "\u0412",
  C: "\u0421",
  E: "\u0415",
  H: "\u041D",
  K: "\u041A",
  M: "\u041C",
  O: "\u041E",
  P: "\u0420",
  T: "\u0422",
  X: "\u0425",
  a: "\u0430",
  c: "\u0441",
  e: "\u0435",
  k: "\u043A",
  m: "\u043C",
  n: "\u043F",
  o: "\u043E",
  p: "\u0440",
  x: "\u0445",
  y: "\u0443",
  \u03C0: "\u043F"
};
function stationWords(words) {
  const cyr = (t) => /\d/.test(t) ? t : t.replace(/[A-Za-zπ]/g, (ch) => LATIN_TWINS[ch] ?? ch);
  const out = [];
  for (const w of words) {
    const text3 = String(w.text);
    const parts = text3.split(/\s+/).filter(Boolean);
    if (parts.length <= 1) {
      out.push({ ...w, text: cyr(text3.trim()) });
      continue;
    }
    const len = text3.length;
    let pos = 0;
    for (const p of parts) {
      const a = text3.indexOf(p, pos);
      pos = a + p.length;
      out.push({ text: cyr(p), x0: w.x0 + (w.x1 - w.x0) * (a / len), x1: w.x0 + (w.x1 - w.x0) * (pos / len), y0: w.y0, y1: w.y1 });
    }
  }
  return out;
}
function specRowKey(row) {
  const base = `${row.code}|${row.top.toFixed(4)}`;
  return row.slot ? `${base}|${row.slot}` : base;
}
function sameSpecBand(a, b) {
  return a.page === b.page && a.code === b.code && Math.abs(a.top - b.top) < 0.01;
}
function sharesBand(rows, r) {
  return rows.some((o) => o !== r && sameSpecBand(o, r));
}
function rereadCandidates(rows) {
  return rows.filter((r) => r.check !== "ok" && !sharesBand(rows, r));
}
function applyRereads(rows, answers) {
  return rows.map((r) => {
    if (r.check === "ok" || sharesBand(rows, r)) return r;
    const v = rereadVerdict(r, answers[specRowKey(r)]);
    if (!v.taken) return r;
    return {
      ...r,
      qty: v.qty,
      qtyRead: v.qtyRead,
      sum: v.sum,
      sumRead: v.sumRead,
      price: v.price,
      check: "ok",
      note: "\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0430 \u0441\u0442\u0440\u043E\u043A\u0443 \u0432\u0442\u043E\u0440\u043E\u0439 \u0440\u0430\u0437 \u2014 \u0441\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u043E \u0441\u043D\u0438\u043C\u043A\u043E\u043C",
      source: "model"
    };
  });
}
function rereadVerdict(row, raw) {
  const none = { taken: false, qty: null, sum: null, price: null, qtyRead: null, sumRead: null };
  if (!raw || raw.startsWith("ERROR")) return none;
  let got;
  try {
    got = JSON.parse(raw);
  } catch {
    return none;
  }
  const qtyRead = String(got?.qty ?? "").trim() || null;
  const sumRead = String(got?.sum ?? "").trim() || null;
  const c = checkSpecRow({ qtyRead, sumRead, unit: row.unit, prices: row.prices });
  return { taken: c.check === "ok", qty: c.qty, sum: c.sum, price: c.price, qtyRead, sumRead };
}
function sameSpecLine(a, b) {
  return sameSpecBand(a, b) && (a.slot ?? 0) === (b.slot ?? 0);
}
function applySpecFixes(rows, blank, fixes) {
  const used = /* @__PURE__ */ new Set();
  const humanRow = (base, f, was) => {
    const price = f.qty !== null && f.sum !== null && f.qty > 0 ? f.sum / f.qty : null;
    const check = f.qty === null ? "sum-only" : f.sum === null ? "qty-only" : price === null || !hasPrice(base.prices) ? "unchecked" : specPriceFits(price, base.prices) ? "ok" : "outside";
    const note = f.confirmed ? "\u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C \u043F\u043E \u0441\u043D\u0438\u043C\u043A\u0443" : was && (was.qty !== null || was.sum !== null) ? `\u043F\u043E\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C, \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E \u0431\u044B\u043B\u043E ${was.qty === null ? "\u2014" : fmt(was.qty)} / ${was.sum === null ? "\u2014" : fmt(was.sum)}` : "\u0434\u043E\u043F\u0438\u0441\u0430\u043D\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C: \u0447\u0442\u0435\u043D\u0438\u0435 \u0441\u0442\u0440\u043E\u043A\u0443 \u043F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u043B\u043E";
    return { ...base, qty: f.qty, sum: f.sum, price, check, note, source: "human", slot: f.slot ?? 0 };
  };
  const out = rows.map((r) => {
    const f = fixes.find((x) => !used.has(x) && sameSpecLine(x, r));
    if (!f) return r;
    used.add(f);
    return humanRow(r, f, r);
  });
  for (const f of fixes) {
    if (used.has(f)) continue;
    const b = blank.find((x) => sameSpecBand(x, f));
    if (!b) continue;
    used.add(f);
    out.push(humanRow({ ...b, qtyRead: null, sumRead: null }, f, null));
  }
  return out.sort((a, b) => a.page - b.page || a.top - b.top || (a.slot ?? 0) - (b.slot ?? 0));
}
function specBulkConfirmable(rows) {
  return rows.filter((r) => r.check === "ok" && !r.source);
}
function specReaderLabel(model) {
  if (!model) return "\u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043A\u0435\u043C";
  return model.startsWith("station:") ? "\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438" : "\u0441\u043B\u0443\u0436\u0431\u043E\u0439 \u042F\u043D\u0434\u0435\u043A\u0441\u0430";
}
var CANVAS_LINE_RE = /монтаж\s+потолочн|натяжк/i;
function matchSpecToOrder(read, lines, workTypes) {
  const keysByCode = /* @__PURE__ */ new Map();
  for (const wt of workTypes) {
    const art = (wt.article ?? "").trim();
    if (!art) continue;
    const set = keysByCode.get(art) ?? /* @__PURE__ */ new Set();
    for (const k of workTypeKeys(wt)) set.add(k);
    keysByCode.set(art, set);
  }
  const codeKeys = (code) => {
    const base = code.split("/")[0];
    return keysByCode.get(base) ?? keysByCode.get(base.slice(0, 4)) ?? /* @__PURE__ */ new Set();
  };
  const near3 = (a, b, tol) => Math.abs(a - b) <= tol;
  const cands = [];
  const sumCount = (values, v) => values.filter((x) => x !== null && near3(x, v, 1)).length;
  const rowSums = read.rows.map((r) => r.sum);
  const lineSums = lines.map((l) => Number(l.sum));
  read.rows.forEach((row, r) => {
    const keys = codeKeys(row.code);
    lines.forEach((line2, l) => {
      if (CANVAS_LINE_RE.test(line2.name)) return;
      const byCode = keys.has(normalizeWorkName(line2.name));
      const byName = row.name ? workNameSimilarity(row.name, line2.name) >= 0.6 : false;
      const sameSum = row.sum !== null && near3(Number(line2.sum), row.sum, 1);
      const sameQty = row.qty !== null && near3(line2.qty, row.qty, 0.011);
      const onlySum = sameSum && sumCount(rowSums, row.sum) === 1 && sumCount(lineSums, row.sum) === 1;
      if (!byCode && !byName && !(sameSum && sameQty) && !onlySum) return;
      cands.push({
        src: "row",
        r,
        l,
        score: (byCode ? 4 : 0) + (byName ? 2 : 0) + (sameSum ? 3 : 0) + (sameQty ? 2 : 0),
        sameQty,
        sameSum
      });
    });
  });
  (read.canvas ?? []).forEach((row, r) => {
    lines.forEach((line2, l) => {
      if (!CANVAS_LINE_RE.test(line2.name)) return;
      const sameSum = row.sum !== null && near3(Number(line2.sum), row.sum, 1);
      const sameQty = row.area !== null && near3(line2.qty, row.area, 0.011);
      if (!sameSum && !sameQty) return;
      cands.push({ src: "canvas", r, l, score: (sameSum ? 3 : 0) + (sameQty ? 2 : 0), sameQty, sameSum });
    });
  });
  cands.sort((a, b) => b.score - a.score);
  const rows = read.rows.map(() => ({ line: null, sameQty: false, sameSum: false }));
  const canvas = (read.canvas ?? []).map(() => ({ line: null, sameQty: false, sameSum: false }));
  const used = /* @__PURE__ */ new Set();
  const usedLine = /* @__PURE__ */ new Set();
  for (const c of cands) {
    const key = `${c.src}:${c.r}`;
    if (used.has(key) || usedLine.has(c.l)) continue;
    used.add(key);
    usedLine.add(c.l);
    (c.src === "row" ? rows : canvas)[c.r] = { line: lines[c.l], sameQty: c.sameQty, sameSum: c.sameSum };
  }
  return { rows, canvas, unmatched: lines.filter((_, l) => !usedLine.has(l)) };
}

// src/calc/spec-learn.ts
function specLearnRowId(fileId, row) {
  return `${fileId}:${row.page}:${row.code}:${Math.round(row.top * 1e4)}:${row.slot ?? 0}`;
}
function specLearnEmptyId(fileId, line2) {
  return `${fileId}:${line2.page}:${line2.code}:${Math.round(line2.top * 1e4)}:e`;
}
var SPEC_EMPTY_PER_PAGE = 3;
function specEmptyLines(rows, blank, perPage = SPEC_EMPTY_PER_PAGE) {
  const priced = (b) => b.prices.from !== null || b.prices.to !== null || b.prices.variants.length > 0;
  const empty = blank.filter((b) => priced(b) && !rows.some((r) => sameSpecBand(r, b)));
  const h = (b) => fnv(`${b.code}:${Math.round(b.top * 1e4)}`);
  return [...empty].sort((a, b) => h(a) - h(b) || a.top - b.top).slice(0, Math.max(0, perPage));
}
function fnv(text3) {
  let h = 2166136261;
  for (let i = 0; i < text3.length; i++) {
    h ^= text3.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h;
}
function specLearnSplit(scanId) {
  return fnv(scanId) % 5 === 0 ? "test" : "train";
}
function specLearnSplitOf(fileIds) {
  return fileIds.length > 0 && fileIds.every((id) => specLearnSplit(id) === "test") ? "test" : "train";
}
var near2 = (a, b, tol) => Math.abs(a - b) <= tol;
function specLearnLabel(row, match) {
  if (row.source === "human") {
    return row.qty !== null && row.sum !== null && row.qty > 0 && row.sum > 0 ? { qty: row.qty, sum: row.sum, kind: "human" } : null;
  }
  const line2 = match?.line;
  if (!line2 || line2.kind !== "work") return null;
  const qty = Number(line2.qty);
  const sum = Number(line2.sum);
  if (!(qty > 0 && sum > 0)) return null;
  if (match.sameQty && match.sameSum) return { qty, sum, kind: "agree" };
  if (match.sameQty === match.sameSum) return null;
  const priced = row.prices.variants.length > 0 || row.prices.from !== null || row.prices.to !== null;
  return priced && specPriceFits(sum / qty, row.prices) ? { qty, sum, kind: "order" } : null;
}
function specLearnTestLabel(first, firstMatch, final) {
  if (final.source === "human") return specLearnLabel(final, null);
  if (!first) return null;
  const label = specLearnLabel(first, firstMatch);
  if (!label) return null;
  const priced = first.prices.variants.length > 0 || first.prices.from !== null || first.prices.to !== null;
  return priced && specPriceFits(label.sum / label.qty, first.prices) ? label : null;
}
function specRereadScore(items) {
  const filled = items.filter((i) => i.row.kind !== "empty");
  const empties = items.filter((i) => i.row.kind === "empty");
  const s = { n: filled.length, answered: 0, taken: 0, correct: 0, wrong: 0 };
  for (const { row, answer } of filled) {
    if (answer && !answer.startsWith("ERROR")) s.answered++;
    const v = rereadVerdict(row, answer);
    if (!v.taken) continue;
    s.taken++;
    if (v.qty !== null && v.sum !== null && near2(v.qty, row.qty, 0.011) && near2(v.sum, row.sum, 1)) s.correct++;
    else s.wrong++;
  }
  if (empties.length) {
    s.empty = empties.length;
    s.emptyTaken = empties.filter(({ row, answer }) => rereadVerdict(row, answer).taken).length;
  }
  return s;
}
var SPEC_PROMOTE_RULE = { minRows: 40, minGainRows: 3, minGainShare: 0.05, minEmptyRows: 40 };
function specCandidatePasses(candidate, references, emptyRefs = []) {
  const n = candidate.n;
  if (n < SPEC_PROMOTE_RULE.minRows) return { passed: false, why: `\u0441\u0442\u0440\u043E\u043A \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 ${n} \u2014 \u043C\u0435\u043D\u044C\u0448\u0435 ${SPEC_PROMOTE_RULE.minRows}, \u0441\u0443\u0434\u0438\u0442\u044C \u0440\u0430\u043D\u043E` };
  const gain = Math.max(SPEC_PROMOTE_RULE.minGainRows, Math.ceil(SPEC_PROMOTE_RULE.minGainShare * n));
  for (const r of references) {
    if (candidate.correct < r.correct + gain) {
      return { passed: false, why: `\u0432\u0435\u0440\u043D\u044B\u0445 ${candidate.correct} \u043F\u0440\u043E\u0442\u0438\u0432 ${r.correct} \u2014 \u043D\u0443\u0436\u043D\u043E \u0431\u043E\u043B\u044C\u0448\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043D\u0430 ${gain}` };
    }
    if (candidate.wrong > r.wrong) return { passed: false, why: `\u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0445 ${candidate.wrong} \u043F\u0440\u043E\u0442\u0438\u0432 ${r.wrong} \u2014 \u0441\u0442\u0430\u043B\u043E \u0431\u043E\u043B\u044C\u0448\u0435` };
  }
  const empty = candidate.empty ?? 0;
  if (empty < SPEC_PROMOTE_RULE.minEmptyRows) {
    return { passed: false, why: `\u043F\u0443\u0441\u0442\u044B\u0445 \u0441\u0442\u0440\u043E\u043A \u0432 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 ${empty} \u2014 \u043C\u0435\u043D\u044C\u0448\u0435 ${SPEC_PROMOTE_RULE.minEmptyRows}: \u043C\u043E\u043B\u0447\u0438\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0442\u0430\u043C, \u043D\u0435 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u043E` };
  }
  const taken = candidate.emptyTaken ?? 0;
  const refs = emptyRefs.filter((r) => r.empty === empty);
  if (!refs.length) return { passed: false, why: "\u043D\u0430 \u043F\u0443\u0441\u0442\u044B\u0445 \u0441\u0442\u0440\u043E\u043A\u0430\u0445 \u0441\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u043D\u0435 \u0441 \u0447\u0435\u043C: \u043F\u0440\u0435\u0436\u043D\u044E\u044E \u043E \u043D\u0438\u0445 \u043D\u0435 \u0441\u043F\u0440\u043E\u0441\u0438\u043B\u0438" };
  for (const r of refs) {
    if (taken > (r.emptyTaken ?? 0)) {
      return { passed: false, why: `\u043D\u0430 \u043F\u0443\u0441\u0442\u044B\u0445 \u0441\u0442\u0440\u043E\u043A\u0430\u0445 \u0447\u0438\u0442\u0430\u0435\u0442 \u0446\u0438\u0444\u0440\u044B ${taken} \u0438\u0437 ${empty} \u043F\u0440\u043E\u0442\u0438\u0432 ${r.emptyTaken ?? 0} \u2014 \u0432\u044B\u0434\u0443\u043C\u044B\u0432\u0430\u0435\u0442` };
    }
  }
  return {
    passed: true,
    why: references.length ? "\u0432\u0435\u0440\u043D\u044B\u0445 \u0431\u043E\u043B\u044C\u0448\u0435, \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0445 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435, \u043D\u0430 \u043F\u0443\u0441\u0442\u044B\u0445 \u0441\u0442\u0440\u043E\u043A\u0430\u0445 \u043D\u0435 \u0432\u044B\u0434\u0443\u043C\u044B\u0432\u0430\u0435\u0442" : "\u0441\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u0442\u044C \u043D\u0435 \u0441 \u0447\u0435\u043C"
  };
}
function specLearnDayStats(items, pages) {
  const s = {
    contracts: new Set(items.map((i) => i.contractKey)).size,
    pages,
    rows: items.length,
    ok: 0,
    model: 0,
    check: 0,
    human: 0,
    same: 0,
    differs: 0,
    absent: 0,
    modelSame: 0,
    modelDiffers: 0,
    candidates: 0
  };
  for (const { row, match, noOrder, candidate } of items) {
    if (candidate) s.candidates++;
    if (row.source === "human") s.human++;
    else if (row.source === "model") s.model++;
    else if (row.check === "ok") s.ok++;
    else s.check++;
    if (noOrder) continue;
    const same = !!match?.line && match.sameQty && match.sameSum;
    if (!match?.line) s.absent++;
    else if (same) s.same++;
    else s.differs++;
    if (row.source === "model" && match?.line) {
      if (same) s.modelSame++;
      else s.modelDiffers++;
    }
  }
  return s;
}

// src/permissions.ts
var Permission = {
  // Клиенты и сделки
  CLIENT_VIEW: "client:view",
  CLIENT_CREATE: "client:create",
  CLIENT_EDIT: "client:edit",
  DEAL_VIEW: "deal:view",
  DEAL_CREATE: "deal:create",
  DEAL_EDIT: "deal:edit",
  DEAL_CHANGE_STATUS: "deal:change-status",
  // Замеры
  MEASUREMENT_VIEW_ALL: "measurement:view-all",
  // все замеры компании
  MEASUREMENT_VIEW_OWN: "measurement:view-own",
  // только свои наряды
  MEASUREMENT_SCHEDULE: "measurement:schedule",
  // назначить дату и замерщика
  MEASUREMENT_COMPLETE: "measurement:complete",
  // заполнить результат замера
  // Замеры дня по замерщикам и записи, которые ещё никто не взял, — смотреть
  // (главный по замерщикам, 14.10.2026)
  MEASUREMENT_OVERVIEW: "measurement:overview",
  // Назначить замерщика на запись пула — с записью в «Замеры» 1С (правило 269)
  MEASUREMENT_ASSIGN: "measurement:assign",
  // Свои выезды (16.10.2026): записать замер на себя — обзвонил незаключённого
  // и едет сам — и потом его результат; то и другое встаёт в «Замеры» 1С
  MEASUREMENT_OWN_VISITS: "measurement:own-visits",
  // Монтаж
  INSTALLATION_VIEW: "installation:view",
  INSTALLATION_SCHEDULE: "installation:schedule",
  // назначить дату и бригаду
  INSTALLATION_COMPLETE: "installation:complete",
  // отметить работу принятой
  // Деньги
  PRICE_VIEW: "price:view",
  PAYROLL_VIEW_OWN: "payroll:view-own",
  PAYROLL_VIEW_ALL: "payroll:view-all",
  PAYROLL_APPROVE: "payroll:approve",
  /**
   * Зарплата МОНТАЖНИКОВ: смотреть, начислять, править их правила.
   *
   * Отдельным правом, а не через `payroll:view-all`. Монтаж ведут отдел
   * документов и конструкторский: они собирают бригаду под объект и
   * знают, кто сколько сделал, — считать бригаде деньги им и положено.
   * Но зарплата замерщиков, менеджеров и директора их не касается, а
   * `view-all` отдал бы всю ведомость компании разом.
   */
  PAYROLL_INSTALLERS: "payroll:installers",
  /**
   * ВЫДАТЬ деньги по утверждённому начислению — и ничего больше.
   *
   * Владелец (30.09.2026): «нужен аккаунт кассиру, который выдаёт эти
   * зарплаты монтажникам». Выдача уже шла по правам выше, но каждое из них
   * даёт и РЕШАТЬ суммы: утверждать начисления, ставить оклады, заводить
   * удержания. Тот, кто отдаёт наличные, не должен сам определять, сколько
   * отдать, — иначе ведомость проводится мимо того, кто отвечает за цифры.
   *
   * Поэтому право узкое: видеть зарплату монтажников и ведомость (только
   * их — как у `payroll:installers`, срез делает сервер) и отмечать выдачу
   * УТВЕРЖДЁННОГО. Утвердить им нельзя: сервер отвечает отказом на любой
   * статус, кроме «выплачено».
   */
  PAYROLL_PAY: "payroll:pay",
  /**
   * Списание материалов и склад: заводить акт, проводить, принимать
   * остатки из 1С.
   *
   * ОТДЕЛЬНЫМ ПРАВОМ, а не через «записать на монтаж». Записывать на
   * монтаж умеет и колл-центр — оператор ставит дату по звонку, — а
   * списание это движение материальных ценностей: проведённый акт
   * уходит в бухгалтерию, и переписать его уже нельзя. Оператор, у
   * которого случайно оказалась эта кнопка, спишет полотно на чужой
   * адрес, и разбирать это будут инвентаризацией.
   *
   * Та же причина, что у зарплаты монтажников выше: похожая работа не
   * значит те же люди.
   */
  WAREHOUSE_MANAGE: "warehouse:manage",
  /**
   * Расходка монтажника: заполнить карточку расходных материалов на свой
   * адрес и отправить её на склад.
   *
   * Отдельно от `warehouse:manage`: бригада называет, ЧТО ей нужно на
   * объект, а списывает склад — тот, кто выдал и проверил. Дать бригаде
   * право склада значило бы дать ей проводить акты; дать складу только
   * это право — оставить его без выдачи. Похожая работа не значит те же
   * люди (та же причина, что у зарплаты монтажников).
   */
  CONSUMABLES_FILL: "consumables:fill",
  /**
   * Смотреть чужие расходки и лист по адресам — и НИЧЕГО не менять.
   *
   * Кладовщику нужен ровно просмотр: он стоит у окна, бригада называет
   * улицу, он читает, что на неё запросили, и выдаёт с полки. Владелец
   * сказал прямо: «кладовщик отдельная роль, ему ничего не нужно кроме
   * просмотра списка».
   *
   * Отдельно от `warehouse:manage`: то право проводит акты списания и
   * правит справочник — проведённое уходит в бухгалтерию и не
   * переписывается (правило 115). Дать его ради просмотра значило бы
   * дать кнопку, которой человек пользоваться не должен, а похожая
   * работа не значит те же люди.
   */
  CONSUMABLES_VIEW_ALL: "consumables:view-all",
  /**
   * Склад забора: видеть строки расходки, отмеченные «выдадут на нашем
   * складе», и отмечать «выдал» (правило 292).
   *
   * Владелец (28.10.2026): «для склада на Ключевом не надо показывать все
   * расходки, только те, которые на них падают». Расходку выдаёт и
   * подписывает основной склад, а запасной отдаёт с полки отмеченное им
   * (правило 290). Отдельно от `consumables:view-all`: то открывает все
   * расходки всех бригад, а здесь — только свои строки.
   */
  CONSUMABLES_PICKUP: "consumables:pickup",
  /**
   * Справочник строк карточки: как строка бумажной расходки называется,
   * её артикул, палка и позиция 1С за ней (вкладка «Строки карточки»).
   *
   * Отдельно от `warehouse:manage`: кладовщик выдаёт ПО строкам и
   * подбирает позицию к строке, но сам справочник — не его. Владелец
   * (24.09.2026): «от кладовщика надо скрыть строки карточки». Правит
   * справочник отдел документов и руководство; кладовщику вкладки нет
   * вовсе, а ручка записи отказывает (правила 104 и 200).
   */
  CONSUMABLES_ITEMS_MANAGE: "consumables:items-manage",
  /**
   * Справочник работ: какие товары 1С уходят на работу наряда и сколько
   * за неё получает бригада (правило 215).
   *
   * Ведёт отдел документов: он пишет списки работ на выезд и считал
   * зарплату «за объект» в своей таблице. Отдельно от `catalog:manage` —
   * там прайс, фактуры и нормы по раскрою, это не их работа; и отдельно
   * от `payroll:installers` — ставку работы видит и конструкторский
   * отдел, а править её ему незачем.
   */
  WORK_TYPES_MANAGE: "work-types:manage",
  // Справочники и администрирование
  CATALOG_MANAGE: "catalog:manage",
  PAYROLL_RULES_MANAGE: "payroll-rules:manage",
  USER_MANAGE: "user:manage",
  /**
   * Управлять МОНТАЖНИКАМИ, и только ими: заводить, править, отключать,
   * выдавать вход и менять пароль (правило 281).
   *
   * Владелец (21.10.2026): «для отдела сервиса и отдела документов надо выдать
   * доступ управлять сотрудниками (монтажниками) и только монтажниками,
   * выдавать или менять их пароли». Бригадиры теряют пароли и меняют
   * телефоны каждую неделю, а ходили с этим к администратору.
   *
   * Отдельно от `user:manage`: то право заводит кого угодно с любыми ролями,
   * то есть открывает всю программу. Здесь сервер пускает только к учётке,
   * у которой одна роль — монтажник, и роль ей ставит только эту
   * (`isPureInstaller`): иначе отдел, правящий монтажника, дописал бы ему
   * «Руководителя» и вошёл под ним сам.
   */
  USER_MANAGE_INSTALLERS: "user:manage-installers",
  REPORT_VIEW: "report:view",
  /**
   * Прибыль договоров до работ (правило 262): сумма договора, монтажникам,
   * товары, полотно и проценты отделам. Отдельно от `report:view` — это
   * разговор о деньгах компании по каждому договору, и его ведёт главный
   * по замерщикам вместе с руководством, а не всякий, кто видит отчёты.
   */
  REPORT_PROFIT: "report:profit",
  /**
   * Итоги компании в этом расчёте (16.10.2026): сколько получим, потратим и
   * заработаем за срок, общая маржа, куда уходят деньги и помесячно. Владелец:
   * главному по замерщикам прибыль компании знать не нужно — ему договоры по
   * одному, замерщики и что выгодно продавать. Сервер такие суммы ему не
   * отдаёт вовсе: спрятанное только на экране — это «отдали и попросили не
   * смотреть» (правило 106).
   */
  REPORT_PROFIT_TOTALS: "report:profit-totals",
  /**
   * Проценты отделам и стоимость полотна за м² для этого расчёта. Это
   * решение владельца о деньгах людей — правит администратор, а главный по
   * замерщикам их только видит.
   */
  PROFIT_RATES_MANAGE: "profit:rates-manage",
  /**
   * Обзвон незаключённых (правило 264): кто не заключился, его телефон из
   * «Замеров» 1С и запись итога звонка с причиной. Отдельно от `report:view`:
   * здесь телефоны и имена заказчиков списком, и звонит по ним главный по
   * замерщикам с руководством, а не всякий, кто видит отчёты.
   */
  NONCLOSURE_CALLS: "nonclosures:calls",
  /**
   * Отчёт о работе главного по замерщикам (19.10.2026): кого он обзвонил, у
   * кого после звонка появился договор в 1С и на сколько, кто отказался и
   * почему, куда ездил сам. Владелец: «надо отдельно отчёт по работе
   * Картапова». Это отчёт начальнику о человеке — руководству, а не ему
   * самому: свои звонки он видит в «Кому позвонить».
   */
  REPORT_HEAD_WORK: "report:head-work",
  /**
   * Та же страница — самому главному по замерщикам, но только о нём: его
   * звонки и его выезды (владелец, 22.10.2026: «сделай, чтобы главному по
   * замерщикам тоже была видна эта статистика чисто по нему»). Срез делает
   * сервер: чужие звонки ему не отдаются вовсе (правило 106 про то же)
   */
  REPORT_HEAD_WORK_OWN: "report:head-work-own",
  /**
   * Справочник замерщика (правило 282) — таблица компании «Справочник» в
   * CRM: спецификации с ценами безнал, наличка и Лемана Про, каталоги
   * вентиляции, решёток, карнизов и полотен, памятки. Владелец
   * (21.10.2026): «просто показывать главному по замерщикам для общей
   * информации, а не подвязывать к CRM» — в смету и бланк он не идёт. В
   * памятках внутреннее (откаты, закупочные цены, телефоны сотрудников),
   * поэтому видят его главный по замерщикам и отдел документов.
   */
  REFERENCE_VIEW: "reference:view",
  /** Загрузить новую выгрузку таблицы вместо прежней */
  REFERENCE_MANAGE: "reference:manage",
  /**
   * Поиск договора во всех базах 1С и скачивание скана (правило 288).
   * Сначала экран жил под `document:edit` — отдел документов. Владелец
   * (28.10.2026): «заведи аккаунт для отдела конструкторского, им надо тоже
   * поиск по договорам 1С» — лист замерщика и спецификация лежат в том же
   * скане. Своё право, а не `document:edit`: то открыло бы конструкторам
   * утверждение расходки и «ЗП» в 1С. В сканах паспорта заказчиков — потому
   * только этим двум отделам. Обмен агента по-прежнему под `document:edit`.
   */
  ONEC_CONTRACTS_SEARCH: "onec:contracts-search",
  // Следующие этапы
  DESIGN_VIEW: "design:view",
  DESIGN_EDIT: "design:edit",
  DOCUMENT_VIEW: "document:view",
  DOCUMENT_EDIT: "document:edit"
};
var ROLE_PERMISSIONS = {
  ADMIN: Object.values(Permission),
  CALL_CENTER: [
    Permission.CLIENT_VIEW,
    Permission.CLIENT_CREATE,
    Permission.CLIENT_EDIT,
    Permission.DEAL_VIEW,
    Permission.DEAL_CREATE,
    Permission.DEAL_EDIT,
    Permission.DEAL_CHANGE_STATUS,
    Permission.MEASUREMENT_VIEW_ALL,
    Permission.MEASUREMENT_SCHEDULE,
    Permission.INSTALLATION_VIEW,
    Permission.INSTALLATION_SCHEDULE,
    Permission.INSTALLATION_COMPLETE,
    Permission.PRICE_VIEW
  ],
  SURVEYOR: [
    Permission.CLIENT_VIEW,
    Permission.DEAL_VIEW,
    Permission.MEASUREMENT_VIEW_OWN,
    Permission.MEASUREMENT_COMPLETE,
    Permission.PRICE_VIEW,
    Permission.PAYROLL_VIEW_OWN
  ],
  // На монтаж записывают ДВА отдела: конструкторский знает, когда полотно
  // сварено и готово к установке, отдел документов — когда подписаны
  // бумаги и получены деньги. Раньше запись висела на колл-центре, и
  // готовый заказ ждал, пока о нём вспомнят
  CONSTRUCTOR: [
    Permission.CLIENT_VIEW,
    Permission.DEAL_VIEW,
    Permission.MEASUREMENT_VIEW_ALL,
    Permission.INSTALLATION_VIEW,
    Permission.INSTALLATION_SCHEDULE,
    Permission.INSTALLATION_COMPLETE,
    Permission.DESIGN_VIEW,
    Permission.DESIGN_EDIT,
    // Бригаду под объект собирают они же — им и считать ей деньги
    Permission.PAYROLL_INSTALLERS,
    // Они же видят, что реально ушло на объект
    Permission.WAREHOUSE_MANAGE,
    Permission.CONSUMABLES_VIEW_ALL,
    // Договор и его скан из любой базы 1С (правило 288, владелец 28.10.2026)
    Permission.ONEC_CONTRACTS_SEARCH
  ],
  DOCUMENTS: [
    Permission.CLIENT_VIEW,
    Permission.DEAL_VIEW,
    Permission.MEASUREMENT_VIEW_ALL,
    Permission.INSTALLATION_VIEW,
    Permission.INSTALLATION_SCHEDULE,
    Permission.INSTALLATION_COMPLETE,
    Permission.DOCUMENT_VIEW,
    Permission.DOCUMENT_EDIT,
    Permission.PAYROLL_INSTALLERS,
    Permission.WAREHOUSE_MANAGE,
    Permission.CONSUMABLES_VIEW_ALL,
    Permission.CONSUMABLES_ITEMS_MANAGE,
    Permission.WORK_TYPES_MANAGE,
    // Входы и пароли монтажников — и только их (правило 281)
    Permission.USER_MANAGE_INSTALLERS,
    // Справочник замерщика — смотреть (правило 282)
    Permission.REFERENCE_VIEW,
    // Договор и его скан из любой базы 1С (правило 288)
    Permission.ONEC_CONTRACTS_SEARCH
  ],
  // Монтажник заполняет расходку сам — иначе её заполняет за него отдел
  // документов с его слов, ради чего расходка и заводилась
  INSTALLER: [Permission.PAYROLL_VIEW_OWN, Permission.CONSUMABLES_FILL],
  MANAGER: [
    Permission.CLIENT_VIEW,
    Permission.CLIENT_CREATE,
    Permission.CLIENT_EDIT,
    Permission.DEAL_VIEW,
    Permission.DEAL_CREATE,
    Permission.DEAL_EDIT,
    Permission.DEAL_CHANGE_STATUS,
    Permission.MEASUREMENT_VIEW_ALL,
    Permission.MEASUREMENT_SCHEDULE,
    Permission.INSTALLATION_VIEW,
    Permission.INSTALLATION_SCHEDULE,
    Permission.INSTALLATION_COMPLETE,
    Permission.MEASUREMENT_OVERVIEW,
    Permission.MEASUREMENT_ASSIGN,
    Permission.PRICE_VIEW,
    Permission.PAYROLL_VIEW_ALL,
    Permission.PAYROLL_APPROVE,
    Permission.CATALOG_MANAGE,
    Permission.PAYROLL_RULES_MANAGE,
    Permission.REPORT_VIEW,
    Permission.REPORT_PROFIT,
    Permission.REPORT_PROFIT_TOTALS,
    Permission.NONCLOSURE_CALLS,
    Permission.REPORT_HEAD_WORK,
    Permission.DESIGN_VIEW,
    Permission.DOCUMENT_VIEW,
    Permission.WAREHOUSE_MANAGE,
    Permission.CONSUMABLES_VIEW_ALL,
    Permission.CONSUMABLES_ITEMS_MANAGE,
    Permission.WORK_TYPES_MANAGE
  ],
  /**
   * Кладовщик: лист по адресам, выдача и списание.
   *
   * СНАЧАЛА БЫЛО «ТОЛЬКО ПРОСМОТР» — так сказал владелец, заводя роль.
   * Через день выяснилось, чем он занят на самом деле: «монтажники могут
   * не знать названия всех гардин, поэтому они отправляют на утверждение
   * кладовщикам, а кладовщик вписывает реальную позицию со склада по
   * названию и отправляет акт в 1С на списание». То есть подбор позиции
   * и проведение — его работа, и права на неё он и получил.
   *
   * БОЛЬШЕ НИЧЕГО У НЕГО НЕТ: ни сделок, ни денег, ни зарплаты, ни
   * замеров — право склада открывает расходку, остатки и акты списания,
   * и на этом список кончается. Роль, которой можно всё «на всякий
   * случай», перестаёт что-либо значить.
   *
   * СПРАВОЧНИК СТРОК КАРТОЧКИ — ТОЖЕ НЕ ЕГО (правило 200): он выдаёт по
   * строкам, а что за строка и какая позиция 1С за ней, решают отдел
   * документов и руководство.
   */
  STOREKEEPER: [Permission.CONSUMABLES_VIEW_ALL, Permission.WAREHOUSE_MANAGE],
  /**
   * Кладовщик склада забора (правило 292): выдаёт с полки строки, которые
   * основной склад отметил «выдадут на этом складе», и отмечает «выдал».
   * Выдачи, разноса, правки строк и актов у него нет: документы заводит
   * основной склад, в 1С их отправляет отдел документов (правило 290).
   */
  PICKUP_KEEPER: [Permission.CONSUMABLES_PICKUP],
  /**
   * Отдел сервиса: возит материал монтажникам прямо на объект и отвечает
   * за них.
   *
   * Владелец (30.09.2026): «у нас есть отдел сервиса, он может привозить
   * монтажникам прям на место работы, им надо дать возможность дополнять
   * адреса какие либо, а также они по сути главные по монтажникам — дай им
   * доступ ко всем функциям монтажников».
   *
   * ПОЭТОМУ ЗДЕСЬ ДВА НАБОРА РАЗОМ. Свой, монтажничий: заполнять расходку
   * и видеть свою зарплату — они и сами выезжают. И начальственный: чужие
   * расходки всех бригад, деньги монтажников по адресам, запись и приёмка
   * монтажа, бригады с их умениями и запретами (правило 61 — они идут по
   * тому же праву, что запись на монтаж).
   *
   * ДОПОЛНЯТЬ АДРЕСА В РАСХОДКЕ им даёт `consumables:fill` вместе с
   * `consumables:view-all`: первое правит карточку, второе открывает ЧУЖУЮ.
   * Привезли на объект, которого в карточке нет, — дописали адрес, и разнос
   * склада по остальным остался на месте.
   *
   * ЧЕГО У НИХ НЕТ, и это не забывчивость: `warehouse:manage` — выдача и
   * проведение актов списания в 1С (правило 115: проведённое уходит в
   * бухгалтерию и не переписывается), правка прайса, сделок и бумаг. Роль,
   * которой можно всё «на всякий случай», перестаёт что-либо значить.
   */
  /**
   * Касса: выдаёт монтажникам зарплату по утверждённой ведомости.
   *
   * Своя зарплата — тоже видна: кассир такой же сотрудник. Больше ничего:
   * ни сделок, ни склада, ни правил зарплаты — выдающий деньги не решает,
   * сколько выдать (см. `payroll:pay`).
   */
  CASHIER: [Permission.PAYROLL_VIEW_OWN, Permission.PAYROLL_PAY],
  /**
   * Главный по замерщикам (12.10.2026): следит, какую прибыль принесёт
   * договор, ещё до работ, и разбирает, что выгоднее поставить другое
   * (правило 262). Видит договоры, замеры всех замерщиков, прайс и отчёты —
   * в том числе «Незаключённые по замерщикам» (правило 259). Проценты
   * отделам правит администратор, записью на замер занимается колл-центр;
   * сам он назначает замерщика на запись, которую никто не взял, — и это
   * встаёт в 1С (правило 269).
   */
  SURVEYOR_HEAD: [
    Permission.CLIENT_VIEW,
    Permission.DEAL_VIEW,
    Permission.MEASUREMENT_VIEW_ALL,
    // Замеры сегодня и записи, которые ждут замерщика (14.10.2026)
    Permission.MEASUREMENT_OVERVIEW,
    // …и назначить на них замерщика — запись встаёт в 1С (правило 269)
    Permission.MEASUREMENT_ASSIGN,
    // Сам ездит к незаключённым и записывает результат — в 1С (правило 271)
    Permission.MEASUREMENT_OWN_VISITS,
    Permission.PRICE_VIEW,
    Permission.REPORT_VIEW,
    Permission.REPORT_PROFIT,
    // Кто не заключился — позвонить и записать почему (правило 264)
    Permission.NONCLOSURE_CALLS,
    // Отчёт о своей работе по незаключённым — только о себе (правило 278)
    Permission.REPORT_HEAD_WORK_OWN,
    // Справочник замерщика: смотреть и загружать новую выгрузку (правило 282)
    Permission.REFERENCE_VIEW,
    Permission.REFERENCE_MANAGE
  ],
  SERVICE: [
    // Адреса и заказчики — иначе список выездов нечитаем: одни номера
    Permission.CLIENT_VIEW,
    Permission.DEAL_VIEW,
    Permission.INSTALLATION_VIEW,
    Permission.INSTALLATION_SCHEDULE,
    Permission.INSTALLATION_COMPLETE,
    // Деньги монтажников — по адресам и в ведомости монтажников (правило 106)
    Permission.PAYROLL_INSTALLERS,
    // Функции монтажника: свою расходку заполняют и сами
    Permission.CONSUMABLES_FILL,
    Permission.PAYROLL_VIEW_OWN,
    // Расходки всех бригад — чтобы дополнять адреса и видеть, что повезли
    Permission.CONSUMABLES_VIEW_ALL,
    // Главные по монтажникам — заводят их, выдают вход и меняют пароль
    // (правило 281); остальных сотрудников не трогают
    Permission.USER_MANAGE_INSTALLERS
  ]
};
function isPureInstaller(roles) {
  return roles.length > 0 && roles.every((r) => r === UserRole.INSTALLER);
}
function permissionsForRoles(roles) {
  const result = /* @__PURE__ */ new Set();
  for (const role of roles) {
    for (const p of ROLE_PERMISSIONS[role] ?? []) result.add(p);
  }
  return result;
}
function hasPermission(roles, permission) {
  return permissionsForRoles(roles).has(permission);
}
function hasAnyPermission(roles, permissions) {
  const owned = permissionsForRoles(roles);
  return permissions.some((p) => owned.has(p));
}
function defaultRouteForRoles(roles) {
  if (roles.includes(UserRole.SURVEYOR) && roles.length === 1) return "/my-measurements";
  if (roles.includes(UserRole.INSTALLER) && roles.length === 1) return "/consumables";
  if (roles.includes(UserRole.DOCUMENTS) && roles.length === 1) return "/documents";
  if (roles.includes(UserRole.STOREKEEPER) && roles.length === 1) return "/consumables";
  if (roles.includes(UserRole.PICKUP_KEEPER) && roles.length === 1) return "/consumables";
  if (roles.includes(UserRole.CASHIER) && roles.length === 1) return "/payroll";
  if (roles.includes(UserRole.SURVEYOR_HEAD) && roles.length === 1) return "/measurements/today";
  return "/today";
}

// src/dashboard.ts
var TONE_ORDER = {
  urgent: 0,
  attention: 1,
  calm: 2
};
function sortCards(cards) {
  return [...cards].sort((a, b) => {
    const byTone = TONE_ORDER[a.tone] - TONE_ORDER[b.tone];
    if (byTone !== 0) return byTone;
    return b.count - a.count;
  });
}
function daysSince(from, now = /* @__PURE__ */ new Date()) {
  const a = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const b = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(0, Math.round((b.getTime() - a.getTime()) / 864e5));
}

// src/reference.ts
function referenceSearchKey(s) {
  return s.toLowerCase().replace(/ё/g, "\u0435").replace(/[  \s]+/g, " ").trim();
}
function referenceCellText(cell) {
  return cell.t ?? (cell.r ?? []).map((x) => x.t).join("");
}
function referenceRowText(row) {
  return row.cells.map(referenceCellText).map((t) => t.replace(/\s+/g, " ").trim()).filter(Boolean).join(" \xB7 ");
}
function referenceRowMatches(rowKey, words) {
  return words.every((w) => rowKey.includes(w));
}
export {
  ACTIVE_DEAL_STATUSES,
  ARC_SLICE_KIND,
  AREA_GAP_MM,
  CELL_SIZES_MM,
  CLOSURE_TOLERANCE_MM,
  CONSUMABLES_CARD_STATUS_LABELS,
  CONSUMABLE_CHARGE_LABELS,
  CONSUMPTION_BASE_LABELS,
  CORNER_EXTRA_PRICE_CODE,
  CP_ACQ_KIND,
  CP_ARCHIVE_KIND,
  CP_PAY_KIND,
  CP_PRICE_KIND,
  CP_RATE_KINDS,
  CP_RATE_LABEL,
  CP_SHARE_KINDS,
  CP_SLICE_KIND,
  CURTAIN_NICHE_PRICE_CODE,
  ConsumableCharge,
  ConsumablesCardStatus,
  ConsumptionBase,
  DEAL_STATUS_LABELS,
  DEAL_STATUS_TRANSITIONS,
  DEBT_KIND_LABELS,
  DEFAULT_CELL_MM,
  DEFAULT_CONTRIBUTIONS_PERCENT,
  DEFAULT_FIXTURE_DIAMETER_MM,
  DEFAULT_NDFL_PERCENT,
  DEFAULT_PVC_SHRINKAGE_PERCENT,
  DEFAULT_WALL_PROFILE,
  DIAGONAL_TOLERANCE_MM,
  DRAWING_LINK_KINDS,
  DRAWING_PAGE_THRESHOLDS,
  DXF_LAYERS,
  DealStatus,
  Decimal,
  ESTIMATE_TOLERANCE,
  FIXTURE_LABELS,
  FIXTURE_PRICE_CODE,
  HISTORY_KINDS,
  HW_OUTCOME_RU,
  INSTALLATION_STATUS_LABELS,
  InstallationStatus,
  LAMP_WALL_MARGIN_MM,
  LEAD_KIND_RU,
  LIVE_MEASURERS_KIND,
  LIVE_MEASURE_DAYS_AHEAD,
  LIVE_MEASURE_DAYS_BACK,
  LIVE_MEASURE_KIND,
  LIVE_NO_MEASURER,
  LIVE_POOL_NAME,
  LIVE_RESULTS,
  MEASUREMENT_STATUS_LABELS,
  MOUNT_PRICE_CODE,
  MeasurementStatus,
  NC_AGREED_WAIT_DAYS,
  NC_BASES,
  NC_BASE_LABEL,
  NC_CALL_OUTCOMES,
  NC_CALL_OUTCOME_RU,
  NC_KIND_RU,
  NC_ORDER,
  NC_REFUSAL_REASONS,
  NC_REPAIR,
  NC_SHEETS,
  NC_SLICE_KINDS,
  NC_START,
  NC_WON_CHECK_DAYS,
  ONEC_ID_PREFIX,
  PAYMENT_METHOD_LABELS,
  PAYMENT_PLAN_TEMPLATES,
  PAYROLL_BASIS_LABELS,
  PAYROLL_STATUS_LABELS,
  PAYROLL_TARGET_LABELS,
  PAY_FORM_BASE,
  PAY_FORM_DIFF,
  PAY_FORM_LABEL,
  PAY_SHEET_MONTHS,
  PAY_SHEET_PREFIX,
  POOL_PAST_WINDOW_DAYS,
  PRICE_UNIT_LABELS,
  PROFILE_PRICE_CODE,
  PaymentMethod,
  PayrollBasis,
  PayrollStatus,
  PayrollTarget,
  Permission,
  PriceUnit,
  RECOGNITION_JSON_SCHEMA,
  RECOGNITION_LABELS,
  RECOGNITION_LIMITS,
  RECOGNITION_LOG_LABELS,
  RECONCILED_PRICE_CODES,
  REMNANT_MARGIN_MM,
  REVIEW_BONUS,
  REVIEW_BONUS_PER_PERSON,
  ROAD_EXPENSE,
  ROLE_PERMISSIONS,
  ROLL_WIDTHS_MM,
  SCHEDULE_END_HOUR,
  SCHEDULE_START_HOUR,
  SEAM_CLEARANCE_MM,
  SEAM_PRICE_CODE,
  SHEET_COMMENT_MARKER,
  SHEET_PROMOTE_RULE,
  SLOT_MINUTES,
  SPEC_EMPTY_PER_PAGE,
  SPEC_PROMOTE_RULE,
  STOCK_SEARCH_LIMIT,
  STOCK_SEARCH_WORDS,
  SWITCH_HOW_LABEL,
  ServiceCategoryCode,
  TONE_ORDER,
  TRAVEL_SLACK_MIN,
  TYPICAL_FABRIC_SHRINKAGE_PERCENT,
  USER_ROLE_LABELS,
  UserRole,
  WALL_PROFILE_LABELS,
  WON_DEAL_STATUSES,
  absentHoursCount,
  absentHoursFrom,
  accrueMonthSchema,
  actMoney,
  actRole,
  addDeductionSchema,
  addRemnantSchema,
  addressInText,
  addressKey,
  addressMoneyTotals,
  addressRelation,
  addressScore,
  addressSplitSig,
  advanceProductionSchema,
  allocateByBrigade,
  allocateByLines,
  allocateConsumables,
  allocatedOver,
  allocatedShort,
  amountInWords,
  analyzeNonclosures,
  anglesToWalls,
  applyRereads,
  applySpecFixes,
  approvalBlockers,
  arcPoints,
  archiveScanTargets,
  archiveSpecContracts,
  articleWords,
  assignMeasurementSchema,
  assignOptions,
  attachInstallationSchema,
  attachPayDocs,
  blameBrigadeSchema,
  boundingBox,
  brigadeConflictSchema,
  brigadeSchema,
  buildDocx,
  buildDxf,
  buildEasyCeiling,
  buildPayGrid,
  buildPaymentPlan,
  buildPaymentQr,
  buildWriteOffLines,
  calcAmendments,
  calcCutPlan,
  calcCutSnapshot,
  calcDealTotals,
  calcLineTotal,
  calcMonthlyPayroll,
  calcPayroll,
  calcSettlement,
  calcSlotOccupancy,
  calcTaxes,
  calcWorksPay,
  calcWriteOffBasis,
  calendarDay,
  calendarDayKey,
  canMoveMeasure,
  cancelInstallationSchema,
  cancelMeasurementSchema,
  cancelProductionSchema,
  ceilToPack,
  ceilingCutInputSchema,
  ceilingMaterialSchema,
  centerOnGrid,
  centroid,
  chainToContour,
  changeDealStatusSchema,
  changePasswordSchema,
  changePayrollStatusSchema,
  chargeForCode,
  chargeShiftDeductionsSchema,
  checkBrigadeFit,
  checkDiagonals,
  checkSpecRow,
  checkTravelFit,
  chordThrough,
  chordsOnLine,
  clampMoney,
  cleanPath,
  closeDealSchema,
  closeShiftRuleSchema,
  closeWarrantyClaimSchema,
  closeWorkRateSchema,
  closureAxisText,
  compareParsedAddresses,
  completeInstallationSchema,
  completeMeasurementSchema,
  completeVertexAngles,
  complexityLevelSchema,
  consumableItemCodes,
  contourFromWalls,
  contractNumber,
  contractNumberToken,
  contractProfits,
  contractScanFiles,
  cpByItem,
  cpByMeasurer,
  cpByMonth,
  cpInPeriod,
  cpPayHistory,
  cpPayHistoryOf,
  cpRateOn,
  cpTotals,
  createAmendmentSchema,
  createClientSchema,
  createDealSchema,
  createDebtSchema,
  createUserSchema,
  createWarrantyClaimSchema,
  crewDecides,
  crewLabel,
  csvCell,
  csvText,
  curtainNicheLengthM,
  cutInternalNote,
  dateKey,
  dayOf,
  dayParts,
  daySheetApplySchema,
  daySheetParseSchema,
  dayStr,
  daysInMonth,
  daysSince,
  debtInstalment,
  debtInstalmentSchema,
  debtInstalments,
  debtRemaining,
  defaultRouteForRoles,
  describeAbsentHours,
  diagonalCheckSchema,
  diffEstimate,
  digitVariants,
  discountPercentToValue,
  discountValueToPercent,
  distanceAlong,
  distanceToWall,
  documentNumber,
  drawingAddressKey,
  drawingFileKinds,
  drawingOwnerIsOrganization,
  drawingOwnerWords,
  drawingPageKind,
  drawingToken,
  drawingTokenBase,
  easyCeilingFileName,
  emptyTotals,
  encodeEasyCeiling,
  evenLightLines,
  expandSpecLine,
  expectedEstimateLines,
  extentInBand,
  extrasEntries,
  findConflict,
  findInstallerConflicts,
  findShortages,
  findWorkType,
  findWorkTypeForLine,
  fixtureMarks,
  floorToPack,
  formatDaysOff,
  formatFreeSlots,
  formatHour,
  formatMoney,
  formatMoneyShort,
  formatMonth,
  formatPhone,
  formatPhoneInput,
  formatQuantity,
  gridEdgeKey,
  gridPointToRoom,
  gridToWalls,
  grossUpFromNet,
  groupSpecification,
  guessToWalls,
  hasAnyPermission,
  hasPermission,
  headWorkReport,
  historyBaseKeySchema,
  historyMonthSchema,
  historyPartSchema,
  historyPlan,
  historySearchText,
  historySpanSchema,
  hourOf,
  indexNomenclature,
  installerConflictSchema,
  isConditionerPay,
  isContourClosed,
  isFromOnec,
  isMoneyUnit,
  isObsoleteCandidate,
  isObsoletePosition,
  isOurWarehouse,
  isPointInside,
  isPureInstaller,
  isRoadExpenseLine,
  isRuleEffective,
  isSheetComment,
  isSheetMoney,
  isUnassignedMeasurer,
  isUuid,
  isValidPhone,
  isWarehouseList,
  isWithinWorkingHours,
  isWorkRateOn,
  isoWeekday,
  issueAccessSchema,
  kindByText,
  labelSheetSchema,
  layoutRooms,
  leadKey,
  leadMonthFromGrid,
  leadMonthSummary,
  leadPeriodEnd,
  leadPrevMonth,
  leadSourceSchema,
  leadTotalFirstDays,
  lightLineGaps,
  liveMeasureState,
  liveMeasuresDay,
  liveMeasuresWindow,
  localMonthStart,
  loginSchema,
  longestChord,
  longestDiagonal,
  looksLikeSheetTime,
  matchAddress,
  matchByArticle,
  matchConsumableAliases,
  matchPriceItem,
  matchRemnants,
  matchSpecToOrder,
  measurementItemSchema,
  measurementRoomSchema,
  measurersMonth,
  memberMoney,
  metricsFromWalls,
  missingRequisiteFields,
  mm2ToSqm,
  mmHeadWork,
  mmToM,
  moneySchema,
  moneyToNumber,
  moneyToString,
  monthEnd,
  monthStart,
  monthWindow,
  monthsBetween,
  ncCallState,
  ncConfirmation,
  ncContractNum,
  ncKcRows,
  ncMatchKcRows,
  ncMeasurerName,
  ncOnecNote,
  ncRefusalWhy,
  ncSheetNote,
  ncSourceLabel,
  ncWhoIn,
  newId,
  nextAmendmentNumber,
  nomenclatureWords,
  nonNegativeMoneySchema,
  nonclosureBySource,
  nonclosureCallList,
  nonclosureReport,
  normalizeAddress,
  normalizeAlias,
  normalizePhone,
  normalizeWorkName,
  onIssueShelf,
  onecBaseSchema,
  onecDocumentText,
  onecDocumentTitle,
  onecDrawingUploadSchema,
  onecDrawingsCheckedSchema,
  onecInstallationSchema,
  onecInstallationsImportSchema,
  onecPostReason,
  onecWorkRatesSchema,
  optionalPhoneSchema,
  orderByShelf,
  outlineToWalls,
  overlappingFixtures,
  overriddenPrice,
  overriddenSum,
  ownMeasurers,
  paperArticles,
  parseAddress,
  parseAltCodes,
  parseDaysOff,
  parseEasyCeiling,
  parseLeadSheetTitle,
  parseLengthChain,
  parseLiveMeasurers,
  parseLiveMeasures,
  parsePastedWorks,
  parsePriceCell,
  parseSpecTable,
  parseWorkNames,
  partyGender,
  partyPreamble,
  partyTaxIds,
  pastedQuantity,
  payBrigadeKey,
  payFormDiffPct,
  payFormFactor,
  payFormOfBase,
  payOutSchema,
  paySheetLive,
  paySheetTitles,
  payShortName,
  paymentPlanItemSchema,
  paymentQrProblems,
  payrollRuleSchema,
  percentOf,
  permissionsForRoles,
  phoneSchema,
  pickTwin,
  pickupStock,
  pickupWarehouses,
  placeSheetNumbers,
  planBrigadePay,
  planFromTemplate,
  planLampGrid,
  planLamps,
  planRollPurchase,
  planShiftDeductions,
  pluralRu,
  polygonAreaMm2,
  polygonPerimeterMm,
  positionTitle,
  priceForPayment,
  priceItemSchema,
  priceKey,
  priceLines,
  profileLengths,
  qtyGuesses,
  quickLeadSchema,
  readAddressTakes,
  readCluster,
  readOutlineSketch,
  readSheetRooms,
  readSketchNumbers,
  readSpecPage,
  reassignInstallationSchema,
  recognitionAcceptedSchema,
  recognitionResultSchema,
  recognizeRequestSchema,
  recognizedItemSchema,
  recognizedRoomSchema,
  recognizedWallSchema,
  recordPaymentSchema,
  referenceCellText,
  referenceRowMatches,
  referenceRowText,
  referenceSearchKey,
  refreshSchema,
  remnantAreaSqm,
  rereadCandidates,
  rereadVerdict,
  rescheduleInstallationSchema,
  rescheduleMeasurementSchema,
  reviewBonusAmount,
  reviewBonusTitle,
  ridesVisitDay,
  roomFixtureSchema,
  roomMetrics,
  roomPointOnGrid,
  roomPointToGrid,
  rotateFixtures,
  rotatePolygon,
  roundMoney,
  roundQuantity,
  ruleDayKey,
  salaryForMonth,
  sameDrawingOwner,
  sameSpecBand,
  sameSpecLine,
  sameUnit,
  sampleRequisiteFields,
  sanitizeRecognition,
  saveCeilingProjectSchema,
  saveOrgSettingsSchema,
  saveRatingsSchema,
  saveSheetEntrySchema,
  scaleFixtures,
  scalePolygon,
  scanSignature,
  scheduleHours,
  scheduleInstallationSchema,
  scheduleMeasurementSchema,
  seamMarks,
  seamSegments,
  searchStockIndex,
  selectApplicableRules,
  sendToProductionSchema,
  serviceCategorySchema,
  setAbsenceSchema,
  setContractNoSchema,
  setFollowUpSchema,
  setInstallationActMarksSchema,
  setInstallationCrewSchema,
  setInstallationDaysSchema,
  setInstallationNoteSchema,
  setInstallationWorksSchema,
  setPaymentPlanSchema,
  setSalarySchema,
  setShippingSchema,
  setUserPasswordSchema,
  sheetAnswerWords,
  sheetBoxScore,
  sheetBoxVerdict,
  sheetCandidatePasses,
  sheetCommentParts,
  sheetCropsToAsk,
  sheetLabels,
  sheetLearnBoxes,
  sheetLearnRowId,
  sheetMoneySplit,
  sheetNumberKindSchema,
  sheetOutlineRequestSchema,
  sheetPhone,
  sheetPhones,
  sheetStageNote,
  sheetWallNumbers,
  shelfRank,
  shiftDayKey,
  shiftRuleSchema,
  shiftsWord,
  signatureSchema,
  signerPhrase,
  similarWorkTypes,
  slotStart,
  sortCards,
  specBulkConfirmable,
  specCandidatePasses,
  specEmptyLines,
  specItemCode,
  specLearnDayStats,
  specLearnEmptyId,
  specLearnLabel,
  specLearnRowId,
  specLearnSplit,
  specLearnSplitOf,
  specLearnTestLabel,
  specLineKey,
  specNumber,
  specPriceFits,
  specReaderLabel,
  specRereadScore,
  specRowKey,
  specUnit,
  splitAmongPeople,
  splitAmountByShares,
  splitBrigadeAmount,
  splitByLightLines,
  splitColumns,
  splitDayWithOverrides,
  splitPastedRows,
  splitSheetNotes,
  staffPhonesFor,
  stationWords,
  stockForLine,
  stockSearchKey,
  stockSearchWords,
  stockShort,
  stockWordsMatch,
  strokeToPath,
  suggestBrigades,
  suggestLampGrid,
  suggestNomenclature,
  suggestOutlineFix,
  sumMoney,
  sumPlanItems,
  sumTotals,
  switchContractName,
  switchIndex,
  switchLine,
  switchPriceTable,
  switchTotals,
  syncOperationSchema,
  syncPullSchema,
  syncPushSchema,
  textFingerprint,
  timestampFromId,
  toDecimal,
  travelSummary,
  twinNameKey,
  twinStockKey,
  twinStockKeys,
  uniqueScanFiles,
  updateClientSchema,
  updateDealSchema,
  updateDebtSchema,
  updateEstimateSchema,
  useRemnantSchema,
  uuidSchema,
  variantLabels,
  vertexIndexForPathPoint,
  vertexLetter,
  wallCmOf,
  wallLengthMm,
  wallSegmentSchema,
  wallsToGrid,
  warrantyLabel,
  warrantyState,
  withOnecRates,
  withReviewBonus,
  withRoadExpenses,
  workKeyCollisions,
  workLineAmount,
  workLineKeys,
  workNameBases,
  workNameSimilarity,
  workNameWords,
  workPayLineSchema,
  workPayPersonSchema,
  workRateOn,
  workRateSchema,
  workTypeIndex,
  workTypeKeys,
  workTypeMaterialSchema,
  workTypeSchema,
  workTypesAsRates,
  worksAtHour,
  writeOffActTitle,
  writeOffDebtSchema,
  xmlEscape,
  zipStore
};
//# sourceMappingURL=index.js.map